webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(333);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _common = __webpack_require__(337);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _containers = __webpack_require__(792);
	
	var _containers2 = _interopRequireDefault(_containers);
	
	var _app = __webpack_require__(976);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	__webpack_require__(981);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularUiRouter2.default, _common2.default.name, _containers2.default.name, "kendo.directives"]).config(["$locationProvider", function ($locationProvider) {
	  'ngInject';
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	}]).run(["$rootScope", "$window", "$state", "$location", "AuthService", "AppContextService", "EventsService", function ($rootScope, $window, $state, $location, AuthService, AppContextService, EventsService) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	    var defaultState = _env2.default.defaultState();
	    var pageTitle = _env2.default.pageTitle();
	
	    $window.document.title = pageTitle;
	
	    if (toState.name != 'login') {
	      if (!AuthService.isAuthorized()) {
	        console.log("Access denied");
	        $state.go('login');
	        event.preventDefault();
	      } else {
	        if (!AppContextService.getAppContext()) {
	          AppContextService.fetchAppContext(function (response) {
	            var roles = response.data.roles;
	
	            if (AppContextService.hasAccess(roles)) {
	
	              AppContextService.setAppContext(response.data);
	              EventsService.broadcast(_constants2.default.events.AUTHORIZATION_SUCCESS);
	
	              if (AppContextService.hasReadAccess(roles)) {
	
	                if (toState.name != defaultState) $state.go(defaultState);
	              }
	            } else {
	              $state.go("login");
	            }
	          }, function () {
	            $state.go("login");
	          });
	        } else {
	
	          var roles = AppContextService.getAppContext().roles;
	
	          if (AppContextService.hasReadAccess(roles)) {
	            // Allow navigation to all admin states, only redirect analytics users to analytics
	            if (toState.name.indexOf("analytics") == -1 && _env2.default.isAnalytics()) {
	              event.preventDefault();
	              $state.go(defaultState);
	            }
	          }
	        }
	      }
	    }
	  });
	
	  if ($location.path() == "/") {
	    var defaultState = _env2.default.defaultState();
	    $state.go(defaultState);
	  }
	}]).component('app', _app2.default);

/***/ },
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularToastr = __webpack_require__(338);
	
	var _angularToastr2 = _interopRequireDefault(_angularToastr);
	
	var _Components = __webpack_require__(340);
	
	var _Components2 = _interopRequireDefault(_Components);
	
	var _services = __webpack_require__(711);
	
	var _services2 = _interopRequireDefault(_services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_Components2.default.name, _services2.default.name, _angularToastr2.default]);
	
	exports.default = commonModule;

/***/ },
/* 338 */,
/* 339 */,
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbar = __webpack_require__(341);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _leftnav = __webpack_require__(371);
	
	var _leftnav2 = _interopRequireDefault(_leftnav);
	
	var _usersFilter = __webpack_require__(376);
	
	var _usersFilter2 = _interopRequireDefault(_usersFilter);
	
	var _profilesFilter = __webpack_require__(381);
	
	var _profilesFilter2 = _interopRequireDefault(_profilesFilter);
	
	var _userBasicDetails = __webpack_require__(386);
	
	var _userBasicDetails2 = _interopRequireDefault(_userBasicDetails);
	
	var _userAddressDetails = __webpack_require__(518);
	
	var _userAddressDetails2 = _interopRequireDefault(_userAddressDetails);
	
	var _userPaymentDetails = __webpack_require__(523);
	
	var _userPaymentDetails2 = _interopRequireDefault(_userPaymentDetails);
	
	var _userClientDetails = __webpack_require__(528);
	
	var _userClientDetails2 = _interopRequireDefault(_userClientDetails);
	
	var _userProviderDetails = __webpack_require__(533);
	
	var _userProviderDetails2 = _interopRequireDefault(_userProviderDetails);
	
	var _userProfileCompleteness = __webpack_require__(538);
	
	var _userProfileCompleteness2 = _interopRequireDefault(_userProfileCompleteness);
	
	var _userRatings = __webpack_require__(543);
	
	var _userRatings2 = _interopRequireDefault(_userRatings);
	
	var _userTimesheets = __webpack_require__(548);
	
	var _userTimesheets2 = _interopRequireDefault(_userTimesheets);
	
	var _userWalletTransactions = __webpack_require__(596);
	
	var _userWalletTransactions2 = _interopRequireDefault(_userWalletTransactions);
	
	var _userChildren = __webpack_require__(601);
	
	var _userChildren2 = _interopRequireDefault(_userChildren);
	
	var _userVouches = __webpack_require__(606);
	
	var _userVouches2 = _interopRequireDefault(_userVouches);
	
	var _userExternalAccounts = __webpack_require__(611);
	
	var _userExternalAccounts2 = _interopRequireDefault(_userExternalAccounts);
	
	var _userGuardians = __webpack_require__(616);
	
	var _userGuardians2 = _interopRequireDefault(_userGuardians);
	
	var _userJobPreferences = __webpack_require__(621);
	
	var _userJobPreferences2 = _interopRequireDefault(_userJobPreferences);
	
	var _userCertificates = __webpack_require__(626);
	
	var _userCertificates2 = _interopRequireDefault(_userCertificates);
	
	var _mediaFilter = __webpack_require__(631);
	
	var _mediaFilter2 = _interopRequireDefault(_mediaFilter);
	
	var _surveyFilter = __webpack_require__(636);
	
	var _surveyFilter2 = _interopRequireDefault(_surveyFilter);
	
	var _certificatesFilter = __webpack_require__(641);
	
	var _certificatesFilter2 = _interopRequireDefault(_certificatesFilter);
	
	var _checksFilter = __webpack_require__(646);
	
	var _checksFilter2 = _interopRequireDefault(_checksFilter);
	
	var _jobsFilter = __webpack_require__(651);
	
	var _jobsFilter2 = _interopRequireDefault(_jobsFilter);
	
	var _jobRequestsFilter = __webpack_require__(656);
	
	var _jobRequestsFilter2 = _interopRequireDefault(_jobRequestsFilter);
	
	var _affiliatesFilter = __webpack_require__(661);
	
	var _affiliatesFilter2 = _interopRequireDefault(_affiliatesFilter);
	
	var _vouchesFilter = __webpack_require__(666);
	
	var _vouchesFilter2 = _interopRequireDefault(_vouchesFilter);
	
	var _userMessages = __webpack_require__(671);
	
	var _userMessages2 = _interopRequireDefault(_userMessages);
	
	var _botManagerFilter = __webpack_require__(676);
	
	var _botManagerFilter2 = _interopRequireDefault(_botManagerFilter);
	
	var _userPayAgreements = __webpack_require__(681);
	
	var _userPayAgreements2 = _interopRequireDefault(_userPayAgreements);
	
	var _botSessionsFilter = __webpack_require__(686);
	
	var _botSessionsFilter2 = _interopRequireDefault(_botSessionsFilter);
	
	var _businessesFilter = __webpack_require__(691);
	
	var _businessesFilter2 = _interopRequireDefault(_businessesFilter);
	
	var _postJob = __webpack_require__(696);
	
	var _postJob2 = _interopRequireDefault(_postJob);
	
	var _userInvoices = __webpack_require__(701);
	
	var _userInvoices2 = _interopRequireDefault(_userInvoices);
	
	var _userJobEdit = __webpack_require__(706);
	
	var _userJobEdit2 = _interopRequireDefault(_userJobEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommonComponents = _angular2.default.module('app.common.components', []).component('navbar', _navbar2.default).component('leftnav', _leftnav2.default).component('usersFilter', _usersFilter2.default).component('profilesFilter', _profilesFilter2.default).component('userBasicDetails', _userBasicDetails2.default).component('userAddressDetails', _userAddressDetails2.default).component('userPaymentDetails', _userPaymentDetails2.default).component('userClientDetails', _userClientDetails2.default).component('userProviderDetails', _userProviderDetails2.default).component('userProfileCompleteness', _userProfileCompleteness2.default).component('userRatings', _userRatings2.default).component('userTimesheets', _userTimesheets2.default).component('userWalletTransactions', _userWalletTransactions2.default).component('userChildren', _userChildren2.default).component('userVouches', _userVouches2.default).component('userExternalAccounts', _userExternalAccounts2.default).component('userGuardians', _userGuardians2.default).component('userJobPreferences', _userJobPreferences2.default).component('userCertificates', _userCertificates2.default).component('mediaFilter', _mediaFilter2.default).component('surveyFilter', _surveyFilter2.default).component('certificatesFilter', _certificatesFilter2.default).component('checksFilter', _checksFilter2.default).component('jobsFilter', _jobsFilter2.default).component('jobRequestsFilter', _jobRequestsFilter2.default).component('affiliatesFilter', _affiliatesFilter2.default).component('vouchesFilter', _vouchesFilter2.default).component('userMessages', _userMessages2.default).component('botManagerFilter', _botManagerFilter2.default).component('botSessionsFilter', _botSessionsFilter2.default).component('businessesFilter', _businessesFilter2.default).component('postJob', _postJob2.default).component('userInvoices', _userInvoices2.default).component('userPayAgreements', _userPayAgreements2.default).component('userJobEdit', _userJobEdit2.default);
	
	exports.default = CommonComponents;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(342);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(343);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	  restrict: 'E',
	  bindings: {
	    hideGlobalFilters: '<',
	    globalFilterOptions: '<'
	  },
	  template: _navbar2.default,
	  controller: _navbar4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = navbarComponent;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<nav class=\"top-navbar\">\r\n  <div class=\"navbar-inner-container\">\r\n    <div class=\"full-logo\">\r\n      <img src=\"/images/js-new-logo-full-white.png\" />\r\n    </div>\r\n    <div class=\"global-filters\">\r\n        <a ng-repeat=\"filter in vm.globalFilterOptions\" ng-click=\"vm.applyGlobalFilter(filter)\"\r\n            class=\"filter-item\" ng-class=\"{'active-filter': filter.isActive}\">\r\n            <span class=\"fa fa-users\"></span>\r\n            {{filter.label}}\r\n          </a>\r\n    </div>\r\n    <div class=\"rightbar\">\r\n      <div class=\"location-filter\">\r\n        <select class=\"k-input\" ng-model=\"vm.activeLocation\">\r\n          <option value=\"\">All Countries</option>\r\n          <option value=\"au\">Australia</option>\r\n          <option value=\"nz\">New Zealand</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"app-context\"\r\n          ng-if=\"vm.appContext\"\r\n          ng-mouseenter=\"vm.displayOverlay = true\"\r\n          ng-mouseleave=\"vm.displayOverlay = false\">\r\n        <!-- <img ng-show=\"vm.appContext.defaultImage.scale1ImageUrl\" ng-src=\"{{vm.appContext.defaultImage.scale1ImageUrl}}\" alt=\"profile-image\"> -->\r\n        <a>{{vm.appContext.userName}}</a>\r\n      </div>\r\n      <div ng-click=\"vm.logout()\">\r\n        <a href=\"#\" style=\"color: white; margin: 0 10px\">Logout</a>\r\n      </div>\r\n      <!-- <div class=\"overlay-container\"\r\n          ng-show=\"vm.displayOverlay\"\r\n          ng-mouseenter=\"vm.displayOverlay = true\"\r\n          ng-mouseleave=\"vm.displayOverlay = false\"\r\n          ng-click=\"vm.logout()\">\r\n        <a>Logout</a>\r\n      </div> -->\r\n    </div>\r\n  </div>\r\n</nav>\r\n"

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function () {
	  NavbarController.$inject = ["$scope", "AuthService", "AppContextService", "FilterService", "EventsService", "NavigationService"];
	  function NavbarController($scope, AuthService, AppContextService, FilterService, EventsService, NavigationService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, NavbarController);
	    this.authService = AuthService;
	    this.appContextService = AppContextService;
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	    this.navigationService = NavigationService;
	
	    $scope.$watch("vm.activeLocation", this.onLocationChange.bind(this), true);
	  }
	
	  (0, _createClass3.default)(NavbarController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.appContext = this.appContextService.getAppContext();
	      this.activeLocation = this.appContextService.getActiveLocation();
	
	      this.eventsService.listen(_constants2.default.events.AUTHORIZATION_SUCCESS, function () {
	        _this.appContext = _this.appContextService.getAppContext();
	        console.log("AUTHORIZATION_SUCCESS Event listener called", _this.appContext);
	      });
	    }
	  }, {
	    key: "onLocationChange",
	    value: function onLocationChange(value) {
	      this.appContextService.setActiveLocation(value);
	    }
	  }, {
	    key: "logout",
	    value: function logout() {
	      this.authService.logout();
	      this.appContextService.clearAppContext();
	    }
	  }, {
	    key: "applyGlobalFilter",
	    value: function applyGlobalFilter(filter) {
	
	      for (var i = 0; i < this.globalFilterOptions.length; i++) {
	        if (this.globalFilterOptions[i] == filter) this.globalFilterOptions[i].isActive = true;else this.globalFilterOptions[i].isActive = false;
	      }
	
	      this.eventsService.broadcast(_constants2.default.events.GLOBAL_FILTER_APPLIED, filter);
	    }
	  }]);
	  return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ },
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(366);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var c = function () {
	    var _ref;
	
	    return _ref = {
	        entityType: {
	            "CLIENT": 1,
	            "PROVIDER": 2
	        },
	        deviceType: {
	            "DESKTOP": 1,
	            "MOBILE": 2,
	            "BOT": 3,
	            "MOBILEAPP": 4
	        },
	        notificationOutcome: {
	            QUEUED: 0,
	            PROCESSING: 2,
	            COMPLETED: 3,
	            ABANDONED: 4,
	            UNKNOWN: 5,
	            NOTARGETFOUND: 6,
	            CANCELLED: 7
	        },
	        profileItems: {
	            BASIC_INFO: 1,
	            CLIENT_PHOTO: 2,
	            TRUST_VERIFICATION: 4,
	            CLIENT_ABOUT_ME: 8,
	            // MY_CHILDREN: 16,
	            MY_HOME: 32,
	            // MY_BABYSITTING_EXPERIENCE: 64,
	            PROVIDER_ABOUT_ME: 128,
	            PROVIDER_PHOTO: 256,
	            PROVIDER_JOB_CATEGORIES: 512,
	            PROVIDER_PROFILE_VISIBILITY: 1024,
	            PROVIDER_CERTIFICATES: 2048,
	            PROVIDER_GUARDIAN: 4096,
	            CITIZENSHIP: 8192
	        },
	        globalUsersFilterTypes: {
	            ALL_USERS: 1,
	            PAYG_USERS: 2,
	            ALL_PAYING_USERS: 3,
	            NSW_CUSTOMERS: 4,
	            VIC_CUSTOMERS: 5
	        },
	        globalBusinessesFilterTypes: {
	            ALL_BUSINESSS: 1,
	            NSW_BUSINESSES: 2,
	            VIC_BUSINESSES: 3
	        },
	        globalProfilesFilterTypes: {
	            ALL_PROFILES: 1
	        },
	        globalJobsFilterTypes: {
	            ALL_JOBS: 1,
	            JOBS_POSTED_TODAY: 2,
	            JOBS_EXPIRE_TODAY: 3,
	            RECURRING_JOB_POSTED_15_DAYS_AGO: 4
	        },
	        globalJobRequestsFilterTypes: {
	            ALL_JOB_REQUESTS: 1
	        },
	        globalAffiliatesFilterTypes: {
	            ALL_AFFILIATES: 1,
	            EMPLOYEE_BENEFITS: 2,
	            REFERRALS: 3
	        },
	        globalVouchesFilterTypes: {
	            ALL_VOUCHES: 1
	        },
	        globalBotManagerFilterTypes: {
	            ALL_BOT_FLOWS: 1
	        },
	        globalBotSessionsFilterTypes: {
	            ALL_BOT_SESSIONS: 1
	        },
	        globalCertificatesFilterTypes: {
	            ALL_CERTIFICATES: 1,
	            PENDING_VERIFICATION: 2
	        },
	        globalChecksFilterTypes: {
	            ALL_CHECKS: 1
	        },
	        events: {
	            GLOBAL_FILTER_APPLIED: "GLOBAL_FILTER_APPLIED",
	            AUTHORIZATION_SUCCESS: "AUTHORIZATION_SUCCESS",
	            VERIFICATION_CODE_RECEIEVED: "VERIFICATION_CODE_RECEIEVED"
	        },
	        membershipType: {
	            free: 0,
	            subscription: 1,
	            payg: 2,
	            corporateAgreement: 3
	        },
	        userPaymentType: {
	            NONE: 0,
	            MONTHLY_STANDARD_SUBSCRIPTION: 1,
	            ANNUAL_FOUNDING_MEMBER: 2,
	            ANNUAL_STANDARD_SUBSCRIPTION: 3,
	            QUARTERLY_STANDARD_SUBSCRIPTION: 4,
	            ONE_OFF_PAYG: 5,
	            SINGLE_ONE_OFF_JOB: 1001,
	            SINGLE_RECURRING_JOB: 1002,
	            ANNUAL_UNLIMITED_PAY_AS_YOU_GO: 1003,
	            SIX_MONTHS_UNLIMITED_PAY_AS_YOU_GO: 1004,
	            EXTEND_RECURRING_JOB: 1005,
	            QUARTERLY_STANDARD_SUBSCRIPTION_60: 11,
	            ANNUAL_STANDARD_SUBSCRIPTION_120: 12,
	            ANNUAL_STANDARD_SUBSCRIPTION_180: 13,
	            QUARTERLY_STANDARD_SUBSCRIPTION_75: 14,
	            QUARTERLY_STANDARD_SUBSCRIPTION_90: 2015,
	            ANNUAL_STANDARD_SUBSCRIPTION_150: 15,
	            SINGLE_AU_PAIR_JOB: 1006,
	            SINGLE_PRIMARY_SCHOOL_TUTORING_JOB: 1008,
	            SINGLE_HIGH_SCHOOL_TUTORING_JOB: 1009,
	            ANNUAL_BABYSITTING_SUBSCRIPTION60: 2001,
	            ANNUAL_BABYSITTING_SUBSCRIPTION120: 2013,
	            MONTHLY_BABYSITTING_SUBSCRIPTION40: 2014,
	            ANNUAL_CHILDCARE_SUBSCRIPTION120: 2002,
	            ANNUAL_TUTORING_SUBSCRIPTION90: 2003,
	            ANNUAL_AU_PAIR_SUBSCRIPTION195: 2004,
	            ANNUAL_PRIMARY_SCHOOL_TUTORING_SUBSCRIPTION120: 2005,
	            ANNUAL_TUTORING_SUBSCRIPTION195: 2006,
	            ANNUAL_HIGH_SCHOOL_TUTORING_SUBSCRIPTION195: 2007,
	            ANNUAL_TUTORING_SUBSCRIPTION245: 2008,
	            ANNUAL_HELPER_SUBSCRIPTION24: 3001,
	            MONTHLY_HELPER_STANDARD_SUBSCRIPTION5: 3002,
	            ANNUAL_HELPER_SUBSCRIPTION30: 3003,
	            QUARTERLY_HELPER_SUBSCRIPTION15: 3004,
	            ANNUAL_TUTORING_SUBSCRIPTION180: 2009,
	            ANNUAL_FAMILY_CARE_SUBSCRIPTION240: 2010,
	            ANNUAL_STANDARD_SUBSCRIPTION360: 2011,
	            ANNUAL_CHILDCARE_SUBSCRIPTION180: 2012,
	            QUARTERLY_BUSINESS_TIER1_SUBSCRIPTION_500: 4001,
	            QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_500: 4002,
	            ANNUAL_BUSINESS_TIER1_SUBSCRIPTION_1500: 4003,
	            ANNUAL_BUSINESS_TIER2_SUBSCRIPTION_1500: 4004,
	            ANNUAL_HELPER_SUBSCRIPTION40: 3005,
	            QUARTERLY_HELPER_SUBSCRIPTION20: 3006,
	            QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_750: 4005,
	            MONTHLY_CHILDCARE_SUBSCRIPTION90: 2016,
	            ANNUAL_COMPLETE_FAMILY_CARE_SUBSCRIPTION120: 16,
	            THREE_MONTHS_HELPER_STANDARD_SUBSCRIPTION25: 3007,
	            ANNUAL_HELPER_STANDARD_SUBSCRIPTION50: 3008,
	            MONTHLY_CHILDCARE_SUBSCRIPTION60: 2018
	        },
	        walletTransactionReason: {
	            ACCOUNT_CREATED: 1,
	            JOB_POSTED: 2,
	            JOB_CANCELLED: 3,
	            ADMIN_ACTION: 4,
	            SINGLE_ONE_OFF_JOB_PURCHASE: 5,
	            SINGLE_RECURRING_JOB_PURCHASE: 6,
	            WALLET_PAYMENT: 7,
	            JOB_CANCELLED_BY_HELPER: 8,
	            SPECIAL_OFFER: 11
	        },
	        walletTransactionType: {
	            ADD: 1,
	            DEDUCT: 2,
	            REFUND: 3
	        },
	        walletTransactionOwner: {
	            UNSPECIFIED: 0,
	            USER: 1,
	            SYSTEM: 20,
	            ADMIN: 30
	        },
	        walletTransactionPaymentType: {
	            UNSPECIFIED: 0,
	            FREE: 1,
	            PAID: 2
	        },
	        gender: {
	            UNSPECIFIED: 0,
	            MALE: 1,
	            FEMALE: 2
	        },
	        accountStatus: {
	            PENDING: 1,
	            APPROVED: 2,
	            PENDING_APPROVAL: 4
	        },
	        vouchStatus: {
	            PENDING: 1,
	            APPROVED: 2,
	            CANCELLED: 3,
	            EXPIRED: 4,
	            NONE: 0
	        },
	        externalAccountType: {
	            FACEBOOK: 1,
	            LINKEDIN: 2
	        },
	        guardianRelation: {
	            FATHER: 1,
	            MOTHER: 2,
	            LEGALGUARDIAN: 3
	        },
	        guardianStatus: {
	            PENDING: 1,
	            APPROVED: 2,
	            CANCELLED: 3,
	            NONE: 4
	        },
	        certificateCategory: {
	            CHECK: 1,
	            QUALIFICATION: 2,
	            FIRSTAID: 3
	        },
	        certificateStatus: {
	            PENDINGVERIFICATION: 1,
	            ACTIVE: 2,
	            INVALID: 3,
	            EXPIRED: 4
	        },
	        affiliateType: {
	            CREDIT: 1,
	            SUBSCRIPTION: 2
	        },
	        jugglerType: {
	            PARENT: 1,
	            HELPER: 2
	        },
	        visaCheckStatus: {
	            PENDINGVERIFICATION: 1,
	            APPROVED: 2,
	            INVALID: 3,
	            EXPIRED: 4
	        },
	        locationStatus: {
	            UNSPECIFIED: 0,
	            NEWLEAD: 1,
	            PURCHASEDLEAD: 2,
	            CONTACTEDLEAD: 3,
	            FOLLOWEDUP: 4,
	            ARCHIVED: 5,
	            INPROGRESS: 6
	        },
	        locationType: {
	            UNSPECIFIED: 0,
	            SCHOOL: 1,
	            CENTRE_BASED_DAYCARE: 2,
	            FAMILY_DAYCARE: 3,
	            INHOME_CARE: 4,
	            OUTSIDE_SCHOOL_HOURS_CARE: 5
	        },
	        getLocationTypeText: function getLocationTypeText(type) {
	            switch (type) {
	                case c.locationType.UNSPECIFIED:
	                    return "Unspecified";
	                case c.locationType.SCHOOL:
	                    return "School";
	                case c.locationType.CENTRE_BASED_DAYCARE:
	                    return "Centre Day Care";
	                case c.locationType.FAMILY_DAYCARE:
	                    return "Family Day Care";
	                case c.locationType.INHOME_CARE:
	                    return "In-Home Care";
	                case c.locationType.OUTSIDE_SCHOOL_HOURS_CARE:
	                    return "OOSH";
	            }
	        }
	    }, (0, _defineProperty3.default)(_ref, "locationStatus", {
	        UNSPECIFIED: 0,
	        NEW_LEAD: 1,
	        EDM_SENT: 2,
	        CALLS_COMMENCED: 3,
	        CONTACT_MADE: 4,
	        NOT_INTERESTED: 5,
	        INTERESTED_IN_PROGRESS: 6,
	        ACQUIRED: 7,
	        EDM_READY: 8,
	        EDM_OPENED: 9,
	        EDM_CLICKED: 10,
	        EDM_REJECTED: 11
	    }), (0, _defineProperty3.default)(_ref, "getLocationStatusText", function getLocationStatusText(locationStatus) {
	        switch (locationStatus) {
	            case c.locationStatus.UNSPECIFIED:
	                return 'Unspecified';
	            case c.locationStatus.NEW_LEAD:
	                return 'New Lead';
	            case c.locationStatus.EDM_SENT:
	                return 'EDM Sent';
	            case c.locationStatus.EDM_READY:
	                return 'EDM Ready';
	            case c.locationStatus.EDM_OPENED:
	                return 'EDM Opened';
	            case c.locationStatus.EDM_CLICKED:
	                return 'EDM Clicked';
	            case c.locationStatus.EDM_REJECTED:
	                return 'EDM Rejected';
	            case c.locationStatus.CALLS_COMMENCED:
	                return 'Calls Commenced';
	            case c.locationStatus.CONTACT_MADE:
	                return 'Contact Made';
	            case c.locationStatus.NOT_INTERESTED:
	                return 'Not Interested';
	            case c.locationStatus.INTERESTED_IN_PROGRESS:
	                return 'Interested - In-Progress';
	            case c.locationStatus.ACQUIRED:
	                return 'Acquired';
	            default:
	                return 'Unknown';
	        }
	    }), (0, _defineProperty3.default)(_ref, "vouchReferenceType", {
	        FAMILY: 1,
	        CHILDCAREEMPLOYMENT: 2,
	        NONCHILDCAREEMPLOYMENT: 3,
	        OTHER: 4,
	        JUGGLESTREET: 5,
	        UNSPECIFIED: 0,
	        REFERENCES: 6
	    }), (0, _defineProperty3.default)(_ref, "certificateType", {
	        WWCC: 1
	    }), (0, _defineProperty3.default)(_ref, "mediaReviewStatuts", {
	        UNSPECIFIED: 0,
	        PENDING: 1,
	        APPROVED: 2,
	        REJECTED: 3
	    }), (0, _defineProperty3.default)(_ref, "surveyResponse", {
	        YES: 1,
	        NO: 2,
	        NA: 3
	    }), (0, _defineProperty3.default)(_ref, "profileReviewStatus", {
	        APPROVED: 0,
	        REQUIRED: 1,
	        IN_PROGRESS: 2
	    }), (0, _defineProperty3.default)(_ref, "jobType", {
	        BABYSITTING: 1,
	        NANNYING: 2,
	        BEFORE_SCHOOL_CARE: 4,
	        AFTER_SCHOOL_CARE: 8,
	        BEFORE_AFTER_SCHOOL_CARE: 12,
	        RECURRING_JOB: 14,
	        AU_PAIR: 16,
	        PRIMARY_SCHOOL_TUTORING: 64,
	        HIGH_SCHOOL_TUTORING: 128,
	        ONE_OFF_ODD_JOBS: 256,
	        JUNIOR_HIGH_SCHOOL_TUTORING: 512,
	        SENIOR_HIGH_SCHOOL_TUTORING: 1024
	    }), (0, _defineProperty3.default)(_ref, "botFlowStatus", {
	        INACTIVE: 0,
	        TEST: 1,
	        LIVE: 2
	    }), (0, _defineProperty3.default)(_ref, "jobStatus", {
	        PENDING: 1,
	        AWARDED: 2,
	        CANCELLED: 3,
	        COMPLETED: 4,
	        FILLED: 5,
	        FILLED_AND_CANCELLED: 6
	    }), (0, _defineProperty3.default)(_ref, "jobRequestStatus", {
	        NEW_REQUEST: 1,
	        CALL_SCHEDULED: 2,
	        JOB_POSTED: 3,
	        JOB_TRANSFERRED: 4,
	        JOB_AWARDED: 5
	    }), (0, _defineProperty3.default)(_ref, "managedBy", {
	        USER: 1,
	        SYSTEM: 20
	    }), (0, _defineProperty3.default)(_ref, "screens", {
	        ANALYTICS: "analytics",
	        USERS: "users",
	        JOBS: "jobs",
	        JOB_REQUESTS: "jobRequests",
	        CERTIFICATES: "certificates",
	        CHECKS: "checks",
	        AFFILIATES: "affiliates",
	        MEDIA: "media",
	        SURVEY: "survey",
	        BOT_MANAGER: "botManager",
	        BOT_FLOW: "botFlow",
	        BOT_SESSIONS: "botSessions",
	        VOUCHES: "vouches",
	        BUSINESSES: "businesses"
	    }), (0, _defineProperty3.default)(_ref, "flowDiagrams", {
	        SMS_CHANNEL: 1,
	        FACEBOOK_CHANNEL: 2,
	        LOCATE_HELPERS_IN_AREA_FLOW: 3,
	        POST_JOB_FLOW: 4,
	        DISPLAY_PROFILE_FLOW: 5,
	        BABYSITTING_JOB: 6,
	        RECURRING_JOB: 7
	    }), (0, _defineProperty3.default)(_ref, "adminEntitiesActionType", {
	        UPDATE_ACCOUNT_INFO: 1,
	        CREDIT_ACCOUNT_BALANCE: 2,
	        REFRESH_CACHE: 3
	    }), _ref;
	}();
	
	exports.default = c;

/***/ },
/* 366 */,
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(368);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./navbar.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./navbar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.top-navbar{height:3rem;background-color:#299c4a;display:flex;z-index:4000;align-items:center;position:relative}.top-navbar .navbar-inner-container{width:100%}.top-navbar .navbar-inner-container .full-logo{display:flex;align-items:center;float:left;margin-left:5rem;height:3rem}.top-navbar .navbar-inner-container .full-logo img{width:110px;vertical-align:middle}.top-navbar .navbar-inner-container .global-filters{float:left;height:3rem;display:flex;align-items:center;margin-left:.5rem}.top-navbar .navbar-inner-container .global-filters .filter-item{padding:.4rem .7rem;margin:0 .5rem;color:#f4f4f4;cursor:pointer}.top-navbar .navbar-inner-container .global-filters .active-filter{background:#ffa63d;color:#212121;border-radius:.5rem}.top-navbar .navbar-inner-container .logo{margin-left:.5rem}.top-navbar .navbar-inner-container .logo a{text-decoration:initial;color:#fff}.top-navbar .navbar-inner-container .rightbar{float:right;display:flex;padding:.5rem;margin-top:5px}.top-navbar .navbar-inner-container .rightbar .location-filter{margin:0 25px;display:none}.top-navbar .navbar-inner-container .rightbar .app-context{display:flex;align-items:center;justify-content:center;text-align:center;cursor:pointer}.top-navbar .navbar-inner-container .rightbar .app-context:hover{background:#9fc45c}.top-navbar .navbar-inner-container .rightbar .app-context a{color:#fff}.top-navbar .navbar-inner-container .rightbar .app-context img{height:2rem;margin-right:.5rem}.top-navbar .navbar-inner-container .rightbar .overlay-container{background:#f5f5f5;position:absolute;top:3rem;right:0;width:9rem;height:2rem;border:1px solid #bbb;border-top:none;border-right:none;display:flex;align-items:center;padding-left:.5rem;cursor:pointer}", ""]);
	
	// exports


/***/ },
/* 369 */,
/* 370 */,
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leftnav = __webpack_require__(372);
	
	var _leftnav2 = _interopRequireDefault(_leftnav);
	
	var _leftnav3 = __webpack_require__(373);
	
	var _leftnav4 = _interopRequireDefault(_leftnav3);
	
	__webpack_require__(374);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leftNavComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _leftnav2.default,
	  controller: _leftnav4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = leftNavComponent;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<nav class=\"left-nav\" ng-show=\"vm.displayAdminNav\">\r\n  <div class=\"logo-container\">\r\n    <img src=\"/images/icons/js-logo.png\" alt=\"jugglestreet-logo\">\r\n  </div>\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"users\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('users') }\">\r\n      <span class=\"fa fa-users left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Users</span>\r\n    </a>\r\n  </div>\r\n\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"jobs\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('jobs') }\">\r\n      <span class=\"fa fa-briefcase left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Jobs</span>\r\n    </a>\r\n  </div>\r\n\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"jobRequests\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('jobRequests') }\">\r\n      <span class=\"fa fa-taxi left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Concierge</span>\r\n    </a>\r\n  </div>\r\n\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"businesses\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('businesses') }\">\r\n      <span class=\"fa fa-building left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Pipeline</span>\r\n    </a>\r\n  </div>\r\n\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"affiliates\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('affiliates') }\">\r\n      <span class=\"fa fa-map-marker left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Benefits</span>\r\n    </a>\r\n  </div>\r\n\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"profiles\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('profiles') }\">\r\n      <span class=\"fa fa-bookmark left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Profiles</span>\r\n    </a>\r\n  </div>\r\n\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"certificates\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('certificates') }\">\r\n      <span class=\"fa fa-graduation-cap left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Certificates</span>\r\n    </a>\r\n  </div>\r\n\r\n  <!-- <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"checks\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('checks') }\">\r\n      <span class=\"fa fa-globe left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Checks</span>\r\n    </a>\r\n  </div> -->\r\n\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"vouches\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('vouches') }\">\r\n      <span class=\"fa fa-user-plus left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Vouches</span>\r\n    </a>\r\n  </div>\r\n\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"media\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('media') }\">\r\n      <span class=\"fa fa-play-circle-o left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Media</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"survey\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('survey') }\">\r\n      <span class=\"fa fa-line-chart left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Survey</span>\r\n    </a>\r\n  </div>\r\n  <!--<div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"flow\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('flow') }\">\r\n      <span class=\"fa fa-line-chart left-nav-icon\"></span>\r\n      <span class=\"icon-text\">FLOW</span>\r\n    </a>\r\n  </div>-->\r\n  <!-- <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"botManager\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('botManager') }\">\r\n      <span class=\"fa fa-gears left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Bot Manager</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\" ng-hide=\"vm.hasOnlyReadAccess\">\r\n    <a ui-sref=\"botSessions\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('botSessions') }\">\r\n      <span class=\"fa fa-eye left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Bot Sessions</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\" ng-show=\"vm.hasGlobalAdminAccess\">\r\n    <a ui-sref=\"botFlow\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('botFlow') }\">\r\n      <span class=\"fa fa-android left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Bot Flow</span>\r\n    </a>\r\n  </div> -->\r\n</nav>\r\n<nav class=\"left-nav\" ng-show=\"vm.displayAnalyticsNav\">\r\n  <div class=\"logo-container\">\r\n    <img src=\"/images/icons/js-logo.png\" alt=\"jugglestreet-logo\">\r\n  </div>\r\n  <div class=\"left-nav-item\" style=\"display: none\">\r\n    <a ui-sref=\"analytics\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('analytics') }\">\r\n      <span class=\"fa fa-dashboard left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Dashboard</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\">\r\n    <a ui-sref=\"analyticsUsers\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('analyticsUsers') }\">\r\n      <span class=\"fa fa-users left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Acquisition</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\">\r\n    <a ui-sref=\"analyticsRevenue\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('analyticsRevenue') }\">\r\n      <span class=\"fa fa-shopping-cart left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Revenue</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\">\r\n    <a ui-sref=\"analyticsMarketing\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('analyticsMarketing') }\">\r\n      <span class=\"fa fa-dashboard left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Marketing</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\" style=\"display: none\">\r\n    <a ui-sref=\"analyticsBot\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('analyticsTraffic') }\">\r\n      <span class=\"fa fa-android left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Bot</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\">\r\n    <a ui-sref=\"analyticsData\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('analyticsData') }\">\r\n      <span class=\"fa fa-table left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Data</span>\r\n    </a>\r\n  </div>\r\n  <div class=\"left-nav-item\" style=\"display: none\">\r\n    <a ui-sref=\"analyticsTraffic\" ng-class=\"{'left-nav-icon-highlight': vm.isCurrentPage('analyticsTraffic') }\">\r\n      <span class=\"fa fa-google left-nav-icon\"></span>\r\n      <span class=\"icon-text\">Traffic</span>\r\n    </a>\r\n  </div>\r\n</nav>\r\n"

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeftnavController = function () {
	  LeftnavController.$inject = ["NavigationService", "AppContextService", "EventsService"];
	  function LeftnavController(NavigationService, AppContextService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, LeftnavController);
	    this.navigationService = NavigationService;
	    this.appContextService = AppContextService;
	    this.eventsService = EventsService;
	    this.displayAdminNav = false;
	    this.displayAnalyticsNav = false;
	  }
	
	  (0, _createClass3.default)(LeftnavController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.appContext = this.appContextService.getAppContext();
	
	      this.eventsService.listen(_constants2.default.events.AUTHORIZATION_SUCCESS, function () {
	        _this.appContext = _this.appContextService.getAppContext();
	        _this.setLeftNavVisibility(_this.appContext);
	        console.log("AUTHORIZATION_SUCCESS Event listener called", _this.appContext);
	      });
	    }
	  }, {
	    key: "setLeftNavVisibility",
	    value: function setLeftNavVisibility(appContext) {
	      if (this.appContextService.isAdmin()) this.displayAdminNav = true;
	      if (this.appContextService.isAnalytics()) this.displayAnalyticsNav = true;
	
	      if (appContext && appContext.roles) {
	
	        // Check if user has ONLY read access (no admin or global admin)
	        if (this.appContextService.hasReadAccess(appContext.roles) && !appContext.roles.includes('Admin') && !appContext.roles.includes('GlobalAdmin')) this.hasOnlyReadAccess = true;else this.hasOnlyReadAccess = false;
	
	        if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) this.hasGlobalAdminAccess = true;else this.hasGlobalAdminAccess = false;
	      }
	    }
	  }, {
	    key: "isCurrentPage",
	    value: function isCurrentPage(page) {
	      return this.navigationService.isCurrent(page);
	    }
	  }]);
	  return LeftnavController;
	}();
	
	exports.default = LeftnavController;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(375);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./leftnav.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./leftnav.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.left-nav{height:100vh;width:4rem;position:fixed;left:0;top:0;background:#1c1c1c;z-index:5000}.left-nav .logo-container{height:3rem;background:#1c1c1c;display:flex;align-items:center;justify-content:center}.left-nav .logo-container img{width:2.5rem}.left-nav .left-nav-item{height:3.5rem;cursor:pointer}.left-nav .left-nav-item,.left-nav .left-nav-item a{display:flex;align-items:center;justify-content:center}.left-nav .left-nav-item a{flex-direction:column;text-decoration:initial;color:#bababa}.left-nav .left-nav-item a .left-nav-icon{font-size:1.5rem}.left-nav .left-nav-item a .icon-text{font-size:.6rem;margin-top:.3rem}.left-nav .left-nav-item .left-nav-icon-highlight{color:#fff}", ""]);
	
	// exports


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usersFilter = __webpack_require__(377);
	
	var _usersFilter2 = _interopRequireDefault(_usersFilter);
	
	var _usersFilter3 = __webpack_require__(378);
	
	var _usersFilter4 = _interopRequireDefault(_usersFilter3);
	
	__webpack_require__(379);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _usersFilter2.default,
	  controller: _usersFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = usersFilterComponent;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">USER DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n    \r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\"> \r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n    \r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n      \r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label> \r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\" ng-hide=\"filterItem.hideValueField\">\r\n      </div>\r\n      \r\n      <select class=\"k-input\" \r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\" \r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n      \r\n      <div class=\"filter-item\" ng-if=\"filter.filterType == 3\">\r\n        <label>{{filterItem.label}}</label>\r\n        <input kendo-date-picker k-ng-model=\"filter.value\">\r\n      </div>\r\n      \r\n    </div>\r\n    \r\n  </div>  \r\n</div>\r\n"

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersFilterController = function () {
	  UsersFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function UsersFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UsersFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(UsersFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getUsersFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      // Apply filters only if filter options are changed
	      var isFilterOptionsChanged = false;
	
	      for (var i = 0; i < newval.length; i++) {
	        if (newval[i].isActive != oldval[i].isActive) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	
	        if (newval[i].filterItemSelected != oldval[i].filterItemSelected) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	
	        if (newval[i].value != oldval[i].value) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	      }
	
	      if (!isFilterOptionsChanged) return;
	
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return UsersFilterController;
	}();
	
	exports.default = UsersFilterController;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(380);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./users-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./users-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.filter-container{font-size:.8rem;margin-top:2rem}.filter-container .header{font-weight:700;margin-left:.5rem;margin-bottom:1rem}.filter-container .filter-type-container{margin:.5rem}.filter-container .filter-type-container .filter-type .filter-icon{margin:0 .4rem}.filter-container .filter-type-container .filter-items-container{margin:.5rem;background:#f5f5f5;border-radius:.3rem;padding:.5rem;border:1px solid #d8d8d8;position:relative}.filter-container .filter-type-container .filter-items-container .close-icon{position:absolute;right:.2rem;top:.2rem;color:#898989;cursor:pointer}.filter-container .filter-type-container .filter-items-container .filter-item>label{display:inline-block;width:80%}.filter-container .filter-type-container .filter-items-container .filter-item{margin-bottom:.2rem}.filter-container .filter-type-container .filter-items-container .filter-item .filter-value-text-box{margin:.1rem 0 .3rem .9rem;width:10rem}", ""]);
	
	// exports


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _profilesFilter = __webpack_require__(382);
	
	var _profilesFilter2 = _interopRequireDefault(_profilesFilter);
	
	var _profilesFilter3 = __webpack_require__(383);
	
	var _profilesFilter4 = _interopRequireDefault(_profilesFilter3);
	
	__webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profilesFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _profilesFilter2.default,
	  controller: _profilesFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = profilesFilterComponent;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">PROFILES</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n\r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\">\r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n\r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n\r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label>\r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\" ng-hide=\"filterItem.hideValueField\">\r\n      </div>\r\n\r\n      <select class=\"k-input\"\r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\"\r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n\r\n      <div class=\"filter-item\" ng-if=\"filter.filterType == 3\">\r\n        <label>{{filterItem.label}}</label>\r\n        <input kendo-date-picker k-ng-model=\"filter.value\">\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilesFilterController = function () {
	  ProfilesFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function ProfilesFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ProfilesFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(ProfilesFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getProfilesFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      // Apply filters only if filter options are changed
	      var isFilterOptionsChanged = false;
	
	      for (var i = 0; i < newval.length; i++) {
	        if (newval[i].isActive != oldval[i].isActive) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	
	        if (newval[i].filterItemSelected != oldval[i].filterItemSelected) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	
	        if (newval[i].value != oldval[i].value) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	      }
	
	      if (!isFilterOptionsChanged) return;
	
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return ProfilesFilterController;
	}();
	
	exports.default = ProfilesFilterController;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(385);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./profiles-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./profiles-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.filter-container{font-size:.8rem;margin-top:2rem}.filter-container .header{font-weight:700;margin-left:.5rem;margin-bottom:1rem}.filter-container .filter-type-container{margin:.5rem}.filter-container .filter-type-container .filter-type .filter-icon{margin:0 .4rem}.filter-container .filter-type-container .filter-items-container{margin:.5rem;background:#f5f5f5;border-radius:.3rem;padding:.5rem;border:1px solid #d8d8d8;position:relative}.filter-container .filter-type-container .filter-items-container .close-icon{position:absolute;right:.2rem;top:.2rem;color:#898989;cursor:pointer}.filter-container .filter-type-container .filter-items-container .filter-item>label{display:inline-block;width:80%}.filter-container .filter-type-container .filter-items-container .filter-item{margin-bottom:.2rem}.filter-container .filter-type-container .filter-items-container .filter-item .filter-value-text-box{margin:.1rem 0 .3rem .9rem;width:10rem}", ""]);
	
	// exports


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userBasicDetails = __webpack_require__(387);
	
	var _userBasicDetails2 = _interopRequireDefault(_userBasicDetails);
	
	var _userBasicDetails3 = __webpack_require__(388);
	
	var _userBasicDetails4 = _interopRequireDefault(_userBasicDetails3);
	
	__webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userBasicDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    user: '='
	  },
	  template: _userBasicDetails2.default,
	  controller: _userBasicDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userBasicDetailsComponent;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-basic-details\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-user\"></span>\r\n      USER\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">User Id</h4>\r\n      <span class=\"item-text\">{{vm.user.userId}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        First Name\r\n        <span class=\"fa fa-pencil-square-o pointer-cursor\" ng-hide=\"vm.editMode.firstName.active\" ng-click=\"vm.enableEditMode('firstName')\"></span>\r\n      </h4>\r\n      <div class=\"edit-section\" ng-show=\"vm.editMode.firstName.active\">\r\n        <input class=\"k-input\" type=\"text\" ng-model=\"vm.user.firstName\" style=\"margin-bottom: 0.5rem\"><br>\r\n        <button class=\"k-button k-state-active\" ng-click=\"vm.saveDetails('firstName')\" ng-disabled=\"vm.editMode.firstName.isLoading\">Save</button>\r\n        <button class=\"k-button k-secondary-button\" ng-click=\"vm.disableEditMode('firstName')\" ng-disabled=\"vm.editMode.firstName.isLoading\">Cancel</button>\r\n        <i style=\"font-size: 1.5rem;\" ng-if=\"vm.editMode.firstName.isLoading\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n      </div>\r\n      <span class=\"item-text\" ng-hide=\"vm.editMode.firstName.active\">{{vm.user.firstName}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        Last Name\r\n        <span class=\"fa fa-pencil-square-o pointer-cursor\" ng-hide=\"vm.editMode.lastName.active\" ng-click=\"vm.enableEditMode('lastName')\"></span>\r\n      </h4>\r\n      <div class=\"edit-section\" ng-show=\"vm.editMode.lastName.active\">\r\n        <input class=\"k-input\" type=\"text\" ng-model=\"vm.user.lastName\" style=\"margin-bottom: 0.5rem\"><br>\r\n        <button class=\"k-button k-state-active\" ng-click=\"vm.saveDetails('lastName')\" ng-disabled=\"vm.editMode.lastName.isLoading\">Save</button>\r\n        <button class=\"k-button k-secondary-button\" ng-click=\"vm.disableEditMode('lastName')\" ng-disabled=\"vm.editMode.lastName.isLoading\">Cancel</button>\r\n        <i style=\"font-size: 1.5rem;\" ng-if=\"vm.editMode.lastName.isLoading\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n      </div>\r\n      <span class=\"item-text\" ng-hide=\"vm.editMode.lastName.active\">{{vm.user.lastName}}</span>\r\n    </div>\r\n    <!-- <div class=\"item\">\r\n      <h4 class=\"item-title\">Email</h4>\r\n      <span class=\"item-text\">{{vm.user.email}}</span>\r\n    </div> -->\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        Email\r\n        <span class=\"fa fa-pencil-square-o pointer-cursor\" ng-hide=\"vm.editMode.email.active\" ng-click=\"vm.enableEditMode('email')\"></span>\r\n      </h4>\r\n      <div class=\"edit-section\" ng-show=\"vm.editMode.email.active\">\r\n        <input class=\"k-input\" type=\"text\" ng-model=\"vm.user.email\" style=\"margin-bottom: 0.5rem; width: 300px\"><br>\r\n        <button class=\"k-button k-state-active\" ng-click=\"vm.saveDetails('email')\" ng-disabled=\"vm.editMode.email.isLoading\">Save</button>\r\n        <button class=\"k-button k-secondary-button\" ng-click=\"vm.disableEditMode('email')\" ng-disabled=\"vm.editMode.email.isLoading\">Cancel</button>\r\n        <i style=\"font-size: 1.5rem;\" ng-if=\"vm.editMode.email.isLoading\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n      </div>\r\n      <span class=\"item-text\" ng-hide=\"vm.editMode.email.active\">{{vm.user.email}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        Phone Number\r\n        <!-- <span class=\"fa fa-pencil-square-o pointer-cursor\" ng-hide=\"vm.editMode.phoneNumber.active\" ng-click=\"vm.enableEditMode('phoneNumber')\"></span> -->\r\n      </h4>\r\n      <div class=\"edit-section\" ng-show=\"vm.editMode.phoneNumber.active\">\r\n        <input class=\"k-input\" type=\"text\" ng-model=\"vm.user.phoneNumber\" style=\"margin-bottom: 0.5rem\"><br>\r\n        <button class=\"k-button k-state-active\" ng-click=\"vm.saveDetails('phoneNumber')\" ng-disabled=\"vm.editMode.phoneNumber.isLoading\">Save</button>\r\n        <button class=\"k-button k-secondary-button\" ng-click=\"vm.disableEditMode('phoneNumber')\" ng-disabled=\"vm.editMode.phoneNumber.isLoading\">Cancel</button>\r\n        <i style=\"font-size: 1.5rem;\" ng-if=\"vm.editMode.phoneNumber.isLoading\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n      </div>\r\n      <span class=\"item-text\" ng-hide=\"vm.editMode.phoneNumber.active\">{{vm.user.normalisedPhoneNumber}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        Date of Birth\r\n        <span class=\"fa fa-pencil-square-o pointer-cursor\" ng-hide=\"vm.editMode.dateOfBirth.active\" ng-click=\"vm.enableEditMode('dateOfBirth')\"></span>\r\n      </h4>\r\n      <div class=\"edit-section\" ng-show=\"vm.editMode.dateOfBirth.active\">\r\n        <input kendo-date-picker k-options=\"vm.datePickerOptions\" ng-model=\"vm.user.dateOfBirth\">\r\n        <div style=\"margin-top: 0.5rem;\">\r\n          <button class=\"k-button k-state-active\" ng-click=\"vm.saveDetails('dateOfBirth')\" ng-disabled=\"vm.editMode.dateOfBirth.isLoading\">Save</button>\r\n          <button class=\"k-button k-secondary-button\" ng-click=\"vm.disableEditMode('dateOfBirth')\" ng-disabled=\"vm.editMode.dateOfBirth.isLoading\">Cancel</button>\r\n          <i style=\"font-size: 1.5rem;\" ng-if=\"vm.editMode.dateOfBirth.isLoading\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n        </div>\r\n      </div>\r\n      <span class=\"item-text\" ng-hide=\"vm.editMode.dateOfBirth.active\">{{vm.user.dateOfBirthText}}</span>\r\n    </div>\r\n    <div class=\"item\" ng-show=\"vm.user.affiliateCode\">\r\n      <h4 class=\"item-title\">\r\n        Affiliate Code\r\n        <!-- <span class=\"fa fa-pencil-square-o pointer-cursor\" ng-hide=\"vm.editMode.affiliateCode.active\" ng-click=\"vm.enableEditMode('affiliateCode')\"></span> -->\r\n      </h4>\r\n      <div class=\"edit-section\" ng-show=\"vm.editMode.affiliateCode.active\">\r\n        <input class=\"k-input\" type=\"text\" ng-model=\"vm.user.affiliateCode\">\r\n        <div style=\"margin-top: 0.5rem;\">\r\n          <button class=\"k-button k-state-active\" ng-click=\"vm.saveDetails('affiliateCode')\" ng-disabled=\"vm.editMode.affiliateCode.isLoading\">Save</button>\r\n          <button class=\"k-button k-secondary-button\" ng-click=\"vm.disableEditMode('affiliateCode')\" ng-disabled=\"vm.editMode.affiliateCode.isLoading\">Cancel</button>\r\n          <i style=\"font-size: 1.5rem;\" ng-if=\"vm.editMode.affiliateCode.isLoading\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n        </div>\r\n      </div>\r\n      <span class=\"item-text\" ng-hide=\"vm.editMode.affiliateCode.active\">{{vm.user.affiliateCode}}</span>\r\n    </div>\r\n    <div class=\"item\" ng-show=\"vm.user.primaryImage && vm.user.primaryImage.originalImageUrl\">\r\n      <h4 class=\"item-title\">\r\n        Original Photo\r\n      </h4>\r\n      <a class=\"item-text\" target=\"_blank\"  ng-href=\"{{vm.imageBaseUrl + vm.user.primaryImage.originalImageUrl}}\">Photo Link</a>\r\n    </div>\r\n    <div class=\"item\" ng-show=\"vm.user.medias && vm.user.medias.length > 0\">\r\n      <h4 class=\"item-title\">\r\n        Profile Video\r\n      </h4>\r\n      <a class=\"item-text\" target=\"_blank\"  ng-href=\"{{vm.videoBaseUrl + vm.user.medias[0].externalHashedId}}\">Video Link</a>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userBasicDetailsController = function () {
	  userBasicDetailsController.$inject = ["UsersService", "NotificationService", "AppContextService"];
	  function userBasicDetailsController(UsersService, NotificationService, AppContextService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userBasicDetailsController);
	    this.usersService = UsersService;
	    this.appContextService = AppContextService;
	    this.notificationService = NotificationService;
	    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
	    this.videoBaseUrl = "//jugglestreet.wistia.com/medias/";
	
	    this.editMode = {
	      firstName: {
	        active: false,
	        value: ""
	      },
	      lastName: {
	        active: false,
	        value: ""
	      },
	      email: {
	        active: false,
	        value: ""
	      },
	      phoneNumber: {
	        active: false,
	        value: ""
	      },
	      dateOfBirth: {
	        active: false,
	        value: "",
	        isLoading: false
	      },
	      affiliateCode: {
	        active: false,
	        value: "",
	        isLoading: false
	      }
	    };
	
	    this.datePickerOptions = {
	      format: "dd/MM/yyyy"
	    };
	  }
	
	  (0, _createClass3.default)(userBasicDetailsController, [{
	    key: "enableEditMode",
	    value: function enableEditMode(field) {
	      this.editMode[field].active = true;
	
	      // Save the field incase if you want to revert the changes
	      this.editMode[field].value = this.user[field];
	    }
	  }, {
	    key: "disableEditMode",
	    value: function disableEditMode(field) {
	      this.editMode[field].active = false;
	
	      // Revert the changes
	      this.user[field] = this.editMode[field].value;
	    }
	  }, {
	    key: "saveDetails",
	    value: function saveDetails(field) {
	      var _this = this;
	
	      this.editMode[field].isLoading = true;
	      var payload = (0, _assign2.default)({}, this.user);
	
	      if (field == "dateOfBirth") {
	        var arr = payload.dateOfBirth.split("/");
	
	        payload.dateOfBirthDay = parseInt(arr[0]);
	        payload.dateOfBirthMonth = parseInt(arr[1]);
	        payload.dateOfBirthYear = parseInt(arr[2]);
	      }
	
	      this.usersService.updateUserDetails(this.user.userId, payload, function (response) {
	        _this.editMode[field].isLoading = false;
	        _this.editMode[field].active = false;
	        _this.notificationService.success("Update Successful");
	        _this.user = response.data;
	      }, function (error) {
	        _this.notificationService.error("Update Failed");
	        _this.editMode[field].isLoading = false;
	      });
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      if (!date) return "-";
	
	      return _common2.default.formatDate(date, "DD/MM/YYYY");
	    }
	  }, {
	    key: "hasPaymentsAdminAccess",
	    value: function hasPaymentsAdminAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasPaymentsAdminAccess(appContext.roles)) return true;else return false;
	    }
	  }]);
	  return userBasicDetailsController;
	}();
	
	exports.default = userBasicDetailsController;

/***/ },
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _moment = __webpack_require__(412);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var common = function () {
	    var formatDate = function formatDate(date) {
	        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "DD/MM/YYYY";
	
	        return (0, _moment2.default)(date).utc().format(format);
	    };
	
	    var converToUtcDate = function converToUtcDate(date) {
	        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
	    };
	
	    var subtractDays = function subtractDays(date, numberOfDays) {
	        var newDate = (0, _moment2.default)(date).subtract(numberOfDays, "days");
	        return new Date(newDate);
	    };
	
	    return { formatDate: formatDate, converToUtcDate: converToUtcDate, subtractDays: subtractDays };
	}();
	
	exports.default = common;

/***/ },
/* 412 */,
/* 413 */,
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 415,
		"./af.js": 415,
		"./ar": 416,
		"./ar-ma": 417,
		"./ar-ma.js": 417,
		"./ar-sa": 418,
		"./ar-sa.js": 418,
		"./ar-tn": 419,
		"./ar-tn.js": 419,
		"./ar.js": 416,
		"./az": 420,
		"./az.js": 420,
		"./be": 421,
		"./be.js": 421,
		"./bg": 422,
		"./bg.js": 422,
		"./bn": 423,
		"./bn.js": 423,
		"./bo": 424,
		"./bo.js": 424,
		"./br": 425,
		"./br.js": 425,
		"./bs": 426,
		"./bs.js": 426,
		"./ca": 427,
		"./ca.js": 427,
		"./cs": 428,
		"./cs.js": 428,
		"./cv": 429,
		"./cv.js": 429,
		"./cy": 430,
		"./cy.js": 430,
		"./da": 431,
		"./da.js": 431,
		"./de": 432,
		"./de-at": 433,
		"./de-at.js": 433,
		"./de.js": 432,
		"./dv": 434,
		"./dv.js": 434,
		"./el": 435,
		"./el.js": 435,
		"./en-au": 436,
		"./en-au.js": 436,
		"./en-ca": 437,
		"./en-ca.js": 437,
		"./en-gb": 438,
		"./en-gb.js": 438,
		"./en-ie": 439,
		"./en-ie.js": 439,
		"./en-nz": 440,
		"./en-nz.js": 440,
		"./eo": 441,
		"./eo.js": 441,
		"./es": 442,
		"./es.js": 442,
		"./et": 443,
		"./et.js": 443,
		"./eu": 444,
		"./eu.js": 444,
		"./fa": 445,
		"./fa.js": 445,
		"./fi": 446,
		"./fi.js": 446,
		"./fo": 447,
		"./fo.js": 447,
		"./fr": 448,
		"./fr-ca": 449,
		"./fr-ca.js": 449,
		"./fr-ch": 450,
		"./fr-ch.js": 450,
		"./fr.js": 448,
		"./fy": 451,
		"./fy.js": 451,
		"./gd": 452,
		"./gd.js": 452,
		"./gl": 453,
		"./gl.js": 453,
		"./he": 454,
		"./he.js": 454,
		"./hi": 455,
		"./hi.js": 455,
		"./hr": 456,
		"./hr.js": 456,
		"./hu": 457,
		"./hu.js": 457,
		"./hy-am": 458,
		"./hy-am.js": 458,
		"./id": 459,
		"./id.js": 459,
		"./is": 460,
		"./is.js": 460,
		"./it": 461,
		"./it.js": 461,
		"./ja": 462,
		"./ja.js": 462,
		"./jv": 463,
		"./jv.js": 463,
		"./ka": 464,
		"./ka.js": 464,
		"./kk": 465,
		"./kk.js": 465,
		"./km": 466,
		"./km.js": 466,
		"./ko": 467,
		"./ko.js": 467,
		"./ky": 468,
		"./ky.js": 468,
		"./lb": 469,
		"./lb.js": 469,
		"./lo": 470,
		"./lo.js": 470,
		"./lt": 471,
		"./lt.js": 471,
		"./lv": 472,
		"./lv.js": 472,
		"./me": 473,
		"./me.js": 473,
		"./mk": 474,
		"./mk.js": 474,
		"./ml": 475,
		"./ml.js": 475,
		"./mr": 476,
		"./mr.js": 476,
		"./ms": 477,
		"./ms-my": 478,
		"./ms-my.js": 478,
		"./ms.js": 477,
		"./my": 479,
		"./my.js": 479,
		"./nb": 480,
		"./nb.js": 480,
		"./ne": 481,
		"./ne.js": 481,
		"./nl": 482,
		"./nl.js": 482,
		"./nn": 483,
		"./nn.js": 483,
		"./pa-in": 484,
		"./pa-in.js": 484,
		"./pl": 485,
		"./pl.js": 485,
		"./pt": 486,
		"./pt-br": 487,
		"./pt-br.js": 487,
		"./pt.js": 486,
		"./ro": 488,
		"./ro.js": 488,
		"./ru": 489,
		"./ru.js": 489,
		"./se": 490,
		"./se.js": 490,
		"./si": 491,
		"./si.js": 491,
		"./sk": 492,
		"./sk.js": 492,
		"./sl": 493,
		"./sl.js": 493,
		"./sq": 494,
		"./sq.js": 494,
		"./sr": 495,
		"./sr-cyrl": 496,
		"./sr-cyrl.js": 496,
		"./sr.js": 495,
		"./ss": 497,
		"./ss.js": 497,
		"./sv": 498,
		"./sv.js": 498,
		"./sw": 499,
		"./sw.js": 499,
		"./ta": 500,
		"./ta.js": 500,
		"./te": 501,
		"./te.js": 501,
		"./th": 502,
		"./th.js": 502,
		"./tl-ph": 503,
		"./tl-ph.js": 503,
		"./tlh": 504,
		"./tlh.js": 504,
		"./tr": 505,
		"./tr.js": 505,
		"./tzl": 506,
		"./tzl.js": 506,
		"./tzm": 507,
		"./tzm-latn": 508,
		"./tzm-latn.js": 508,
		"./tzm.js": 507,
		"./uk": 509,
		"./uk.js": 509,
		"./uz": 510,
		"./uz.js": 510,
		"./vi": 511,
		"./vi.js": 511,
		"./x-pseudo": 512,
		"./x-pseudo.js": 512,
		"./zh-cn": 513,
		"./zh-cn.js": 513,
		"./zh-tw": 514,
		"./zh-tw.js": 514
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 414;


/***/ },
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var env = function () {
	    var getApiRoot = function getApiRoot() {
	        var apiRoot;
	        var location = window.location.hostname.toLowerCase();
	
	        if (_isProd(location)) apiRoot = "https://bigfoot.jugglestreet.com";else if (_isStaging(location)) apiRoot = "https://sbigfoot.jugglestreet.com";else if (_isLocal(location)) apiRoot = "https://dbigfoot.jugglestreet.com";else if (_isDev(location)) apiRoot = "http://localhost:7171";
	
	        return apiRoot;
	    };
	
	    var getApiUrl = function getApiUrl(path) {
	        var apiRoot = getApiRoot(path);
	
	        return apiRoot + "/api/" + path;
	    };
	
	    var getLoginAsBaseUrl = function getLoginAsBaseUrl(targetDevice, country) {
	        var rootUrl = void 0;
	        var location = window.location.hostname.toLowerCase();
	
	        if (targetDevice == _constants2.default.deviceType.DESKTOP) {
	
	            if (_isProd(location)) rootUrl = country === "au" ? "https://web.jugglestreet.com.au/" : "https://web.jugglestreet.co.nz/";else if (_isStaging(location)) rootUrl = "https://sw.jugglestreet.com/";else if (_isLocal(location)) rootUrl = "//localhost:3000/";else if (_isDev(location)) rootUrl = "//frontendserver:3000/";
	        } else {
	            if (_isProd(location)) rootUrl = country === "au" ? "https://m.jugglestreet.com.au/" : "https://m.jugglestreet.co.nz/";else if (_isStaging(location)) rootUrl = "https://sm.jugglestreet.com/";else if (_isLocal(location)) rootUrl = "//localhost:8080/";else if (_isDev(location)) rootUrl = "//frontendserver:8080/";
	        }
	
	        return rootUrl;
	    };
	
	    var getStorageUrl = function getStorageUrl(path) {
	        var storageUrl;
	        var location = window.location.hostname.toLowerCase();
	
	        if (_isProd(location)) storageUrl = "https://jsprodaue.blob.core.windows.net/";else if (_isStaging(location)) storageUrl = "https://jsstagingaue.blob.core.windows.net/";else if (_isLocal(location)) storageUrl = "https://jsdevaue.blob.core.windows.net/";else if (_isDev(location)) storageUrl = "https://jsdevlocalaue.blob.core.windows.net/";
	
	        return storageUrl;
	    };
	
	    var isAdmin = function isAdmin() {
	        var location = window.location.hostname.toLowerCase();
	        return location.startsWith("admin") || location.startsWith("sadmin");
	    };
	
	    var isAnalytics = function isAnalytics() {
	        var location = window.location.hostname.toLowerCase();
	        return location.startsWith("analytics") || location.startsWith("sanalytics");
	    };
	
	    var defaultState = function defaultState() {
	        var defaultState = void 0;
	        if (env.isAdmin()) {
	            defaultState = "users";
	        } else if (env.isAnalytics()) {
	            defaultState = "analyticsUsers";
	        } else {
	            throw new Error("Unsupported subdomain");
	        }
	
	        return defaultState;
	    };
	
	    var pageTitle = function pageTitle() {
	        var pageTitle = void 0;
	        if (env.isAdmin()) {
	            pageTitle = "Juggle Street Admin Portal";
	        } else if (env.isAnalytics()) {
	            pageTitle = "Juggle Street Analytics Portal";
	        } else {
	            throw new Error("Unsupported subdomain");
	        }
	
	        return pageTitle;
	    };
	
	    var _isLocal = function _isLocal(location) {
	        return location.startsWith("localhost");
	    };
	
	    var _isDev = function _isDev(location) {
	        return location.indexOf("frontendserver") != -1 || location.indexOf("local") != -1;
	    };
	
	    var _isProd = function _isProd(location) {
	        return location.startsWith("admin.jugglestreet.com") || location.startsWith("analytics.jugglestreet.com");
	    };
	
	    var _isStaging = function _isStaging(location) {
	        return location.startsWith("sadmin.jugglestreet.com") || location.startsWith("sanalytics.jugglestreet.com");
	    };
	
	    return { getApiRoot: getApiRoot, getApiUrl: getApiUrl, getLoginAsBaseUrl: getLoginAsBaseUrl, getStorageUrl: getStorageUrl, isAdmin: isAdmin, isAnalytics: isAnalytics, defaultState: defaultState, pageTitle: pageTitle };
	}();
	
	exports.default = env;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(517);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-basic-details.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-basic-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userAddressDetails = __webpack_require__(519);
	
	var _userAddressDetails2 = _interopRequireDefault(_userAddressDetails);
	
	var _userAddressDetails3 = __webpack_require__(520);
	
	var _userAddressDetails4 = _interopRequireDefault(_userAddressDetails3);
	
	__webpack_require__(521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userAddressDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    address: '<'
	  },
	  template: _userAddressDetails2.default,
	  controller: _userAddressDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userAddressDetailsComponent;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-address-details\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-map-marker\"></span>\r\n      ADDRESS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Address Line 1</h4>\r\n      <span class=\"item-text\">{{vm.address.addressLine1}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Address Line 2</h4>\r\n      <span class=\"item-text\">{{vm.address.addressLine2 || \"-\"}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Suburb</h4>\r\n      <span class=\"item-text\">{{vm.address.formattedSuburb}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">State</h4>\r\n      <span class=\"item-text\">{{vm.address.state}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Post Code</h4>\r\n      <span class=\"item-text\">{{vm.address.postCode}}</span>\r\n    </div>\r\n    <!--<div class=\"item\">\r\n      <h4 class=\"item-title\">Lived Here Since</h4>\r\n      <span class=\"item-text\">{{vm.formatDate(vm.address.livedHereSince) || '-'}}</span>\r\n    </div>-->\r\n  </div>\r\n</div>"

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userAddressDetailsController = function () {
	  function userAddressDetailsController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userAddressDetailsController);
	  }
	
	  (0, _createClass3.default)(userAddressDetailsController, [{
	    key: "formatDate",
	    value: function formatDate(date) {
	      if (!date) return false;
	
	      return _common2.default.formatDate(date);
	    }
	  }]);
	  return userAddressDetailsController;
	}();
	
	exports.default = userAddressDetailsController;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(522);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-address-details.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-address-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userPaymentDetails = __webpack_require__(524);
	
	var _userPaymentDetails2 = _interopRequireDefault(_userPaymentDetails);
	
	var _userPaymentDetails3 = __webpack_require__(525);
	
	var _userPaymentDetails4 = _interopRequireDefault(_userPaymentDetails3);
	
	__webpack_require__(526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userPaymentDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    user: '<'
	  },
	  template: _userPaymentDetails2.default,
	  controller: _userPaymentDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userPaymentDetailsComponent;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-payment-details\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-dollar\"></span>\r\n      PAYMENT\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n\r\n    <div class=\"section-left\">\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Membership Type</h4>\r\n        <span class=\"item-text\">{{vm.user.membershipTypeName}}</span>\r\n        <button class=\"k-button k-state-active\" style=\"margin: 0 20px\" ng-click=\"vm.cancelSubscription()\"\r\n        ng-show=\"vm.hasPaymentsAdminAccess() && vm.user.membershipType === 1\">Cancel Subscription</button>\r\n      </div>\r\n      <div class=\"item\" ng-show=\"vm.hasGlobalAdminAccess()\">\r\n        <h4 class=\"item-title\">\r\n          Wallet Balance\r\n          <span class=\"fa fa-pencil-square-o pointer-cursor\" ng-hide=\"vm.editMode.walletBalance.active\" ng-click=\"vm.enableEditMode('walletBalance')\"></span>\r\n        </h4>\r\n        <div class=\"edit-section\" ng-show=\"vm.editMode.walletBalance.active\">\r\n          <input class=\"k-input\" type=\"text\" ng-model=\"vm.user.walletBalance\" style=\"margin-bottom: 0.5rem\"><br>\r\n          <button class=\"k-button k-state-active\" ng-click=\"vm.updateWalletBalance('walletBalance')\" ng-disabled=\"vm.editMode.walletBalance.isLoading\">Save</button>\r\n          <button class=\"k-button k-secondary-button\" ng-click=\"vm.disableEditMode('walletBalance')\" ng-disabled=\"vm.editMode.walletBalance.isLoading\">Cancel</button>\r\n          <i style=\"font-size: 1.5rem;\" ng-if=\"vm.editMode.walletBalance.isLoading\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n        </div>\r\n        <span class=\"item-text\" ng-hide=\"vm.editMode.walletBalance.active\">{{vm.user.walletBalance}}</span>\r\n      </div>\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Active Until</h4>\r\n        <span class=\"item-text\">{{vm.formatDate(vm.user.activeUntil) || \"-\"}}</span>\r\n      </div>\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Payment Type</h4>\r\n        <span class=\"item-text\">{{vm.getPaymentType(vm.user.paymentInfo.paymentType)}}</span>\r\n      </div>\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Card Last 4 Digits</h4>\r\n        <span class=\"item-text\">{{vm.user.paymentInfo.cardLast4Digits || \"-\"}}</span>\r\n      </div>\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Card Expiry Month</h4>\r\n        <span class=\"item-text\">{{vm.user.paymentInfo.cardExpiryMonth || \"-\"}}</span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"section-right\">\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Card Expiry Year</h4>\r\n        <span class=\"item-text\">{{vm.user.paymentInfo.cardExpiryYear || \"-\"}}</span>\r\n      </div>\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Auto Renew</h4>\r\n        <span class=\"item-text\">{{vm.user.paymentInfo.autoRenew || \"-\"}}</span>\r\n      </div>\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Paying Member Since</h4>\r\n        <span class=\"item-text\">{{vm.formatDate(vm.user.paymentInfo.payingMemberSince) || \"-\"}}</span>\r\n      </div>\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Service Suspended On</h4>\r\n        <span class=\"item-text\">{{vm.formatDate(vm.user.paymentInfo.serviceSuspendedOn) || \"-\"}}</span>\r\n      </div>\r\n      <div class=\"item\">\r\n        <h4 class=\"item-title\">Payment Device Type</h4>\r\n        <span class=\"item-text\">{{vm.getPaymentDeviceType(vm.user.paymentInfo.paymentDeviceType)}}</span>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>"

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userPaymentDetailsController = function () {
	  userPaymentDetailsController.$inject = ["UsersService", "AppContextService", "NotificationService"];
	  function userPaymentDetailsController(UsersService, AppContextService, NotificationService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userPaymentDetailsController);
	    this.usersService = UsersService;
	    this.appContextService = AppContextService;
	    this.notificationService = NotificationService;
	
	    this.editMode = {
	      walletBalance: {
	        active: false,
	        value: ""
	      }
	    };
	  }
	
	  (0, _createClass3.default)(userPaymentDetailsController, [{
	    key: "enableEditMode",
	    value: function enableEditMode(field) {
	      this.editMode[field].active = true;
	
	      this.editMode[field].value = this.user[field];
	    }
	  }, {
	    key: "disableEditMode",
	    value: function disableEditMode(field) {
	      this.editMode[field].active = false;
	      if (field == 'walletBalance') {
	        var newBalance = parseInt(this.editMode[field].value);
	        this.user[field] = newBalance;
	      } else {
	        this.user[field] = this.editMode[field].value;
	      }
	    }
	  }, {
	    key: "updateWalletBalance",
	    value: function updateWalletBalance(field) {
	      var _this = this;
	
	      this.editMode[field].isLoading = true;
	      this.usersService.updateWalletBalance(this.user.userId, this.user.walletBalance, function (response) {
	        _this.editMode[field].isLoading = false;
	        _this.editMode[field].active = false;
	        _this.notificationService.success("Update Successful");
	        _this.user = response.data;
	      }, function (error) {
	        _this.notificationService.error("Update Failed");
	        _this.editMode[field].isLoading = false;
	      });
	    }
	  }, {
	    key: "getPaymentDeviceType",
	    value: function getPaymentDeviceType(type) {
	      if (!type) return "-";
	
	      switch (type) {
	        case _constants2.default.deviceType.DESKTOP:
	          return "Desktop";
	        case _constants2.default.deviceType.MOBILE:
	          return "Mobile Web";
	        case _constants2.default.deviceType.MOBILEAPP:
	          return "Mobile App";
	        default:
	          return 'Unknown';
	      }
	    }
	  }, {
	    key: "getPaymentType",
	    value: function getPaymentType(paymentType) {
	      if (!paymentType) return "-";
	
	      switch (paymentType) {
	        case _constants2.default.userPaymentType.SINGLE_ONE_OFF_JOB:
	          return 'One-off Job';
	        case _constants2.default.userPaymentType.SINGLE_RECURRING_JOB:
	          return 'Recurring Job';
	        case _constants2.default.userPaymentType.SINGLE_AU_PAIR_JOB:
	          return 'Au Pair Job';
	        case _constants2.default.userPaymentType.SINGLE_PRIMARY_SCHOOL_TUTORING_JOB:
	          return 'Primary School Tutoring Job';
	        case _constants2.default.userPaymentType.SINGLE_HIGH_SCHOOL_TUTORING_JOB:
	          return 'High School Tutoring Job';
	        case _constants2.default.userPaymentType.ANNUAL_UNLIMITED_PAY_AS_YOU_GO:
	          return '12 Months Unlimited Plan';
	        case _constants2.default.userPaymentType.SIX_MONTHS_UNLIMITED_PAY_AS_YOU_GO:
	          return '6 Months Unlimited Plan';
	        case _constants2.default.userPaymentType.EXTEND_RECURRING_JOB:
	          return 'Extend Recurring Job';
	        case _constants2.default.userPaymentType.ANNUAL_BABYSITTING_SUBSCRIPTION60:
	        case _constants2.default.userPaymentType.ANNUAL_BABYSITTING_SUBSCRIPTION120:
	          return 'Babysitting Annual Subscription';
	        case _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION120:
	          return 'Complete Childminding Annual Subscription';
	        case _constants2.default.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION90:
	        case _constants2.default.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION195:
	        case _constants2.default.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION245:
	          return 'Tutoring Annual Subscription';
	        case _constants2.default.userPaymentType.ANNUAL_PRIMARY_SCHOOL_TUTORING_SUBSCRIPTION120:
	          return 'Primary School Tutoring Annual Subscription';
	        case _constants2.default.userPaymentType.ANNUAL_HIGH_SCHOOL_TUTORING_SUBSCRIPTION195:
	          return 'High School Tutoring Annual Subscription';
	        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION:
	        case _constants2.default.userPaymentType.ANNUAL_FOUNDING_MEMBER:
	        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_120:
	        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_150:
	        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_180:
	        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_180:
	        case _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION24:
	        case _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30:
	        case _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION40:
	        case _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180:
	        case _constants2.default.userPaymentType.ANNUAL_COMPLETE_FAMILY_CARE_SUBSCRIPTION120:
	        case _constants2.default.userPaymentType.ANNUAL_HELPER_STANDARD_SUBSCRIPTION50:
	          return 'Annual Subscription';
	        case _constants2.default.userPaymentType.MONTHLY_HELPER_STANDARD_SUBSCRIPTION5:
	          return 'Monthly Subscription';
	        case _constants2.default.userPaymentType.MONTHLY_BABYSITTING_SUBSCRIPTION40:
	        case _constants2.default.userPaymentType.MONTHLY_CHILDCARE_SUBSCRIPTION90:
	        case _constants2.default.userPaymentType.MONTHLY_CHILDCARE_SUBSCRIPTION60:
	          return 'Monthly Subscription';
	        case _constants2.default.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION:
	        case _constants2.default.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_60:
	        case _constants2.default.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_75:
	        case _constants2.default.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_90:
	        case _constants2.default.userPaymentType.QUARTERLY_HELPER_SUBSCRIPTION15:
	        case _constants2.default.userPaymentType.QUARTERLY_HELPER_SUBSCRIPTION20:
	        case _constants2.default.userPaymentType.THREE_MONTHS_HELPER_STANDARD_SUBSCRIPTION25:
	          return 'Quarterly Subscription';
	        case _constants2.default.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION180:
	          return 'Tutoring (In-home & Online)';
	        case _constants2.default.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240:
	          return 'Complete Childcare & Tutoring';
	        case _constants2.default.userPaymentType.ANNUAL_AU_PAIR_SUBSCRIPTION195:
	          return 'Au Pair Annual Membership';
	        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION360:
	          return 'Au Pair Premium Membership';
	        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER1_SUBSCRIPTION_500:
	          return 'Juggle St Pro - Single Site Quarterly';
	        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_500:
	          return 'Juggle St Pro - Agency Quarterly';
	        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_750:
	          return 'Juggle St Pro - Quarterly';
	        case _constants2.default.userPaymentType.ANNUAL_BUSINESS_TIER1_SUBSCRIPTION_1500:
	          return 'Juggle St Pro - Single Site Annual';
	        case _constants2.default.userPaymentType.ANNUAL_BUSINESS_TIER2_SUBSCRIPTION_1500:
	          return 'Juggle St Pro - Agency Annual';
	        default:
	          throw new Error("Unsupported option: " + paymentType);
	      }
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      if (!date) return false;
	
	      return _common2.default.formatDate(date);
	    }
	  }, {
	    key: "hasPaymentsAdminAccess",
	    value: function hasPaymentsAdminAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasPaymentsAdminAccess(appContext.roles)) return true;else return false;
	    }
	  }, {
	    key: "hasGlobalAdminAccess",
	    value: function hasGlobalAdminAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
	    }
	  }, {
	    key: "cancelSubscription",
	    value: function cancelSubscription() {
	      var _this2 = this;
	
	      if (confirm('Are you sure you want to cancel this subscription?')) {
	
	        this.usersService.cancelSubscription(this.user.userId, this.user, function (response) {
	          _this2.notificationService.success("Update Successful");
	          _this2.user = response.data;
	        }, function (error) {
	          _this2.notificationService.error(error.data ? error.data : "Update Failed");
	        });
	      }
	    }
	  }]);
	  return userPaymentDetailsController;
	}();
	
	exports.default = userPaymentDetailsController;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(527);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-payment-details.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-payment-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-payment-details{width:1280px!important}.user-payment-details .details{display:flex;justify-content:space-between}.user-payment-details .details .section-left{flex-basis:48%;border-right:1px solid #d8d8d8}.user-payment-details .details .section-right{flex-basis:50%}", ""]);
	
	// exports


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userClientDetails = __webpack_require__(529);
	
	var _userClientDetails2 = _interopRequireDefault(_userClientDetails);
	
	var _userClientDetails3 = __webpack_require__(530);
	
	var _userClientDetails4 = _interopRequireDefault(_userClientDetails3);
	
	__webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userClientDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    user: '<'
	  },
	  template: _userClientDetails2.default,
	  controller: _userClientDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userClientDetailsComponent;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-client-details\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-user\"></span>\r\n      JOB\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <!-- <div class=\"item\">\r\n      <h4 class=\"item-title\">Job Description</h4>\r\n      <span class=\"item-text\">{{vm.user.clientInfo.jobDescription || \"-\"}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Job Rules</h4>\r\n      <span class=\"item-text\">{{vm.user.clientInfo.jobRules || \"-\"}}</span>\r\n    </div> -->\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Jobs Placed</h4>\r\n      <span class=\"item-text\">{{vm.user.clientInfo.jobsPlaced}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Jobs Awarded</h4>\r\n      <span class=\"item-text\">{{vm.user.clientInfo.jobsAwarded}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Jobs Completed</h4>\r\n      <span class=\"item-text\">{{vm.user.clientInfo.jobsCompleted}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Jobs Cancelled</h4>\r\n      <span class=\"item-text\">{{vm.user.clientInfo.jobsCancelled}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Average Rating</h4>\r\n      <span class=\"item-text\">{{vm.user.clientInfo.ratingsAvg | number : 2}}</span>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userClientDetailsController = function userClientDetailsController() {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, userClientDetailsController);
	};
	
	exports.default = userClientDetailsController;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(532);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-client-details.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-client-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userProviderDetails = __webpack_require__(534);
	
	var _userProviderDetails2 = _interopRequireDefault(_userProviderDetails);
	
	var _userProviderDetails3 = __webpack_require__(535);
	
	var _userProviderDetails4 = _interopRequireDefault(_userProviderDetails3);
	
	__webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userProviderDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    user: '<'
	  },
	  template: _userProviderDetails2.default,
	  controller: _userProviderDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userProviderDetailsComponent;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-provider-details\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-bar-chart-o\"></span>\r\n      JOBS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Jobs Awarded</h4>\r\n      <span class=\"item-text\">{{vm.user.providerInfo.jobsAwarded}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Jobs Completed</h4>\r\n      <span class=\"item-text\">{{vm.user.providerInfo.jobsCompleted}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Jobs Cancelled</h4>\r\n      <span class=\"item-text\">{{vm.user.providerInfo.jobsCancelled}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Average Rating</h4>\r\n      <span class=\"item-text\">{{vm.user.providerInfo.ratingsAvg | number : 2}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Number of Clients</h4>\r\n      <span class=\"item-text\">{{vm.clientsCount()}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Estimated Working Hours</h4>\r\n      <span class=\"item-text\">{{vm.totalHours()}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Estimated Revenue</h4>\r\n      <span class=\"item-text\">{{vm.totalRevenue()}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Estimated Revenue (Last 12 Months)</h4>\r\n      <span class=\"item-text\">{{vm.totalRevenue12Months()}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Membership Fees</h4>\r\n      <span class=\"item-text\">\r\n        {{vm.membershipFeesFormatted()}}\r\n        <br/>\r\n        {{vm.membershipPercentage()}}\r\n      </span>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userProviderDetailsController = function () {
	  function userProviderDetailsController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userProviderDetailsController);
	  }
	
	  (0, _createClass3.default)(userProviderDetailsController, [{
	    key: 'clientsCount',
	    value: function clientsCount() {
	      var count = this.user.providerInfo.clientsCount;
	      if (!count) count = 0;
	
	      return count;
	    }
	  }, {
	    key: 'totalRevenue',
	    value: function totalRevenue() {
	      var value = this.user.stats.totalRevenue;
	      if (!value) value = 0;
	
	      return kendo.toString(value, 'c0');
	    }
	  }, {
	    key: 'totalRevenue12Months',
	    value: function totalRevenue12Months() {
	      var value = this.user.stats.totalRevenue12Months;
	      if (!value) value = 0;
	
	      return kendo.toString(value, 'c0');
	    }
	  }, {
	    key: 'totalHours',
	    value: function totalHours() {
	      var value = this.user.stats.totalWorkingHours;
	      if (!value) value = 0;
	
	      return kendo.toString(value, 'n0');
	    }
	  }, {
	    key: 'membershipFees',
	    value: function membershipFees() {
	      var total = 0;
	      this.user.invoices.forEach(function (invoice) {
	        total += invoice.adjustedTotal - invoice.amountRefunded;
	      });
	
	      total /= 100;
	
	      return total;
	    }
	  }, {
	    key: 'membershipFeesFormatted',
	    value: function membershipFeesFormatted() {
	      var total = this.membershipFees();
	
	      return kendo.toString(total, 'c0');
	    }
	  }, {
	    key: 'membershipPercentage',
	    value: function membershipPercentage() {
	      var membershipFees = this.membershipFees();
	      var totalRevenue = this.user.stats.totalRevenue;
	      if (!membershipFees || !totalRevenue) return '';
	
	      return kendo.toString(membershipFees / totalRevenue, 'p2') + ' of estimated revenue';
	    }
	  }]);
	  return userProviderDetailsController;
	}();
	
	exports.default = userProviderDetailsController;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(537);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-provider-details.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-provider-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userProfileCompleteness = __webpack_require__(539);
	
	var _userProfileCompleteness2 = _interopRequireDefault(_userProfileCompleteness);
	
	var _userProfileCompleteness3 = __webpack_require__(540);
	
	var _userProfileCompleteness4 = _interopRequireDefault(_userProfileCompleteness3);
	
	__webpack_require__(541);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userProfileCompletenessComponent = {
	  restrict: 'E',
	  bindings: {
	    profileItems: '<',
	    isClient: '<',
	    clientInfo: '<',
	    providerInfo: '<',
	    userId: '<'
	  },
	  template: _userProfileCompleteness2.default,
	  controller: _userProfileCompleteness4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userProfileCompletenessComponent;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-pofile-completeness\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-user\"></span>\r\n      PROFILE COMPLETENESS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.BASIC_INFO) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Basic Info\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\" ng-if=\"vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.CLIENT_PHOTO) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Photo\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\" ng-if=\"!vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.PROVIDER_PHOTO) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Photo\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.TRUST_VERIFICATION) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Account Verification\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\" ng-if=\"vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.CLIENT_ABOUT_ME) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        About Me\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\" ng-if=\"!vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.PROVIDER_ABOUT_ME) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        About Me\r\n      </h4>\r\n    </div>\r\n    <!--<div class=\"item\" ng-if=\"vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.MY_CHILDREN) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        My Children\r\n      </h4>\r\n    </div>-->\r\n    <!-- <div class=\"item\" ng-if=\"vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.MY_HOME) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        My Home\r\n      </h4>\r\n    </div> -->\r\n    <div class=\"item\" ng-if=\"!vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.PROVIDER_JOB_CATEGORIES) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Job Categories\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\" ng-if=\"!vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.PROVIDER_PROFILE_VISIBILITY) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Profile Visibility\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\" ng-if=\"!vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.PROVIDER_CERTIFICATES) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Certificates\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\" ng-if=\"!vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.CITIZENSHIP) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Citizenship\r\n      </h4>\r\n    </div>\r\n    <!-- <div class=\"item\" ng-if=\"!vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.PROVIDER_GUARDIAN) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Guardian\r\n      </h4>\r\n    </div> -->\r\n    <div class=\"item\" ng-if=\"vm.requiresGuardianApproval()\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasApprovedGuardian() ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Guardian Approval\r\n      </h4>\r\n    </div>\r\n    <!--<div class=\"item\" ng-if=\"!vm.isClient\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.hasItem(vm.profileItemOptions.MY_BABYSITTING_EXPERIENCE) ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        My Babysitting Experience\r\n      </h4>\r\n    </div>-->\r\n</div>"

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userProfileCompletenessController = function () {
	  userProfileCompletenessController.$inject = ["UsersService", "NotificationService"];
	  function userProfileCompletenessController(UsersService, NotificationService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userProfileCompletenessController);
	    this.profileItemOptions = _constants2.default.profileItems;
	    this.usersService = UsersService;
	    this.notificationService = NotificationService;
	  }
	
	  (0, _createClass3.default)(userProfileCompletenessController, [{
	    key: "resetPayto",
	    value: function resetPayto() {
	      var _this = this;
	
	      if (!confirm('Are you sure you want to reset PayTo for this user?')) return;
	      this.usersService.resetPayto(this.userId, function () {
	        return _this.notificationService.success('PayTo reset successful.');
	      }, function () {
	        return _this.notificationService.error('PayTo reset failed.');
	      });
	    }
	  }, {
	    key: "hasItem",
	    value: function hasItem(item) {
	      return this.profileItems & item;
	    }
	  }, {
	    key: "requiresGuardianApproval",
	    value: function requiresGuardianApproval() {
	      return this.providerInfo.requiresGuardianApproval || this.hasGuardian();
	    }
	  }, {
	    key: "hasGuardian",
	    value: function hasGuardian() {
	      return this.providerInfo.guardians != null && this.providerInfo.guardians.length > 0;
	    }
	  }, {
	    key: "hasApprovedGuardian",
	    value: function hasApprovedGuardian() {
	      if (!this.hasGuardian()) return false;
	
	      return this.providerInfo.guardians[0].status == 2;
	    }
	  }]);
	  return userProfileCompletenessController;
	}();
	
	exports.default = userProfileCompletenessController;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(542);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-profile-completeness.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-profile-completeness.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-pofile-completeness .fa{margin-right:1rem}.user-pofile-completeness .green{color:#1c1c1c}.user-pofile-completeness .red{color:red}", ""]);
	
	// exports


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userRatings = __webpack_require__(544);
	
	var _userRatings2 = _interopRequireDefault(_userRatings);
	
	var _userRatings3 = __webpack_require__(545);
	
	var _userRatings4 = _interopRequireDefault(_userRatings3);
	
	__webpack_require__(546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userRatingsComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<',
	    userType: '<',
	    onRatingUpdated: '&'
	  },
	  template: _userRatings2.default,
	  controller: _userRatings4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userRatingsComponent;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-ratings\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-star\"></span>\r\n      RATINGS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"ratings-grid\">\r\n      <div id=\"ratings-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserRatingsController = function () {
	  UserRatingsController.$inject = ["UsersService", "$scope"];
	  function UserRatingsController(UsersService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, UserRatingsController);
	    this.usersService = UsersService;
	    this.$scope = $scope;
	  }
	
	  (0, _createClass3.default)(UserRatingsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var isClient = this.userType === 'client';
	
	      var dataSource = this.usersService.getRatingsDataSource(this.userId, isClient);
	
	      dataSource.bind('requestEnd', function (e) {
	        if (e.type === 'update' && e.response) {
	          var totalRatingsAvg = e.response.totalRatingsAvg;
	          if (totalRatingsAvg != null) {
	            _this.onRatingUpdated({ totalRatingsAvg: totalRatingsAvg });
	            _this.$scope.$apply();
	          }
	        }
	      });
	
	      this.gridOptions = {
	        dataSource: dataSource,
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        editable: 'inline',
	        noRecords: {
	          template: 'No Ratings.'
	        },
	        save: function save(e) {
	          var item = e.model;
	          var sum = item.category1 + item.category2 + item.category3 + item.category4;
	          var avg = sum / 4.0;
	          item.ratingSum = parseFloat(sum.toFixed(2));
	          item.ratingAvg = parseFloat(avg.toFixed(2));
	        },
	        columns: [{ field: 'id', title: 'ID', width: '1.5rem', filterable: false }, { field: 'ratingById', title: 'Rated By ID', width: '2rem', filterable: false }, { field: 'firstName', title: 'First Name', width: '3rem', filterable: false }, { field: 'lastName', title: 'Last Name', width: '3rem', filterable: false }, { field: 'category1', title: 'Category 1', width: '2.5rem', filterable: false }, { field: 'category2', title: 'Category 2', width: '2.5rem', filterable: false }, { field: 'category3', title: 'Category 3', width: '2.5rem', filterable: false }, { field: 'category4', title: 'Category 4', width: '2.5rem', filterable: false }, { field: 'ratingSum', title: 'Rating Sum', width: '2.5rem', filterable: false }, { field: 'ratingAvg', title: 'Avg Rating', width: '2.5rem', filterable: false }, { field: 'ratingDate', title: 'Rating Date', width: '3rem', filterable: false, template: '#= kendo.toString(new Date(ratingDate), \'dd/MM/yyyy\') #' }, { command: ['edit'], title: 'Actions', width: '3rem' }]
	      };
	    }
	  }]);
	  return UserRatingsController;
	}();
	
	exports.default = UserRatingsController;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(547);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-ratings.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-ratings.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-ratings{width:1280px!important;flex-basis:100%}", ""]);
	
	// exports


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userTimesheets = __webpack_require__(549);
	
	var _userTimesheets2 = _interopRequireDefault(_userTimesheets);
	
	var _userTimesheets3 = __webpack_require__(550);
	
	var _userTimesheets4 = _interopRequireDefault(_userTimesheets3);
	
	__webpack_require__(594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userTimesheetsComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<'
	  },
	  template: _userTimesheets2.default,
	  controller: _userTimesheets4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userTimesheetsComponent;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-timesheets\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-clock-o\"></span>\r\n      TIMESHEET\r\n    </h4>\r\n  </div>\r\n  <div class=\"timesheet-search\">\r\n    <span class=\"fa fa-search timesheet-search-icon\" ng-if=\"!vm.isSearching\"></span>\r\n    <span class=\"fa fa-spinner fa-spin timesheet-search-icon\" ng-if=\"vm.isSearching\"></span>\r\n    <input\r\n      type=\"number\"\r\n      class=\"k-textbox timesheet-search-input\"\r\n      placeholder=\"Search by Job ID\"\r\n      ng-model=\"vm.searchJobId\"\r\n      ng-change=\"vm.onSearchInput()\"\r\n    />\r\n  </div>\r\n  <div class=\"details\" style=\"position: relative;\">\r\n    <div ng-if=\"vm.isDeleting\" style=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.7); z-index: 9999; display: flex; align-items: center; justify-content: center;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n    </div>\r\n    <div id=\"timesheets-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n  </div>\r\n</div>\r\n<div kendo-dialog=\"vm.confirmDeleteDialog\" id=\"timesheet-confirm-delete-dialog\" k-options=\"vm.confirmDeleteDialogOptions\">\r\n  Are you sure you want to remove timesheet for this Job?\r\n</div>\r\n"

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(551);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserTimesheetsController = function () {
	  UserTimesheetsController.$inject = ["JobsService", "NotificationService", "$scope"];
	  function UserTimesheetsController(JobsService, NotificationService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserTimesheetsController);
	    this.JobsService = JobsService;
	    this.NotificationService = NotificationService;
	    this.$scope = $scope;
	    this._searchTimer = null;
	    this.searchJobId = '';
	    this._deletedJobIds = new _set2.default(); // track locally deleted job IDs
	  }
	
	  (0, _createClass3.default)(UserTimesheetsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this._dataSource = this.JobsService.getJugglerJobsDataSource(this.userId);
	
	      this._dataSource.bind("requestStart", function () {
	        // Use Kendo's native progress over the whole component so it always shows
	        kendo.ui.progress($("#timesheets-grid"), true);
	      });
	
	      this._dataSource.bind("requestEnd", function () {
	        kendo.ui.progress($("#timesheets-grid"), false);
	      });
	
	      this._dataSource.bind("error", function () {
	        kendo.ui.progress($("#timesheets-grid"), false);
	      });
	
	      // After every read from the API, strip out any locally-deleted jobs
	      this._dataSource.bind('change', function () {
	        _this._removeDeletedFromDataSource();
	      });
	
	      var ctr = this;
	      this.confirmDeleteDialogOptions = {
	        title: 'Confirm Remove',
	        visible: false,
	        closable: true,
	        modal: true,
	        buttonLayout: 'normal',
	        messages: { close: '' },
	        actions: [{ text: 'No' }, {
	          text: 'Yes',
	          primary: true,
	          action: function action() {
	            return ctr._doDelete();
	          }
	        }]
	      };
	
	      this.gridOptions = {
	        dataSource: this._dataSource,
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        noRecords: {
	          template: 'No Completed One-off Jobs found.'
	        },
	        columns: [{ field: 'id', title: 'Job ID', width: '100px', filterable: false, template: '#= data.id || data.jobId || data.JobId || data.Id || "" #' }, { field: 'paymentType', title: 'Payment Type', width: '130px', filterable: false, template: '#= (data.paymentType == 1 || data.PaymentType == 1) ? "Fixed Payment" : (data.paymentType == 2 || data.PaymentType == 2) ? "Hourly Payment" : (data.paymentType || data.PaymentType || "") #' }, { field: 'jobDate', title: 'Job Date', width: '120px', filterable: false, template: "#= (data.jobDate || data.JobDate) ? kendo.toString(new Date(data.jobDate || data.JobDate), 'dd/MM/yyyy') : \"\" #" }, { field: 'price', title: 'Price ($)', width: '100px', filterable: false, template: '#= data.price || data.Price || 0 #' }, { field: 'jobStatus', title: 'Job Status', width: '120px', filterable: false, template: 'Completed' }, {
	          command: [{
	            text: 'Remove Timesheet',
	            className: 'k-grid-deleteTimesheet',
	            click: this.deleteTimesheet.bind(this)
	          }],
	          title: 'Actions',
	          width: '160px'
	        }]
	      };
	    }
	  }, {
	    key: "onSearchInput",
	    value: function onSearchInput() {
	      var _this2 = this;
	
	      // Show loader as soon as user types
	      this.isSearching = true;
	
	      // Clear any existing timer on every keystroke
	      if (this._searchTimer) {
	        clearTimeout(this._searchTimer);
	      }
	
	      // Start a new 2-second debounce timer
	      this._searchTimer = setTimeout(function () {
	        // Input type="number" gives a Number, so cast to String before .trim()
	        var term = String(_this2.searchJobId || '').trim();
	
	        if (term === '') {
	          // No search term — clear filter, show all records
	          _this2._dataSource.filter([]);
	        } else {
	          var parsedTerm = parseInt(term, 10) || 0;
	          // Filter where any id variant matches the typed job ID
	          _this2._dataSource.filter({
	            logic: "or",
	            filters: [{ field: 'id', operator: 'eq', value: parsedTerm }, { field: 'jobId', operator: 'eq', value: parsedTerm }, { field: 'JobId', operator: 'eq', value: parsedTerm }, { field: 'Id', operator: 'eq', value: parsedTerm }]
	          });
	        }
	
	        _this2._searchTimer = null;
	        _this2.isSearching = false;
	        _this2.$scope.$applyAsync();
	      }, 2000);
	    }
	  }, {
	    key: "_removeDeletedFromDataSource",
	    value: function _removeDeletedFromDataSource() {
	      var _this3 = this;
	
	      if (this._deletedJobIds.size === 0) return;
	      var ds = this._dataSource;
	      var toRemove = ds.data().filter(function (item) {
	        var id = item.id || item.jobId || item.JobId || item.Id;
	        return _this3._deletedJobIds.has(id);
	      });
	      toRemove.forEach(function (item) {
	        return ds.remove(item);
	      });
	    }
	  }, {
	    key: "deleteTimesheet",
	    value: function deleteTimesheet(e) {
	      e.preventDefault();
	      var grid = $(e.target).closest("[data-role=grid]").data("kendoGrid");
	      var dataItem = grid.dataItem($(e.target).closest("tr"));
	      this._pendingDeleteJobId = dataItem.id || dataItem.jobId || dataItem.JobId || dataItem.Id;
	      this.confirmDeleteDialog.open();
	    }
	  }, {
	    key: "_doDelete",
	    value: function _doDelete() {
	      var _this4 = this;
	
	      if (!this._pendingDeleteJobId) return;
	
	      // Show loader over the component while the delete API is running
	      this.isDeleting = true;
	      this.$scope.$applyAsync();
	
	      this.JobsService.deleteTimesheet(this._pendingDeleteJobId, function () {
	        _this4.isDeleting = false;
	        _this4.$scope.$applyAsync();
	        _this4.NotificationService.success("Timesheet is removed");
	
	        // Add to local blacklist so this job never shows again even after search
	        _this4._deletedJobIds.add(_this4._pendingDeleteJobId);
	
	        var grid = $("#timesheets-grid").data("kendoGrid");
	        if (grid) {
	          // Immediately remove from in-memory data so it disappears instantly
	          var dataItem = grid.dataSource.get(_this4._pendingDeleteJobId);
	          if (dataItem) {
	            grid.dataSource.remove(dataItem);
	          } else {
	            _this4._removeDeletedFromDataSource();
	          }
	        }
	        _this4._pendingDeleteJobId = null;
	      }, function (error) {
	        _this4.isDeleting = false;
	        _this4.$scope.$applyAsync();
	        _this4.NotificationService.error("Failed to remove timesheet: " + (error && error.data || "Unknown error"));
	        _this4._pendingDeleteJobId = null;
	      });
	    }
	  }]);
	  return UserTimesheetsController;
	}();
	
	exports.default = UserTimesheetsController;

/***/ },
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(595);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-timesheets.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-timesheets.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-timesheets{width:1280px!important;flex-basis:100%}.user-timesheets .timesheet-search{display:flex;align-items:center;margin-bottom:12px;margin-top:4px}.user-timesheets .timesheet-search .timesheet-search-icon{font-size:14px;color:#777;margin-right:8px}.user-timesheets .timesheet-search .timesheet-search-input{width:320px}.user-timesheets .k-grid-deleteTimesheet{background-color:#fff!important;color:#d9534f!important;border-color:#d9534f!important}.user-timesheets .k-grid-deleteTimesheet:hover{background-color:#d9534f!important;color:#fff!important}", ""]);
	
	// exports


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userWalletTransactions = __webpack_require__(597);
	
	var _userWalletTransactions2 = _interopRequireDefault(_userWalletTransactions);
	
	var _userWalletTransactions3 = __webpack_require__(598);
	
	var _userWalletTransactions4 = _interopRequireDefault(_userWalletTransactions3);
	
	__webpack_require__(599);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userWalletTransactionsComponent = {
	  restrict: 'E',
	  bindings: {
	    walletTransactions: '<'
	  },
	  template: _userWalletTransactions2.default,
	  controller: _userWalletTransactions4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userWalletTransactionsComponent;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-children\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-dollar\"></span>\r\n      WALLET TRANSACTIONS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"children-grid\">\r\n      <div id=\"children-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userWalletTransactionsController = function () {
	  function userWalletTransactionsController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userWalletTransactionsController);
	  }
	
	  (0, _createClass3.default)(userWalletTransactionsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.gridOptions = {
	        dataSource: this.walletTransactions,
	        sortable: true,
	        pageable: false,
	        resizable: true,
	        noRecords: {
	          template: "No Transactions."
	        },
	        columns: [{ field: "creationDate", title: "Date", filterable: false, width: "4rem", template: "#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #" }, { field: "transactionType", title: "Type", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getTransactionType(dataItem.transactionType);
	          } }, { field: "total", title: "Total", filterable: false, width: "4rem", template: "#= '$' + (total/100).toFixed(2) #" }, { field: "transactionReason", title: "Reason", filterable: false, width: "8rem", template: function template(dataItem) {
	            return "" + _this._getTransactionReason(dataItem.transactionReason);
	          } }, { field: "transactionOwner", title: "Owner", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getTransactionOwner(dataItem.transactionOwner);
	          } }]
	      };
	    }
	  }, {
	    key: "_getTransactionType",
	    value: function _getTransactionType(type) {
	      switch (type) {
	        case _constants2.default.walletTransactionType.ADD:
	          return "Add";
	        case _constants2.default.walletTransactionType.DEDUCT:
	          return "Deduct";
	        case _constants2.default.walletTransactionType.REFUND:
	          return "Refund";
	      }
	    }
	  }, {
	    key: "_getTransactionReason",
	    value: function _getTransactionReason(reason) {
	      switch (reason) {
	        case _constants2.default.walletTransactionReason.ACCOUNT_CREATED:
	          return "Account Created";
	        case _constants2.default.walletTransactionReason.JOB_POSTED:
	          return "Job Posted";
	        case _constants2.default.walletTransactionReason.JOB_CANCELLED:
	          return "Job Cancelled";
	        case _constants2.default.walletTransactionReason.ADMIN_ACTION:
	          return "Admin Action";
	        case _constants2.default.walletTransactionReason.SINGLE_ONE_OFF_JOB_PURCHASE:
	          return "Single One-off Job Purchase";
	        case _constants2.default.walletTransactionReason.SINGLE_RECURRING_JOB_PURCHASE:
	          return "Single Recurring Job Purchase";
	        case _constants2.default.walletTransactionReason.WALLET_PAYMENT:
	          return "Wallet Payment";
	        case _constants2.default.walletTransactionReason.JOB_CANCELLED_BY_HELPER:
	          return "Job Cancelled by Helper";
	
	      }
	    }
	  }, {
	    key: "_getTransactionOwner",
	    value: function _getTransactionOwner(owner) {
	      switch (owner) {
	        case _constants2.default.walletTransactionOwner.UNSPECIFIED:
	          return "Unspecified";
	        case _constants2.default.walletTransactionOwner.USER:
	          return "User";
	        case _constants2.default.walletTransactionOwner.SYSTEM:
	          return "System";
	        case _constants2.default.walletTransactionOwner.ADMIN:
	          return "Admin";
	      }
	    }
	  }]);
	  return userWalletTransactionsController;
	}();
	
	exports.default = userWalletTransactionsController;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(600);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-wallet-transactions.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-wallet-transactions.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-wallet-transactions{width:1280px!important}", ""]);
	
	// exports


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userChildren = __webpack_require__(602);
	
	var _userChildren2 = _interopRequireDefault(_userChildren);
	
	var _userChildren3 = __webpack_require__(603);
	
	var _userChildren4 = _interopRequireDefault(_userChildren3);
	
	__webpack_require__(604);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userChildrenComponent = {
	  restrict: 'E',
	  bindings: {
	    children: '<'
	  },
	  template: _userChildren2.default,
	  controller: _userChildren4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userChildrenComponent;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-children\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      CHILDREN\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"children-grid\">\r\n      <div id=\"children-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userChildrenController = function () {
	  function userChildrenController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userChildrenController);
	  }
	
	  (0, _createClass3.default)(userChildrenController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.gridOptions = {
	        dataSource: this.children,
	        sortable: true,
	        pageable: false,
	        resizable: true,
	        noRecords: {
	          template: "No Children."
	        },
	        columns: [{ field: "firstName", title: "First Name", filterable: false, width: "6rem" }, { field: "lastName", title: "Last Name", filterable: false, width: "6rem" }, { field: "dateOfBirth", title: "Date of Birth", filterable: false, width: "4rem", template: "#= kendo.toString(new Date(dateOfBirth), 'dd-MM-yyyy') #" }, { field: "gender", title: "Gender", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getGenderText(dataItem.gender);
	          } }, { field: "allergyDetails", title: "Allergy Details", filterable: false, width: "6rem" }, { field: "aboutMe", title: "More Details", filterable: false, width: "6rem" }]
	      };
	    }
	  }, {
	    key: "_getGenderText",
	    value: function _getGenderText(gender) {
	      switch (gender) {
	        case _constants2.default.gender.MALE:
	          return "Male";
	        case _constants2.default.gender.FEMALE:
	          return "Female";
	        case _constants2.default.gender.UNSPECIFIED:
	          return "-";
	
	      }
	    }
	  }]);
	  return userChildrenController;
	}();
	
	exports.default = userChildrenController;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(605);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-children.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-children.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-children{width:1280px!important;flex-basis:100%}", ""]);
	
	// exports


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userVouches = __webpack_require__(607);
	
	var _userVouches2 = _interopRequireDefault(_userVouches);
	
	var _userVouches3 = __webpack_require__(608);
	
	var _userVouches4 = _interopRequireDefault(_userVouches3);
	
	__webpack_require__(609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userVouchesComponent = {
	  restrict: 'E',
	  bindings: {
	    vouches: '<'
	  },
	  template: _userVouches2.default,
	  controller: _userVouches4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userVouchesComponent;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-vouches\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      REFERENCES\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"vouches-grid\">\r\n      <div id=\"vouches-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userVouchesController = function () {
	  function userVouchesController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userVouchesController);
	  }
	
	  (0, _createClass3.default)(userVouchesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.gridOptions = {
	        dataSource: this.vouches,
	        sortable: true,
	        pageable: false,
	        resizable: true,
	        noRecords: {
	          template: "No Vouches."
	        },
	        columns: [
	        // { field: "firstName", title: "First Name", filterable: false, width: "6rem" },
	        // { field: "lastName", title: "Last Name", filterable: false, width: "6rem" },
	        { field: "fullName", title: "Name", filterable: false, width: "4rem" }, { field: "referenceType", title: "Type", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getVouchReferenceType(dataItem.referenceType, dataItem.otherReferenceType);
	          } }, { field: "email", title: "Email", filterable: false, width: "6rem" }, { field: "phoneNumber", title: "Phone Number", filterable: false, width: "4rem" }, { field: "whatWouldYouLikeToSay", title: "Feedback", filterable: false, width: "12rem" }]
	      };
	    }
	  }, {
	    key: "_getVouchReferenceType",
	    value: function _getVouchReferenceType(status, otherReferenceType) {
	      switch (status) {
	        case _constants2.default.vouchReferenceType.FAMILY:
	          return "Family";
	        case _constants2.default.vouchReferenceType.CHILDCAREEMPLOYMENT:
	          return "Childcare Employment";
	        case _constants2.default.vouchReferenceType.NONCHILDCAREEMPLOYMENT:
	          return "Non-childcare Employment";
	        case _constants2.default.vouchReferenceType.OTHER:
	          return "Other (" + otherReferenceType + ")";
	        case _constants2.default.vouchReferenceType.JUGGLESTREET:
	          return "Juggle Street";
	        case _constants2.default.vouchReferenceType.UNSPECIFIED:
	          return "-";
	      }
	    }
	  }, {
	    key: "_getVouchStatus",
	    value: function _getVouchStatus(status) {
	      switch (status) {
	        case _constants2.default.vouchStatus.PENDING:
	          return "Follow-up";
	        case _constants2.default.vouchStatus.APPROVED:
	          return "Complete";
	        case _constants2.default.vouchStatus.CANCELLED:
	          return "Incomplete";
	        case _constants2.default.vouchStatus.EXPIRED:
	          return "Expired";
	        case _constants2.default.vouchStatus.NONE:
	          return "-";
	      }
	    }
	  }]);
	  return userVouchesController;
	}();
	
	exports.default = userVouchesController;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(610);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-vouches.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-vouches.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-vouches{width:1280px!important;flex-basis:100%}", ""]);
	
	// exports


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userExternalAccounts = __webpack_require__(612);
	
	var _userExternalAccounts2 = _interopRequireDefault(_userExternalAccounts);
	
	var _userExternalAccounts3 = __webpack_require__(613);
	
	var _userExternalAccounts4 = _interopRequireDefault(_userExternalAccounts3);
	
	__webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userExternalAccountsComponent = {
	  restrict: 'E',
	  bindings: {
	    externalAccounts: '<'
	  },
	  template: _userExternalAccounts2.default,
	  controller: _userExternalAccounts4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userExternalAccountsComponent;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-external-accounts\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      EXTERNAL ACCOUNTS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"external-accounts-grid\">\r\n      <div id=\"external-accounts-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userExternalAccountsController = function () {
	  function userExternalAccountsController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userExternalAccountsController);
	  }
	
	  (0, _createClass3.default)(userExternalAccountsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.gridOptions = {
	        dataSource: this.externalAccounts,
	        sortable: true,
	        pageable: false,
	        resizable: true,
	        noRecords: {
	          template: "No External Accounts."
	        },
	        columns: [{ field: "name", title: "Name", filterable: false, width: "6rem" }, { field: "status", title: "Status", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getAccountType(dataItem.accountType);
	          } }, { field: "email", title: "Email", filterable: false, width: "6rem" }, { field: "creationDate", title: "Creation Date", filterable: false, width: "4rem", template: "#= kendo.toString(new Date(creationDate), 'dd/MM/yyyy')#" }]
	      };
	    }
	  }, {
	    key: "_getAccountType",
	    value: function _getAccountType(type) {
	      switch (type) {
	        case _constants2.default.externalAccountType.FACEBOOK:
	          return "Facebook";
	        case _constants2.default.externalAccountType.LINKEDIN:
	          return "LinkedIn";
	      }
	    }
	  }]);
	  return userExternalAccountsController;
	}();
	
	exports.default = userExternalAccountsController;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(615);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-external-accounts.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-external-accounts.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-external-accounts{width:1280px!important;flex-basis:100%}", ""]);
	
	// exports


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userGuardians = __webpack_require__(617);
	
	var _userGuardians2 = _interopRequireDefault(_userGuardians);
	
	var _userGuardians3 = __webpack_require__(618);
	
	var _userGuardians4 = _interopRequireDefault(_userGuardians3);
	
	__webpack_require__(619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userGuardiansComponent = {
	  restrict: 'E',
	  bindings: {
	    guardians: '<'
	  },
	  template: _userGuardians2.default,
	  controller: _userGuardians4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userGuardiansComponent;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-guardians\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      GUARDIANS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"guardians-grid\">\r\n      <div id=\"guardians-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userGuardiansController = function () {
	  function userGuardiansController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userGuardiansController);
	  }
	
	  (0, _createClass3.default)(userGuardiansController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.gridOptions = {
	        dataSource: this.guardians,
	        sortable: true,
	        pageable: false,
	        resizable: true,
	        noRecords: {
	          template: "No Guardians."
	        },
	        columns: [{ field: "firstName", title: "First Name", filterable: false, width: "6rem" }, { field: "lastName", title: "Last Name", filterable: false, width: "6rem" }, { field: "relationship", title: "Relationship", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getRelationship(dataItem.relationship);
	          } }, { field: "status", title: "Status", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getGuardianStatus(dataItem.status);
	          } }, { field: "email", title: "Email", filterable: false, width: "6rem" }, { field: "phoneNumber", title: "Phone Number", filterable: false, width: "6rem" }, { field: "submissionDate", title: "Submission Date", filterable: false, width: "4rem", template: "#= submissionDate ? kendo.toString(new Date(submissionDate), 'dd-MM-yyyy') : '-' #" }, { field: "approvalDate", title: "Approval Date", filterable: false, width: "4rem", template: "#= approvalDate ? kendo.toString(new Date(approvalDate), 'dd-MM-yyyy') : '-' #" }]
	      };
	    }
	  }, {
	    key: "_getGuardianStatus",
	    value: function _getGuardianStatus(status) {
	      switch (status) {
	        case _constants2.default.guardianStatus.PENDING:
	          return "Pending";
	        case _constants2.default.guardianStatus.APPROVED:
	          return "Approved";
	        case _constants2.default.guardianStatus.CANCELLED:
	          return "Cancelled";
	        case _constants2.default.guardianStatus.NONE:
	          return "-";
	      }
	    }
	  }, {
	    key: "_getRelationship",
	    value: function _getRelationship(relationship) {
	      switch (relationship) {
	        case _constants2.default.guardianRelation.FATHER:
	          return "Father";
	        case _constants2.default.guardianRelation.MOTHER:
	          return "Mother";
	        case _constants2.default.guardianRelation.LEGALGUARDIAN:
	          return "Legal Guardian";
	      }
	    }
	  }]);
	  return userGuardiansController;
	}();
	
	exports.default = userGuardiansController;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(620);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-guardians.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-guardians.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-guardians{width:1280px!important;flex-basis:100%}", ""]);
	
	// exports


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userJobPreferences = __webpack_require__(622);
	
	var _userJobPreferences2 = _interopRequireDefault(_userJobPreferences);
	
	var _userJobPreferences3 = __webpack_require__(623);
	
	var _userJobPreferences4 = _interopRequireDefault(_userJobPreferences3);
	
	__webpack_require__(624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userJobPreferencesComponent = {
	  restrict: 'E',
	  bindings: {
	    jobPreferences: '<',
	    options: '<'
	  },
	  template: _userJobPreferences2.default,
	  controller: _userJobPreferences4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userJobPreferencesComponent;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-job-preferences\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-user\"></span>\r\n      JOB PREFERENCES\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.jobPreferences.babysitting ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Babysitting\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.jobPreferences.nannying ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Nannying\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.jobPreferences.beforeSchoolCare ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Before School Care\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.jobPreferences.afterSchoolCare ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        After School Care\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.jobPreferences.auPair ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Au Pair\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.jobPreferences.primarySchoolTutoring ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Home Tutoring - Primary School\r\n      </h4>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">\r\n        <span class=\"{{vm.jobPreferences.highSchoolTutoring ? 'fa fa-check green' : 'fa fa-close red'}}\"></span>\r\n        Home Tutoring - High School\r\n      </h4>\r\n    </div>\r\n</div>"

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userJobPreferencesController = function () {
	  function userJobPreferencesController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userJobPreferencesController);
	  }
	
	  (0, _createClass3.default)(userJobPreferencesController, [{
	    key: "hasOptedToPrimarySchool",
	    value: function hasOptedToPrimarySchool() {
	      return this.options.filter(function (o) {
	        return o.optionCategoryId === 1020 && o.valueBool;
	      }).length > 0;
	    }
	  }, {
	    key: "hasOptedToHighSchool",
	    value: function hasOptedToHighSchool() {
	      return this.options.filter(function (o) {
	        return o.optionCategoryId === 1021 && o.valueBool;
	      }).length > 0;
	    }
	  }]);
	  return userJobPreferencesController;
	}();
	
	exports.default = userJobPreferencesController;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(625);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-job-preferences.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-job-preferences.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-job-preferences .fa{margin-right:1rem}.user-job-preferences .green{color:#1c1c1c}.user-job-preferences .red{color:red}", ""]);
	
	// exports


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userCertificates = __webpack_require__(627);
	
	var _userCertificates2 = _interopRequireDefault(_userCertificates);
	
	var _userCertificates3 = __webpack_require__(628);
	
	var _userCertificates4 = _interopRequireDefault(_userCertificates3);
	
	__webpack_require__(629);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userCertificatesComponent = {
	  restrict: 'E',
	  bindings: {
	    certificates: '<'
	  },
	  template: _userCertificates2.default,
	  controller: _userCertificates4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userCertificatesComponent;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-certificates\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      CERTIFICATES\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"certificates-grid\">\r\n      <div id=\"certificates-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userCertificatesController = function () {
	  function userCertificatesController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userCertificatesController);
	  }
	
	  (0, _createClass3.default)(userCertificatesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.gridOptions = {
	        dataSource: this.certificates,
	        sortable: true,
	        pageable: false,
	        resizable: true,
	        noRecords: {
	          template: "No Certificates."
	        },
	        columns: [{ field: "category", title: "Category", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getCategory(dataItem.category);
	          } }, { field: "certificateTypeId", title: "Certificate Type", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getCertificateType(dataItem.certificateTypeId);
	          } }, { field: "certificateNumber", title: "Certificate Number", filterable: false, width: "4rem" }, { field: "certificateStatus", title: "Certificate Status", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getCertificateStatus(dataItem.certificateStatus);
	          } }, { field: "expiryDate", title: "Expiry Date", filterable: false, width: "4rem", template: "#= expiryDate ? kendo.toString(new Date(expiryDate), 'dd/MM/yyyy'): '-' #" }, { field: "verificationDate", title: "Verification Date", filterable: false, width: "4rem", template: "#= verificationDate ? kendo.toString(new Date(verificationDate), 'dd/MM/yyyy'): '-' #" }]
	      };
	    }
	  }, {
	    key: "_getCertificateStatus",
	    value: function _getCertificateStatus(status) {
	      switch (status) {
	        case _constants2.default.certificateStatus.PENDINGVERIFICATION:
	          return "Pending Verification";
	        case _constants2.default.certificateStatus.ACTIVE:
	          return "Active";
	        case _constants2.default.certificateStatus.INVALID:
	          return "Invalid";
	        case _constants2.default.certificateStatus.EXPIRED:
	          return "Expired";
	      }
	    }
	  }, {
	    key: "_getCategory",
	    value: function _getCategory(category) {
	      switch (category) {
	        case _constants2.default.certificateCategory.CHECK:
	          return "Check";
	        case _constants2.default.certificateCategory.FIRSTAID:
	          return "First Aid";
	        case _constants2.default.certificateCategory.QUALIFICATION:
	          return "Qualification";
	      }
	    }
	  }, {
	    key: "_getCertificateType",
	    value: function _getCertificateType(type) {
	      switch (type) {
	        case _constants2.default.certificateType.WWCC:
	          return "WWCC";
	      }
	    }
	  }]);
	  return userCertificatesController;
	}();
	
	exports.default = userCertificatesController;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(630);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-certificates.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-certificates.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-certificates{width:1280px!important;flex-basis:100%}", ""]);
	
	// exports


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mediaFilter = __webpack_require__(632);
	
	var _mediaFilter2 = _interopRequireDefault(_mediaFilter);
	
	var _mediaFilter3 = __webpack_require__(633);
	
	var _mediaFilter4 = _interopRequireDefault(_mediaFilter3);
	
	__webpack_require__(634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mediaFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _mediaFilter2.default,
	  controller: _mediaFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = mediaFilterComponent;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">MEDIA DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n    \r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\"> \r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n    \r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n      \r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label> \r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n      \r\n      <select class=\"k-input\" \r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\" \r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n      \r\n    </div>\r\n    \r\n  </div>  \r\n</div>\r\n"

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaFilterController = function () {
	  MediaFilterController.$inject = ["$scope", "FilterService"];
	  function MediaFilterController($scope, FilterService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MediaFilterController);
	    this.filterService = FilterService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(MediaFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.setFilterOptions();
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions() {
	      this.filterOptions = this.filterService.getMediaFilterOptions();
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return MediaFilterController;
	}();
	
	exports.default = MediaFilterController;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(635);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./media-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./media-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _surveyFilter = __webpack_require__(637);
	
	var _surveyFilter2 = _interopRequireDefault(_surveyFilter);
	
	var _surveyFilter3 = __webpack_require__(638);
	
	var _surveyFilter4 = _interopRequireDefault(_surveyFilter3);
	
	__webpack_require__(639);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surveyFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _surveyFilter2.default,
	  controller: _surveyFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = surveyFilterComponent;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">In Home Aged Care Survey</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n    \r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\"> \r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n    \r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n      \r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label> \r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n      \r\n      <select class=\"k-input\" \r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\" \r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n      \r\n    </div>\r\n    \r\n  </div>  \r\n</div>\r\n"

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyFilterController = function () {
	  SurveyFilterController.$inject = ["$scope", "FilterService"];
	  function SurveyFilterController($scope, FilterService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SurveyFilterController);
	    this.filterService = FilterService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(SurveyFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.setFilterOptions();
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions() {
	      this.filterOptions = this.filterService.getSurveyFilterOptions();
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return SurveyFilterController;
	}();
	
	exports.default = SurveyFilterController;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(640);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./survey-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./survey-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _certificatesFilter = __webpack_require__(642);
	
	var _certificatesFilter2 = _interopRequireDefault(_certificatesFilter);
	
	var _certificatesFilter3 = __webpack_require__(643);
	
	var _certificatesFilter4 = _interopRequireDefault(_certificatesFilter3);
	
	__webpack_require__(644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var certificatesFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _certificatesFilter2.default,
	  controller: _certificatesFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = certificatesFilterComponent;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">CERTIFICATE DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n    \r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\"> \r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n    \r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n      \r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label> \r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n      \r\n      <select class=\"k-input\" \r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\" \r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n      \r\n    </div>\r\n    \r\n  </div>  \r\n</div>\r\n"

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CertificatesFilterController = function () {
	  CertificatesFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function CertificatesFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CertificatesFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(CertificatesFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Certificates global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getCertificatesFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return CertificatesFilterController;
	}();
	
	exports.default = CertificatesFilterController;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(645);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./certificates-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./certificates-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checksFilter = __webpack_require__(647);
	
	var _checksFilter2 = _interopRequireDefault(_checksFilter);
	
	var _checksFilter3 = __webpack_require__(648);
	
	var _checksFilter4 = _interopRequireDefault(_checksFilter3);
	
	__webpack_require__(649);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checksFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _checksFilter2.default,
	  controller: _checksFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = checksFilterComponent;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">CHECK DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n\r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\">\r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n\r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n\r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label>\r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n\r\n      <select class=\"k-input\"\r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\"\r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChecksFilterController = function () {
	  ChecksFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function ChecksFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ChecksFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(ChecksFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Checks global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getChecksFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return ChecksFilterController;
	}();
	
	exports.default = ChecksFilterController;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(650);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./checks-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./checks-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobsFilter = __webpack_require__(652);
	
	var _jobsFilter2 = _interopRequireDefault(_jobsFilter);
	
	var _jobsFilter3 = __webpack_require__(653);
	
	var _jobsFilter4 = _interopRequireDefault(_jobsFilter3);
	
	__webpack_require__(654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _jobsFilter2.default,
	  controller: _jobsFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = jobsFilterComponent;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">JOB DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n    \r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\"> \r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n    \r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n      \r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label> \r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n      \r\n      <select class=\"k-input\" \r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\" \r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n      \r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 3\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label>\r\n        <br/>\r\n        <input kendo-date-picker k-ng-model=\"filter.value\" ng-show=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n      \r\n    </div>\r\n    \r\n  </div>  \r\n</div>\r\n"

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobsFilterController = function () {
	  JobsFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function JobsFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, JobsFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(JobsFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getJobsFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return JobsFilterController;
	}();
	
	exports.default = JobsFilterController;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(655);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./jobs-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./jobs-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobRequestsFilter = __webpack_require__(657);
	
	var _jobRequestsFilter2 = _interopRequireDefault(_jobRequestsFilter);
	
	var _jobRequestsFilter3 = __webpack_require__(658);
	
	var _jobRequestsFilter4 = _interopRequireDefault(_jobRequestsFilter3);
	
	__webpack_require__(659);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobRequestsFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _jobRequestsFilter2.default,
	  controller: _jobRequestsFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = jobRequestsFilterComponent;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">CONCIERGE REQUESTS</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n\r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\">\r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n\r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n\r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label>\r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n\r\n      <select class=\"k-input\"\r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\"\r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n\r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 3\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label>\r\n        <br/>\r\n        <input kendo-date-picker k-ng-model=\"filter.value\" ng-show=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobRequestsFilterController = function () {
	  JobRequestsFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function JobRequestsFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, JobRequestsFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(JobRequestsFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getJobRequestsFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return JobRequestsFilterController;
	}();
	
	exports.default = JobRequestsFilterController;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(660);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./job-requests-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./job-requests-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _affiliatesFilter = __webpack_require__(662);
	
	var _affiliatesFilter2 = _interopRequireDefault(_affiliatesFilter);
	
	var _affiliatesFilter3 = __webpack_require__(663);
	
	var _affiliatesFilter4 = _interopRequireDefault(_affiliatesFilter3);
	
	__webpack_require__(664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var affiliatesFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _affiliatesFilter2.default,
	  controller: _affiliatesFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = affiliatesFilterComponent;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">PARTNER DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n\r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\">\r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n\r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n\r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label>\r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n\r\n      <select class=\"k-input\"\r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\"\r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AffiliatesFilterController = function () {
	  AffiliatesFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function AffiliatesFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AffiliatesFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(AffiliatesFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Affiliates global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getAffiliatesFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return AffiliatesFilterController;
	}();
	
	exports.default = AffiliatesFilterController;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(665);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./affiliates-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./affiliates-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vouchesFilter = __webpack_require__(667);
	
	var _vouchesFilter2 = _interopRequireDefault(_vouchesFilter);
	
	var _vouchesFilter3 = __webpack_require__(668);
	
	var _vouchesFilter4 = _interopRequireDefault(_vouchesFilter3);
	
	__webpack_require__(669);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var affiliatesFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _vouchesFilter2.default,
	  controller: _vouchesFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = affiliatesFilterComponent;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">VOUCHES DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n\r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\">\r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n\r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n\r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label>\r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n\r\n      <select class=\"k-input\"\r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\"\r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VouchesFilterController = function () {
	  VouchesFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function VouchesFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VouchesFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(VouchesFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Vouches global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getVouchesFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return VouchesFilterController;
	}();
	
	exports.default = VouchesFilterController;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(670);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vouches-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vouches-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userMessages = __webpack_require__(672);
	
	var _userMessages2 = _interopRequireDefault(_userMessages);
	
	var _userMessages3 = __webpack_require__(673);
	
	var _userMessages4 = _interopRequireDefault(_userMessages3);
	
	__webpack_require__(674);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userMessagesComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<'
	  },
	  template: _userMessages2.default,
	  controller: _userMessages4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userMessagesComponent;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-messages\">\r\n  <div>\r\n    <div id=\"messages-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n  </div>\r\n</div>"

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userMessagesController = function () {
	  userMessagesController.$inject = ["UsersService", "AuthService"];
	  function userMessagesController(UsersService, AuthService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userMessagesController);
	    this.usersService = UsersService;
	    this.authService = AuthService;
	  }
	
	  (0, _createClass3.default)(userMessagesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.gridOptions = {
	        dataSource: this.usersService.getMessagesDataSource(this.userId, true, function () {}, this.dataSourceErrorSuccessCallback),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        noRecords: {
	          template: "No Messages."
	        },
	        columns: [{ field: "creationDate", title: "Date", filterable: false, width: "2.5rem", template: "#= kendo.toString(new Date(creationDate), 'dd/MM @ hh:mmtt') #" }, { field: "messageType", title: "Type", filterable: false, width: "1rem", template: function template(dataItem) {
	            return dataItem.messageType == 1 ? "Email" : dataItem.messageType == 2 ? "SMS" : "Push";
	          } }, { field: "destination", title: "Target", filterable: false, width: "2rem" }, { field: "title", title: "Title", filterable: false, width: "3rem" }, { field: "body", title: "Body", filterable: false, width: "8rem" }, { field: "notificationOutcome", title: "Notification Outcome", filterable: false, sortable: false, width: "3rem", template: function template(dataItem) {
	            return "" + _this.getNotificationOutcome(dataItem);
	          } }]
	      };
	    }
	  }, {
	    key: "getNotificationOutcome",
	    value: function getNotificationOutcome(dataItem) {
	      if (dataItem.messageType !== 3) return "";
	
	      var outcome = "";
	
	      switch (dataItem.notificationOutcome) {
	        case _constants2.default.notificationOutcome.QUEUED:
	          outcome += "N/A";
	          break;
	        case _constants2.default.notificationOutcome.PROCESSING:
	          outcome += "Processing";
	          break;
	        case _constants2.default.notificationOutcome.COMPLETED:
	          outcome += "Completed";
	          break;
	        case _constants2.default.notificationOutcome.ABANDONED:
	          outcome += "Abandoned";
	          break;
	        case _constants2.default.notificationOutcome.UNKNOWN:
	          outcome += "Unknown";
	          break;
	        case _constants2.default.notificationOutcome.NOTARGETFOUND:
	          outcome += "No Target Found";
	          break;
	        case _constants2.default.notificationOutcome.CANCELLED:
	          outcome += "Cancelled";
	          break;
	        default:
	          outcome += '';
	          break;
	      }
	
	      if (dataItem.notes) {
	        outcome += ' - ' + dataItem.notes;
	      }
	
	      return outcome;
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }]);
	  return userMessagesController;
	}();
	
	exports.default = userMessagesController;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(675);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-messages.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-messages.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-messages{width:1280px!important}", ""]);
	
	// exports


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _botManagerFilter = __webpack_require__(677);
	
	var _botManagerFilter2 = _interopRequireDefault(_botManagerFilter);
	
	var _botManagerFilter3 = __webpack_require__(678);
	
	var _botManagerFilter4 = _interopRequireDefault(_botManagerFilter3);
	
	__webpack_require__(679);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botManagerFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _botManagerFilter2.default,
	  controller: _botManagerFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = botManagerFilterComponent;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">BOT MANAGER DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n    \r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\"> \r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n    \r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n      \r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label> \r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n      \r\n      <select class=\"k-input\" \r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\" \r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n      \r\n    </div>\r\n    \r\n  </div>  \r\n</div>\r\n"

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotManagerFilterController = function () {
	  BotManagerFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function BotManagerFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BotManagerFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(BotManagerFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Bot Manager global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getbotManagerFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return BotManagerFilterController;
	}();
	
	exports.default = BotManagerFilterController;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(680);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./bot-manager-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./bot-manager-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userPayAgreements = __webpack_require__(682);
	
	var _userPayAgreements2 = _interopRequireDefault(_userPayAgreements);
	
	var _userPayAgreements3 = __webpack_require__(683);
	
	var _userPayAgreements4 = _interopRequireDefault(_userPayAgreements3);
	
	__webpack_require__(684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userPayAgreementsComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<'
	  },
	  template: _userPayAgreements2.default,
	  controller: _userPayAgreements4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userPayAgreementsComponent;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-pay-agreements\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-credit-card\"></span>\r\n      PAY AGREEMENTS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details-grid\">\r\n    <div ng-show=\"vm.isLoading\" style=\"text-align:center; padding: 1rem;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-2x fa-fw\"></i>\r\n    </div>\r\n    <div id=\"pay-agreements-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n  </div>\r\n</div>\r\n<div kendo-dialog=\"vm.confirmDeleteDialog\" id=\"pay-agreement-confirm-delete-dialog\" k-options=\"vm.confirmDeleteDialogOptions\">\r\n  Are you sure you want to delete this pay agreement?\r\n</div>"

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userPayAgreementsController = function () {
	  userPayAgreementsController.$inject = ["UsersService", "NotificationService", "$scope"];
	  function userPayAgreementsController(UsersService, NotificationService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, userPayAgreementsController);
	    this.usersService = UsersService;
	    this.notificationService = NotificationService;
	    this.$scope = $scope;
	    this.isLoading = false;
	  }
	
	  (0, _createClass3.default)(userPayAgreementsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var ctr = this;
	      this.confirmDeleteDialogOptions = {
	        title: 'Confirm Delete',
	        visible: false,
	        closable: true,
	        modal: true,
	        buttonLayout: 'normal',
	        messages: { close: '' },
	        actions: [{ text: 'No' }, {
	          text: 'Yes',
	          primary: true,
	          action: function action() {
	            return ctr._doDelete();
	          }
	        }]
	      };
	      this.gridOptions = {
	        dataSource: [],
	        sortable: true,
	        pageable: false,
	        scrollable: false,
	        resizable: true,
	        noRecords: { template: 'No pay agreements found.' },
	        columns: [{ field: 'payAgreementId', title: 'ID' }, { field: 'dateCreatedUtc', title: 'Date Created', template: '#= dateCreatedUtc ? kendo.toString(new Date(dateCreatedUtc), \'dd-MM-yyyy HH:mm\') : \'-\' #' }, { field: 'dateModifiedUtc', title: 'Date Modified', template: '#= dateModifiedUtc ? kendo.toString(new Date(dateModifiedUtc), \'dd-MM-yyyy HH:mm\') : \'-\' #' }, { field: 'isActive', title: 'Is Active', template: '#= isActive ? \'Yes\' : \'No\' #' }, { field: 'parentJugglerID', title: 'Parent Juggler ID' }, { field: 'payAgreementStatus', title: 'Status' }, { field: 'payPayer', title: 'Pay Payer' }, {
	          title: 'Delete',
	          width: '80px',
	          command: [{
	            text: ' ',
	            iconClass: 'fa fa-trash',
	            click: function click(e) {
	              e.preventDefault();
	              var tr = $(e.currentTarget).closest('tr');
	              var dataItem = this.dataItem(tr);
	              ctr._pendingDeleteId = dataItem.payAgreementId;
	              ctr.confirmDeleteDialog.open();
	            }
	          }]
	        }]
	      };
	      this._loadAgreements();
	    }
	  }, {
	    key: '_doDelete',
	    value: function _doDelete() {
	      var _this = this;
	
	      this.usersService.resetPayto(this.userId, this._pendingDeleteId, function () {
	        _this.notificationService.success('Pay agreement deleted.');
	        _this._loadAgreements();
	      }, function () {
	        return _this.notificationService.error('Failed to delete pay agreement.');
	      });
	    }
	  }, {
	    key: '_loadAgreements',
	    value: function _loadAgreements() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      this.usersService.getPayAgreements(this.userId, function (response) {
	        _this2.isLoading = false;
	        var grid = $('#pay-agreements-grid').data('kendoGrid');
	        if (grid) {
	          grid.setDataSource(new kendo.data.DataSource({ data: response.data }));
	        }
	        _this2.$scope.$apply();
	      }, function () {
	        _this2.isLoading = false;
	        _this2.notificationService.error('Failed to load pay agreements.');
	        _this2.$scope.$apply();
	      });
	    }
	  }]);
	  return userPayAgreementsController;
	}();
	
	exports.default = userPayAgreementsController;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-pay-agreements.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-pay-agreements.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-pay-agreements{width:1280px!important}.user-pay-agreements .k-grid{width:100%}.user-pay-agreements .fa-trash{color:red;cursor:pointer}", ""]);
	
	// exports


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _botSessionsFilter = __webpack_require__(687);
	
	var _botSessionsFilter2 = _interopRequireDefault(_botSessionsFilter);
	
	var _botSessionsFilter3 = __webpack_require__(688);
	
	var _botSessionsFilter4 = _interopRequireDefault(_botSessionsFilter3);
	
	__webpack_require__(689);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botSessionsFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _botSessionsFilter2.default,
	  controller: _botSessionsFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = botSessionsFilterComponent;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">BOT SESSIONS DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n    \r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\"> \r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n    \r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n      \r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label> \r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\">\r\n      </div>\r\n      \r\n      <select class=\"k-input\" \r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\" \r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n      \r\n    </div>\r\n    \r\n  </div>  \r\n</div>\r\n"

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotSessionsFilterController = function () {
	  BotSessionsFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function BotSessionsFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BotSessionsFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(BotSessionsFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Bot Sessions global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getbotSessionsFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return BotSessionsFilterController;
	}();
	
	exports.default = BotSessionsFilterController;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(690);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./bot-sessions-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./bot-sessions-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _businessesFilter = __webpack_require__(692);
	
	var _businessesFilter2 = _interopRequireDefault(_businessesFilter);
	
	var _businessesFilter3 = __webpack_require__(693);
	
	var _businessesFilter4 = _interopRequireDefault(_businessesFilter3);
	
	__webpack_require__(694);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var businessesFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    applyFilters: '&'
	  },
	  template: _businessesFilter2.default,
	  controller: _businessesFilter4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = businessesFilterComponent;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"filter-container\">\r\n  <div class=\"header\">BUSINESS DATA</div>\r\n  <div class=\"filter-type-container\" ng-repeat=\"filter in vm.filterOptions\">\r\n\r\n    <div class=\"filter-type\">\r\n      <input type=\"checkbox\" id=\"filter-type-{{filter.field}}\" ng-model=\"filter.isActive\">\r\n      <span class=\"filter-icon fa {{filter.icon}}\"></span>\r\n      <label for=\"filter-type-{{filter.field}}\">{{filter.label}}</label>\r\n    </div>\r\n\r\n    <div class=\"filter-items-container\" ng-if=\"filter.isActive\">\r\n      <span class=\"fa fa-close close-icon\" ng-click=\"filter.isActive = false\"></span>\r\n\r\n      <div class=\"filter-item\" ng-repeat=\"(key, filterItem) in filter.filterIitems\" ng-if=\"filter.filterType == 1\">\r\n        <input type=\"radio\" id=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\" ng-model=\"filter.filterItemSelected\" ng-value=\"filterItem.value\">\r\n        <label for=\"filter-item-label-{{filter.field + '-' + filterItem.label}}\">{{filterItem.label}}</label>\r\n        <br/>\r\n        <input type=\"text\" class=\"filter-value-text-box k-input\" ng-model=\"filter.value\" ng-if=\"filter.filterItemSelected == filterItem.value\" ng-hide=\"filterItem.hideValueField\">\r\n      </div>\r\n\r\n      <select class=\"k-input\"\r\n        ng-options=\"filterItem.value as filterItem.label for (key, filterItem) in filter.filterIitems\"\r\n        ng-if=\"filter.filterType == 2\"\r\n        ng-model=\"filter.value\">\r\n        <option value=\"\">Choose</option>\r\n      </select>\r\n\r\n      <div class=\"filter-item\" ng-if=\"filter.filterType == 3\">\r\n        <label>{{filterItem.label}}</label>\r\n        <input kendo-date-picker k-ng-model=\"filter.value\">\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BusinessesFilterController = function () {
	  BusinessesFilterController.$inject = ["$scope", "FilterService", "EventsService"];
	  function BusinessesFilterController($scope, FilterService, EventsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BusinessesFilterController);
	    this.filterService = FilterService;
	    this.eventsService = EventsService;
	
	    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
	  }
	
	  (0, _createClass3.default)(BusinessesFilterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.setFilterOptions();
	
	      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
	        console.log("Global filter applied::", globalFilter);
	
	        _this.setFilterOptions(globalFilter.type);
	      });
	    }
	  }, {
	    key: "setFilterOptions",
	    value: function setFilterOptions(activeGlobalFilter) {
	      this.filterOptions = this.filterService.getBusinessesFilterOptions(activeGlobalFilter);
	      return this.filterOptions;
	    }
	  }, {
	    key: "onFilterChagne",
	    value: function onFilterChagne(newval, oldval) {
	      // Apply filters only if filter options are changed
	      var isFilterOptionsChanged = false;
	
	      for (var i = 0; i < newval.length; i++) {
	        if (newval[i].isActive != oldval[i].isActive) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	
	        if (newval[i].filterItemSelected != oldval[i].filterItemSelected) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	
	        if (newval[i].value != oldval[i].value) {
	          isFilterOptionsChanged = true;
	          break;
	        }
	      }
	
	      if (!isFilterOptionsChanged) return;
	
	      this.filterService.generateFilterExpression(this.filterOptions);
	      this.applyFilters();
	    }
	  }]);
	  return BusinessesFilterController;
	}();
	
	exports.default = BusinessesFilterController;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(695);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./businesses-filter.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./businesses-filter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.filter-container{font-size:.8rem;margin-top:2rem}.filter-container .header{font-weight:700;margin-left:.5rem;margin-bottom:1rem}.filter-container .filter-type-container{margin:.5rem}.filter-container .filter-type-container .filter-type .filter-icon{margin:0 .4rem}.filter-container .filter-type-container .filter-items-container{margin:.5rem;background:#f5f5f5;border-radius:.3rem;padding:.5rem;border:1px solid #d8d8d8;position:relative}.filter-container .filter-type-container .filter-items-container .close-icon{position:absolute;right:.2rem;top:.2rem;color:#898989;cursor:pointer}.filter-container .filter-type-container .filter-items-container .filter-item>label{display:inline-block;width:80%}.filter-container .filter-type-container .filter-items-container .filter-item{margin-bottom:.2rem}.filter-container .filter-type-container .filter-items-container .filter-item .filter-value-text-box{margin:.1rem 0 .3rem .9rem;width:10rem}", ""]);
	
	// exports


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _postJob = __webpack_require__(697);
	
	var _postJob2 = _interopRequireDefault(_postJob);
	
	var _postJob3 = __webpack_require__(698);
	
	var _postJob4 = _interopRequireDefault(_postJob3);
	
	__webpack_require__(699);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postJobComponent = {
	  restrict: 'E',
	  bindings: {
	    user: '<'
	  },
	  template: _postJob2.default,
	  controller: _postJob4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = postJobComponent;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component post-job\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-briefcase\"></span>\r\n      ADD JOB\r\n    </h4>\r\n    \r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Current Job Post Limit</h4>\r\n      <span class=\"item-text\">{{vm.user.clientInfo.jobPostLimit}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <h4 class=\"item-title\">Increase By</h4>\r\n      <select class=\"k-input\" ng-model=\"vm.selectedJobCount\">\r\n        <option value=\"\">-- Select --</option>\r\n        <option ng-repeat=\"opt in vm.jobCountOptions\" value=\"{{opt}}\">{{opt}}</option>\r\n        <!-- <option value=\"manual\">Manual</option> -->\r\n      </select>\r\n      <input type=\"number\" class=\"k-textbox\" ng-if=\"vm.selectedJobCount === 'manual'\" ng-model=\"vm.manualJobCount\" placeholder=\"Enter custom count\" min=\"1\" style=\"margin-top: 8px;\" />\r\n    </div>\r\n    <div class=\"item\">\r\n      <button class=\"k-button k-primary\" ng-click=\"vm.addJobs()\" ng-disabled=\"vm.isLoading\">{{vm.isLoading ? 'Saving...' : 'Increase Job Limit'}}</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postJobController = function () {
	  postJobController.$inject = ["UsersService", "NotificationService"];
	  function postJobController(UsersService, NotificationService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, postJobController);
	    this.usersService = UsersService;
	    this.notificationService = NotificationService;
	    this.jobCountOptions = [50, 100, 150];
	    this.selectedJobCount = null;
	    this.manualJobCount = null;
	    this.isLoading = false;
	  }
	
	  (0, _createClass3.default)(postJobController, [{
	    key: 'addJobs',
	    value: function addJobs() {
	      var _this = this;
	
	      var count = this.selectedJobCount === 'manual' ? this.manualJobCount : this.selectedJobCount;
	      if (!count || count <= 0) return;
	
	      this.isLoading = true;
	      this.usersService.updateJobPostLimit(this.user.userId, count, function (response) {
	        _this.user.clientInfo.jobPostLimit = response.data;
	        _this.selectedJobCount = null;
	        _this.manualJobCount = null;
	        _this.isLoading = false;
	        _this.notificationService.success('Job post limit updated successfully.');
	      }, function (error) {
	        _this.isLoading = false;
	        _this.notificationService.error('Failed to update job post limit.');
	      });
	    }
	  }]);
	  return postJobController;
	}();
	
	exports.default = postJobController;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(700);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./post-job.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./post-job.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}", ""]);
	
	// exports


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userInvoices = __webpack_require__(702);
	
	var _userInvoices2 = _interopRequireDefault(_userInvoices);
	
	var _userInvoices3 = __webpack_require__(703);
	
	var _userInvoices4 = _interopRequireDefault(_userInvoices3);
	
	__webpack_require__(704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userInvoicesComponent = {
	  restrict: 'E',
	  bindings: {
	    user: '='
	  },
	  template: _userInvoices2.default,
	  controller: _userInvoices4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userInvoicesComponent;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-invoices\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-dollar\"></span>\r\n      INVOICES\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"invoices-grid\">\r\n      <div id=\"invoices-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userInvoicesController = function () {
	  userInvoicesController.$inject = ["UsersService", "AppContextService", "NotificationService"];
	  function userInvoicesController(UsersService, AppContextService, NotificationService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, userInvoicesController);
	    this.usersService = UsersService;
	    this.appContextService = AppContextService;
	    this.notificationService = NotificationService;
	  }
	
	  (0, _createClass3.default)(userInvoicesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var paidInvoices = this.user.invoices.filter(function (i) {
	        return i.paid;
	      });
	      var ctr = this;
	      this.gridOptions = {
	        dataSource: paidInvoices,
	        sortable: true,
	        pageable: false,
	        resizable: true,
	        noRecords: {
	          template: "No Invoices."
	        },
	        columns: [{ field: "date", title: "Date", filterable: false, width: "4rem", template: "#= kendo.toString(new Date(date), 'dd-MM-yyyy') #" }, { field: "description", title: "Description", filterable: false, width: "8rem" },
	        // { field: "subtotal", title: "Subtotal", filterable: false, width: "4rem", template: `#= '$' + (subtotal/100).toFixed(2) #` },
	        // { field: "taxPercent", title: "Tax Percent", filterable: false, width: "4rem" },
	        // { field: "tax", title: "Tax", filterable: false, width: "4rem", template: `#= '$' + (tax/100).toFixed(2) #` },
	        // { field: "total", title: "Total", filterable: false, width: "4rem", template: `#= '$' + ((adjustedTotal - amountRefunded)/100).toFixed(2) #` },
	        { field: "total", title: "Total", filterable: false, width: "4rem", template: "#= '$' + ((adjustedTotal)/100).toFixed(2) #" }, { field: "refunded", title: "Refunded", filterable: false, width: "4rem", template: "#= '$' + ((amountRefunded)/100).toFixed(2) #" }]
	      };
	
	      if (this.hasPaymentsAdminAccess()) {
	        this.gridOptions.columns.push({
	          title: "Refund",
	          command: [{
	            click: function click(e) {
	              ctr.refundInvoice(this, e, ctr);
	            },
	            // Doesn't work with the current Kendo release.
	            visible: function visible(dataItem) {
	              return false;
	            },
	            text: "Refund"
	          }],
	          width: "4rem"
	        });
	      }
	    }
	  }, {
	    key: "hasPaymentsAdminAccess",
	    value: function hasPaymentsAdminAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasPaymentsAdminAccess(appContext.roles)) return true;else return false;
	    }
	  }, {
	    key: "hasGlobalAdminAccess",
	    value: function hasGlobalAdminAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
	    }
	  }, {
	    key: "refundInvoice",
	    value: function refundInvoice(context, args, ctrl) {
	      var tr = $(args.target).closest("tr");
	      var invoice = context.dataItem(tr);
	
	      if (!this.hasGlobalAdminAccess()) {
	        var rawInvoice = this.user.invoices.find(function (i) {
	          return i.id == invoice.id;
	        });
	        var invoiceIdx = this.user.invoices.indexOf(rawInvoice);
	        if (invoiceIdx != this.user.invoices.length - 1) {
	          alert('Only the most recent invoice can be refunded.');
	          return;
	        }
	      }
	
	      if (invoice.amountRefunded > 0) {
	        alert('This invoice has already been refunded.');
	        return;
	      }
	
	      if (confirm('Are you sure you want to refund this invoice?')) {
	        ctrl.usersService.refundInvoice(invoice.id, invoice, function (response) {
	          ctrl.notificationService.success("Update Successful");
	          ctrl.user = response.data;
	
	          var dataSource = new kendo.data.DataSource({
	            data: ctrl.user.invoices
	          });
	          var grid = $("#invoices-grid").data("kendoGrid");
	          grid.setDataSource(dataSource);
	        }, function (error) {
	          ctrl.notificationService.error(error.data ? error.data : "Update Failed");
	        });
	      }
	    }
	  }]);
	  return userInvoicesController;
	}();
	
	exports.default = userInvoicesController;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(705);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-invoices.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-invoices.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-invoices{width:1280px!important}", ""]);
	
	// exports


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userJobEdit = __webpack_require__(707);
	
	var _userJobEdit2 = _interopRequireDefault(_userJobEdit);
	
	var _userJobEdit3 = __webpack_require__(708);
	
	var _userJobEdit4 = _interopRequireDefault(_userJobEdit3);
	
	__webpack_require__(709);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userJobEditComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<'
	  },
	  template: _userJobEdit2.default,
	  controller: _userJobEdit4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userJobEditComponent;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-component user-job-edit\">\n  <div class=\"title\">\n    <h4>\n      <span class=\"fa fa-briefcase\"></span>\n      JOB PRICING EDIT\n    </h4>\n  </div>\n  <div class=\"details-grid\">\n    <div kendo-grid=\"vm.grid\" k-options=\"vm.gridOptions\"></div>\n  </div>\n</div>\n"

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserJobEditController = function () {
	  UserJobEditController.$inject = ["JobsService", "$scope", "$window"];
	  function UserJobEditController(JobsService, $scope, $window) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserJobEditController);
	    this.JobsService = JobsService;
	    this.$scope = $scope;
	    this.$window = $window;
	  }
	
	  (0, _createClass3.default)(UserJobEditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var dataSource = this.JobsService.getJugglerJobsDataSource(this.userId);
	
	      dataSource.bind('requestEnd', function (e) {
	        if (e.type === 'update' && e.response) {
	          _this.$scope.$applyAsync();
	          _this.$window.location.reload();
	        }
	      });
	
	      this.gridOptions = {
	        dataSource: dataSource,
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        editable: 'inline',
	        noRecords: {
	          template: 'No Jobs found.'
	        },
	        columns: [{ field: 'id', title: 'ID', width: '2rem', filterable: false, template: '#= data.id || data.jobId || data.JobId || data.Id || "" #' }, { field: 'paymentType', title: 'Payment Type', width: '4rem', filterable: false, template: '#= data.paymentType || data.PaymentType || "" #' }, { field: 'jobDate', title: 'Job Date', width: '3.5rem', filterable: false, template: '#= (data.jobDate || data.JobDate) ? kendo.toString(new Date(data.jobDate || data.JobDate), \'dd/MM/yyyy\') : "" #' }, { field: 'estimatedJobHours', title: 'Est. Hours', width: '3rem', filterable: false, template: '#= data.estimatedJobHours || data.EstimatedJobHours || "" #' }, { field: 'price', title: 'Price', width: '3rem', filterable: false, template: '#= data.price || data.Price || 0 #' }, { field: 'overtimeRate', title: 'Overtime Rate', width: '3.5rem', filterable: false, template: '#= data.overtimeRate || data.OvertimeRate || 0 #' }, { field: 'estimatedJobValue', title: 'Est. Value', width: '3rem', filterable: false, template: '#= data.estimatedJobValue || data.EstimatedJobValue || 0 #' }, { command: ['edit'], title: 'Actions', width: '3.5rem' }]
	      };
	    }
	  }]);
	  return UserJobEditController;
	}();
	
	exports.default = UserJobEditController;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(710);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-job-edit.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./user-job-edit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	
	
	// module
	exports.push([module.id, ".user-job-edit{width:100%!important}.user-job-edit .details-grid{background:#fff;padding:0}.user-job-edit .details-grid .k-grid-cancel,.user-job-edit .details-grid .k-grid-edit,.user-job-edit .details-grid .k-grid-update{margin:1px!important;min-width:0}", ""]);
	
	// exports


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auth = __webpack_require__(712);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _http = __webpack_require__(713);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _navigation = __webpack_require__(754);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _users = __webpack_require__(755);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _filter = __webpack_require__(758);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _notification = __webpack_require__(760);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _appContext = __webpack_require__(761);
	
	var _appContext2 = _interopRequireDefault(_appContext);
	
	var _events = __webpack_require__(762);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _analytics = __webpack_require__(763);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _media = __webpack_require__(764);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _survey = __webpack_require__(765);
	
	var _survey2 = _interopRequireDefault(_survey);
	
	var _profiles = __webpack_require__(766);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _certificates = __webpack_require__(767);
	
	var _certificates2 = _interopRequireDefault(_certificates);
	
	var _checks = __webpack_require__(768);
	
	var _checks2 = _interopRequireDefault(_checks);
	
	var _jobs = __webpack_require__(769);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _jobRequests = __webpack_require__(770);
	
	var _jobRequests2 = _interopRequireDefault(_jobRequests);
	
	var _affiliates = __webpack_require__(771);
	
	var _affiliates2 = _interopRequireDefault(_affiliates);
	
	var _vouches = __webpack_require__(786);
	
	var _vouches2 = _interopRequireDefault(_vouches);
	
	var _mermaid = __webpack_require__(787);
	
	var _mermaid2 = _interopRequireDefault(_mermaid);
	
	var _botFlow = __webpack_require__(788);
	
	var _botFlow2 = _interopRequireDefault(_botFlow);
	
	var _botManager = __webpack_require__(789);
	
	var _botManager2 = _interopRequireDefault(_botManager);
	
	var _botSessions = __webpack_require__(790);
	
	var _botSessions2 = _interopRequireDefault(_botSessions);
	
	var _businesses = __webpack_require__(791);
	
	var _businesses2 = _interopRequireDefault(_businesses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = _angular2.default.module('app.common.services', [_angularUiRouter2.default]).factory('AuthService', _auth2.default).factory('HttpService', _http2.default).factory('UsersService', _users2.default).factory('NavigationService', _navigation2.default).factory('FilterService', _filter2.default).factory('NotificationService', _notification2.default).factory('AppContextService', _appContext2.default).factory('EventsService', _events2.default).factory('AnalyticsService', _analytics2.default).factory('MediaService', _media2.default).factory('SurveyService', _survey2.default).factory('ProfilesService', _profiles2.default).factory('CertificatesService', _certificates2.default).factory('ChecksService', _checks2.default).factory('JobsService', _jobs2.default).factory('AffiliatesService', _affiliates2.default).factory('VouchesService', _vouches2.default).factory('MermaidService', _mermaid2.default).factory('BotFlowService', _botFlow2.default).factory('BotManagerService', _botManager2.default).factory('BotSessionsService', _botSessions2.default).factory('BusinessesService', _businesses2.default).factory('JobRequestsService', _jobRequests2.default);
	
	exports.default = Services;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthService = function AuthService($http, NavigationService) {
	  "ngInject";
	
	  var _accessToken = void 0;
	
	  var setAccessToken = function setAccessToken(response) {
	    window.localStorage.setItem("bigfootAccessToken", response.data.accessToken);
	    window.localStorage.setItem("bigfootRefreshToken", response.data.refreshToken);
	    _accessToken = response.data.accessToken;
	  };
	
	  var getAccessToken = function getAccessToken() {
	    // Always retrieve from storage.
	    // if (_accessToken) return _accessToken;
	
	    var token = window.localStorage.getItem("bigfootAccessToken");
	    if (token) _accessToken = token;
	
	    return token;
	  };
	
	  var getRefreshToken = function getRefreshToken() {
	    var token = window.localStorage.getItem("bigfootRefreshToken");
	
	    return token;
	  };
	
	  var refreshToken = function refreshToken() {
	    var payload = {
	      refreshToken: getRefreshToken()
	    };
	
	    return $http({
	      method: "POST",
	      url: _env2.default.getApiUrl("identity/refreshtoken"),
	      data: payload
	    }).then(function (response) {
	      setAccessToken(response);
	
	      return response;
	    });
	  };
	
	  var initiateLogin = function initiateLogin(payload, successCb, errorCb) {
	    $http({
	      method: "POST",
	      url: _env2.default.getApiUrl("identity/initiatetwofactorlogin"),
	      data: payload
	    }).then(function (response) {
	      setAccessToken(response);
	      successCb(response);
	    }, errorCb);
	  };
	
	  var login = function login(payload, successCb, errorCb) {
	    $http({
	      method: "POST",
	      url: _env2.default.getApiUrl("identity/token"),
	      data: payload
	    }).then(function (response) {
	      setAccessToken(response);
	      successCb(response);
	    }, errorCb);
	  };
	
	  var logout = function logout() {
	    window.localStorage.removeItem("bigfootAccessToken");
	    window.localStorage.removeItem("bigfootRefreshToken");
	    NavigationService.go("login");
	    window.location.reload();
	  };
	
	  var isAuthorized = function isAuthorized() {
	    if (window.localStorage.getItem("bigfootAccessToken")) return true;
	
	    return false;
	  };
	
	  return { isAuthorized: isAuthorized, login: login, logout: logout, getAccessToken: getAccessToken, initiateLogin: initiateLogin, refreshToken: refreshToken, getRefreshToken: getRefreshToken };
	};
	AuthService.$inject = ["$http", "NavigationService"];
	
	exports.default = AuthService;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(714);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = __webpack_require__(728);
	
	var MAXRETRIES = 3;
	var RETRYINTERVALS = [5000, 10000, 15000];
	var refreshTokenRequestTime = new Date(2018, 11);
	var isRefreshing = false;
	var failedQueue = [];
	
	var delay = function delay(t) {
	  return new _promise2.default(function (resolve) {
	    return setTimeout(resolve, t);
	  });
	};
	
	var processQueue = function processQueue(error) {
	  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  failedQueue.forEach(function (prom) {
	    if (error) {
	      prom.reject(error);
	    } else {
	      prom.resolve(token);
	    }
	  });
	  failedQueue = [];
	};
	
	var HttpService = function HttpService($http, AuthService, $q) {
	  "ngInject";
	
	  axios.interceptors.request.use(function (config) {
	    if (!config.retries) config.retries = 0;
	    return config;
	  }, function (error) {
	    return _promise2.default.reject(error);
	  });
	
	  axios.interceptors.response.use(function (response) {
	    return response;
	  }, function (error) {
	    var originalRequest = error.config;
	
	    if (error.response && error.response.status === 401 && !originalRequest.url.endsWith('refreshtoken') && !originalRequest._retry) {
	
	      if (isRefreshing) {
	        return new _promise2.default(function (resolve, reject) {
	          failedQueue.push({ resolve: resolve, reject: reject });
	        }).then(function (token) {
	          originalRequest.headers.Authorization = "Bearer " + token;
	          return axios.request(originalRequest);
	        }).catch(function (err) {
	          return _promise2.default.reject(err);
	        });
	      }
	
	      originalRequest._retry = true;
	      isRefreshing = true;
	
	      if (AuthService.getRefreshToken()) {
	        return AuthService.refreshToken().then(function () {
	          var newToken = AuthService.getAccessToken();
	          originalRequest.headers.Authorization = "Bearer " + newToken;
	          processQueue(null, newToken);
	          isRefreshing = false;
	          return axios.request(originalRequest);
	        }).catch(function (err) {
	          processQueue(err, null);
	          isRefreshing = false;
	          AuthService.logout();
	          return _promise2.default.reject(err);
	        });
	      }
	    }
	    return _promise2.default.reject(error);
	  });
	
	  // const refreshToken = () => {
	  //   const payload = {
	  //     refreshToken: AuthService.getRefreshToken()
	  //   };
	
	  //   return axios({
	  //     method: "POST",
	  //     url: env.getApiUrl("identity/refreshtoken"),
	  //     data: payload
	  //   })
	  //   .then((response) => {
	  //     AuthService.setAccessToken(response);
	
	  //     return response;
	  //   });
	  // };
	
	  var get = function get(path, successCallback, errorCallback) {
	    console.log("Get called::", path);
	
	    axios({
	      method: "GET",
	      url: _env2.default.getApiUrl(path),
	      headers: {
	        "Authorization": "Bearer " + AuthService.getAccessToken()
	      }
	    }).then(successCallback).catch(errorCallback);
	
	    // $http({
	    //   method: "GET",
	    //   url: env.getApiUrl(path),
	    //   headers: {
	    //     "Authorization": `Bearer ${AuthService.getAccessToken()}`
	    //   },
	    // })
	    // .then(successCallback, (error) => {
	    //   if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
	    //     AuthService.refreshToken().then(() => {
	    //       return get(path, successCallback, errorCallback);
	    //     }).catch(errorCallback);
	    //   }
	    // });
	  };
	
	  var post = function post(path, payload, successCallback, errorCallback) {
	    console.log("Post called::", path, payload);
	
	    $http({
	      method: "POST",
	      url: _env2.default.getApiUrl(path),
	      data: payload,
	      headers: {
	        "Authorization": "Bearer " + AuthService.getAccessToken()
	      }
	    }).then(successCallback, function (error) {
	      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
	        AuthService.refreshToken().then(function () {
	          return post(path, payload, successCallback, errorCallback);
	        }).catch(errorCallback);
	      } else {
	        if (errorCallback) {
	          errorCallback(error);
	        }
	      }
	    });
	  };
	
	  var patch = function patch(path, payload, successCallback, errorCallback) {
	    console.log("Patch called::", path, payload);
	
	    $http({
	      method: "PATCH",
	      url: _env2.default.getApiUrl(path),
	      data: payload,
	      headers: {
	        "Authorization": "Bearer " + AuthService.getAccessToken()
	      }
	    }).then(successCallback, function (error) {
	      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
	        AuthService.refreshToken().then(function () {
	          return patch(path, payload, successCallback, errorCallback);
	        }).catch(errorCallback);
	      } else {
	        if (errorCallback) {
	          errorCallback(error);
	        }
	      }
	    });
	  };
	
	  var deleteResource = function deleteResource(path, successCallback, errorCallback) {
	    console.log("Delete called::", path);
	
	    $http({
	      method: "DELETE",
	      url: _env2.default.getApiUrl(path),
	      headers: {
	        "Authorization": "Bearer " + AuthService.getAccessToken()
	      }
	    }).then(successCallback, function (error) {
	      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
	        AuthService.refreshToken().then(function () {
	          return deleteResource(path, successCallback, errorCallback);
	        }).catch(errorCallback);
	      } else {
	        errorCallback(error);
	      }
	    });
	  };
	
	  var getPromise = function getPromise(path) {
	    console.log("Get promise called::", path);
	
	    var deferred = $q.defer();
	
	    axios({
	      method: "GET",
	      url: _env2.default.getApiUrl(path),
	      headers: {
	        "Authorization": "Bearer " + AuthService.getAccessToken()
	      }
	    }).then(function (response) {
	      deferred.resolve(response.data);
	    }, function (error) {
	      deferred.reject(error);
	    });
	
	    return deferred.promise;
	  };
	
	  return { get: get, post: post, patch: patch, getPromise: getPromise, deleteResource: deleteResource };
	};
	HttpService.$inject = ["$http", "AuthService", "$q"];
	
	exports.default = HttpService;

/***/ },
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NavigationService = function NavigationService($state) {
	  "ngInject";
	
	  var go = function go(to) {
	    return $state.go(to);
	  };
	
	  var isCurrent = function isCurrent(page) {
	    return $state.is(page);
	  };
	
	  return { go: go, isCurrent: isCurrent };
	};
	NavigationService.$inject = ["$state"];
	
	exports.default = NavigationService;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersService = function UsersService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb, errorCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("entities/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total"
	      },
	      error: errorCb,
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  var getUserDetails = function getUserDetails(userId, successCb, failureCb) {
	    HttpService.get("entities/" + userId, successCb, failureCb);
	  };
	
	  var getPayAgreements = function getPayAgreements(userId, successCb, failureCb) {
	    HttpService.get("entities/" + userId + "/payagreements", successCb, failureCb);
	  };
	
	  var resetPayto = function resetPayto(userId, payAgreementId, successCb, failureCb) {
	    HttpService.deleteResource("entities/" + userId + "/payagreements/" + payAgreementId, successCb, failureCb);
	  };
	
	  // Not supported.
	  var updateUserDetails = function updateUserDetails(userId, payload, successCb, failureCb) {
	    HttpService.patch("entities/" + userId, payload, successCb, failureCb);
	  };
	
	  var cancelSubscription = function cancelSubscription(userId, payload, successCb, failureCb) {
	    HttpService.patch("entities/" + userId + "/cancelsubscription", payload, successCb, failureCb);
	  };
	
	  var refundInvoice = function refundInvoice(invoiceId, payload, successCb, failureCb) {
	    HttpService.patch("entities/refundinvoice/" + invoiceId, payload, successCb, failureCb);
	  };
	
	  var getLoginAsUserAccessToken = function getLoginAsUserAccessToken(userId, successCb, failureCb) {
	    HttpService.get("tokens/" + userId, successCb, failureCb);
	  };
	
	  var deleteUser = function deleteUser(userId, successCb, failureCb) {
	    HttpService.deleteResource("entities/" + userId, successCb, failureCb);
	  };
	
	  var disableAccount = function disableAccount(userId, successCb, failureCb) {
	    HttpService.patch("entities/" + userId + "/disableaccount", {}, successCb, failureCb);
	  };
	
	  var reactivateAccount = function reactivateAccount(userId, successCb, failureCb) {
	    HttpService.patch("entities/" + userId + "/reactivateaccount", {}, successCb, failureCb);
	  };
	
	  var updateWalletBalance = function updateWalletBalance(userId, walletBalance, successCb, failureCb) {
	    var payload = {
	      userId: userId,
	      walletBalance: walletBalance
	    };
	    HttpService.patch("entities/" + userId + "/updatewalletbalance", payload, successCb, failureCb);
	  };
	
	  var updateJobPostLimit = function updateJobPostLimit(userId, increaseBy, successCb, failureCb) {
	    HttpService.patch("entities/" + userId + "/updatejobpostlimit", { increaseBy: parseInt(increaseBy) }, successCb, failureCb);
	  };
	
	  // Not supported.
	  var resetPassword = function resetPassword(userId, payload, successCb, failureCb) {
	    HttpService.post("bigfoot/users/changepassword/" + userId, payload, successCb, failureCb);
	  };
	
	  var getRatingsDataSource = function getRatingsDataSource(userId, isClient) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("entities/" + userId + "/ratings?isClient=" + isClient),
	          contentType: "application/json",
	          type: "GET",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: function url(item) {
	            return _env2.default.getApiUrl("entities/" + userId + "/ratings/" + item.id + "?isClient=" + isClient);
	          },
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: function parameterMap(data, type) {
	          if (type === "update") {
	            return (0, _stringify2.default)({
	              category1: data.category1,
	              category2: data.category2,
	              category3: data.category3,
	              category4: data.category4
	
	            });
	          }
	        }
	      },
	      schema: {
	        model: {
	          id: "id",
	          fields: {
	            id: { editable: false },
	            ratingById: { editable: false },
	            firstName: { editable: false },
	            lastName: { editable: false },
	            category1: { type: "number", validation: { min: 0, max: 5 } },
	            category2: { type: "number", validation: { min: 0, max: 5 } },
	            category3: { type: "number", validation: { min: 0, max: 5 } },
	            category4: { type: "number", validation: { min: 0, max: 5 } },
	            ratingSum: { editable: false },
	            ratingAvg: { editable: false },
	            feedback: { editable: false },
	            jobId: { editable: false },
	            ratingDate: { editable: false }
	          }
	        }
	      },
	      serverFiltering: false,
	      serverPaging: false,
	      serverSorting: false,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  var getMessagesDataSource = function getMessagesDataSource(userId, convertToLocalTime, successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("entities/" + userId + "/messages/" + convertToLocalTime),
	          contentType: "application/json",
	          type: "GET",
	          beforeSend: _onBeforeSend
	
	        }
	      },
	      change: successCb,
	      serverFiltering: false,
	      serverPaging: false,
	      serverSorting: false,
	
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return {
	    getDataSource: getDataSource,
	    getUserDetails: getUserDetails,
	    updateUserDetails: updateUserDetails,
	
	    cancelSubscription: cancelSubscription,
	    refundInvoice: refundInvoice,
	    getLoginAsUserAccessToken: getLoginAsUserAccessToken,
	    deleteUser: deleteUser,
	    disableAccount: disableAccount,
	    updateWalletBalance: updateWalletBalance,
	    updateJobPostLimit: updateJobPostLimit,
	    reactivateAccount: reactivateAccount,
	    resetPassword: resetPassword,
	    getMessagesDataSource: getMessagesDataSource,
	    getRatingsDataSource: getRatingsDataSource,
	    getPayAgreements: getPayAgreements,
	    resetPayto: resetPayto
	  };
	};
	UsersService.$inject = ["HttpService"];
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  var filters = [];
	
	  if (data.filter) filters = data.filter.filters;
	
	  var query = (0, _assign2.default)({}, { filters: filters }, data);
	  delete query.filter;
	
	  console.log("Query::", query);
	
	  return (0, _stringify2.default)(query);
	}
	
	exports.default = UsersService;

/***/ },
/* 756 */,
/* 757 */,
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _filterHelper = __webpack_require__(759);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterService = function FilterService(EventsService, NavigationService) {
	  "ngInject";
	
	  var filterType = _filterHelper2.default.filterType;
	
	  var _usersFilterOptions = _filterHelper2.default.usersFilterOptions;
	
	  var _profilesFilterOptions = _filterHelper2.default.profilesFilterOptions;
	
	  var _mediaFilterOptions = _filterHelper2.default.mediaFilterOptions;
	
	  var _surveyFilterOptions = _filterHelper2.default.surveyFilterOptions;
	
	  var _certificatesFilterOptions = _filterHelper2.default.certificatesFilterOptions;
	
	  var _checksFilterOptions = _filterHelper2.default.checksFilterOptions;
	
	  var _jobsFilterOptions = _filterHelper2.default.jobsFilterOptions;
	
	  var _jobRequestsFilterOptions = _filterHelper2.default.jobRequestsFilterOptions;
	
	  var _affiliatesFilterOptions = _filterHelper2.default.affiliatesFilterOptions;
	
	  var _vouchesFilterOptions = _filterHelper2.default.vouchesFilterOptions;
	
	  var _botManagerFilterOptions = _filterHelper2.default.botManagerFilterOptions;
	
	  var _botSessionsFilterOptions = _filterHelper2.default.botSessionsFilterOptions;
	
	  var _businessesFilterOptions = _filterHelper2.default.businessesFilterOptions;
	
	  var _globalUsersFilterOptions = _filterHelper2.default.globalUsersFilterOptions;
	
	  var _globalJobsFilterOptions = _filterHelper2.default.globalJobsFilterOptions;
	
	  var _globalJobsRequestsFilterOptions = _filterHelper2.default.globalJobRequestsFilterOptions;
	
	  var _globalCertificatesFilterOptions = _filterHelper2.default.globalCertificatesFilterOptions;
	
	  var _globalCheckssFilterOptions = _filterHelper2.default.globalChecksFilterOptions;
	
	  var _globalAffiliatesFilterOptions = _filterHelper2.default.globalAffiliatesFilterOptions;
	
	  var _globalBotManagerFilterOptions = _filterHelper2.default.globalBotManagerFilterOptions;
	
	  var _globalVouchesFilterOptions = _filterHelper2.default.globalVouchesFilterOptions;
	
	  var _globalBotSessionsFilterOptions = _filterHelper2.default.globalBotSessionsFilterOptions;
	
	  var _globalBusinessesFilterOptions = _filterHelper2.default.globalBusinessesFilterOptions;
	
	  var _filterExpression = {};
	
	  var generateFilterExpression = function generateFilterExpression(filters) {
	    _filterExpression = {
	      logic: 'and',
	      filters: []
	    };
	
	    for (var i = 0; i < filters.length; i++) {
	
	      var filterItem = filters[i];
	
	      if (filterItem.isActive && (filterItem.value || filterItem.field === "gender" && filterItem.value === 0)) {
	        var filter = void 0;
	
	        if (filterItem.filterType == filterType.FREE_TEXT) {
	          var value = filterItem.value;
	          if (filterItem.field == "userId" || filterItem.field == "userNumberOfJobPosts") value = parseInt(value);
	
	          filter = {
	            field: filterItem.field,
	            operator: filterItem.filterIitems[filterItem.filterItemSelected].operator,
	            value: value
	          };
	        } else if (filterItem.filterType == filterType.DROP_DOWN) {
	          filter = {
	            field: filterItem.field,
	            operator: "eq",
	            value: filterItem.value
	          };
	        } else if (filterItem.filterType == filterType.DATE_PICKER) {
	          filter = {
	            field: filterItem.field,
	            operator: filterItem.filterIitems[filterItem.filterItemSelected].operator,
	            value: _common2.default.converToUtcDate(filterItem.value)
	          };
	        }
	
	        _filterExpression.filters.push(filter);
	      }
	    }
	
	    console.log("_filterExpression", _filterExpression);
	  };
	
	  var getAppliedFilters = function getAppliedFilters() {
	    return _filterExpression;
	  };
	
	  // Get global filter options
	
	  var getGlobalUsersFilterOptions = function getGlobalUsersFilterOptions() {
	    return _globalUsersFilterOptions;
	  };
	
	  var getGlobalJobsFilterOptions = function getGlobalJobsFilterOptions() {
	    return _globalJobsFilterOptions;
	  };
	
	  var getGlobalJobRequestsFilterOptions = function getGlobalJobRequestsFilterOptions() {
	    return _globalJobsRequestsFilterOptions;
	  };
	
	  var getGlobalAffiliatesFilterOptions = function getGlobalAffiliatesFilterOptions() {
	    return _globalAffiliatesFilterOptions;
	  };
	
	  var getGlobalVocuhesFilterOptions = function getGlobalVocuhesFilterOptions() {
	    return _globalVouchesFilterOptions;
	  };
	
	  var getGlobalCertificatesFilterOptions = function getGlobalCertificatesFilterOptions() {
	    return _globalCertificatesFilterOptions;
	  };
	
	  var getGlobalCheckssFilterOptions = function getGlobalCheckssFilterOptions() {
	    return _globalCheckssFilterOptions;
	  };
	
	  var getGlobalBotManagerFilterOptions = function getGlobalBotManagerFilterOptions() {
	    return _globalBotManagerFilterOptions;
	  };
	
	  var getGlobalBotSessionsFilterOptions = function getGlobalBotSessionsFilterOptions() {
	    return _globalBotSessionsFilterOptions;
	  };
	
	  var getGlobalBusinessesFilterOptions = function getGlobalBusinessesFilterOptions() {
	    return _globalBusinessesFilterOptions;
	  };
	
	  ////////////
	
	
	  var getUsersFilterOptions = function getUsersFilterOptions(globaFilterType) {
	
	    switch (globaFilterType) {
	      case _constants2.default.globalUsersFilterTypes.PAYG_USERS:
	        return _applyPAYGModifier(_usersFilterOptions);
	      case _constants2.default.globalUsersFilterTypes.ALL_PAYING_USERS:
	        return _applyPayingSinceModifier(_usersFilterOptions);
	      case _constants2.default.globalUsersFilterTypes.NSW_CUSTOMERS:
	        return _applyNSWModifier(_usersFilterOptions);
	      case _constants2.default.globalUsersFilterTypes.VIC_CUSTOMERS:
	        return _applyVICModifier(_usersFilterOptions);
	      case _constants2.default.globalUsersFilterTypes.ALL_USERS:
	        return _resetFilterOptions(_usersFilterOptions);
	      default:
	        return _usersFilterOptions;
	    }
	  };
	
	  var getBusinessesFilterOptions = function getBusinessesFilterOptions(globalFilterType) {
	    switch (globalFilterType) {
	      case _constants2.default.globalBusinessesFilterTypes.NSW_BUSINESSES:
	        return _applyNSWBusinessModifier(_businessesFilterOptions);
	      case _constants2.default.globalBusinessesFilterTypes.VIC_BUSINESSES:
	        return _applyVICBusinessModifier(_businessesFilterOptions);
	      default:
	        return _businessesFilterOptions;
	    }
	  };
	
	  var getProfilesFilterOptions = function getProfilesFilterOptions(globaFilterType) {
	
	    switch (globaFilterType) {
	      default:
	        return _profilesFilterOptions;
	    }
	  };
	
	  var getMediaFilterOptions = function getMediaFilterOptions() {
	    return _mediaFilterOptions;
	  };
	
	  var getSurveyFilterOptions = function getSurveyFilterOptions() {
	    return _surveyFilterOptions;
	  };
	
	  var getCertificatesFilterOptions = function getCertificatesFilterOptions(globalFilterType) {
	    switch (globalFilterType) {
	      case _constants2.default.globalCertificatesFilterTypes.PENDING_VERIFICATION:
	        return _applyPendingVerificationCertificatesModifier(_certificatesFilterOptions);
	      case _constants2.default.globalCertificatesFilterTypes.ALL_CERTIFICATES:
	        return _resetFilterOptions(_certificatesFilterOptions);
	      default:
	        return _certificatesFilterOptions;
	    }
	  };
	
	  var getChecksFilterOptions = function getChecksFilterOptions(globalFilterType) {
	    switch (globalFilterType) {
	      case _constants2.default.globalChecksFilterTypes.ALL_CHECKS:
	        return _resetFilterOptions(_checksFilterOptions);
	      default:
	        return _checksFilterOptions;
	    }
	  };
	
	  var getJobsFilterOptions = function getJobsFilterOptions(globaFilterType) {
	    switch (globaFilterType) {
	      case _constants2.default.globalJobsFilterTypes.ALL_JOBS:
	        return _resetFilterOptions(_jobsFilterOptions);
	      case _constants2.default.globalJobsFilterTypes.JOBS_POSTED_TODAY:
	        return _applyJobsPostedTodayModifier(_jobsFilterOptions);
	      case _constants2.default.globalJobsFilterTypes.JOBS_EXPIRE_TODAY:
	        return _applyJobsExpireTodayModifier(_jobsFilterOptions);
	      case _constants2.default.globalJobsFilterTypes.RECURRING_JOB_POSTED_15_DAYS_AGO:
	        return _applyRecurringJobsPosted15DaysAgoModifier(_jobsFilterOptions);
	      default:
	        return _jobsFilterOptions;
	    }
	  };
	
	  var getJobRequestsFilterOptions = function getJobRequestsFilterOptions(globaFilterType) {
	    switch (globaFilterType) {
	      case _constants2.default.globalJobRequestsFilterTypes.ALL_JOB_REQUESTS:
	        return _resetFilterOptions(_jobRequestsFilterOptions);
	      default:
	        return _jobRequestsFilterOptions;
	    }
	  };
	
	  var _applyEmployeeBenefitsModifier = function _applyEmployeeBenefitsModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "affiliateSource") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 2 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyReferralModifier = function _applyReferralModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "affiliateSource") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1 });
	      } else if (option.field == "affiliateStatus") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 2 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var getAffiliatesFilterOptions = function getAffiliatesFilterOptions(globaFilterType) {
	    switch (globaFilterType) {
	      case _constants2.default.globalAffiliatesFilterTypes.ALL_AFFILIATES:
	        return _resetFilterOptions(_affiliatesFilterOptions);
	      case _constants2.default.globalAffiliatesFilterTypes.EMPLOYEE_BENEFITS:
	        return _applyEmployeeBenefitsModifier(_affiliatesFilterOptions);
	      case _constants2.default.globalAffiliatesFilterTypes.REFERRALS:
	        return _applyReferralModifier(_affiliatesFilterOptions);
	      default:
	        return _affiliatesFilterOptions;
	    }
	  };
	
	  var getVouchesFilterOptions = function getVouchesFilterOptions(globaFilterType) {
	    switch (globaFilterType) {
	      case _constants2.default.globalVouchesFilterTypes.ALL_VOUCHES:
	        return _resetFilterOptions(_vouchesFilterOptions);
	      default:
	        return _vouchesFilterOptions;
	    }
	  };
	
	  var getbotManagerFilterOptions = function getbotManagerFilterOptions(globaFilterType) {
	    switch (globaFilterType) {
	      case _constants2.default.globalBotManagerFilterTypes.ALL_BOT_FLOWS:
	        return _resetFilterOptions(_botManagerFilterOptions);
	      default:
	        return _botManagerFilterOptions;
	    }
	  };
	
	  var getbotSessionsFilterOptions = function getbotSessionsFilterOptions(globaFilterType) {
	    switch (globaFilterType) {
	      case _constants2.default.globalBotSessionsFilterTypes.ALL_BOT_SESSIONS:
	        return _resetFilterOptions(_botSessionsFilterOptions);
	      default:
	        return _botSessionsFilterOptions;
	    }
	  };
	
	  // Global filter modifiers
	
	  var _applyPAYGModifier = function _applyPAYGModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "membershipTypeName") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: "PayAsYouGo" });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyPayingSinceModifier = function _applyPayingSinceModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "paymentInfo.payingMemberSince") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyNSWModifier = function _applyNSWModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "addresses.state") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 'nsw' });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyVICModifier = function _applyVICModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "addresses.state") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 'vic' });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyPendingVerificationCertificatesModifier = function _applyPendingVerificationCertificatesModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "accountStatus") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1 });
	      } else if (option.field == "certificateStatus") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyJobsPostedTodayModifier = function _applyJobsPostedTodayModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "postDate") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: _common2.default.converToUtcDate(new Date()), filterItemSelected: 1 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyJobsExpireTodayModifier = function _applyJobsExpireTodayModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "expiresInDays") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 1, filterItemSelected: 1 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyRecurringJobsPosted15DaysAgoModifier = function _applyRecurringJobsPosted15DaysAgoModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "postDate") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: _common2.default.subtractDays(new Date(), 15), filterItemSelected: 1 });
	      } else if (option.field == "jobType") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 14, filterItemSelected: 2 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyNSWBusinessModifier = function _applyNSWBusinessModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "state") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 'nsw' });
	      } else if (option.field == "locationType") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: _constants2.default.locationType.CENTRE_BASED_DAYCARE });
	      } else if (option.field == "helpersCount") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 100, filterItemSelected: 3 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _applyVICBusinessModifier = function _applyVICBusinessModifier(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = void 0;
	      if (option.field == "state") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 'vic' });
	      } else if (option.field == "locationType") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: _constants2.default.locationType.CENTRE_BASED_DAYCARE });
	      } else if (option.field == "helpersCount") {
	        optionModified = (0, _assign2.default)({}, option, { isActive: true, value: 100, filterItemSelected: 3 });
	      } else {
	        optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      }
	
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  var _resetFilterOptions = function _resetFilterOptions(filterOptions) {
	    var modifiedFilter = filterOptions.map(function (option) {
	      var optionModified = (0, _assign2.default)({}, option, { isActive: false });
	      return optionModified;
	    });
	    console.log("Modified Filter", modifiedFilter);
	    return modifiedFilter;
	  };
	
	  return {
	    generateFilterExpression: generateFilterExpression,
	    getAppliedFilters: getAppliedFilters,
	    getUsersFilterOptions: getUsersFilterOptions,
	    getProfilesFilterOptions: getProfilesFilterOptions,
	    getMediaFilterOptions: getMediaFilterOptions,
	    getSurveyFilterOptions: getSurveyFilterOptions,
	    getCertificatesFilterOptions: getCertificatesFilterOptions,
	    getChecksFilterOptions: getChecksFilterOptions,
	    getJobsFilterOptions: getJobsFilterOptions,
	    getAffiliatesFilterOptions: getAffiliatesFilterOptions,
	    getVouchesFilterOptions: getVouchesFilterOptions,
	    getbotManagerFilterOptions: getbotManagerFilterOptions,
	    getbotSessionsFilterOptions: getbotSessionsFilterOptions,
	    getGlobalUsersFilterOptions: getGlobalUsersFilterOptions,
	    getGlobalJobsFilterOptions: getGlobalJobsFilterOptions,
	    getGlobalAffiliatesFilterOptions: getGlobalAffiliatesFilterOptions,
	    getGlobalVocuhesFilterOptions: getGlobalVocuhesFilterOptions,
	    getGlobalCertificatesFilterOptions: getGlobalCertificatesFilterOptions,
	    getGlobalCheckssFilterOptions: getGlobalCheckssFilterOptions,
	    getGlobalBotManagerFilterOptions: getGlobalBotManagerFilterOptions,
	    getGlobalBotSessionsFilterOptions: getGlobalBotSessionsFilterOptions,
	    getGlobalBusinessesFilterOptions: getGlobalBusinessesFilterOptions,
	    getBusinessesFilterOptions: getBusinessesFilterOptions,
	    getJobRequestsFilterOptions: getJobRequestsFilterOptions,
	    getGlobalJobRequestsFilterOptions: getGlobalJobRequestsFilterOptions
	  };
	};
	FilterService.$inject = ["EventsService", "NavigationService"];
	
	exports.default = FilterService;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterHelper = function () {
	
	    var filterType = { FREE_TEXT: 1, DROP_DOWN: 2, DATE_PICKER: 3 };
	
	    var globalUsersFilterOptions = [{
	        type: _constants2.default.globalUsersFilterTypes.ALL_USERS,
	        label: "All Users",
	        isActive: true
	    }, {
	        type: _constants2.default.globalUsersFilterTypes.PAYG_USERS,
	        label: "PAYG Customers",
	        isActive: false
	    }, {
	        type: _constants2.default.globalUsersFilterTypes.NSW_CUSTOMERS,
	        label: "NSW Customers",
	        isActive: false
	    }, {
	        type: _constants2.default.globalUsersFilterTypes.VIC_CUSTOMERS,
	        label: "VIC Customers",
	        isActive: false
	    }];
	
	    var globalBusinessesFilterOptions = [{
	        type: _constants2.default.globalBusinessesFilterTypes.ALL_BUSINESSS,
	        label: "All Businesses",
	        isActive: true
	    }, {
	        type: _constants2.default.globalBusinessesFilterTypes.NSW_BUSINESSES,
	        label: "Targeted NSW",
	        isActive: false
	    }, {
	        type: _constants2.default.globalBusinessesFilterTypes.VIC_BUSINESSES,
	        label: "Targeted VIC",
	        isActive: false
	    }];
	
	    var globalProfilesFilterOptions = [{
	        type: _constants2.default.globalProfilesFilterTypes.ALL_PROFILES,
	        label: "All Profiles",
	        isActive: false
	    }];
	
	    var globalJobsFilterOptions = [{
	        type: _constants2.default.globalJobsFilterTypes.ALL_JOBS,
	        label: "All Jobs",
	        isActive: true
	    }, {
	        type: _constants2.default.globalJobsFilterTypes.JOBS_POSTED_TODAY,
	        label: "Jobs Posted Today",
	        isActive: false
	    }, {
	        type: _constants2.default.globalJobsFilterTypes.JOBS_EXPIRE_TODAY,
	        label: "Jobs Expire Today",
	        isActive: false
	    }, {
	        type: _constants2.default.globalJobsFilterTypes.RECURRING_JOB_POSTED_15_DAYS_AGO,
	        label: "Recurring Jobs Posted 15 Days Ago",
	        isActive: false
	    }];
	
	    var globalJobRequestsFilterOptions = [{
	        type: _constants2.default.globalJobRequestsFilterTypes.ALL_JOB_REQUESTS,
	        label: "All Concierge Requests",
	        isActive: true
	    }];
	
	    var globalAffiliatesFilterOptions = [{
	        type: _constants2.default.globalAffiliatesFilterTypes.ALL_AFFILIATES,
	        label: "All Partnerships",
	        isActive: true
	    }, {
	        type: _constants2.default.globalAffiliatesFilterTypes.EMPLOYEE_BENEFITS,
	        label: "Employee Benefits",
	        isActive: false
	    }, {
	        type: _constants2.default.globalAffiliatesFilterTypes.REFERRALS,
	        label: "Referrals",
	        isActive: false
	    }];
	
	    var globalVouchesFilterOptions = [{
	        type: _constants2.default.globalVouchesFilterTypes.ALL_VOUCHES,
	        label: "All Vouches",
	        isActive: true
	    }];
	
	    var globalBotManagerFilterOptions = [{
	        type: _constants2.default.globalBotManagerFilterTypes.ALL_BOT_FLOWS,
	        label: "All Flows",
	        isActive: true
	    }];
	
	    var globalBotSessionsFilterOptions = [{
	        type: _constants2.default.globalBotSessionsFilterTypes.ALL_BOT_SESSIONS,
	        label: "All Sessions",
	        isActive: true
	    }];
	
	    var globalCertificatesFilterOptions = [{
	        type: _constants2.default.globalCertificatesFilterTypes.ALL_CERTIFICATES,
	        label: "All Certificates",
	        isActive: true
	    }, {
	        type: _constants2.default.globalCertificatesFilterTypes.PENDING_VERIFICATION,
	        label: "Pending Verification",
	        isActive: false
	    }];
	
	    var globalChecksFilterOptions = [{
	        type: _constants2.default.globalChecksFilterTypes.ALL_CHECKS,
	        label: "All Checks",
	        isActive: true
	    }];
	
	    var profilesFilterOptions = [{
	        field: "userId",
	        label: "USER ID",
	        icon: "fa-tag",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "fullName",
	        label: "NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "entityTypeName",
	        label: "ACCOUNT TYPE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "Family", label: "Family" },
	            2: { value: "Business", label: "Business" },
	            3: { value: "Helper", label: "Helper" }
	        }
	    }, {
	        field: "accountStatusName",
	        label: "ACCOUNT STATUS",
	        icon: "fa-clock-o",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "Pending", label: "Pending" },
	            2: { value: "Approved", label: "Approved" }
	        }
	    }, {
	        field: "requiredReviews",
	        label: "REVIEW TYPE",
	        icon: "fa-bookmark",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "1", label: "New Profile" },
	            2: { value: "32", label: "Missing About Me" },
	            3: { value: "2", label: "Missing Au Pair Details" },
	            4: { value: "4", label: "Missing Tuturing Details" },
	            5: { value: "16", label: "Missing Certificate" },
	            6: { value: "8", label: "Tutoring Category Changed" }
	        }
	    }, {
	        field: "isHidden",
	        label: "VISIBILITY",
	        icon: "fa-eye",
	        isActive: false,
	        value: "",
	        filterItemSelected: 1,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "false", label: "Visible" },
	            2: { value: "true", label: "Hidden" }
	        }
	    }];
	
	    var businessesFilterOptions = [{
	        field: "locationId",
	        label: "LEAD ID",
	        icon: "fa-tag",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "name",
	        label: "NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "locationType",
	        label: "BUSINESS TYPE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.locationType.SCHOOL, label: "School" },
	            2: { value: _constants2.default.locationType.CENTRE_BASED_DAYCARE, label: "Centre Day Care" },
	            3: { value: _constants2.default.locationType.FAMILY_DAYCARE, label: "Family Day Care" },
	            4: { value: _constants2.default.locationType.INHOME_CARE, label: "In-Home Care" },
	            5: { value: _constants2.default.locationType.OUTSIDE_SCHOOL_HOURS_CARE, label: "OOSH" }
	        }
	    }, {
	        field: "locationStatus",
	        label: "LEAD STATUS",
	        icon: "fa-bookmark",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.locationStatus.NEW_LEAD, label: "New Lead" },
	            2: { value: _constants2.default.locationStatus.EDM_SENT, label: "EDM Sent" },
	            // 3: { value: c.locationStatus.EDM_READY, label: "EDM Ready" },
	            4: { value: _constants2.default.locationStatus.EDM_OPENED, label: "EDM Opened" },
	            5: { value: _constants2.default.locationStatus.EDM_CLICKED, label: "EDM Clicked" },
	            6: { value: _constants2.default.locationStatus.EDM_REJECTED, label: "EDM Rejected" },
	            7: { value: _constants2.default.locationStatus.CALLS_COMMENCED, label: "Calls Commenced" },
	            8: { value: _constants2.default.locationStatus.CONTACT_MADE, label: "Contact Made" },
	            9: { value: _constants2.default.locationStatus.NOT_INTERESTED, label: "Not Interested" },
	            10: { value: _constants2.default.locationStatus.INTERESTED_IN_PROGRESS, label: "Interested In-Progress" },
	            11: { value: _constants2.default.locationStatus.ACQUIRED, label: "Acquired" }
	        }
	    }, {
	        field: "helpersCount",
	        label: "HELPERS COUNT",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "less than", operator: "lt" },
	            3: { value: 3, label: "greater than", operator: "gt" }
	        }
	    }, {
	        field: "state",
	        label: "STATE",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'NSW', value: 'nsw' },
	            2: { label: 'ACT', value: 'act' },
	            3: { label: 'VIC', value: 'vic' },
	            4: { label: 'SA', value: 'sa' },
	            5: { label: 'QLD', value: 'qld' },
	            6: { label: 'NT', value: 'nt' },
	            7: { label: 'WA', value: 'wa' },
	            8: { label: 'TAS', value: 'ta' }
	        }
	    }];
	
	    var usersFilterOptions = [{
	        field: "userId",
	        label: "USER ID",
	        icon: "fa-tag",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "fullName",
	        label: "NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "entityTypeName",
	        label: "ACCOUNT TYPE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "Family", label: "Family" },
	            2: { value: "Business", label: "Business" },
	            3: { value: "Helper", label: "Helper" }
	        }
	    }, {
	        field: "membershipTypeName",
	        label: "MEMBERSHIP TYPE",
	        icon: "fa-bookmark",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "Free", label: "All" },
	            // 2: { value: "PayAsYouGo", label: "Pay as you go" },
	            3: { value: "Subscription", label: "Subscription" }
	        }
	    }, {
	        field: "accountStatusName",
	        label: "ACCOUNT STATUS",
	        icon: "fa-clock-o",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "Pending", label: "Pending" },
	            2: { value: "Approved", label: "Approved" }
	        }
	    }, {
	        field: "email",
	        label: "EMAIL",
	        icon: "fa-at",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "phoneNumber",
	        label: "PHONE NUMBER",
	        icon: "fa-phone",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "hasProfileVideo",
	        label: "HAS PROFILE VIDEO",
	        icon: "fa-play",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "true", label: "Yes" },
	            2: { value: "false", label: "No" }
	        }
	    }, {
	        field: "paymentInfo.payingMemberSince",
	        label: "PAYING MEMBER SINCE",
	        icon: "fa-calendar",
	        isActive: false,
	        value: 1,
	        filterItemSelected: 1,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            // 1: { value: 1, label: "greater than", operator: "gt" },
	            // 2: { value: 2, label: "less than", operator: "lt" },
	            1: { value: 1, label: "has any value", operator: "isnotnull", hideValueField: true }
	        }
	    }, {
	        field: "isImageCropped",
	        label: "HAS CROPPED PICTURE",
	        icon: "fa-photo",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "true", label: "Yes" },
	            2: { value: "false", label: "No" }
	        }
	    }, {
	        field: "isHidden",
	        label: "ACCOUNT VISIBILITY",
	        icon: "fa-eye",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "false", label: "Visible" },
	            2: { value: "true", label: "Hidden" }
	        }
	    }, {
	        field: "addresses.formattedSuburb",
	        label: "SUBURB",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "addresses.state",
	        label: "REGION/CITY",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "addresses.state",
	        label: "STATE",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'NSW', value: 'nsw' },
	            2: { label: 'ACT', value: 'act' },
	            3: { label: 'VIC', value: 'vic' },
	            4: { label: 'SA', value: 'sa' },
	            5: { label: 'QLD', value: 'qld' },
	            6: { label: 'NT', value: 'nt' },
	            7: { label: 'WA', value: 'wa' },
	            8: { label: 'TAS', value: 'ta' }
	        }
	    }, {
	        field: "country",
	        label: "COUNTRY",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'Australia', value: 'au' },
	            2: { label: 'New Zealand', value: 'nz' }
	        }
	    }, {
	        field: "interestedInJobTypes",
	        label: "JOB TYPE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.jobType.BABYSITTING, label: "Babysitting" },
	            3: { value: _constants2.default.jobType.NANNYING, label: "Nannying (Daytime Care)" },
	            4: { value: _constants2.default.jobType.BEFORE_SCHOOL_CARE, label: "Before School Care" },
	            5: { value: _constants2.default.jobType.AFTER_SCHOOL_CARE, label: "After School Care" },
	            6: { value: _constants2.default.jobType.BEFORE_AFTER_SCHOOL_CARE, label: "Before and After School Care" },
	            7: { value: _constants2.default.jobType.AU_PAIR, label: "Au Pair" },
	            8: { value: _constants2.default.jobType.PRIMARY_SCHOOL_TUTORING, label: "Primary School Tutoring" },
	            9: { value: _constants2.default.jobType.HIGH_SCHOOL_TUTORING, label: "High School Tutoring" },
	            10: { value: _constants2.default.jobType.ONE_OFF_ODD_JOBS, label: "Odd Job" }
	        }
	    }, {
	        field: "clientInfo.jobsPlaced",
	        label: "JOB POSTS",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "less than", operator: "lt" },
	            3: { value: 3, label: "greater than", operator: "gt" }
	        }
	    }, {
	        field: "affiliateCode",
	        label: "AFFILIATE CODE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }];
	
	    var mediaFilterOptions = [{
	        field: "fullName",
	        label: "NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "mediaReviewStatus",
	        label: "MEDIA REVIEW STATUS",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.mediaReviewStatuts.UNSPECIFIED, label: "Unspecified" },
	            2: { value: _constants2.default.mediaReviewStatuts.PENDING, label: "Pending" },
	            3: { value: _constants2.default.mediaReviewStatuts.APPROVED, label: "Approved" },
	            4: { value: _constants2.default.mediaReviewStatuts.REJECTED, label: "Rejected" }
	        }
	    }];
	
	    var surveyFilterOptions = [{
	        field: "fullName",
	        label: "NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "interestInHomeAgedCareResponse",
	        label: "RESPONSES",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.surveyResponse.YES, label: "Yes" },
	            2: { value: _constants2.default.surveyResponse.NO, label: "No" },
	            3: { value: _constants2.default.surveyResponse.NA, label: "NA" }
	        }
	    }, {
	        field: "jugglerType",
	        label: "ACCOUNT TYPE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.jugglerType.PARENT, label: "Family" },
	            2: { value: _constants2.default.jugglerType.HELPER, label: "Helper" }
	        }
	    }];
	
	    var certificatesFilterOptions = [{
	        field: "fullName",
	        label: "NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "gender",
	        label: "GENDER",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: 1, label: "Male" },
	            2: { value: 2, label: "Female" },
	            3: { value: 0, label: "Prefer not to say" }
	        }
	    }, {
	        field: "accountStatus",
	        label: "ACCOUNT STATUS",
	        icon: "fa-clock-o",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.accountStatus.PENDING, label: "Pending" },
	            2: { value: _constants2.default.accountStatus.APPROVED, label: "Approved" }
	        }
	    }, {
	        field: "addresses.state",
	        label: "STATE",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'NSW', value: 'nsw' },
	            2: { label: 'ACT', value: 'act' },
	            3: { label: 'VIC', value: 'vic' },
	            4: { label: 'SA', value: 'sa' },
	            5: { label: 'QLD', value: 'qld' },
	            6: { label: 'NT', value: 'nt' },
	            7: { label: 'WA', value: 'wa' },
	            8: { label: 'TAS', value: 'ta' }
	        }
	    }, {
	        field: "membershipType",
	        label: "MEMBERSHIP TYPE",
	        icon: "fa-bookmark",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.membershipType.free, label: "All" },
	            // 2: { value: c.membershipType.payg, label: "PayAsYouGo"},
	            3: { value: _constants2.default.membershipType.subscription, label: "Subscription" }
	        }
	    }, {
	        field: "certificateStatus",
	        label: "CERTIFICATE STATUS",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.certificateStatus.PENDINGVERIFICATION, label: "Pending Verification" },
	            2: { value: _constants2.default.certificateStatus.ACTIVE, label: "Active" },
	            3: { value: _constants2.default.certificateStatus.INVALID, label: "Invalid" },
	            4: { value: _constants2.default.certificateStatus.EXPIRED, label: "Expired" }
	        }
	    }, {
	        field: "isHidden",
	        label: "ACCOUNT VISIBILITY",
	        icon: "fa-eye",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "false", label: "Visible" },
	            2: { value: "true", label: "Hidden" }
	        }
	    }];
	
	    var checksFilterOptions = [{
	        field: "fullName",
	        label: "NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "accountStatus",
	        label: "ACCOUNT STATUS",
	        icon: "fa-clock-o",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.accountStatus.PENDING, label: "Pending" },
	            2: { value: _constants2.default.accountStatus.APPROVED, label: "Approved" }
	        }
	    }, {
	        field: "country",
	        label: "COUNTRY",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'Australia', value: 'au' },
	            2: { label: 'New Zealand', value: 'nz' }
	        }
	    }, {
	        field: "membershipType",
	        label: "MEMBERSHIP TYPE",
	        icon: "fa-bookmark",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.membershipType.free, label: "All" },
	            // 2: { value: c.membershipType.payg, label: "PayAsYouGo"},
	            3: { value: _constants2.default.membershipType.subscription, label: "Subscription" }
	        }
	    }, {
	        field: "visaCheckStatus",
	        label: "CHECK STATUS",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.visaCheckStatus.PENDINGVERIFICATION, label: "Pending Verification" },
	            2: { value: _constants2.default.visaCheckStatus.APPROVED, label: "Approved" },
	            3: { value: _constants2.default.visaCheckStatus.INVALID, label: "Invalid" },
	            4: { value: _constants2.default.visaCheckStatus.EXPIRED, label: "Expired" }
	        }
	    }, {
	        field: "isHidden",
	        label: "ACCOUNT VISIBILITY",
	        icon: "fa-eye",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "false", label: "Visible" },
	            2: { value: "true", label: "Hidden" }
	        }
	    }];
	
	    var jobsFilterOptions = [{
	        field: "jobId",
	        label: "JOB REFERENCE",
	        icon: "fa-tag",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" }
	        }
	    }, {
	        field: "daysSincePost",
	        label: "DAYS SINCE POST",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" }
	        }
	    }, {
	        field: "expiresInDays",
	        label: "EXPIRES IN DAYS",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" }
	        }
	    }, {
	        field: "postDate",
	        label: "JOB POST DATE",
	        icon: "fa-calendar",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DATE_PICKER,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "before", operator: "lt" },
	            3: { value: 3, label: "after", operator: "gt" }
	        }
	    }, {
	        field: "jobDate",
	        label: "JOB START DATE",
	        icon: "fa-calendar",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DATE_PICKER,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" }
	        }
	    },
	    // {
	    //     field: "jobFinishDate",
	    //     label: "JOB FINISH DATE",
	    //     icon: "fa-calendar",
	    //     isActive: false,
	    //     value: "",
	    //     filterItemSelected: 0,
	    //     filterType: filterType.DATE_PICKER,
	    //     filterIitems: {
	    //         1: { value: 1, label: "is", operator: "eq" },
	    //     }
	    // },
	    {
	        field: "userNumberOfJobPosts",
	        label: "TOTAL JOB POSTS",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "less than", operator: "lt" },
	            3: { value: 3, label: "greater than", operator: "gt" }
	        }
	    }, {
	        field: "userId",
	        label: "USER ID",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" }
	        }
	    }, {
	        field: "jobType",
	        label: "JOB TYPE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.jobType.BABYSITTING, label: "Babysitting" },
	            2: { value: _constants2.default.jobType.RECURRING_JOB, label: "Recurring Jobs (All Types)" },
	            3: { value: _constants2.default.jobType.NANNYING, label: "Nannying (Daytime Care)" },
	            4: { value: _constants2.default.jobType.BEFORE_SCHOOL_CARE, label: "Before School Care" },
	            5: { value: _constants2.default.jobType.AFTER_SCHOOL_CARE, label: "After School Care" },
	            6: { value: _constants2.default.jobType.BEFORE_AFTER_SCHOOL_CARE, label: "Before and After School Care" },
	            7: { value: _constants2.default.jobType.AU_PAIR, label: "Au Pair" },
	            8: { value: _constants2.default.jobType.PRIMARY_SCHOOL_TUTORING, label: "Primary School Tutoring" },
	            9: { value: _constants2.default.jobType.HIGH_SCHOOL_TUTORING, label: "High School Tutoring" },
	            10: { value: _constants2.default.jobType.ONE_OFF_ODD_JOBS, label: "Odd Job" }
	        }
	    }, {
	        field: "jobStatus",
	        label: "JOB STATUS",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.jobStatus.AWARDED, label: "Awarded" },
	            2: { value: _constants2.default.jobStatus.CANCELLED, label: "Cancelled" },
	            3: { value: _constants2.default.jobStatus.COMPLETED, label: "Completed" },
	            4: { value: _constants2.default.jobStatus.FILLED, label: "Filled" },
	            5: { value: _constants2.default.jobStatus.PENDING, label: "Pending" },
	            6: { value: _constants2.default.jobStatus.FILLED_AND_CANCELLED, label: "Filled and Closed" }
	        }
	    }, {
	        field: "managedBy",
	        label: "Management",
	        icon: "fa-gear",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.managedBy.USER, label: "Do It Yourself" },
	            2: { value: _constants2.default.managedBy.SYSTEM, label: "Juggle Assist" }
	        }
	    }, {
	        field: "country",
	        label: "COUNTRY",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'Australia', value: 'au' },
	            2: { label: 'New Zealand', value: 'nz' }
	        }
	    }, {
	        field: "addresses.state",
	        label: "STATE",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'NSW', value: 'nsw' },
	            2: { label: 'ACT', value: 'act' },
	            3: { label: 'VIC', value: 'vic' },
	            4: { label: 'SA', value: 'sa' },
	            5: { label: 'QLD', value: 'qld' },
	            6: { label: 'NT', value: 'nt' },
	            7: { label: 'WA', value: 'wa' },
	            8: { label: 'TAS', value: 'ta' }
	        }
	    }];
	
	    var jobRequestsFilterOptions = [{
	        field: "",
	        label: "REQUEST STATUS",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.jobRequestStatus.NEW_REQUEST, label: "New Request" },
	            2: { value: _constants2.default.jobRequestStatus.CALL_SCHEDULED, label: "Call Scheduled" },
	            3: { value: _constants2.default.jobRequestStatus.JOB_POSTED, label: "Job Posted" },
	            4: { value: _constants2.default.jobRequestStatus.JOB_TRANSFERRED, label: "Job Transferred" },
	            5: { value: _constants2.default.jobRequestStatus.JOB_AWARDED, label: "Job Awarded" }
	        }
	    }];
	
	    var affiliatesFilterOptions = [{
	        field: "affiliateSource",
	        label: "AFFILIATE SOURCE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'Referrals', value: 1 },
	            2: { label: 'Employee Benefits', value: 2 }
	        }
	    }, {
	        field: "affiliateStatus",
	        label: "AFFILIATE STATUS",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'All', value: 0 },
	            2: { label: 'Used', value: 1 },
	            3: { label: 'Activated', value: 2 }
	        }
	    }, {
	        field: "affiliateName",
	        label: "PARTNER NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "code",
	        label: "PARTNER CODE",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }];
	
	    var vouchesFilterOptions = [{
	        field: "userId",
	        label: "USER ID",
	        icon: "fa-tag",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" }
	        }
	    }, {
	        field: "fullName",
	        label: "USER NAME",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "status",
	        label: "STATUS",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.vouchStatus.PENDING, label: "Follow-up" },
	            2: { value: _constants2.default.vouchStatus.APPROVED, label: "Complete" },
	            3: { value: _constants2.default.vouchStatus.CANCELLED, label: "Incomplete" },
	            4: { value: _constants2.default.vouchStatus.EXPIRED, label: "Expired" }
	            // 5: { value: c.vouchStatus.NONE, label: "-" },
	        }
	    }, {
	        field: "accountStatus",
	        label: "ACCOUNT STATUS",
	        icon: "fa-clock-o",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: _constants2.default.accountStatus.PENDING, label: "Pending" },
	            2: { value: _constants2.default.accountStatus.PENDING_APPROVAL, label: "Pending 100%" },
	            3: { value: _constants2.default.accountStatus.APPROVED, label: "Approved" }
	        }
	    }, {
	        field: "isHidden",
	        label: "VISIBILITY",
	        icon: "fa-eye",
	        isActive: false,
	        value: "",
	        filterItemSelected: 1,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "false", label: "Visible" },
	            2: { value: "true", label: "Hidden" }
	        }
	    }, {
	        field: "interestedInAuPairJobs",
	        label: "IS AU PAIR",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "true", label: "Yes" },
	            2: { value: "false", label: "No" }
	        }
	    }, {
	        field: "referenceType",
	        label: "REF TYPE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            // 1: { value: c.vouchReferenceType.FAMILY, label: "Family" },
	            // 2: { value: c.vouchReferenceType.CHILDCAREEMPLOYMENT, label: "Childcare Employment" },
	            // 3: { value: c.vouchReferenceType.NONCHILDCAREEMPLOYMENT, label: "Non-childcare Employment" },
	            // 4: { value: c.vouchReferenceType.OTHER, label: "Other" },
	            1: { value: _constants2.default.vouchReferenceType.REFERENCES, label: "References" },
	            2: { value: _constants2.default.vouchReferenceType.JUGGLESTREET, label: "Juggle Street" }
	        }
	    }, {
	        field: "state",
	        label: "REGION/CITY",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "state",
	        label: "STATE",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'NSW', value: 'nsw' },
	            2: { label: 'ACT', value: 'act' },
	            3: { label: 'VIC', value: 'vic' },
	            4: { label: 'SA', value: 'sa' },
	            5: { label: 'QLD', value: 'qld' },
	            6: { label: 'NT', value: 'nt' },
	            7: { label: 'WA', value: 'wa' },
	            8: { label: 'TAS', value: 'ta' }
	        }
	    }, {
	        field: "country",
	        label: "COUNTRY",
	        icon: "fa-map-marker",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { label: 'Australia', value: 'au' },
	            2: { label: 'New Zealand', value: 'nz' }
	        }
	    }];
	
	    var botManagerFilterOptions = [{
	        field: "flowType",
	        label: "FLOW TYPE",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "contains", operator: "contains" }
	        }
	    }];
	
	    var botSessionsFilterOptions = [{
	        field: "userName",
	        label: "User Name",
	        icon: "fa-user",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.FREE_TEXT,
	        filterIitems: {
	            1: { value: 1, label: "is", operator: "eq" },
	            2: { value: 2, label: "contains", operator: "contains" }
	        }
	    }, {
	        field: "channelId",
	        label: "Channel",
	        icon: "fa-ticket",
	        isActive: false,
	        value: "",
	        filterItemSelected: 0,
	        filterType: filterType.DROP_DOWN,
	        filterIitems: {
	            1: { value: "facebook", label: "Facebook" },
	            2: { value: "emulator", label: "Emulator" }
	        }
	    }];
	
	    return {
	        filterType: filterType,
	        usersFilterOptions: usersFilterOptions,
	        profilesFilterOptions: profilesFilterOptions,
	        mediaFilterOptions: mediaFilterOptions,
	        surveyFilterOptions: surveyFilterOptions,
	        certificatesFilterOptions: certificatesFilterOptions,
	        checksFilterOptions: checksFilterOptions,
	        jobsFilterOptions: jobsFilterOptions,
	        jobRequestsFilterOptions: jobRequestsFilterOptions,
	        affiliatesFilterOptions: affiliatesFilterOptions,
	        vouchesFilterOptions: vouchesFilterOptions,
	        botManagerFilterOptions: botManagerFilterOptions,
	        botSessionsFilterOptions: botSessionsFilterOptions,
	        businessesFilterOptions: businessesFilterOptions,
	        globalUsersFilterOptions: globalUsersFilterOptions,
	        globalProfilesFilterOptions: globalProfilesFilterOptions,
	        globalJobsFilterOptions: globalJobsFilterOptions,
	        globalAffiliatesFilterOptions: globalAffiliatesFilterOptions,
	        globalVouchesFilterOptions: globalVouchesFilterOptions,
	        globalCertificatesFilterOptions: globalCertificatesFilterOptions,
	        globalChecksFilterOptions: globalChecksFilterOptions,
	        globalBotManagerFilterOptions: globalBotManagerFilterOptions,
	        globalBotSessionsFilterOptions: globalBotSessionsFilterOptions,
	        globalBusinessesFilterOptions: globalBusinessesFilterOptions,
	        globalJobRequestsFilterOptions: globalJobRequestsFilterOptions
	    };
	}();
	
	exports.default = FilterHelper;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var NotificationService = function NotificationService(toastr) {
	    "ngInject";
	
	    var warning = function warning(message) {
	        toastr.warning(message);
	    };
	
	    var success = function success(message) {
	        toastr.success(message);
	    };
	
	    var error = function error(message) {
	        toastr.error(message);
	    };
	
	    return { warning: warning, success: success, error: error };
	};
	NotificationService.$inject = ["toastr"];
	
	exports.default = NotificationService;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppContextService = function AppContextService(HttpService, AuthService) {
	  "ngInject";
	
	  var _appContext = void 0;
	  var _activeLocation = 'au';
	
	  var getAppContext = function getAppContext() {
	    return _appContext;
	  };
	
	  var setAppContext = function setAppContext(response) {
	    _appContext = response;
	    return _appContext;
	  };
	
	  var clearAppContext = function clearAppContext() {
	    _appContext = undefined;
	    return _appContext;
	  };
	
	  var getActiveLocation = function getActiveLocation() {
	    return _activeLocation;
	  };
	
	  var setActiveLocation = function setActiveLocation(newLocation) {
	    _activeLocation = newLocation;
	    return _activeLocation;
	  };
	
	  var fetchAppContext = function fetchAppContext(successCallback, errorCallback) {
	    HttpService.get("identity/userinfo", successCallback, errorCallback);
	  };
	
	  var hasAccess = function hasAccess(roles) {
	    return roles && (roles.indexOf("GlobalAdmin") != -1 || roles.indexOf("Admin") != -1 || roles.indexOf("ReadOnlyAdmin") != -1 || roles.indexOf("Analytics") != -1);
	  };
	
	  var hasReadAccess = function hasReadAccess(roles) {
	    return roles && roles.indexOf("ReadOnlyAdmin") != -1;
	  };
	
	  var hasGlobalAdminAccess = function hasGlobalAdminAccess(roles) {
	    return roles && roles.indexOf("GlobalAdmin") != -1;
	  };
	
	  var hasPaymentsAdminAccess = function hasPaymentsAdminAccess(roles) {
	    return roles && roles.indexOf("Payments") != -1;
	  };
	
	  var hasLoginAsUserAccess = function hasLoginAsUserAccess(roles) {
	    return roles && roles.indexOf("LogInAsUser") != -1;
	  };
	
	  var isAdmin = function isAdmin() {
	    var location = window.location.hostname.toLowerCase();
	    return _env2.default.isAdmin(location);
	  };
	
	  var isAnalytics = function isAnalytics() {
	    var location = window.location.hostname.toLowerCase();
	    return _env2.default.isAnalytics(location);
	  };
	
	  return { getAppContext: getAppContext, fetchAppContext: fetchAppContext, setAppContext: setAppContext, clearAppContext: clearAppContext, hasAccess: hasAccess, hasReadAccess: hasReadAccess, hasGlobalAdminAccess: hasGlobalAdminAccess, hasPaymentsAdminAccess: hasPaymentsAdminAccess, hasLoginAsUserAccess: hasLoginAsUserAccess, isAnalytics: isAnalytics, isAdmin: isAdmin, getActiveLocation: getActiveLocation, setActiveLocation: setActiveLocation };
	};
	AppContextService.$inject = ["HttpService", "AuthService"];
	
	exports.default = AppContextService;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EventsService = function EventsService($rootScope) {
	  "ngInject";
	
	  var broadcast = function broadcast(eventName, args) {
	    console.log("Broadcast::", eventName, "::Args::", args);
	    $rootScope.$broadcast(eventName, args);
	  };
	
	  var listen = function listen(eventName, handler) {
	    return $rootScope.$on(eventName, handler);
	  };
	
	  return { broadcast: broadcast, listen: listen };
	};
	EventsService.$inject = ["$rootScope"];
	
	exports.default = EventsService;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsService = function AnalyticsService(HttpService) {
	    "ngInject";
	
	    var getRevenueDataSource = function getRevenueDataSource(successCb) {
	        var dataSource = new kendo.data.DataSource({
	            transport: {
	                read: {
	                    url: _env2.default.getApiUrl("analytics/revenue"),
	                    contentType: "application/json",
	                    type: "GET",
	                    beforeSend: _onBeforeSend
	
	                }
	                // parameterMap: _parameterMap
	            },
	            change: successCb,
	            schema: {
	                data: function data(response) {
	                    return response.series[0].data;
	                },
	                model: {
	                    id: "id",
	                    fields: {
	                        "date": { type: "date" },
	                        "revenue": {}
	                    }
	                }
	            }
	        });
	
	        return dataSource;
	    };
	
	    // const getRevenueData = (successCb, failureCb) => {
	    //     HttpService.get("analytics/revenue", successCb, failureCb);
	    // }
	
	    // const getPayingCustomersData = (successCb, failureCb) => {
	    //     HttpService.get("analytics/payingcustomers", successCb, failureCb);
	    // }
	
	    // const getJobsSuccessRateData = (successCb, failureCb) => {
	    //     HttpService.get("analytics/jobssuccessrate", successCb, failureCb);
	    // }
	
	    var getRevenueData = function getRevenueData() {
	        return HttpService.getPromise("analytics/revenue");
	    };
	
	    var getMonthlyRevenueData = function getMonthlyRevenueData() {
	        return HttpService.getPromise("analytics/nmrrevenue");
	    };
	
	    var getRevenueYearOverYearData = function getRevenueYearOverYearData() {
	        return HttpService.getPromise("analytics/revenueyoy");
	    };
	
	    var getRevenueFinancialYearOverYearData = function getRevenueFinancialYearOverYearData() {
	        return HttpService.getPromise("analytics/revenuefyoy");
	    };
	
	    var getRevenueFinancialYearOverYearBreakdownData = function getRevenueFinancialYearOverYearBreakdownData() {
	        return HttpService.getPromise("analytics/revenuefyoybreakdown");
	    };
	
	    var getRevenueBreakdownData = function getRevenueBreakdownData() {
	        return HttpService.getPromise("analytics/revenuebreakdown");
	    };
	
	    var getBusinessRevenueBreakdownData = function getBusinessRevenueBreakdownData() {
	        return HttpService.getPromise("analytics/businessrevenuebreakdown");
	    };
	
	    var getHelperRevenueBreakdownData = function getHelperRevenueBreakdownData() {
	        return HttpService.getPromise("analytics/helperrevenuebreakdown");
	    };
	
	    var getNewRevenueBreakdownData = function getNewRevenueBreakdownData() {
	        return HttpService.getPromise("analytics/newrevenuebreakdown");
	    };
	
	    var getAccountRatingsBreakdownData = function getAccountRatingsBreakdownData() {
	        return HttpService.getPromise("analytics/accountratingsovertime");
	    };
	
	    var getRevenueByStateData = function getRevenueByStateData() {
	        return HttpService.getPromise("analytics/revenuebystate");
	    };
	
	    var getNzRevenueByRegionData = function getNzRevenueByRegionData() {
	        return HttpService.getPromise("analytics/nzrevenuebyregion");
	    };
	
	    var getPayingCustomersOvertimeData = function getPayingCustomersOvertimeData() {
	        return HttpService.getPromise("analytics/payingcustomersovertime");
	    };
	
	    var getUpsellBreakdown = function getUpsellBreakdown() {
	        return HttpService.getPromise("analytics/upsellBreakdown");
	    };
	
	    var getAvgTrnValueData = function getAvgTrnValueData() {
	        return HttpService.getPromise("analytics/avgtrnvalue");
	    };
	
	    var getRefundsData = function getRefundsData() {
	        return HttpService.getPromise("analytics/refunds");
	    };
	
	    var getRefundsAmountData = function getRefundsAmountData() {
	        return HttpService.getPromise("analytics/refundscount");
	    };
	
	    var getClientRefundsData = function getClientRefundsData() {
	        return HttpService.getPromise("analytics/clientrefunds");
	    };
	
	    var getRecentRevenueData = function getRecentRevenueData() {
	        return HttpService.getPromise("analytics/recentrevenue");
	    };
	
	    var getRecentRevenueByDeviceData = function getRecentRevenueByDeviceData() {
	        return HttpService.getPromise("analytics/recentrevenuebydevice");
	    };
	
	    var getRevenueByDeviceData = function getRevenueByDeviceData() {
	        return HttpService.getPromise("analytics/revenuebydevice");
	    };
	
	    var getDataSets = function getDataSets() {
	        return HttpService.getPromise("analytics/datasets");
	    };
	
	    var getJobValueOverTimeData = function getJobValueOverTimeData() {
	        return HttpService.getPromise("analytics/jobsvalueovertime");
	    };
	
	    var getJobValueByFinancialYearData = function getJobValueByFinancialYearData() {
	        return HttpService.getPromise("analytics/jobsvaluebyfinancialyear");
	    };
	
	    var getPayingCustomersData = function getPayingCustomersData() {
	        return HttpService.getPromise("analytics/payingcustomers");
	    };
	
	    var getCustomerRedemptionsOverTime = function getCustomerRedemptionsOverTime() {
	        return HttpService.getPromise("analytics/customerredemptionsovertime");
	    };
	
	    var getRegistrationsOverTimeData = function getRegistrationsOverTimeData() {
	        return HttpService.getPromise("analytics/registrationsovertime");
	    };
	
	    var getRegistrationsYearOverYearData = function getRegistrationsYearOverYearData() {
	        return HttpService.getPromise("analytics/registrationsyoy");
	    };
	
	    var getRegistrationsFinancialYearOverYearData = function getRegistrationsFinancialYearOverYearData() {
	        return HttpService.getPromise("analytics/registrationsfyoy");
	    };
	
	    var getNSWRegistrationsByRegionOverTimeData = function getNSWRegistrationsByRegionOverTimeData() {
	        return HttpService.getPromise("analytics/nswregistrationsbyregionovertime");
	    };
	
	    var getNZRegistrationsByRegionOverTimeData = function getNZRegistrationsByRegionOverTimeData() {
	        return HttpService.getPromise("analytics/nzregistrationsbyregionovertime");
	    };
	
	    var getVICRegistrationsByRegionOverTimeData = function getVICRegistrationsByRegionOverTimeData() {
	        return HttpService.getPromise("analytics/vicregistrationsbyregionovertime");
	    };
	
	    var getQLDRegistrationsByRegionOverTimeData = function getQLDRegistrationsByRegionOverTimeData() {
	        return HttpService.getPromise("analytics/qldregistrationsbyregionovertime");
	    };
	
	    var getRecentRegistrationsData = function getRecentRegistrationsData() {
	        return HttpService.getPromise("analytics/recentregistrations");
	    };
	
	    var getRecentAppDownloadsData = function getRecentAppDownloadsData() {
	        return HttpService.getPromise("analytics/recentappdownloads");
	    };
	
	    var getTopRegistrationsData = function getTopRegistrationsData() {
	        return HttpService.getPromise("analytics/topregistrations");
	    };
	
	    var getTopRevenueData = function getTopRevenueData() {
	        return HttpService.getPromise("analytics/toprevenue");
	    };
	
	    var getRegistrationsByStateData = function getRegistrationsByStateData() {
	        return HttpService.getPromise("analytics/registrationsbystate");
	    };
	
	    var getRecentNSWRegistrationsData = function getRecentNSWRegistrationsData() {
	        return HttpService.getPromise("analytics/recentnswregistrations");
	    };
	
	    var getRecentVICRegistrationsData = function getRecentVICRegistrationsData() {
	        return HttpService.getPromise("analytics/recentvicregistrations");
	    };
	
	    var getRecentQLDRegistrationsData = function getRecentQLDRegistrationsData() {
	        return HttpService.getPromise("analytics/recentqldregistrations");
	    };
	
	    var getJobsSuccessRateData = function getJobsSuccessRateData() {
	        return HttpService.getPromise("analytics/jobssuccessrate");
	    };
	
	    var getAccountApprovalOverTime = function getAccountApprovalOverTime() {
	        return HttpService.getPromise("analytics/accountapprovalovertime");
	    };
	
	    var getNewVersusRecurringRevenueData = function getNewVersusRecurringRevenueData() {
	        return HttpService.getPromise("analytics/newvsrecurringrevenue");
	    };
	
	    var getHelperNewVersusRecurringRevenueData = function getHelperNewVersusRecurringRevenueData() {
	        return HttpService.getPromise("analytics/helpernewvsrecurringrevenue");
	    };
	
	    var getGeneralStatsData = function getGeneralStatsData() {
	        return HttpService.getPromise("analytics/generalstats");
	    };
	
	    var getBotStatsData = function getBotStatsData() {
	        return HttpService.getPromise("analytics/botstats");
	    };
	
	    var getClientProfileItemsPerYearData = function getClientProfileItemsPerYearData() {
	        return HttpService.getPromise("analytics/clientprofileitemsperyear");
	    };
	
	    var getProviderProfileItemsPerYearData = function getProviderProfileItemsPerYearData() {
	        return HttpService.getPromise("analytics/providerprofileitemsperyear");
	    };
	
	    var getMonthlyActiveUsersData = function getMonthlyActiveUsersData() {
	        return HttpService.getPromise("analytics/monthlyactiveusers");
	    };
	
	    var getArruData = function getArruData() {
	        return HttpService.getPromise("analytics/arpu");
	    };
	
	    var formatRevenueData = function formatRevenueData(data) {
	        var revenueData = [];
	        var categories = [];
	        var seriesArr = data.series;
	
	        seriesArr.map(function (item, index) {
	
	            if (categories.length == 0) {
	                item.data.map(function (categoryItem) {
	                    categories.push(categoryItem.data);
	                });
	            }
	
	            revenueData[index] = {
	                name: item.name,
	                data: item.data,
	                field: "revenue",
	                // categoryField: "date",
	                // labels: {
	                //     visible: true,
	                //     format: "{0:C}"
	                // },
	                tooltip: {
	                    visible: true,
	                    background: "#60686e",
	                    format: "{0:C}"
	                }
	            };
	        });
	
	        return {
	            series: [revenueData[0]],
	            categoryAxis: {
	                categories: categories,
	                title: {
	                    text: "Weeks"
	                },
	                labels: {
	                    format: "MMM"
	                },
	                baseUnit: "weeks",
	                field: "date"
	            }
	        };
	    };
	
	    var getColumnChartOptions = function getColumnChartOptions(title, data) {
	        return {
	            title: {
	                text: title
	            },
	            theme: "silver",
	            legend: {
	                position: "top"
	            },
	            seriesDefaults: {
	                type: "column"
	            },
	            series: data.series,
	            valueAxis: {
	                labels: {
	                    format: "{0:p0}"
	                },
	                line: {
	                    visible: false
	                },
	                axisCrossingValue: 0,
	                max: 1
	            },
	            categoryAxis: {
	                categories: data.categories,
	                labels: {
	                    template: "#= kendo.toString(new Date(value), 'yyyy') #"
	                },
	                line: {
	                    visible: false
	                }
	            },
	            tooltip: {
	                visible: true,
	                format: "{0}%",
	                template: "#= series.name #: #= kendo.toString(value, 'p') #"
	            }
	        };
	    };
	
	    var getFunnelChartOptions = function getFunnelChartOptions(title, data, percentageTemplate) {
	        return {
	            title: {
	                text: title,
	                position: "bottom"
	            },
	            theme: "silver",
	            legend: {
	                visible: false,
	                position: "bottom"
	            },
	            seriesDefaults: {
	                labels: {
	                    visible: true,
	                    background: "transparent",
	                    position: "center",
	                    template: "#= category #"
	                    //color:"white",
	                    //format: "N0"
	                },
	                dynamicSlope: false,
	                dynamicHeight: false
	            },
	            series: [{
	                type: "funnel",
	                data: data
	            }],
	            tooltip: {
	                visible: true,
	                template: percentageTemplate
	            }
	        };
	    };
	
	    var getDonutChartOptions = function getDonutChartOptions(set, titleFormat, labelFormat) {
	        return {
	            title: {
	                text: titleFormat,
	                position: "bottom"
	            },
	            theme: "silver",
	            legend: {
	                visible: false,
	                position: "bottom"
	            },
	            seriesDefaults: {
	                startAngle: 150,
	                labels: {
	                    visible: true,
	                    background: "transparent",
	                    position: "outsideEnd",
	                    template: labelFormat
	                }
	            },
	            series: [{
	                type: "donut",
	                field: "percentage",
	                categoryField: "category",
	                data: set.data
	            }],
	            tooltip: {
	                visible: false
	            }
	        };
	    };
	
	    var getPercentage = function getPercentage(entry) {
	        var dataItem = entry.dataItem;
	        if (entry.index > 0) {
	            var prevDataItem = entry.series.data[entry.index - 1];
	            return kendo.format("{0:P} of '{1}' become '{2}', {3:P} of Total Accounts", dataItem.percentage, prevDataItem.category, dataItem.category, dataItem.percentageFromTotal);
	        } else {
	            return kendo.format("{0:P} of Total Accounts", dataItem.percentage);
	        }
	    };
	
	    var getGridOptions = function getGridOptions(set) {
	        var data = set.data;
	        var columns = set.dataInfo;
	        columns[0].width = "250px";
	
	        return {
	            dataSource: {
	                data: data,
	                pageable: false
	            },
	            columns: columns,
	            scrollable: false,
	            sortable: false,
	            filterable: false
	        };
	    };
	
	    var getChartOptions = function getChartOptions(title, series, categories, format, template, dateFormat, tooltipTemplate, categoryBaseUnit) {
	        var tooltipFormatter = void 0;
	        if (typeof tooltipTemplate == "function") {
	            tooltipFormatter = tooltipTemplate;
	        } else {
	            if (!tooltipTemplate) tooltipTemplate = "n0";
	
	            tooltipFormatter = function tooltipFormatter(args) {
	                var date = kendo.toString(new Date(args.category), dateFormat && dateFormat.days ? dateFormat.days : "MMM yyyy");
	                return date + ' - ' + kendo.toString(args.value, tooltipTemplate);
	            };
	        }
	
	        return {
	            title: {
	                text: title
	            },
	            theme: "silver",
	            seriesDefaults: {
	                type: "line",
	                labels: {
	                    visible: true,
	                    format: format
	                }
	            },
	            series: series,
	            legend: {
	                position: "bottom",
	                labels: {
	                    template: template
	                }
	            },
	            tooltip: {
	                visible: true,
	                background: "#60686e",
	                format: format,
	                template: tooltipFormatter
	            },
	            valueAxis: {
	                labels: {
	                    format: format
	                }
	            },
	            categoryAxis: {
	                type: "date",
	                categories: categories,
	                baseUnit: categoryBaseUnit,
	                labels: {
	                    visible: true,
	                    dateFormats: dateFormat
	                }
	            }
	        };
	    };
	
	    return { getRevenueDataSource: getRevenueDataSource, getRevenueBreakdownData: getRevenueBreakdownData, getNewRevenueBreakdownData: getNewRevenueBreakdownData, getRefundsData: getRefundsData, getRefundsAmountData: getRefundsAmountData, getClientRefundsData: getClientRefundsData, getPayingCustomersData: getPayingCustomersData, getRevenueData: getRevenueData, getRecentRevenueData: getRecentRevenueData, getRecentRevenueByDeviceData: getRecentRevenueByDeviceData,
	        getRevenueByDeviceData: getRevenueByDeviceData, formatRevenueData: formatRevenueData, getJobsSuccessRateData: getJobsSuccessRateData, getRegistrationsOverTimeData: getRegistrationsOverTimeData, getNSWRegistrationsByRegionOverTimeData: getNSWRegistrationsByRegionOverTimeData, getVICRegistrationsByRegionOverTimeData: getVICRegistrationsByRegionOverTimeData, getNZRegistrationsByRegionOverTimeData: getNZRegistrationsByRegionOverTimeData, getUpsellBreakdown: getUpsellBreakdown,
	        getRecentRegistrationsData: getRecentRegistrationsData, getRecentNSWRegistrationsData: getRecentNSWRegistrationsData, getRecentVICRegistrationsData: getRecentVICRegistrationsData, getRecentQLDRegistrationsData: getRecentQLDRegistrationsData, getCustomerRedemptionsOverTime: getCustomerRedemptionsOverTime, getRegistrationsYearOverYearData: getRegistrationsYearOverYearData, getRegistrationsFinancialYearOverYearData: getRegistrationsFinancialYearOverYearData,
	        getAccountApprovalOverTime: getAccountApprovalOverTime, getNewVersusRecurringRevenueData: getNewVersusRecurringRevenueData, getGeneralStatsData: getGeneralStatsData, getBotStatsData: getBotStatsData, getRevenueYearOverYearData: getRevenueYearOverYearData, getRevenueFinancialYearOverYearData: getRevenueFinancialYearOverYearData, getQLDRegistrationsByRegionOverTimeData: getQLDRegistrationsByRegionOverTimeData, getRevenueByStateData: getRevenueByStateData, getNzRevenueByRegionData: getNzRevenueByRegionData,
	        getClientProfileItemsPerYearData: getClientProfileItemsPerYearData, getProviderProfileItemsPerYearData: getProviderProfileItemsPerYearData, getJobValueOverTimeData: getJobValueOverTimeData, getDataSets: getDataSets, getRegistrationsByStateData: getRegistrationsByStateData, getAvgTrnValueData: getAvgTrnValueData, getPayingCustomersOvertimeData: getPayingCustomersOvertimeData, getRevenueFinancialYearOverYearBreakdownData: getRevenueFinancialYearOverYearBreakdownData,
	        getColumnChartOptions: getColumnChartOptions, getFunnelChartOptions: getFunnelChartOptions, getDonutChartOptions: getDonutChartOptions, getGridOptions: getGridOptions, getPercentage: getPercentage, getChartOptions: getChartOptions, getTopRegistrationsData: getTopRegistrationsData, getTopRevenueData: getTopRevenueData, getMonthlyRevenueData: getMonthlyRevenueData, getHelperRevenueBreakdownData: getHelperRevenueBreakdownData,
	        getMonthlyActiveUsersData: getMonthlyActiveUsersData, getArruData: getArruData, getJobValueByFinancialYearData: getJobValueByFinancialYearData, getRecentAppDownloadsData: getRecentAppDownloadsData, getAccountRatingsBreakdownData: getAccountRatingsBreakdownData, getHelperNewVersusRecurringRevenueData: getHelperNewVersusRecurringRevenueData, getBusinessRevenueBreakdownData: getBusinessRevenueBreakdownData
	    };
	};
	AnalyticsService.$inject = ["HttpService"];
	
	function _onBeforeSend(req) {
	    var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	    req.setRequestHeader("Authorization", token);
	}
	
	exports.default = AnalyticsService;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaService = function MediaService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("media/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "creationDate": { editable: false },
	            "externalHashedId": {},
	            "name": {},
	            "mediaStatus": {},
	            "mediaReviewStatus": {},
	            "thumbnailUrl": {},
	            "width": {},
	            "height": {},
	            "duration": {},
	            "mediaType": {},
	            "userId": {},
	            "id": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource };
	};
	MediaService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("media/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "update") {
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = MediaService;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyService = function SurveyService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("survey/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "jugglerId",
	          fields: {
	            "responseDate": { editable: false },
	            "fullName": {},
	            "jugglerId": {},
	            "email": {},
	            "jugglerType": {},
	            "interestInHomeAgedCareResponse": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource };
	};
	SurveyService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("survey/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "update") {
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = SurveyService;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilesService = function ProfilesService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("profiles/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "userId",
	          fields: {
	            "userId": {},
	            "creationDate": { editable: false },
	            "flaggedForReview": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource };
	};
	ProfilesService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("profiles/" + options.userId);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "update") {
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = ProfilesService;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CertificatesService = function CertificatesService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("certificates/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "creationDate": {},
	            "category": {},
	            "certificateTypeId": {},
	            "certificateName": {},
	            "certificateNumber": {},
	            "expiryDate": { type: "date" },
	            "notes": {},
	            "verificationDate": {},
	            "certificateNumericData1": {},
	            "certificateTextData1": {},
	            "certificateStatus": {},
	            "fullName": {},
	            "id": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource };
	};
	CertificatesService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("certificates/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "update") {
	    // Dates used in the DataSource are JavaScript Date objects.
	    // Therefore convert the date to utc before sending to remove dateoffset.
	
	    data.expiryDate = _common2.default.converToUtcDate(data.expiryDate);
	
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = CertificatesService;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChecksService = function ChecksService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("checks/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "creationDate": { type: "date" },
	            "dateOfBirth": { type: "date" },
	            "visaExpiry": { type: "date" },
	            "visaGrantDate": { type: "date" },
	            "visaClass": {},
	            "visaSubclass": {},
	            "visaNumber": {},
	            "id": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource };
	};
	ChecksService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("checks/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "update") {
	    // Dates used in the DataSource are JavaScript Date objects.
	    // Therefore convert the date to utc before sending to remove dateoffset.
	
	    if (data.visaGrantDate) data.visaGrantDate = _common2.default.converToUtcDate(data.visaGrantDate);
	
	    if (data.visaExpiry) data.visaExpiry = _common2.default.converToUtcDate(data.visaExpiry);
	
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = ChecksService;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobsService = function JobsService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("jobs/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total"
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  var getJobPaymentDetails = function getJobPaymentDetails(jobId, successCb, failureCb) {
	    HttpService.get("jobs/" + jobId + "/payment-details", successCb, failureCb);
	  };
	
	  var getJobDetails = function getJobDetails(jobId, successCb, failureCb) {
	    HttpService.get("jobs/" + jobId, successCb, failureCb);
	  };
	
	  var updateJobPricing = function updateJobPricing(jobId, data, successCb, failureCb) {
	    HttpService.put("jobs/" + jobId + "/pricing", data, successCb, failureCb);
	  };
	
	  var payHelper = function payHelper(invoiceId, successCb, failureCb) {
	    console.log('JobsService.payHelper called with invoiceId:', invoiceId);
	    HttpService.post("payments/helper/" + invoiceId, null, successCb, failureCb);
	  };
	
	  var deleteTimesheet = function deleteTimesheet(jobId, successCb, failureCb) {
	    HttpService.patch("jobs/" + jobId + "/timesheet", { status: 12 }, successCb, failureCb);
	  };
	
	  var getJugglerJobsDataSource = function getJugglerJobsDataSource(userId) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("jobs/juggler/" + userId),
	          contentType: "application/json",
	          type: "GET",
	          cache: false,
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: function url(item) {
	            return _env2.default.getApiUrl("jobs/" + (item.id || item.jobId || item.JobId || item.Id) + "/pricing");
	          },
	          contentType: "application/json",
	          type: "PUT",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: function parameterMap(data, type) {
	          if (type === "update") {
	            return (0, _stringify2.default)({
	              price: data.price || data.Price,
	              overtimeRate: data.overtimeRate || data.OvertimeRate,
	              estimatedJobValue: data.estimatedJobValue || data.EstimatedJobValue
	            });
	          }
	        }
	      },
	      schema: {
	
	        model: {
	          id: "id", // Assuming id or jobId is present. Handled in update url safely.
	          fields: {
	            id: { editable: false },
	            jobId: { editable: false },
	            paymentType: { editable: false },
	            PaymentType: { editable: false },
	            jobDate: { editable: false },
	            JobDate: { editable: false },
	            jobStartTime: { editable: false },
	            JobStartTime: { editable: false },
	            jobEndTime: { editable: false },
	            JobEndTime: { editable: false },
	            estimatedJobHours: { editable: false },
	            EstimatedJobHours: { editable: false },
	            price: { type: "number", validation: { min: 0 } },
	            Price: { type: "number", validation: { min: 0 } },
	            overtimeRate: { type: "number", validation: { min: 0 } },
	            OvertimeRate: { type: "number", validation: { min: 0 } },
	            estimatedJobValue: { type: "number", validation: { min: 0 } },
	            EstimatedJobValue: { type: "number", validation: { min: 0 } }
	          }
	        }
	      },
	      serverFiltering: false,
	      serverPaging: false,
	      serverSorting: false,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource, getJugglerJobsDataSource: getJugglerJobsDataSource, getJobPaymentDetails: getJobPaymentDetails, getJobDetails: getJobDetails, updateJobPricing: updateJobPricing, payHelper: payHelper, deleteTimesheet: deleteTimesheet };
	};
	JobsService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("bigfoot/medias/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "update") {
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = JobsService;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobRequestsService = function JobRequestsService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("jobrequests/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "creationDate": { type: "date", editable: false, validation: { required: true } },
	            "notes": { nullable: false, validation: { required: false } },
	            "id": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  var transferJob = function transferJob(jobRequest, successCb, failureCb) {
	    HttpService.patch("jobrequests/" + jobRequest.id + "/transfer-job", jobRequest, successCb, failureCb);
	  };
	
	  return { getDataSource: getDataSource, transferJob: transferJob };
	};
	JobRequestsService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("jobrequests/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "update") {
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = JobRequestsService;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(772);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AffiliatesService = function AffiliatesService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("affiliates/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        create: {
	          url: _env2.default.getApiUrl("affiliates/create"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "creationDate": { type: "date", editable: false, validation: { required: true } },
	            "code": { nullable: false, validation: { required: true } },
	            "startDate": { type: "date", nullable: false, validation: { required: true } },
	            "expireDate": { type: "date", nullable: false, validation: { required: true } },
	            "affiliateName": { nullable: false, validation: { required: true } },
	            "affilateType": { defaultValue: 0 },
	            "creditAmount": { defaultValue: 0 },
	            "activationsCount": { defaultValue: 0 },
	            "activationsLimit": { defaultValue: 0 },
	            "paymentType": { defaultValue: 0 },
	            "emailPattern": {},
	            "id": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  var getAffiliateUsersDataSource = function getAffiliateUsersDataSource(id, successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("affiliates/affiliateusers/" + id),
	          contentType: "application/json",
	          type: "GET",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "id": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  var getAffiliateJobsDataSource = function getAffiliateJobsDataSource(id, successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("affiliates/affiliatejobs/" + id),
	          contentType: "application/json",
	          type: "GET",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "id": {}
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource, getAffiliateUsersDataSource: getAffiliateUsersDataSource, getAffiliateJobsDataSource: getAffiliateJobsDataSource };
	};
	AffiliatesService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("affiliates/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "create") {
	
	    // Dates used in the DataSource are JavaScript Date objects.
	    // Therefore convert the date to utc before sending to remove dateoffset.
	
	    delete data.id;
	    data.expireDate = _common2.default.converToUtcDate(data.expireDate);
	    data.startDate = _common2.default.converToUtcDate(data.startDate);
	
	    if (data.affiliateType && data.affiliateType.value) {
	      data.affiliateType = data.affiliateType.value;
	    }
	
	    if (data.paymentType && data.paymentType.value) {
	      data.paymentType = data.paymentType.value;
	    }
	
	    if (data.secondaryPaymentType && (0, _typeof3.default)(data.secondaryPaymentType) === 'object' && data.secondaryPaymentType.hasOwnProperty('value')) {
	      data.secondaryPaymentType = data.secondaryPaymentType.value;
	    }
	
	    console.log("Data::", data);
	
	    return (0, _stringify2.default)(data);
	  }
	
	  if (type == "update") {
	
	    // Dates used in the DataSource are JavaScript Date objects.
	    // Therefore convert the date to utc before sending to remove dateoffset.
	
	    data.expireDate = _common2.default.converToUtcDate(data.expireDate);
	    data.startDate = _common2.default.converToUtcDate(data.startDate);
	
	    if (data.affiliateType && data.affiliateType.value) {
	      data.affiliateType = data.affiliateType.value;
	    }
	
	    if (data.secondaryPaymentType && (0, _typeof3.default)(data.secondaryPaymentType) === 'object' && data.secondaryPaymentType.hasOwnProperty('value')) {
	      data.secondaryPaymentType = data.secondaryPaymentType.value;
	    }
	
	    console.log("Data::", data);
	
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = AffiliatesService;

/***/ },
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VouchesService = function VouchesService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("vouches/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        create: {
	          url: _env2.default.getApiUrl("vouches/create"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend,
	          complete: function complete(e) {
	            $("#vouches-grid").data("kendoGrid").dataSource.read();
	          }
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "creationDate": { type: "date", editable: false, validation: { required: true } },
	            // "code": { nullable: false, validation: { required: true } },
	            // "startDate": { type: "date", nullable: false, validation: { required: true } },
	            // "expireDate": { type: "date", nullable: false, validation: { required: true } },
	            "fullName": { nullable: false, validation: { required: true } },
	            "whatWouldYouLikeToSay": { nullable: false, validation: { required: true } },
	            "notes": { nullable: false, validation: { required: false } },
	            "status": { defaultValue: 0 },
	            "referenceType": { defaultValue: 0 },
	            "id": {},
	            "jugglerId": {},
	            "email": { defaultValue: '' },
	            "phoneNumber": { defaultValue: '' }
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource };
	};
	VouchesService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("vouches/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "create") {
	
	    // Dates used in the DataSource are JavaScript Date objects.
	    // Therefore convert the date to utc before sending to remove dateoffset.
	
	    delete data.id;
	    // data.expireDate = common.converToUtcDate(data.expireDate);
	    // data.startDate = common.converToUtcDate(data.startDate);
	
	    console.log("Data::", data);
	
	    return (0, _stringify2.default)(data);
	  }
	
	  if (type == "update") {
	
	    // Dates used in the DataSource are JavaScript Date objects.
	    // Therefore convert the date to utc before sending to remove dateoffset.
	
	    // data.expireDate = common.converToUtcDate(data.expireDate);
	    // data.startDate = common.converToUtcDate(data.startDate);
	
	    console.log("Data::", data);
	
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = VouchesService;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MermaidService = function MermaidService() {
	  "ngInject";
	
	  var init = function init() {
	    console.log("mermaid initialized");
	    window.mermaidAPI.initialize({
	      startOnLoad: false,
	      flowchart: {
	        useMaxWidth: false,
	        htmlLabels: true
	      }
	    });
	  };
	
	  var render = function render(id, graphDefinition, cb) {
	    window.mermaidAPI.render(id, graphDefinition, cb);
	  };
	
	  var getGraph = function getGraph(diagramId) {
	    switch (diagramId) {
	      case _constants2.default.flowDiagrams.FACEBOOK_CHANNEL:
	        return "graph TB            \n        885108642(Hi Im Agent Juggle I...) --> 885108643(Helper)\n        885108643 --> 885108644(Great Would you like...)\n        885108644 --> 885108645(How JS works)\n        885108645 --> 885108646(JS is a network that...)\n        885108646 --> 885108647(No I want to \xA0know m...)\n        885108647 --> 885108648(what would you like ...)\n        885108648 --> 885108649(Trust in the JS netw...)\n        885108648 --> 885108651(How much it costs  h...)\n        885108648 --> 885108654(something else)\n        885108654 --> 885108655(where we operate)\n        885108654 --> 885108657(Im ready to register)\n        885108646 --> 885108659(Yes)\n        885108646 --> 885108660(No Im ready to regis...)\n        885108660 --> 885108661(go to)\n        885108644 --> 885108662(How much will I earn...)\n        885108662 --> 885108663(There is no cost to ...)\n        885108663 --> 885108664(register)\n        885108664 --> 885108665(go to)\n        885108663 --> 885108666(know more about cost...)\n        885108666 --> 885108667(How much you earn is...)\n        885108667 --> 885108668(Yes I want to know m...)\n        885108668 --> 885108669(what would you like ...)\n        885108669 --> 885108670(trust)\n        885108670 --> 885108671(go to)\n        885108669 --> 885108672(where we operate)\n        885108672 --> 885108673(go to)\n        885108669 --> 885108674(how JS works)\n        885108674 --> 885108675(go to)\n        885108667 --> 885108676(No Im ready to Regis...)\n        885108676 --> 885108678(go to)\n        885108663 --> 885108679(something else)\n        885108644 --> 885108693(Trust in the JS netw...)\n        885108693 --> 885108694(Trust is super impor...)\n        885108694 --> 885108695(Know more about trus...)\n        885108695 --> 885108696(1 your JS profile ph...)\n        885108694 --> 885108715(something else)\n        885108715 --> 885108716(what do you want to ...)\n        885108644 --> 885108729(Where we operate)\n        885108729 --> 885108730(What is your postcod...)\n        885108642 --> 885108794(Parent)\n        classDef selected fill:#f9f,stroke:#333,stroke-width:4px;\n        class 885108642,885108643,885108644,885108662,885108663,885108666,885108667,885108668,885108669,885108670,885108671 selected\n        ";
	      case _constants2.default.flowDiagrams.LOCATE_HELPERS_IN_AREA_FLOW:
	        return "graph TB\n                A(Locate Babysitters and Nannies) --> B(Request Suburb or Postcode)\n                B --> C(Display Suburb Summary)\n                C --> D{Display Top 10 helpers?}\n                D --> E(Yes)\n                D --> F(No)\n                F --> G[End]\n                G --> A\n                E --> H(List 10 Helpers)\n                H --> I[Display Helper Profile]\n                I --> J{Actions}\n                J --> K(Sign Up)\n                J --> L(Post Job)\n                J --> M[End]\n                M --> A";
	      case _constants2.default.flowDiagrams.POST_JOB_FLOW:
	        return "graph TB\n                A(Post Job Request) --> B{Use Usual Sitters?}\n                B --> C(Yes)\n                B --> D(No)\n                D --> F(Specify Sitter By Name)\n                C --> E(When do you need a sitter?)\n                F --> E\n                E --> H(Specify Start Time, End time, Hourly Rate)\n                H --> I(Post Job and Send Confirmation)\n                I --> J(Print Receipt - If Required)\n                J --> K(Rate Previous Jobs - If Any)";
	      case _constants2.default.flowDiagrams.DISPLAY_PROFILE_FLOW:
	        return "graph TB\n                A(Display Profile) --> C(Display Summary)\n                C --> D(Display Family Recommendations)\n                D --> E(Display Video Interview)\n                E --> J{Actions}\n                J --> K(Post Job)\n                J --> L(Connect)\n                J --> M[End]\n                M --> A";
	      default:
	        return "graph TB\n                A(TBD) --> C(TBD)";
	    }
	  };
	
	  return { init: init, render: render, getGraph: getGraph };
	};
	
	exports.default = MermaidService;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotFlowService = function BotFlowService(HttpService) {
	    "ngInject";
	
	    var getBotFlowsPromise = function getBotFlowsPromise() {
	        return HttpService.getPromise("bigfoot/bots/flows");
	    };
	
	    return { getBotFlowsPromise: getBotFlowsPromise };
	};
	BotFlowService.$inject = ["HttpService"];
	
	exports.default = BotFlowService;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotManagerService = function BotManagerService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb, errorCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("bigfoot/bots/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        create: {
	          url: _env2.default.getApiUrl("bigfoot/bots/create"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      error: errorCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "id": { type: "string" },
	            "title": { type: "string", validation: { required: true } },
	            "flowStatus": { type: "number", defaultValue: 0, validation: { required: true } },
	            "flowFileBinary": {},
	            "creationDate": { type: "date", editable: false }
	          }
	        }
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return { getDataSource: getDataSource };
	};
	BotManagerService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("bigfoot/bots/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read" || type == "create") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "update") {
	
	    // Dates used in the DataSource are JavaScript Date objects.
	    // Therefore convert the date to utc before sending to remove dateoffset.
	
	    //data.expireDate = common.converToUtcDate(data.expireDate);
	    //data.startDate = common.converToUtcDate(data.startDate);
	
	    console.log("update data", data);
	
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = BotManagerService;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotSessionsService = function BotSessionsService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("bigfoot/bot-sessions/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total"
	      },
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  var getSessionDetails = function getSessionDetails(sessionId, successCb, failureCb) {
	    HttpService.get("bigfoot/bot-sessions/" + sessionId, successCb, failureCb);
	  };
	
	  var getMessagesDataSource = function getMessagesDataSource(sessionId, successCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("bigfoot/bot-sessions/" + sessionId + "/messages"),
	          contentType: "application/json",
	          type: "GET",
	          beforeSend: _onBeforeSend
	
	        }
	      },
	      change: successCb,
	      serverFiltering: false,
	      serverPaging: false,
	      serverSorting: false,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  return {
	    getDataSource: getDataSource,
	    getSessionDetails: getSessionDetails,
	    getMessagesDataSource: getMessagesDataSource
	  };
	};
	BotSessionsService.$inject = ["HttpService"];
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  var filters = [];
	
	  if (data.filter) filters = data.filter.filters;
	
	  var query = (0, _assign2.default)({}, { filters: filters }, data);
	  delete query.filter;
	
	  console.log("Query::", query);
	
	  return (0, _stringify2.default)(query);
	}
	
	exports.default = BotSessionsService;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(389);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BusinessesService = function BusinessesService(HttpService) {
	  "ngInject";
	
	  var getDataSource = function getDataSource(successCb, errorCb) {
	    var dataSource = new kendo.data.DataSource({
	      transport: {
	        read: {
	          url: _env2.default.getApiUrl("businesses/search"),
	          contentType: "application/json",
	          type: "POST",
	          beforeSend: _onBeforeSend
	        },
	        update: {
	          url: _getResourceLocation,
	          contentType: "application/json",
	          type: "PATCH",
	          beforeSend: _onBeforeSend
	        },
	        parameterMap: _parameterMap
	      },
	      change: successCb,
	      schema: {
	        data: "data",
	        total: "total",
	        model: {
	          id: "id",
	          fields: {
	            "notes": { nullable: false, validation: { required: false } },
	            "locationStatus": { defaultValue: 0 },
	            "id": {}
	          }
	        }
	      },
	      error: errorCb,
	      serverFiltering: true,
	      serverPaging: true,
	      serverSorting: true,
	      pageSize: 50
	    });
	
	    return dataSource;
	  };
	
	  var getBusinessDetails = function getBusinessDetails(id, successCb, failureCb) {
	    HttpService.get("businesses/" + id, successCb, failureCb);
	  };
	
	  return {
	    getDataSource: getDataSource,
	    getBusinessDetails: getBusinessDetails
	  };
	};
	BusinessesService.$inject = ["HttpService"];
	
	function _getResourceLocation(options) {
	  return _env2.default.getApiUrl("businesses/" + options.id);
	}
	
	function _onBeforeSend(req) {
	  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	  req.setRequestHeader("Authorization", token);
	}
	
	function _parameterMap(data, type) {
	  if (type == "read") {
	    var filters = [];
	
	    if (data.filter) filters = data.filter.filters;
	
	    var query = (0, _assign2.default)({}, { filters: filters }, data);
	    delete query.filter;
	
	    console.log("Query::", query);
	
	    return (0, _stringify2.default)(query);
	  }
	
	  if (type == "create") {
	    delete data.id;
	    console.log("Data::", data);
	
	    return (0, _stringify2.default)(data);
	  }
	
	  if (type == "update") {
	
	    console.log("Data::", data);
	
	    return (0, _stringify2.default)(data);
	  }
	}
	
	exports.default = BusinessesService;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _users = __webpack_require__(793);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _profiles = __webpack_require__(807);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _userDetails = __webpack_require__(813);
	
	var _userDetails2 = _interopRequireDefault(_userDetails);
	
	var _jobDetails = __webpack_require__(824);
	
	var _jobDetails2 = _interopRequireDefault(_jobDetails);
	
	var _login = __webpack_require__(830);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _certificates = __webpack_require__(836);
	
	var _certificates2 = _interopRequireDefault(_certificates);
	
	var _checks = __webpack_require__(842);
	
	var _checks2 = _interopRequireDefault(_checks);
	
	var _media = __webpack_require__(849);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _survey = __webpack_require__(855);
	
	var _survey2 = _interopRequireDefault(_survey);
	
	var _affiliates = __webpack_require__(861);
	
	var _affiliates2 = _interopRequireDefault(_affiliates);
	
	var _vouches = __webpack_require__(867);
	
	var _vouches2 = _interopRequireDefault(_vouches);
	
	var _analytics = __webpack_require__(873);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _jobs = __webpack_require__(886);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _flow = __webpack_require__(892);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _botFlow = __webpack_require__(898);
	
	var _botFlow2 = _interopRequireDefault(_botFlow);
	
	var _botSessions = __webpack_require__(904);
	
	var _botSessions2 = _interopRequireDefault(_botSessions);
	
	var _botSessionDetails = __webpack_require__(910);
	
	var _botSessionDetails2 = _interopRequireDefault(_botSessionDetails);
	
	var _botManager = __webpack_require__(916);
	
	var _botManager2 = _interopRequireDefault(_botManager);
	
	var _analyticsRevenue = __webpack_require__(922);
	
	var _analyticsRevenue2 = _interopRequireDefault(_analyticsRevenue);
	
	var _analyticsUsers = __webpack_require__(928);
	
	var _analyticsUsers2 = _interopRequireDefault(_analyticsUsers);
	
	var _analyticsTraffic = __webpack_require__(934);
	
	var _analyticsTraffic2 = _interopRequireDefault(_analyticsTraffic);
	
	var _analyticsData = __webpack_require__(940);
	
	var _analyticsData2 = _interopRequireDefault(_analyticsData);
	
	var _analyticsBot = __webpack_require__(946);
	
	var _analyticsBot2 = _interopRequireDefault(_analyticsBot);
	
	var _analyticsMarketing = __webpack_require__(952);
	
	var _analyticsMarketing2 = _interopRequireDefault(_analyticsMarketing);
	
	var _businesses = __webpack_require__(958);
	
	var _businesses2 = _interopRequireDefault(_businesses);
	
	var _businessDetails = __webpack_require__(964);
	
	var _businessDetails2 = _interopRequireDefault(_businessDetails);
	
	var _jobRequests = __webpack_require__(970);
	
	var _jobRequests2 = _interopRequireDefault(_jobRequests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContainersModule = _angular2.default.module('app.containers', [_users2.default.name, _profiles2.default.name, _userDetails2.default.name, _jobDetails2.default.name, _login2.default.name, _certificates2.default.name, _checks2.default.name, _media2.default.name, _survey2.default.name, _affiliates2.default.name, _vouches2.default.name, _analytics2.default.name, _jobs2.default.name, _flow2.default.name, _botFlow2.default.name, _botSessions2.default.name, _botManager2.default.name, _botSessionDetails2.default.name, _analyticsRevenue2.default.name, _analyticsUsers2.default.name, _analyticsTraffic2.default.name, _analyticsData2.default.name, _analyticsBot2.default.name, _analyticsMarketing2.default.name, _businesses2.default.name, _businessDetails2.default.name, _jobRequests2.default.name]);
	
	exports.default = ContainersModule;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _users = __webpack_require__(794);
	
	var _users2 = _interopRequireDefault(_users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersModule = _angular2.default.module('app.containers.users', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('users', {
	    url: '/users',
	    template: '<users></users>'
	  });
	  // .state('users', {
	  //   url: '/users',
	  //   template: '<users></users>'
	  // })
	}]).component('users', _users2.default);
	
	exports.default = usersModule;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _users = __webpack_require__(795);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _users3 = __webpack_require__(796);
	
	var _users4 = _interopRequireDefault(_users3);
	
	__webpack_require__(805);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _users2.default,
	  controller: _users4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = usersComponent;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"users-container\">\r\n  <div class=\"users-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <users-filter apply-filters=\"vm.applyFilters()\"></users-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"users-match\">{{vm.usersMatchCount ? vm.usersMatchCount + \" users match\" : \"\"}}</div>\r\n      <div class=\"export-btn-container\">\r\n        <button class=\"btn-export\" ng-click=\"vm.exportToExcel()\">Export to Excel</button>\r\n      </div>\r\n      <div class=\"users-grid\">\r\n        <div id=\"users-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(756);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(412);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _xlsx = __webpack_require__(797);
	
	var _xlsx2 = _interopRequireDefault(_xlsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersController = function () {
	  UsersController.$inject = ["UsersService", "FilterService", "AuthService", "$scope"];
	  function UsersController(UsersService, FilterService, AuthService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UsersController);
	    this.usersService = UsersService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
	  }
	
	  (0, _createClass3.default)(UsersController, [{
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        // selectable: "multiple cell",
	        // allowCopy: true,
	        dataSource: this.usersService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          template: "No match found. Change your filter criteria."
	        },
	        columns: [{
	          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "12rem",
	          template: function template(dataItem) {
	            return "<a class=\"cell\" href=\"/users/" + dataItem.userId + "\"><div class=\"image-container\"><img src=\"" + (dataItem.imageUrl ? _this.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png") + "\"></img></div><span>" + dataItem.fullName + "</span></a>";
	          }
	        }, { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" }, { field: "userId", title: "User Id", filterable: false, width: "6rem", template: function template(dataItem) {
	            return "<a href=\"/users/" + dataItem.userId + "\">" + dataItem.userId + "</a>";
	          } }, // { field: "membershipTypeName", title: "Membership Type", filterable: false, width: "10rem" },
	        { field: "accountStatusName", title: "Account Status", filterable: false, width: "8rem" }, {
	          field: "email", title: "Email", filterable: false, width: "15rem",
	          template: "<a href=\"mailto:#= email #\">#= email #</a>"
	        }, { field: "creationDate", title: "Signup Date", template: "<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>", filterable: false, width: "8rem" }, { field: "phoneNumber", title: "Phone Number", filterable: false, width: "10rem" }, { field: "suburb", title: "Suburb", filterable: false, width: "8rem" },
	        // { field: "state", title: "State/Region", filterable: false, width: "8rem" },
	        { field: "country", title: "Country", filterable: false, width: "6rem" }]
	      };
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "exportToExcel",
	    value: function exportToExcel() {
	      var ds = this.gridOptions.dataSource;
	      var currentFilters = ds.filter() || {};
	      var filters = currentFilters.filters || [];
	      var total = ds.total();
	
	      var payload = (0, _stringify2.default)({
	        filters: filters,
	        page: 1,
	        pageSize: total || 100000,
	        skip: 0,
	        take: total || 100000
	      });
	
	      var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");
	
	      fetch(_env2.default.getApiUrl("entities/search"), {
	        method: "POST",
	        headers: { "Content-Type": "application/json", "Authorization": token },
	        body: payload
	      }).then(function (r) {
	        return r.json();
	      }).then(function (result) {
	        var rows = (result.data || []).map(function (u) {
	          return {
	            Name: u.fullName,
	            "Account Type": u.entityTypeName,
	            "Account Status": u.accountStatusName,
	            Email: u.email,
	            "Phone Number": u.phoneNumber || '',
	            "Signup Date": u.creationDate ? new Date(u.creationDate).toLocaleDateString('en-GB') : '',
	            Suburb: u.suburb,
	            Country: u.country
	          };
	        });
	        var ws = _xlsx2.default.utils.json_to_sheet(rows);
	        var wb = _xlsx2.default.utils.book_new();
	        _xlsx2.default.utils.book_append_sheet(wb, ws, "Users");
	        var fileName = "users_" + (0, _moment2.default)().format('YYYY-MM-DD_HH-mm-ss') + ".xlsx";
	        _xlsx2.default.writeFile(wb, fileName);
	      });
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.usersMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }]);
	  return UsersController;
	}();
	
	exports.default = UsersController;

/***/ },
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	/* (ignored) */

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	/* (ignored) */

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(806);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./users.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./users.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.users-container{display:flex;flex-direction:column;height:100vh}.users-container .users-inner-container{height:100%;display:flex}.users-container .users-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.users-container .users-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.users-container .users-inner-container .grid-container .users-grid{margin-top:.5rem;margin-left:.5rem}.users-container .users-inner-container .grid-container .users-grid .col-name .cell{display:flex;align-items:center}.users-container .users-inner-container .grid-container .users-grid .col-name .cell .image-container{width:2rem}.users-container .users-inner-container .grid-container .users-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.users-container .users-inner-container .grid-container .users-grid .k-grid-norecords{margin-top:20rem}.users-container .users-inner-container .grid-container .users-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}.export-btn-container{display:flex;justify-content:flex-end;margin:.5rem}.export-btn-container .btn-export{background:#217346;color:#fff;border:none;padding:.4rem 1rem;cursor:pointer;border-radius:3px;font-size:.9rem}", ""]);
	
	// exports


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _profiles = __webpack_require__(808);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profilesModule = _angular2.default.module('app.containers.profiles', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('profiles', {
	    url: '/profiles',
	    template: '<profiles></profiles>'
	  });
	  // .state('profiles', {
	  //   url: '/profiles',
	  //   template: '<profiles></profiles>'
	  // })
	}]).component('profiles', _profiles2.default);
	
	exports.default = profilesModule;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _profiles = __webpack_require__(809);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _profiles3 = __webpack_require__(810);
	
	var _profiles4 = _interopRequireDefault(_profiles3);
	
	__webpack_require__(811);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profilesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _profiles2.default,
	  controller: _profiles4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = profilesComponent;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"profiles-container\">\r\n  <div class=\"profiles-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <profiles-filter apply-filters=\"vm.applyFilters()\"></profiles-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"profiles-match\">{{vm.usersMatchCount ? vm.usersMatchCount + \" users match\" : \"\"}}</div>\r\n      <div class=\"profiles-grid\">\r\n        <div id=\"profiles-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n  <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n    <p>\r\n      <label>\r\n        <span style=\"font-weight: bold;\">Review Status: </span>\r\n        <input k-on-change=\"vm.onFlagChanged(dataItem)\"\r\n          kendo-dropdownlist\r\n          k-options=\"vm.profileReviewStatusOptions\"\r\n          data-bind=\"value: flaggedForReview\" />\r\n      <label>\r\n    </p>\r\n  </div>\r\n</script>"

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _moment = __webpack_require__(412);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilesController = function () {
	  ProfilesController.$inject = ["ProfilesService", "FilterService", "AppContextService", "AuthService", "$scope"];
	  function ProfilesController(ProfilesService, FilterService, AppContextService, AuthService, $scope) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ProfilesController);
	    this.profilesService = ProfilesService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.appContextService = AppContextService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
	
	    this.onFlagChanged = function (dataItem) {
	      var appContext = _this.appContextService.getAppContext();
	      dataItem.reviewedBy = appContext.userName;
	      dataItem.dirty = true;
	    };
	  }
	
	  (0, _createClass3.default)(ProfilesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.profileReviewStatusOptions = {
	        dataSource: [{ value: 2, text: "In Progress" }, { value: 0, text: "Approved" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this2 = this;
	
	      return {
	        dataSource: this.profilesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          template: "No match found. Change your filter criteria."
	        },
	        columns: [{
	          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "4rem",
	          template: function template(dataItem) {
	            return "<a class=\"cell\" target=\"_blank\" href=\"/users/" + dataItem.userId + "\"><div class=\"image-container\"><img src=\"" + (dataItem.imageUrl ? _this2.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png") + "\"></img></div><span>" + dataItem.fullName + "</span></a>";
	          }
	        }, { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" },
	        // { field: "creationDate", title: "Signup Date", template: `<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>`, filterable: false, width: "8rem" },
	        { field: "requiredReviewsText", title: "Required Reviews", filterable: false, width: "12rem" }, { field: "flaggedForReview", title: "Status", filterable: false, sortable: true, width: "2rem", template: function template(dataItem) {
	            return "" + _this2._getProfileReviewStatus(dataItem.flaggedForReview);
	          } },
	        // { field: "country", title: "Country", filterable: false, width: "6rem" },
	        { field: "reviewedBy", title: "Reviewed By", filterable: false, width: "2rem" }, { title: "Update", command: [{ name: "edit", text: "Update" }], width: "2rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Update Review Status" },
	          template: kendo.template($("#popup-editor").html())
	        }
	      };
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.usersMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this3 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this3.applyFilters();
	        }).catch(function (error) {
	          _this3.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }, {
	    key: "_getProfileReviewStatus",
	    value: function _getProfileReviewStatus(status) {
	
	      switch (status) {
	        case _constants2.default.profileReviewStatus.REQUIRED:
	          return "Required";
	        case _constants2.default.profileReviewStatus.IN_PROGRESS:
	          return "In Progress";
	        default:
	        case _constants2.default.profileReviewStatus.APPROVED:
	          return "Approved";
	      }
	    }
	  }]);
	  return ProfilesController;
	}();
	
	exports.default = ProfilesController;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(812);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./profiles.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./profiles.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.profiles-container{display:flex;flex-direction:column;height:100vh}.profiles-container .profiles-inner-container{height:100%;display:flex}.profiles-container .profiles-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.profiles-container .profiles-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.profiles-container .profiles-inner-container .grid-container .profiles-grid{margin-top:.5rem;margin-left:.5rem}.profiles-container .profiles-inner-container .grid-container .profiles-grid .col-name .cell{display:flex;align-items:center}.profiles-container .profiles-inner-container .grid-container .profiles-grid .col-name .cell .image-container{width:2rem}.profiles-container .profiles-inner-container .grid-container .profiles-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.profiles-container .profiles-inner-container .grid-container .profiles-grid .k-grid-norecords{margin-top:20rem}.profiles-container .profiles-inner-container .grid-container .profiles-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _userDetails = __webpack_require__(814);
	
	var _userDetails2 = _interopRequireDefault(_userDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userDetailsModule = _angular2.default.module('app.containers.user-details', []).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('userDetails', {
	    url: '/users/:userId',
	    template: '<user-details></user-details>'
	  });
	}]).component('userDetails', _userDetails2.default);
	
	exports.default = userDetailsModule;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userDetails = __webpack_require__(815);
	
	var _userDetails2 = _interopRequireDefault(_userDetails);
	
	var _userDetails3 = __webpack_require__(816);
	
	var _userDetails4 = _interopRequireDefault(_userDetails3);
	
	__webpack_require__(822);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userDetailsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _userDetails2.default,
	  controller: _userDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = userDetailsComponent;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"user-details-container\">\r\n  <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n    <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n  </div>\r\n  <div class=\"user-details-inner-container\" ng-if=\"!vm.isLoading\">\r\n    <header class=\"header-container\">\r\n      <div class=\"header-inner-container contain-max-width\">\r\n        <div class=\"basic-info\">\r\n          <img class=\"profile-image\" ng-src=\"{{vm.imageBaseUrl + vm.user.primaryImage.scale1ImageUrl}}\" alt=\"\">\r\n          <div class=\"info-container\">\r\n            <h3>\r\n              <span ng-if=\"vm.user.tradingName\">{{vm.user.tradingName}}</span>\r\n              <span ng-if=\"!vm.user.tradingName\">{{vm.user.fullName}}</span>\r\n              <span class=\"entity-type-label\">{{vm.user.entityTypeName}}</span>\r\n              <span class=\"hidden-account-label\" ng-if=\"vm.isHidden()\">Hidden</span>\r\n              <span class=\"hidden-account-label\" ng-if=\"vm.isDisabled()\">Disabled</span>\r\n            </h3>\r\n            <div style=\"margin: 2px 0\">\r\n              <span class=\"fa fa-star\"></span>\r\n              <span class=\"item-title\">Signup Date:</span>\r\n              <span>{{vm.formatDate(vm.user.creationDate)}}</span>\r\n            </div>\r\n            <div style=\"margin: 2px 0\">\r\n              <span class=\"{{ vm.user.accountStatus == 2 ? 'fa fa-check-circle' : 'fa fa-clock-o' }}\"></span>\r\n              <span class=\"item-title\">Account Status:</span>\r\n              <span>{{vm.user.accountStatusName}}</span>\r\n            </div>\r\n            <div style=\"margin: 2px 0\">\r\n              <span class=\"fa fa-star\"></span>\r\n              <span class=\"item-title\">Profile Ranking:</span>\r\n              <span>{{vm.user.accountScore2}}</span>\r\n            </div>\r\n            <div style=\"margin: 2px 0\">\r\n              <span class=\"fa fa-map-marker\"></span>\r\n              <span>{{vm.user.primaryAddress.formattedSuburb + \" \" + vm.user.primaryAddress.state.toUpperCase() + \", \" + vm.user.primaryAddress.country.toUpperCase()}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"more-info\">\r\n          <!-- <div class=\"info-item\">\r\n            <h4 class=\"item-title\">Account Status</h4>\r\n            <span class=\"item-text\">\r\n              <span class=\"{{ vm.user.accountStatus == 2 ? 'fa fa-check-circle' : 'fa fa-clock-o' }}\"></span>\r\n              {{vm.user.accountStatusName}} (Profile completeness: {{vm.user.profileCompleteness}}%)\r\n            </span>\r\n          </div>\r\n          <div class=\"info-item\">\r\n            <h4 class=\"item-title\">Signup Date</h4>\r\n            <span class=\"item-text\">\r\n              <span class=\"fa fa-calendar\"></span>\r\n              {{vm.formatDate(vm.user.creationDate)}}\r\n            </span>\r\n          </div> -->\r\n        </div>\r\n      </div>\r\n    </header>\r\n    <div class=\"tabs-container\">\r\n      <div class=\"contain-max-width tabs-inner-container\">\r\n        <div class=\"tab\" ng-repeat=\"tab in vm.tabs\" ng-click=\"vm.switchTab(tab)\" ng-class=\"{'active-tab': tab.isActive}\">\r\n          <span class=\"tab-icon {{tab.icon}}\"></span><span>{{tab.label}}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"contain-max-width body-container\">\r\n      <div class=\"body-inner-container\">\r\n        <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.PROFILE]\" class=\"tab-body-container\">\r\n          <!--Common-->\r\n          <user-basic-details user=\"vm.user\"></user-basic-details>\r\n          <!-- <user-address-details address=\"vm.user.primaryAddress\"></user-address-details> -->\r\n\r\n          <user-client-details user=\"vm.user\" ng-if=\"vm.isClient()\" ></user-client-details>\r\n          <user-provider-details user=\"vm.user\" ng-if=\"!vm.isClient()\" ></user-provider-details>\r\n\r\n          <!--Client specific-->\r\n          <!-- <user-children children=\"vm.user.clientInfo.children\" ng-if=\"vm.isClient()\"></user-children> -->\r\n          <user-vouches vouches=\"vm.user.vouches\" ng-if=\"vm.isProvider()\"></user-vouches>\r\n          <!-- <user-external-accounts external-accounts=\"vm.user.externalAccounts\" ng-if=\"vm.isClient()\"></user-external-accounts> -->\r\n\r\n          <!--Helper specific-->\r\n          <!-- <user-guardians guardians=\"vm.user.providerInfo.guardians\" ng-if=\"!vm.isClient()\"></user-guardians> -->\r\n          <user-job-preferences options=\"vm.user.options\" job-preferences=\"vm.user.jobPreferences\" ng-if=\"!vm.isClient()\"></user-job-preferences>\r\n\r\n          <!--Common-->\r\n          <user-profile-completeness profile-items=\"vm.user.profileItems\" is-client=\"vm.isClient()\" client-info=\"vm.user.clientInfo\" provider-info=\"vm.user.providerInfo\" user-id=\"vm.user.userId\"></user-profile-completeness>          <post-job user=\"vm.user\" ng-if=\"vm.isClient()\"></post-job>\r\n          <div class=\"login-as-user\" ng-if=\"!vm.isHidden()\">\r\n            <!-- <div class=\"title\">\r\n              <h4>ACTIONS</h4>\r\n            </div> -->\r\n            <div class=\"title\">\r\n              <button class=\"k-button\" ng-if=\"vm.isClient() && vm.hasLoginAsUserAccess()\" ng-click=\"vm.loginAsUser(1)\">Login to Desktop site</button>\r\n              <button class=\"k-button\" ng-if=\"vm.hasLoginAsUserAccess()\" ng-click=\"vm.loginAsUser(2)\">Login to Mobile site</button>\r\n\r\n              <!-- <button class=\"k-button\" ng-show=\"vm.hasGlobalAdminAccess()\" ng-if=\"vm.isClient()\" ng-click=\"vm.openCreditAccountDialog()\">Credit Account</button> -->\r\n              <!-- <button class=\"k-button\" ng-show=\"vm.hasGlobalAdminAccess()\" ng-click=\"vm.openResetPasswordDialog()\">Reset Password</button> -->\r\n              <!-- <button class=\"k-button\" ng-show=\"vm.hasGlobalAdminAccess()\" ng-click=\"vm.handleRefreshCache()\">Refresh Cache</button> -->\r\n            </div>\r\n          </div>\r\n          <div class=\"user-details-actions\" ng-show=\"vm.hasGlobalAdminAccess()\">\r\n            <!-- <div class=\"title\">\r\n              <h4>ACTIONS</h4>\r\n            </div> -->\r\n\r\n            <div class=\"title\">\r\n              <button class=\"k-button warning-button\" ng-show=\"vm.hasGlobalAdminAccess()\" ng-if=\"vm.isHidden() && !vm.isDisabled()\" ng-click=\"vm.handleDisableAccountDialog()\">Disable Account</button>\r\n              <button class=\"k-button warning-button\" ng-show=\"vm.hasGlobalAdminAccess()\" ng-if=\"vm.isHidden() && vm.isDisabled()\" ng-click=\"vm.handleReactivateAccountDialog()\">Reactivate Account</button>\r\n            </div>\r\n\r\n            <div class=\"title\">\r\n              <div ng-show=\"!vm.requestedDeletedAccount\">\r\n                <input class=\"k-checkbox\"\r\n                id=\"delete-account-checkbox\"\r\n                type=\"checkbox\"\r\n                ng-model=\"vm.requestedDeletedAccount\" />\r\n              <label class=\"k-checkbox-label warning-button\" for=\"delete-account-checkbox\">\r\n                Request Account Deletion (IRREVERSIBLE ACTION)\r\n              </label>\r\n              </div>\r\n\r\n              <div ng-show=\"vm.requestedDeletedAccount\">\r\n                <button class=\"k-button warning-button\" ng-show=\"!vm.isDeletingAccount\" ng-click=\"vm.handleDeleteAccount()\">Delete Account</button>\r\n                <span class=\"warning-button\" ng-show=\"vm.isDeletingAccount\">Deleting account, please wait...</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.PAYMENT]\" class=\"tab-body-container\">\r\n          <user-payment-details user=\"vm.user\"></user-payment-details>\r\n          <user-invoices user=\"vm.user\"></user-invoices>\r\n          <user-pay-agreements user-id=\"vm.user.userId\"></user-pay-agreements>\r\n          <user-job-edit user-id=\"vm.user.userId\"></user-job-edit>\r\n          <!-- <user-wallet-transactions wallet-transactions=\"vm.user.walletTransactions\" ng-if=\"vm.isClient()\" ></user-wallet-transactions> -->\r\n        </div>\r\n        <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.JOBS_AND_RATINGS]\" class=\"tab-body-container\">\r\n          <user-client-details user=\"vm.user\" ng-if=\"vm.isClient()\" ></user-client-details>\r\n          <user-provider-details user=\"vm.user\" ng-if=\"!vm.isClient()\" ></user-provider-details>\r\n          <user-ratings user-id=\"vm.user.userId\" user-type=\"'provider'\" on-rating-updated=\"vm.onRatingUpdated(totalRatingsAvg)\" ng-if=\"!vm.isClient()\"></user-ratings>\r\n        </div>\r\n        <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.CERTIFICATES]\" class=\"tab-body-container\">\r\n          <user-certificates certificates=\"vm.user.providerInfo.certificates\" ng-if=\"!vm.isClient()\"></user-certificates>\r\n        </div>\r\n        <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.MESSAGES]\" class=\"tab-body-container\">\r\n          <user-messages user-id=\"vm.userId\"></user-messages>\r\n        </div>\r\n        <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.RATINGS]\" class=\"tab-body-container\">\r\n          <user-ratings user-id=\"vm.user.userId\" user-type=\"'client'\" on-rating-updated=\"vm.onRatingUpdated(totalRatingsAvg)\"></user-ratings>\r\n        </div>\r\n        <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.TIMESHEET]\" class=\"tab-body-container\">\r\n          <user-timesheets user-id=\"vm.user.userId\"></user-timesheets>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!--Delete confirmation dialog box-->\r\n    <div kendo-dialog id=\"confirm-delete-dialog\" k-options=\"vm.getConfirmDeleteDialogOptions()\">\r\n        Are you sure you want to delete this account? THIS ACTION IS IRREVERSIBLE.\r\n        <br/><br/>\r\n        <input class=\"k-checkbox\"\r\n          id=\"delete-intercom-checkbox\"\r\n          type=\"checkbox\"\r\n          ng-model=\"vm.deleteIntercomAccount\" />\r\n        <label class=\"k-checkbox-label\" for=\"delete-intercom-checkbox\">\r\n          Delete Intercom Account\r\n        </label>\r\n    </div>\r\n    <!--Credit account dialog box-->\r\n    <div kendo-dialog=\"vm.creditAccountDialog\" id=\"credit-account-dialog\" k-options=\"vm.getCreditAccountDialogOptions()\">\r\n      <form kendo-validator=\"vm.creditAccountValidator\" ng-submit=\"vm.creditAccount()\" novalidate>\r\n          <div style=\"margin-bottom: 20px;\">\r\n            <label style=\"width: 75px; display: inline-block;\">Reason:</label>\r\n            <select class=\"k-input\"\r\n              name=\"Credit reason\"\r\n              ng-options=\"item.value as item.label for (key, item) in vm.creditAccountReasonOptions\"\r\n              ng-model=\"vm.creditAccountReason\"\r\n              required\r\n              validationMessage=\"Credit reason is required\" >\r\n              <option value=\"\">Choose</option>\r\n            </select>\r\n            <span class=\"k-invalid-msg\" data-for=\"Credit reason\"></span>\r\n          </div>\r\n          <div>\r\n            <label style=\"width: 75px; display: inline-block;\">Amount:</label>\r\n            <input type=\"number\"\r\n              name=\"Credit amount\"\r\n              required\r\n              min=\"0\"\r\n              ng-model=\"vm.creditAccountAmount\"\r\n              class=\"k-textbox\">\r\n              <span class=\"k-invalid-msg\" data-for=\"Credit amount\"></span>\r\n          </div>\r\n          <div style=\"margin-top: 30px;\">\r\n            <button class=\"k-button\" ng-click=\"vm.closeCreditAccountDialog()\">Cancel</button>\r\n            <button class=\"k-button k-primary\" type=\"submit\">Ok</button>\r\n          </div>\r\n      </form>\r\n    </div>\r\n    <!--Reset password dialog box-->\r\n    <div kendo-dialog=\"vm.resetPasswordDialog\" id=\"reset-password-dialog\" k-options=\"vm.getResetPasswordOptions()\">\r\n      <form kendo-validator=\"vm.resetPasswordValidator\" ng-submit=\"vm.resetPassword()\" novalidate>\r\n          <div style=\"margin-bottom: 20px;\">\r\n            <label style=\"width: 140px; display: inline-block; vertical-align: top;\">New Password:</label>\r\n            <div style=\"display: inline-block;\">\r\n              <input type=\"text\"\r\n                name=\"New password\"\r\n                ng-model=\"vm.newPassword\"\r\n                required\r\n                pattern=\".{7,}\"\r\n                validationMessage=\"Enter at least 7 characters\"\r\n                class=\"k-textbox\">\r\n                <br>\r\n              <span class=\"k-invalid-msg\" data-for=\"New password\"></span>\r\n            </div>\r\n          </div>\r\n          <div>\r\n            <label style=\"width: 140px; display: inline-block; vertical-align: top;\">Repeat Password:</label>\r\n            <div style=\"display: inline-block;\">\r\n              <input type=\"text\"\r\n                name=\"Repeat password\"\r\n                ng-model=\"vm.repeatPassword\"\r\n                required\r\n                pattern=\".{7,}\"\r\n                validationMessage=\"Enter at least 7 characters\"\r\n                class=\"k-textbox\">\r\n                <br>\r\n              <span class=\"k-invalid-msg\" data-for=\"Repeat password\"></span>\r\n              <div style=\"color: red; background: lightpink; padding: 5px; margin-top: 20px;\"\r\n                  ng-show=\"vm.passwordsDoNotMatch\">\r\n                  Passwords do not match\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div style=\"margin-top: 30px;\">\r\n            <button class=\"k-button\" ng-click=\"vm.closeResetPasswordDialog()\">Cancel</button>\r\n            <button class=\"k-button k-primary\" type=\"submit\">Ok</button>\r\n          </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n"

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(817);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(366);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _underscore = __webpack_require__(821);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserDetailsController = function () {
	  UserDetailsController.$inject = ["$stateParams", "UsersService", "AppContextService", "NotificationService", "$scope"];
	  function UserDetailsController($stateParams, UsersService, AppContextService, NotificationService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserDetailsController);
	    this.usersService = UsersService;
	    this.appContextService = AppContextService;
	    console.log($stateParams.userId);
	    this.userId = $stateParams.userId;
	    this.getUserDetails(this.userId);
	    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
	    this.deleteIntercomAccount = true;
	    this.notificationService = NotificationService;
	    this.$scope = $scope;
	    this.isDeletingAccount = false;
	    this.requestedDeletedAccount = false;
	  }
	
	  (0, _createClass3.default)(UserDetailsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.tabTypes = {
	        PROFILE: 1,
	        PAYMENT: 2,
	        JOBS_AND_RATINGS: 3,
	        CERTIFICATES: 4,
	        MESSAGES: 5,
	        RATINGS: 6,
	        TIMESHEET: 7
	      };
	
	      this.creditAccountReasonOptions = [{ value: _constants2.default.walletTransactionReason.SPECIAL_OFFER, label: "Special Offer" }, { value: _constants2.default.walletTransactionReason.JOB_CANCELLED_BY_HELPER, label: "Job Cancelled by Helper" }, { value: _constants2.default.walletTransactionReason.ADMIN_ACTION, label: "Other" }];
	    }
	  }, {
	    key: "getUserDetails",
	    value: function getUserDetails(userId) {
	      var _this = this;
	
	      this.isLoading = true;
	
	      this.usersService.getUserDetails(userId, function (response) {
	        console.log(response.data);
	
	        _this.user = response.data;
	        _this.isLoading = false;
	
	        _this.getTabs();
	
	        _this.$scope.$apply();
	      }, function (error) {
	        _this.isLoading = false;
	      });
	    }
	  }, {
	    key: "getTabs",
	    value: function getTabs() {
	      if (this.isClient()) {
	        var _tabs;
	
	        this.tabs = (_tabs = {}, (0, _defineProperty3.default)(_tabs, this.tabTypes.PROFILE, {
	          key: 1,
	          label: "PROFILE",
	          isActive: true,
	          icon: "fa fa-user"
	        }), (0, _defineProperty3.default)(_tabs, this.tabTypes.PAYMENT, {
	          key: 2,
	          label: "PAYMENT",
	          isActive: false,
	          icon: "fa fa-dollar"
	        }), (0, _defineProperty3.default)(_tabs, this.tabTypes.MESSAGES, {
	          key: 4,
	          label: "MESSAGES",
	          isActive: false,
	          icon: "fa fa-envelope"
	        }), (0, _defineProperty3.default)(_tabs, this.tabTypes.RATINGS, {
	          key: 6,
	          label: "RATINGS",
	          isActive: false,
	          icon: "fa fa-star"
	        }), (0, _defineProperty3.default)(_tabs, this.tabTypes.TIMESHEET, {
	          key: 7,
	          label: "TIMESHEET",
	          isActive: false,
	          icon: "fa fa-clock-o"
	        }), _tabs);
	      } else {
	        var _tabs2;
	
	        this.tabs = (_tabs2 = {}, (0, _defineProperty3.default)(_tabs2, this.tabTypes.PROFILE, {
	          key: 1,
	          label: "PROFILE",
	          isActive: true,
	          icon: "fa fa-user"
	        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.PAYMENT, {
	          key: 2,
	          label: "PAYMENT",
	          isActive: false,
	          icon: "fa fa-dollar"
	        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.CERTIFICATES, {
	          key: 3,
	          label: "CERTIFICATES",
	          isActive: false,
	          icon: "fa fa-user"
	        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.JOBS_AND_RATINGS, {
	          key: 4,
	          label: "JOBS & RATINGS",
	          isActive: false,
	          icon: "fa fa-user"
	        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.MESSAGES, {
	          key: 5,
	          label: "MESSAGES",
	          isActive: false,
	          icon: "fa fa-envelope"
	        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.TIMESHEET, {
	          key: 7,
	          label: "TIMESHEET",
	          isActive: false,
	          icon: "fa fa-clock-o"
	        }), _tabs2);
	      }
	
	      this.activeTab = this.tabs["1"];
	    }
	  }, {
	    key: "switchTab",
	    value: function switchTab(tab) {
	      var _this2 = this;
	
	      this.activeTab = tab;
	
	      (0, _keys2.default)(this.tabs).map(function (i) {
	        if (_this2.tabs[i] == _this2.activeTab) _this2.tabs[i].isActive = true;else _this2.tabs[i].isActive = false;
	      });
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      return _common2.default.formatDate(date);
	    }
	  }, {
	    key: "isClient",
	    value: function isClient() {
	      return this.user && this.user.entityType == _constants2.default.entityType.CLIENT;
	    }
	  }, {
	    key: "isHidden",
	    value: function isHidden() {
	      return this.user && this.user.isHidden;
	    }
	  }, {
	    key: "isDisabled",
	    value: function isDisabled() {
	      return this.user && this.user.isDisabled;
	    }
	  }, {
	    key: "isProvider",
	    value: function isProvider() {
	      return this.user && this.user.entityType == _constants2.default.entityType.PROVIDER;
	    }
	  }, {
	    key: "onRatingUpdated",
	    value: function onRatingUpdated(totalRatingsAvg) {
	      if (this.isClient()) {
	        this.user.clientInfo.ratingsAvg = totalRatingsAvg;
	      } else {
	        this.user.providerInfo.ratingsAvg = totalRatingsAvg;
	      }
	    }
	  }, {
	    key: "loginAsUser",
	    value: function loginAsUser(targetDevice) {
	      var _this3 = this;
	
	      this.usersService.getLoginAsUserAccessToken(this.userId, function (response) {
	        console.log("Access token::", response.data);
	        _this3.redirectToTarget(targetDevice, response.data.accessToken, _this3.user.country);
	      }, function (error) {});
	    }
	  }, {
	    key: "redirectToTarget",
	    value: function redirectToTarget(targetDevice, token, country) {
	      var rootUrl = _env2.default.getLoginAsBaseUrl(targetDevice, country);
	      var url = rootUrl + ("?admin_mode=1&access_token=" + token);
	      console.log(url);
	      window.open(rootUrl + ("?admin_mode=1&access_token=" + token));
	    }
	  }, {
	    key: "hasGlobalAdminAccess",
	    value: function hasGlobalAdminAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
	    }
	  }, {
	    key: "hasLoginAsUserAccess",
	    value: function hasLoginAsUserAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasLoginAsUserAccess(appContext.roles)) return true;else return false;
	    }
	  }, {
	    key: "openConfirmDeleteDialog",
	    value: function openConfirmDeleteDialog() {
	      var dialog = $("#confirm-delete-dialog").data("kendoDialog");
	      dialog.open();
	    }
	
	    // ****************//
	    // Reset Password  //
	    // ****************//
	
	  }, {
	    key: "openResetPasswordDialog",
	    value: function openResetPasswordDialog() {
	      var _this4 = this;
	
	      this.resetPasswordValidator.hideMessages();
	      this.resetPasswordDialog.open();
	      this.resetPasswordDialog.bind("close", function () {
	        return _this4.clearResetPasswordDialog();
	      });
	    }
	  }, {
	    key: "closeResetPasswordDialog",
	    value: function closeResetPasswordDialog() {
	      this.clearResetPasswordDialog();
	      this.resetPasswordDialog.close();
	    }
	  }, {
	    key: "clearResetPasswordDialog",
	    value: function clearResetPasswordDialog() {
	      this.newPassword = "";
	      this.repeatPassword = "";
	      this.passwordsDoNotMatch = false;
	
	      this.resetPasswordDialog.unbind("close", this.closeResetPasswordDialog.bind(this));
	    }
	  }, {
	    key: "resetPassword",
	    value: function resetPassword() {
	      var _this5 = this;
	
	      this.passwordsDoNotMatch = false;
	
	      if (!this.resetPasswordValidator.validate()) return;
	
	      if (this.newPassword != this.repeatPassword) {
	        this.passwordsDoNotMatch = true;
	        return;
	      }
	
	      var payload = {
	        newPassword: this.newPassword,
	        confirmPassword: this.repeatPassword
	      };
	
	      this.usersService.resetPassword(this.userId, payload, function () {
	        _this5.closeResetPasswordDialog();
	      }, function () {
	        _this5.closeResetPasswordDialog();
	      });
	    }
	
	    // ****************//
	
	
	    // ****************//
	    // Credit Account  //
	    // ****************//
	
	  }, {
	    key: "openCreditAccountDialog",
	    value: function openCreditAccountDialog() {
	      this.creditAccountValidator.hideMessages();
	      this.creditAccountDialog.open();
	      this.creditAccountDialog.bind("close", this.clearCreditAccountDialog.bind(this));
	    }
	  }, {
	    key: "closeCreditAccountDialog",
	    value: function closeCreditAccountDialog() {
	      this.clearCreditAccountDialog();
	      this.creditAccountDialog.close();
	    }
	  }, {
	    key: "clearCreditAccountDialog",
	    value: function clearCreditAccountDialog() {
	      this.creditAccountReason = undefined;
	      this.creditAccountAmount = undefined;
	
	      this.creditAccountDialog.unbind("close", this.clearCreditAccountDialog.bind(this));
	    }
	  }, {
	    key: "creditAccount",
	    value: function creditAccount(e) {
	      var _this6 = this;
	
	      if (!this.creditAccountValidator.validate()) return;
	
	      var payload = {
	        actionType: _constants2.default.adminEntitiesActionType.CREDIT_ACCOUNT_BALANCE,
	        transactionReason: this.creditAccountReason,
	        transactionAmount: this.creditAccountAmount * 100
	      };
	      this.usersService.updateUserDetails(this.userId, payload, function () {
	        _this6.closeCreditAccountDialog();
	      }, function () {
	        _this6.closeCreditAccountDialog();
	      });
	    }
	
	    // ****************//
	
	  }, {
	    key: "handleDisableAccountDialog",
	    value: function handleDisableAccountDialog() {
	      var _this7 = this;
	
	      var message = "Are you sure you want to disable this account?";
	      if (confirm(message)) {
	        this.usersService.disableAccount(this.userId, function () {
	          _this7.user.isDisabled = true;
	          alert("This account has been disabled, please allow a few minutes for Bigfoot to update its cache.");
	        }, function (err) {
	          alert(err.data);
	        });
	      }
	    }
	  }, {
	    key: "handleReactivateAccountDialog",
	    value: function handleReactivateAccountDialog() {
	      var _this8 = this;
	
	      var message = "Are you sure you want to want to reactivate this account?";
	      if (confirm(message)) {
	        this.usersService.reactivateAccount(this.userId, function () {
	          _this8.user.isDisabled = false;
	          alert("This account has been reactivated, please allow a few minutes for Bigfoot to update its cache.");
	        }, function (err) {
	          alert(err.data);
	        });
	      }
	    }
	  }, {
	    key: "handleDeleteAccount",
	    value: function handleDeleteAccount() {
	      var _this9 = this;
	
	      var message = "Are you sure you want to delete this account? THIS ACTION IS IRREVERSIBLE.";
	      if (confirm(message)) {
	        this.isDeletingAccount = true;
	        this.usersService.deleteUser(this.userId, function () {
	          _this9.isDeletingAccount = false;
	          alert("This account has been deleted successfully. Please close this window.");
	          // window.close();
	        }, function (err) {
	          _this9.isDeletingAccount = false;
	          alert(err.data);
	        });
	      }
	    }
	  }, {
	    key: "deleteUser",
	    value: function deleteUser(e) {
	      var payload = { deleteIntercomAccount: this.deleteIntercomAccount };
	      this.usersService.deleteUser(this.userId, payload, function () {}, function () {});
	    }
	  }, {
	    key: "getConfirmDeleteDialogOptions",
	    value: function getConfirmDeleteDialogOptions() {
	      var _this10 = this;
	
	      var options = {
	        title: "Are you sure?",
	        close: function close() {
	          _this10.deleteIntercomAccount = true;
	        },
	        actions: [{ text: 'No' }, {
	          text: 'Yes',
	          primary: true,
	          action: function action(e) {
	            return _this10.deleteUser(e);
	          }
	        }]
	      };
	
	      return _underscore2.default.extend(options, this._getDialogOptions());
	    }
	  }, {
	    key: "getResetPasswordOptions",
	    value: function getResetPasswordOptions() {
	      var options = {
	        title: "Reset Password",
	        width: "550px"
	      };
	
	      return _underscore2.default.extend(options, this._getDialogOptions());
	    }
	  }, {
	    key: "getCreditAccountDialogOptions",
	    value: function getCreditAccountDialogOptions() {
	      var options = {
	        title: "Credit Account",
	        width: "550px"
	      };
	
	      return _underscore2.default.extend(options, this._getDialogOptions());
	    }
	  }, {
	    key: "_getDialogOptions",
	    value: function _getDialogOptions() {
	      return {
	        buttonLayout: "normal",
	        messages: {
	          close: ""
	        },
	        visible: false,
	        closable: true,
	        modal: true
	      };
	    }
	  }, {
	    key: "handleRefreshCache",
	    value: function handleRefreshCache() {
	      var _this11 = this;
	
	      var payload = { actionType: _constants2.default.adminEntitiesActionType.REFRESH_CACHE };
	      this.usersService.updateUserDetails(this.userId, payload, function () {
	        _this11.notificationService.success("Cache refresh successful.");
	      }, function () {
	        _this11.notificationService.error("Cache refresh failed.");
	      });
	    }
	  }]);
	  return UserDetailsController;
	}();
	
	exports.default = UserDetailsController;

/***/ },
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(823);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./user-details.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./user-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.user-details-container .user-details-inner-container{margin-left:4rem}.user-details-container .user-details-inner-container .contain-max-width{max-width:1280px;margin:0 auto}.user-details-container .user-details-inner-container .header-container{background:#162e3d;color:#f4f4f4;height:8rem;padding:2rem .5rem 1rem}.user-details-container .user-details-inner-container .header-container .header-inner-container{height:8rem;display:flex;justify-content:space-between}.user-details-container .user-details-inner-container .header-container .header-inner-container .basic-info{min-width:500px;display:flex;justify-content:flex-start}.user-details-container .user-details-inner-container .header-container .header-inner-container .basic-info .profile-image{max-height:8rem;margin-right:.5rem}.user-details-container .user-details-inner-container .header-container .header-inner-container .basic-info .info-container{flex-direction:column;display:flex;justify-content:flex-start}.user-details-container .user-details-inner-container .header-container .header-inner-container .basic-info .info-container .entity-type-label{font-size:.9rem;background:#299c4a;padding:.1rem;margin-left:.5rem;border-radius:.2rem}.user-details-container .user-details-inner-container .header-container .header-inner-container .basic-info .info-container .hidden-account-label{font-size:.9rem;background:red;padding:.1rem;margin-left:.5rem;border-radius:.2rem}.user-details-container .user-details-inner-container .header-container .header-inner-container .more-info{min-width:700px;display:flex;justify-content:flex-end;flex-direction:column}.user-details-container .user-details-inner-container .header-container .header-inner-container .more-info .info-item{margin-bottom:.5rem;display:flex;flex-direction:column;align-items:flex-end}.user-details-container .user-details-inner-container .header-container .header-inner-container .more-info .info-item .item-title{margin-bottom:.2rem}.user-details-container .user-details-inner-container .header-container .header-inner-container .more-info .info-item .item-text{font-size:.9rem}.user-details-container .user-details-inner-container .tabs-container{height:3rem;background:#3f5464;display:flex;align-items:flex-end}.user-details-container .user-details-inner-container .tabs-container .tabs-inner-container{display:flex;justify-content:space-around;align-items:center;color:#f4f4f4;width:100%}.user-details-container .user-details-inner-container .tabs-container .tabs-inner-container .tab{padding:.5em 0;width:20rem;text-align:center;cursor:pointer}.user-details-container .user-details-inner-container .tabs-container .tabs-inner-container .tab .tab-icon{margin-right:1rem}.user-details-container .user-details-inner-container .tabs-container .tabs-inner-container .active-tab{border-bottom:5px solid #299c4a}.user-details-container .user-details-inner-container .body-container{margin-top:2rem}.user-details-container .user-details-inner-container .body-container .body-inner-container{margin:0 .5rem}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container{display:flex;justify-content:space-between;flex-wrap:wrap}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .login-as-user{margin:1rem .5rem;flex-basis:100%}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .login-as-user .title{margin-bottom:1rem}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-actions{margin:1rem .5rem;flex-basis:100%}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-actions .title{margin-bottom:1rem}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-actions .warning-button{color:red;font-weight:700}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-component{width:600px;margin-bottom:2rem}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-component .title{height:1rem;padding:.5rem}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-component .details{padding:.5rem;border:1px solid #d8d8d8}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-component .details .item{margin-bottom:1rem}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-component .details .item .item-title{margin-bottom:.3rem;color:#299c4a}.user-details-container .user-details-inner-container .body-container .body-inner-container .tab-body-container .user-details-component .details .item .item-text{font-size:.9rem;color:#1c1c1c}", ""]);
	
	// exports


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobDetails = __webpack_require__(825);
	
	var _jobDetails2 = _interopRequireDefault(_jobDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobDetailsModule = _angular2.default.module('app.containers.job-details', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('jobDetails', {
	    url: '/jobs/:jobId',
	    template: '<job-details></job-details>'
	  });
	}]).component('jobDetails', _jobDetails2.default);
	
	exports.default = jobDetailsModule;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobDetails = __webpack_require__(826);
	
	var _jobDetails2 = _interopRequireDefault(_jobDetails);
	
	var _jobDetails3 = __webpack_require__(827);
	
	var _jobDetails4 = _interopRequireDefault(_jobDetails3);
	
	__webpack_require__(828);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobDetailsComponent = {
	  template: _jobDetails2.default,
	  controller: _jobDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = jobDetailsComponent;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"job-details-container\">\r\n  <div class=\"job-details-inner-container\">\r\n    <div class=\"job-details-header\">\r\n      <h2>Job Payment Details - Job ID: {{vm.jobId}}</h2>\r\n      <a href=\"/jobs\" class=\"back-link\">← Back to Jobs</a>\r\n    </div>\r\n \r\n    <div ng-if=\"vm.isLoading\" class=\"loading\">\r\n      Loading payment details...\r\n    </div>\r\n \r\n    <div ng-if=\"vm.error\" class=\"error\">\r\n      {{vm.error}}\r\n    </div>\r\n \r\n    <div ng-if=\"vm.invoices && !vm.isLoading\" class=\"invoices-container\">\r\n      <div class=\"invoice-card\" ng-repeat=\"invoice in vm.invoices\">\r\n        <div class=\"invoice-header\">\r\n          <h3>Invoice #{{invoice.id}} - {{invoice.invoiceNo}}</h3>\r\n          <div class=\"header-actions\">\r\n            <button class=\"pay-helper-btn\" ng-click=\"vm.payHelper(invoice.id)\" ng-disabled=\"invoice.isProcessing\">{{invoice.isProcessing ? 'Processing...' : 'Pay Helper'}}</button>\r\n            <span class=\"status\" ng-class=\"{'status-pending': invoice.status === 'Pending', 'status-rejected': invoice.status === 'Rejected', 'status-completed': invoice.status === 'Completed'}\">{{invoice.status}}</span>\r\n          </div>\r\n        </div>\r\n       \r\n        <div class=\"details-grid\">\r\n          <div class=\"detail-row\" ng-if=\"invoice.timesheetId\">\r\n            <label>Timesheet ID:</label>\r\n            <span>{{invoice.timesheetId}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.dateIssued\">\r\n            <label>Date Issued:</label>\r\n            <span>{{vm.formatDate(invoice.dateIssued)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.dueDate\">\r\n            <label>Due Date:</label>\r\n            <span>{{vm.formatDate(invoice.dueDate)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.paymentDate\">\r\n            <label>Payment Date:</label>\r\n            <span>{{vm.formatDate(invoice.paymentDate)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.amount\">\r\n            <label>Amount:</label>\r\n            <span>{{vm.formatCurrency(invoice.amount)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.gst\">\r\n            <label>GST:</label>\r\n            <span>{{vm.formatCurrency(invoice.gst)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.platformFee\">\r\n            <label>Platform Fee:</label>\r\n            <span>{{vm.formatCurrency(invoice.platformFee)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.totalAmount\">\r\n            <label>Total Amount:</label>\r\n            <span class=\"total\">{{vm.formatCurrency(invoice.totalAmount)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.parentAmount\">\r\n            <label>Parent Amount:</label>\r\n            <span>{{vm.formatCurrency(invoice.parentAmount)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.helperAmount\">\r\n            <label>Helper Amount:</label>\r\n            <span>{{vm.formatCurrency(invoice.helperAmount)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.jsAmount\">\r\n            <label>JS Amount:</label>\r\n            <span>{{vm.formatCurrency(invoice.jsAmount)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.parentStatus\">\r\n            <label>Parent Status:</label>\r\n            <span>{{invoice.parentStatus}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.helperStatus\">\r\n            <label>Helper Status:</label>\r\n            <span>{{invoice.helperStatus}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.jugglerId\">\r\n            <label>Juggler ID:</label>\r\n            <span>{{invoice.jugglerId}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.applicantId\">\r\n            <label>Applicant ID:</label>\r\n            <span>{{invoice.applicantId}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.paymentType\">\r\n            <label>Payment Type:</label>\r\n            <span>{{invoice.paymentType}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.created_Date\">\r\n            <label>Created Date:</label>\r\n            <span>{{vm.formatDate(invoice.created_Date)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.updated_Date\">\r\n            <label>Updated Date:</label>\r\n            <span>{{vm.formatDate(invoice.updated_Date)}}</span>\r\n          </div>\r\n \r\n          <div class=\"detail-row\" ng-if=\"invoice.parentTransactionID\">\r\n            <label>Parent Transaction ID:</label>\r\n            <span>{{invoice.parentTransactionID}}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobDetailsController = function () {
	  JobDetailsController.$inject = ["$stateParams", "JobsService", "$scope"];
	  function JobDetailsController($stateParams, JobsService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, JobDetailsController);
	    this.jobsService = JobsService;
	    this.jobId = $stateParams.jobId;
	    this.$scope = $scope;
	    this.getJobPaymentDetails(this.jobId);
	  }
	
	  (0, _createClass3.default)(JobDetailsController, [{
	    key: "getJobPaymentDetails",
	    value: function getJobPaymentDetails(jobId) {
	      var _this = this;
	
	      this.isLoading = true;
	
	      this.jobsService.getJobPaymentDetails(jobId, function (response) {
	        _this.invoices = response.data;
	        _this.isLoading = false;
	        _this.$scope.$apply();
	      }, function (error) {
	        _this.isLoading = false;
	        _this.error = "Payment details not found";
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: "payHelper",
	    value: function payHelper(invoiceId) {
	      var _this2 = this;
	
	      console.log('payHelper called with invoiceId:', invoiceId);
	      var invoice = this.invoices.find(function (inv) {
	        return inv.id === invoiceId;
	      });
	      if (!invoice) {
	        console.log('Invoice not found');
	        return;
	      }
	
	      console.log('Processing payment for invoice:', invoice);
	      invoice.isProcessing = true;
	      this.$scope.$apply();
	
	      this.jobsService.payHelper(invoiceId, function (response) {
	        console.log('Payment success:', response);
	        invoice.isProcessing = false;
	        alert('Payment processed successfully');
	        _this2.getJobPaymentDetails(_this2.jobId);
	      }, function (error) {
	        console.log('Payment error:', error);
	        invoice.isProcessing = false;
	        alert(error.response && error.response.data && error.response.data.Message || 'Payment failed');
	        _this2.$scope.$apply();
	      });
	    }
	  }, {
	    key: "formatCurrency",
	    value: function formatCurrency(amount) {
	      return amount ? "$" + amount.toFixed(2) : '-';
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      return date ? new Date(date).toLocaleDateString('en-AU') : '-';
	    }
	  }]);
	  return JobDetailsController;
	}();
	
	exports.default = JobDetailsController;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(829);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./job-details.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./job-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	
	
	// module
	exports.push([module.id, ".job-details-container{padding:20px;margin-left:200px}.job-details-container .job-details-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:30px}.job-details-container .job-details-header h2{margin:0;color:#333}.job-details-container .job-details-header .back-link{color:#007bff;text-decoration:none}.job-details-container .job-details-header .back-link:hover{text-decoration:underline}.job-details-container .error,.job-details-container .loading{text-align:center;padding:40px;font-size:16px}.job-details-container .error{color:#dc3545}.job-details-container .invoices-container .invoice-card{background:#fff;border-radius:8px;box-shadow:0 2px 4px rgba(0,0,0,.1);margin-bottom:20px;padding:20px}.job-details-container .invoices-container .invoice-card .invoice-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;padding-bottom:15px;border-bottom:2px solid #eee}.job-details-container .invoices-container .invoice-card .invoice-header h3{margin:0;color:#333;font-size:18px}.job-details-container .invoices-container .invoice-card .invoice-header .header-actions{display:flex;align-items:center;gap:10px}.job-details-container .invoices-container .invoice-card .invoice-header .header-actions .pay-helper-btn{background:#ffa63d;color:#fff;border:none;padding:8px 16px;border-radius:4px;font-size:12px;font-weight:600;cursor:pointer}.job-details-container .invoices-container .invoice-card .invoice-header .header-actions .pay-helper-btn:hover:not(:disabled){background:#ff9520}.job-details-container .invoices-container .invoice-card .invoice-header .header-actions .pay-helper-btn:disabled{opacity:.6;cursor:not-allowed}.job-details-container .invoices-container .invoice-card .invoice-header .status{padding:6px 12px;border-radius:4px;font-size:12px;font-weight:600;text-transform:uppercase}.job-details-container .invoices-container .invoice-card .invoice-header .status.status-pending{background:#fff3cd;color:#856404}.job-details-container .invoices-container .invoice-card .invoice-header .status.status-rejected{background:#f8d7da;color:#721c24}.job-details-container .invoices-container .invoice-card .invoice-header .status.status-completed{background:#d4edda;color:#155724}.job-details-container .invoices-container .invoice-card .details-grid{display:grid;grid-template-columns:1fr 1fr;gap:15px}.job-details-container .invoices-container .invoice-card .details-grid .detail-row{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #f0f0f0}.job-details-container .invoices-container .invoice-card .details-grid .detail-row label{font-weight:600;color:#555;min-width:120px}.job-details-container .invoices-container .invoice-card .details-grid .detail-row span{color:#333}.job-details-container .invoices-container .invoice-card .details-grid .detail-row span.total{font-weight:700;color:#28a745}.job-details-container .invoices-container .invoice-card .details-grid .detail-row span.error-text{color:#dc3545;font-size:12px}.job-details-container .invoices-container .invoice-card .details-grid .detail-row.error-row{grid-column:1/-1;background:#f8f9fa;padding:10px;border-radius:4px}", ""]);
	
	// exports


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _login = __webpack_require__(831);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginModule = _angular2.default.module('app.login', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('login', {
	    url: '/login',
	    template: '<login></login>'
	  });
	}]).component('login', _login2.default);
	
	exports.default = loginModule;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(832);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(833);
	
	var _login4 = _interopRequireDefault(_login3);
	
	__webpack_require__(834);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _login2.default,
	  controller: _login4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = loginComponent;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"login-container\">\r\n  <div class=\"logo-container\">\r\n    <!-- <img src=\"/images/js-logo-full-animation.gif\" alt=\"JuggleStreet Logo\"> -->\r\n    <div>\r\n      <img class=\"main-img\" src=\"/images/js-new-logo-full.png\"/>\r\n    </div>\r\n    <div class=\"secondary-img-container\"\">\r\n      <img class=\"secondary-img\" src=\"/images/js-pro-childcare.png\"/>\r\n      <img class=\"secondary-img\"src=\"/images/js-pro-education.png\"/>\r\n    </div>\r\n  </div>\r\n  <div class=\"input-container\">\r\n    <form class=\"login-form\" novalidate>\r\n      <div class=\"form-item\" ng-show=\"vm.phase == 1\">\r\n        <input type=\"text\" placeholder=\"Username\" class=\"k-input\" ng-model=\"vm.username\" autofocus>\r\n      </div>\r\n      <div class=\"form-item\" ng-show=\"vm.phase == 1\">\r\n        <input type=\"password\" placeholder=\"Password\" class=\"k-input\" ng-model=\"vm.password\">\r\n      </div>\r\n\r\n      <div class=\"form-item\" ng-show=\"vm.phase == 2\">\r\n          <span>Verification Code was sent to phone ending</span>\r\n          <span style=\"font-weight: bold; margin: 0 5px\">{{vm.phoneNumber}}</span>\r\n      </div>\r\n      <div class=\"form-item\" ng-show=\"vm.phase == 2\">\r\n        <input id=\"verificationCode\" type=\"text\" placeholder=\"Code\" class=\"k-input\" ng-model=\"vm.verificationCode\">\r\n      </div>\r\n\r\n      <div class=\"form-item\">\r\n        <input type=\"submit\" ng-value=\"vm.loginText\" ng-click=\"vm.submit($event)\" ng-disabled=\"vm.isLoading\" class=\"k-button\" >\r\n      </div>\r\n      <div style=\"height: 25px\" class=\"form-item error-message k-error-colored\">\r\n        <span ng-bind=\"vm.errorMessage\"></span>\r\n      </div>\r\n    </ng-form>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function () {
	  LoginController.$inject = ["AuthService", "NavigationService", "AppContextService", "EventsService", "$state"];
	  function LoginController(AuthService, NavigationService, AppContextService, EventsService, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoginController);
	    this.authService = AuthService;
	    this.navigationService = NavigationService;
	    this.appContextService = AppContextService;
	    this.eventsService = EventsService;
	
	    this.username = '';
	    this.password = '';
	    this.verificationCode = '';
	    this.errorMessage = '';
	    this.isLoading = false;
	    this.loginText = 'Verify';
	    this.phase = 1;
	  }
	
	  (0, _createClass3.default)(LoginController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.eventsService.listen(_constants2.default.events.VERIFICATION_CODE_RECEIEVED, function (e, args) {
	        console.log(args);
	        _this.verificationCode = args;
	        _this.submit();
	      });
	    }
	  }, {
	    key: "submit",
	    value: function submit(e) {
	      if (e) e.preventDefault();
	
	      this.isLoading = true;
	      this.loginText = 'Checking...';
	
	      if (this.phase === 1) {
	        var payload = {
	          userName: this.username,
	          password: this.password
	        };
	        this.authService.initiateLogin(payload, this._onInitiateLoginSuccess.bind(this), this._onInitiateLoginFailure.bind(this));
	      } else {
	        var _payload = {
	          userName: this.username,
	          password: this.password,
	          verificationCode: this.verificationCode
	        };
	        this.authService.login(_payload, this._onLoginSuccess.bind(this), this._onLoginFailure.bind(this));
	      }
	    }
	  }, {
	    key: "_onInitiateLoginSuccess",
	    value: function _onInitiateLoginSuccess(response) {
	      this.setErrorMessage("");
	
	      this.isLoading = false;
	      this.loginText = 'Login';
	
	      this.phoneNumber = response.data.phoneNumber;
	      this.phase = 2;
	
	      setTimeout(function () {
	        document.getElementById("verificationCode").focus();
	      }, 500);
	    }
	  }, {
	    key: "_onInitiateLoginFailure",
	    value: function _onInitiateLoginFailure(error) {
	      console.log("Initiate login failed:", error.data.message);
	
	      this.isLoading = false;
	      this.loginText = 'Verify';
	
	      this.setErrorMessage("Invalid username or password.");
	    }
	  }, {
	    key: "_onLoginSuccess",
	    value: function _onLoginSuccess(response) {
	      var _this2 = this;
	
	      this.setErrorMessage("");
	
	      this.appContextService.fetchAppContext(function (response) {
	        var roles = response.data.roles;
	        if (_this2.appContextService.hasAccess(roles)) {
	          _this2.appContextService.setAppContext(response.data);
	          var defaultState = _env2.default.defaultState();
	          _this2.navigationService.go(defaultState);
	
	          // Let the world know that you have access to bigfoot! yaay!!
	          _this2.eventsService.broadcast(_constants2.default.events.AUTHORIZATION_SUCCESS);
	        } else {
	          _this2.setErrorMessage("You are not authorized to access this application.");
	        }
	      }, function () {
	        _this2.setErrorMessage("You are not authorized to access this application.");
	      });
	    }
	  }, {
	    key: "_onLoginFailure",
	    value: function _onLoginFailure(error) {
	      console.log("Login failed:", error.data.message);
	
	      this.isLoading = false;
	      this.loginText = 'Login';
	
	      this.setErrorMessage("Invalid verification code.");
	    }
	  }, {
	    key: "setErrorMessage",
	    value: function setErrorMessage(error) {
	      this.errorMessage = error;
	      this.isLoading = false;
	    }
	  }]);
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(835);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./login.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./login.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.login-container{display:flex;height:400px;width:450px;align-items:center;text-align:center;flex-direction:column;box-shadow:0 2px 8px 0 #1c1c1c;padding:30px 30px 0;margin:100px auto;border:1px solid #1c1c1c;border-radius:10px}.login-container .logo-container .main-img{width:250px;margin-bottom:1rem}.login-container .logo-container .secondary-img-container{display:flex;align-items:center}.login-container .logo-container .secondary-img-container .secondary-img{margin:10px;width:150px;margin-bottom:10px}.login-container .login-form{display:flex;flex-direction:column;align-items:center}.login-container .login-form .form-item{margin:.5rem 0}", ""]);
	
	// exports


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _certificates = __webpack_require__(837);
	
	var _certificates2 = _interopRequireDefault(_certificates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var certificatesModule = _angular2.default.module('app.containers.certificates', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('certificates', {
	    url: '/certificates',
	    template: '<certificates></certificates>'
	  });
	}]).component('certificates', _certificates2.default);
	
	exports.default = certificatesModule;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _certificates = __webpack_require__(838);
	
	var _certificates2 = _interopRequireDefault(_certificates);
	
	var _certificates3 = __webpack_require__(839);
	
	var _certificates4 = _interopRequireDefault(_certificates3);
	
	__webpack_require__(840);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var certificatesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _certificates2.default,
	  controller: _certificates4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = certificatesComponent;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"certificates-container\">\r\n  <div class=\"certificates-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <certificates-filter apply-filters=\"vm.applyFilters()\"></certificates-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"certificates-match\">{{vm.certificatesMatchCount ? vm.certificatesMatchCount + \" certificates match\" : \"\"}}</div>\r\n      <div class=\"certificates-grid\">\r\n        <div id=\"certificates-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n  <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n    <p>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Full Name: </span> \r\n        <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\" \r\n          data-bind=\"value: certificateTextData1\" validationMessage=\"Enter full name\" name=\"Full Name\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Expiry Date: </span> \r\n        <input k-on-change=\"dataItem.dirty=true\" \r\n          kendo-datepicker\r\n          data-bind=\"value: expiryDate\" \r\n          validationMessage=\"Enter expirty date\" name=\"Expiry Date\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Certificate Status: </span> \r\n        <input k-on-change=\"dataItem.dirty=true\" \r\n          kendo-dropdownlist \r\n          k-options=\"vm.certificatesReviewStatusOptions\" \r\n          data-bind=\"value: certificateStatus\" \r\n          validationMessage=\"Select certificate status\" name=\"Certificate Status\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Type: </span> \r\n        <input k-on-change=\"dataItem.dirty=true\" \r\n          kendo-dropdownlist \r\n          k-options=\"vm.certificatesTypeOptions\" \r\n          data-bind=\"value: certificateNumericData1\" \r\n          validationMessage=\"Select certificate type\" name=\"Certificate type\"/>\r\n      </div>\r\n    </p>\r\n  </div>\r\n</script>"

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CertificatesController = function () {
	  CertificatesController.$inject = ["CertificatesService", "FilterService", "AuthService", "$scope"];
	  function CertificatesController(CertificatesService, FilterService, AuthService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CertificatesController);
	    this.certificatesService = CertificatesService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(CertificatesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.certificatesReviewStatusOptions = {
	        dataSource: [{ value: 1, text: "Pending Verification" }, { value: 2, text: "Active" }, { value: 3, text: "Invalid" }, { value: 4, text: "Expired" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	
	      this.certificatesTypeOptions = {
	        valuePrimitive: true,
	        dataSource: [{ value: 0, text: "Unspecified" }, { value: 1, text: "Volunteer" }, { value: 2, text: "Paid" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.certificatesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          template: "No Certificates."
	        },
	        columns: [{
	          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "8rem",
	          template: function template(dataItem) {
	            return "<a class=\"cell\" href=\"/users/" + dataItem.jugglerId + "\">" + dataItem.fullName + "</a>";
	          }
	        }, { field: "officialFullName", title: "Legal Name", filterable: false, sortable: false, width: "8rem" }, { field: "creationDate", title: "Upload Date", filterable: false, sortable: false, width: "4rem", template: "#= creationDate ? kendo.toString(new Date(creationDate), 'dd/MM/yyyy'): '-' #" }, { field: "dateOfBirth", title: "Date of Birth", filterable: false, sortable: false, width: "4rem", template: "#= dateOfBirth ? kendo.toString(new Date(dateOfBirth), 'dd/MM/yyyy'): '-' #" },
	        // { field: "category", title: "Category", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getCategory(dataItem.category)}` },
	        { field: "certificateTypeId", title: "Certificate Type", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getCertificateType(dataItem.certificateTypeId);
	          } }, { field: "addressState", title: "State", filterable: false, sortable: false, width: "4rem" }, { field: "certificateNumber", title: "Certificate Number", filterable: false, sortable: false, width: "4rem" }, { field: "certificateStatus", title: "Certificate Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getCertificateStatus(dataItem.certificateStatus);
	          } }, { field: "expiryDate", title: "Expiry Date", filterable: false, width: "4rem", sortable: false, template: "#= expiryDate ? kendo.toString(new Date(expiryDate), 'dd/MM/yyyy'): '-' #" },
	        // { field: "verificationDate", title: "Verification Date", filterable: false, sortable: false, width: "4rem", template: `#= verificationDate ? kendo.toString(new Date(verificationDate), 'dd/MM/yyyy'): '-' #` },
	        { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Update Certificate Status" },
	          template: kendo.template($("#popup-editor").html())
	        }
	      };
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.certificatesMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }, {
	    key: "_getCertificateStatus",
	    value: function _getCertificateStatus(status) {
	      switch (status) {
	        case _constants2.default.certificateStatus.PENDINGVERIFICATION:
	          return "Pending Verification";
	        case _constants2.default.certificateStatus.ACTIVE:
	          return "Active";
	        case _constants2.default.certificateStatus.INVALID:
	          return "Invalid";
	        case _constants2.default.certificateStatus.EXPIRED:
	          return "Expired";
	      }
	    }
	  }, {
	    key: "_getCategory",
	    value: function _getCategory(category) {
	      switch (category) {
	        case _constants2.default.certificateCategory.CHECK:
	          return "Check";
	        case _constants2.default.certificateCategory.FIRSTAID:
	          return "First Aid";
	        case _constants2.default.certificateCategory.QUALIFICATION:
	          return "Qualification";
	      }
	    }
	  }, {
	    key: "_getCertificateType",
	    value: function _getCertificateType(type) {
	      switch (type) {
	        case _constants2.default.certificateType.WWCC:
	          return "WWCC";
	      }
	    }
	  }]);
	  return CertificatesController;
	}();
	
	exports.default = CertificatesController;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(841);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./certificates.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./certificates.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.certificates-container{display:flex;flex-direction:column;height:100vh}.certificates-container .certificates-inner-container{height:100%;display:flex}.certificates-container .certificates-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.certificates-container .certificates-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.certificates-container .certificates-inner-container .grid-container .certificates-grid{margin-top:.5rem;margin-left:.5rem}.certificates-container .certificates-inner-container .grid-container .certificates-grid .col-name .cell{display:flex;align-items:center}.certificates-container .certificates-inner-container .grid-container .certificates-grid .col-name .cell .image-container{width:2rem}.certificates-container .certificates-inner-container .grid-container .certificates-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.certificates-container .certificates-inner-container .grid-container .certificates-grid .k-grid-norecords{margin-top:20rem}.certificates-container .certificates-inner-container .grid-container .certificates-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}.form-item{display:flex;align-items:center;justify-content:space-between;margin-bottom:.5rem;position:relative}.form-item>.k-tooltip-validation.k-invalid-msg{position:absolute;right:1.5rem;top:1.8rem}", ""]);
	
	// exports


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _checks = __webpack_require__(843);
	
	var _checks2 = _interopRequireDefault(_checks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checksModule = _angular2.default.module('app.containers.checks', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('checks', {
	    url: '/checks',
	    template: '<checks></checks>'
	  });
	}]).component('checks', _checks2.default);
	
	exports.default = checksModule;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checks = __webpack_require__(844);
	
	var _checks2 = _interopRequireDefault(_checks);
	
	var _checks3 = __webpack_require__(845);
	
	var _checks4 = _interopRequireDefault(_checks3);
	
	__webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checksComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _checks2.default,
	  controller: _checks4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = checksComponent;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"checks-container\">\r\n  <div class=\"checks-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <checks-filter apply-filters=\"vm.applyFilters()\"></checks-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"checks-match\">{{vm.certificatesMatchCount ? vm.certificatesMatchCount + \" checks match\" : \"\"}}</div>\r\n      <div class=\"checks-grid\">\r\n        <div id=\"checks-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n  <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n    <p>\r\n        <!-- <div class=\"form-item\">\r\n            <span style=\"font-weight: bold;\">Visa Number: </span>\r\n            <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n              data-bind=\"value: visaNumber\" validationMessage=\"Enter visa number\" name=\"Visa number\"/>\r\n          </div> -->\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Visa Class: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n          data-bind=\"value: visaClass\" validationMessage=\"Enter visa class\" name=\"Visa class\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Visa Subclass: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n          data-bind=\"value: visaSubclass\" validationMessage=\"Enter visa subclass\" name=\"Visa Subclass\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Grant Date: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\"\r\n          kendo-datepicker\r\n          data-bind=\"value: visaGrantDate\"\r\n          validationMessage=\"Enter grant date\" name=\"Grant Date\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Expiry Date: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\"\r\n          kendo-datepicker\r\n          data-bind=\"value: visaExpiry\"\r\n          validationMessage=\"Enter expirty date\" name=\"Expiry Date\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Check Status: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\"\r\n          kendo-dropdownlist\r\n          k-options=\"vm.visaCheckStatusOptions\"\r\n          data-bind=\"value: visaCheckStatus\"\r\n          validationMessage=\"Select check status\" name=\"check Status\"/>\r\n      </div>\r\n    </p>\r\n  </div>\r\n</script>"

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _datasets = __webpack_require__(846);
	
	var _datasets2 = _interopRequireDefault(_datasets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChecksController = function () {
	  ChecksController.$inject = ["ChecksService", "FilterService", "AuthService", "NotificationService", "$scope"];
	  function ChecksController(ChecksService, FilterService, AuthService, NotificationService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ChecksController);
	    this.checksService = ChecksService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.notificationService = NotificationService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(ChecksController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.visaCheckStatusOptions = {
	        dataSource: [{ value: 1, text: "Pending Verification" }, { value: 2, text: "Approved" }, { value: 3, text: "Invalid" }, { value: 4, text: "Expired" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.checksService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        save: this.saveChanges.bind(this),
	        height: "90vh",
	        noRecords: {
	          template: "No Checks."
	        },
	        columns: [{
	          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "8rem",
	          template: function template(dataItem) {
	            return "<a class=\"cell\" href=\"/users/" + dataItem.jugglerId + "\">" + dataItem.fullName + "</a>";
	          }
	        }, { field: "visaCheckStatus", title: "Check Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getCheckStatus(dataItem.visaCheckStatus);
	          } }, { field: "officialFirstName", title: "Given Name", filterable: false, sortable: false, width: "4rem" }, { field: "officialLastName", title: "Last Name", filterable: false, sortable: false, width: "4rem" }, { field: "passportNumber", title: "Passport Number", filterable: false, sortable: false, width: "4rem" }, { field: "passportCountry", title: "Passport Country", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getCountry(dataItem.passportCountry);
	          } },
	        // { field: "creationDate", title: "Signup Date", filterable: false, sortable: false, width: "4rem", template: `#= creationDate ? kendo.toString(new Date(creationDate), 'dd/MM/yyyy'): '-' #` },
	        { field: "dateOfBirth", title: "Date of Birth", filterable: false, sortable: false, width: "4rem", template: "#= dateOfBirth ? kendo.toString(new Date(dateOfBirth), 'dd/MM/yyyy'): '-' #" }, { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Update Check Status" },
	          template: kendo.template($("#popup-editor").html())
	        }
	      };
	    }
	  }, {
	    key: "saveChanges",
	    value: function saveChanges(e) {
	      var check = e.model;
	
	      if (check.visaCheckStatus == 2 && (!check.visaClass || !check.visaSubclass || !check.visaGrantDate || !check.visaExpiry)) {
	        this.notificationService.error("Check missing fields and try again.");
	        e.preventDefault();
	      }
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.certificatesMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }, {
	    key: "_getCountry",
	    value: function _getCountry(countryId) {
	      var match = _datasets2.default.countriesIso.find(function (country) {
	        return country.value === countryId || country.alpha2 === countryId;
	      });
	
	      if (!match) return "N/A";
	
	      return match.label;
	    }
	  }, {
	    key: "_getCheckStatus",
	    value: function _getCheckStatus(status) {
	      switch (status) {
	        case _constants2.default.visaCheckStatus.PENDINGVERIFICATION:
	          return "Pending";
	        case _constants2.default.visaCheckStatus.APPROVED:
	          return "Approved";
	        case _constants2.default.visaCheckStatus.INVALID:
	          return "Invalid";
	        case _constants2.default.visaCheckStatus.EXPIRED:
	          return "Expired";
	      }
	    }
	  }]);
	  return ChecksController;
	}();
	
	exports.default = ChecksController;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var datasets = function () {
	  return {
	    countries: [{ label: 'Afghanistan', value: 'AF' }, { label: 'Åland Islands', value: 'AX' }, { label: 'Albania', value: 'AL' }, { label: 'Algeria', value: 'DZ' }, { label: 'American Samoa', value: 'AS' }, { label: 'AndorrA', value: 'AD' }, { label: 'Angola', value: 'AO' }, { label: 'Anguilla', value: 'AI' }, { label: 'Antarctica', value: 'AQ' }, { label: 'Antigua and Barbuda', value: 'AG' }, { label: 'Argentina', value: 'AR' }, { label: 'Armenia', value: 'AM' }, { label: 'Aruba', value: 'AW' }, { label: 'Australia', value: 'AU' }, { label: 'Austria', value: 'AT' }, { label: 'Azerbaijan', value: 'AZ' }, { label: 'Bahamas', value: 'BS' }, { label: 'Bahrain', value: 'BH' }, { label: 'Bangladesh', value: 'BD' }, { label: 'Barbados', value: 'BB' }, { label: 'Belarus', value: 'BY' }, { label: 'Belgium', value: 'BE' }, { label: 'Belize', value: 'BZ' }, { label: 'Benin', value: 'BJ' }, { label: 'Bermuda', value: 'BM' }, { label: 'Bhutan', value: 'BT' }, { label: 'Bolivia', value: 'BO' }, { label: 'Bosnia and Herzegovina', value: 'BA' }, { label: 'Botswana', value: 'BW' }, { label: 'Bouvet Island', value: 'BV' }, { label: 'Brazil', value: 'BR' }, { label: 'British Indian Ocean Territory', value: 'IO' }, { label: 'Brunei Darussalam', value: 'BN' }, { label: 'Bulgaria', value: 'BG' }, { label: 'Burkina Faso', value: 'BF' }, { label: 'Burundi', value: 'BI' }, { label: 'Cambodia', value: 'KH' }, { label: 'Cameroon', value: 'CM' }, { label: 'Canada', value: 'CA' }, { label: 'Cape Verde', value: 'CV' }, { label: 'Cayman Islands', value: 'KY' }, { label: 'Central African Republic', value: 'CF' }, { label: 'Chad', value: 'TD' }, { label: 'Chile', value: 'CL' }, { label: 'China', value: 'CN' }, { label: 'Christmas Island', value: 'CX' }, { label: 'Cocos (Keeling) Islands', value: 'CC' }, { label: 'Colombia', value: 'CO' }, { label: 'Comoros', value: 'KM' }, { label: 'Congo', value: 'CG' }, { label: 'Congo, The Democratic Republic of the', value: 'CD' }, { label: 'Cook Islands', value: 'CK' }, { label: 'Costa Rica', value: 'CR' }, { label: 'Cote D\'Ivoire', value: 'CI' }, { label: 'Croatia', value: 'HR' }, { label: 'Cuba', value: 'CU' }, { label: 'Cyprus', value: 'CY' }, { label: 'Czech Republic', value: 'CZ' }, { label: 'Denmark', value: 'DK' }, { label: 'Djibouti', value: 'DJ' }, { label: 'Dominica', value: 'DM' }, { label: 'Dominican Republic', value: 'DO' }, { label: 'Ecuador', value: 'EC' }, { label: 'Egypt', value: 'EG' }, { label: 'El Salvador', value: 'SV' }, { label: 'Equatorial Guinea', value: 'GQ' }, { label: 'Eritrea', value: 'ER' }, { label: 'Estonia', value: 'EE' }, { label: 'Ethiopia', value: 'ET' }, { label: 'Falkland Islands (Malvinas)', value: 'FK' }, { label: 'Faroe Islands', value: 'FO' }, { label: 'Fiji', value: 'FJ' }, { label: 'Finland', value: 'FI' }, { label: 'France', value: 'FR' }, { label: 'French Guiana', value: 'GF' }, { label: 'French Polynesia', value: 'PF' }, { label: 'French Southern Territories', value: 'TF' }, { label: 'Gabon', value: 'GA' }, { label: 'Gambia', value: 'GM' }, { label: 'Georgia', value: 'GE' }, { label: 'Germany', value: 'DE' }, { label: 'Ghana', value: 'GH' }, { label: 'Gibraltar', value: 'GI' }, { label: 'Greece', value: 'GR' }, { label: 'Greenland', value: 'GL' }, { label: 'Grenada', value: 'GD' }, { label: 'Guadeloupe', value: 'GP' }, { label: 'Guam', value: 'GU' }, { label: 'Guatemala', value: 'GT' }, { label: 'Guernsey', value: 'GG' }, { label: 'Guinea', value: 'GN' }, { label: 'Guinea-Bissau', value: 'GW' }, { label: 'Guyana', value: 'GY' }, { label: 'Haiti', value: 'HT' }, { label: 'Heard Island and Mcdonald Islands', value: 'HM' }, { label: 'Holy See (Vatican City State)', value: 'VA' }, { label: 'Honduras', value: 'HN' }, { label: 'Hong Kong', value: 'HK' }, { label: 'Hungary', value: 'HU' }, { label: 'Iceland', value: 'IS' }, { label: 'India', value: 'IN' }, { label: 'Indonesia', value: 'ID' }, { label: 'Iran, Islamic Republic Of', value: 'IR' }, { label: 'Iraq', value: 'IQ' }, { label: 'Ireland', value: 'IE' }, { label: 'Isle of Man', value: 'IM' }, { label: 'Israel', value: 'IL' }, { label: 'Italy', value: 'IT' }, { label: 'Jamaica', value: 'JM' }, { label: 'Japan', value: 'JP' }, { label: 'Jersey', value: 'JE' }, { label: 'Jordan', value: 'JO' }, { label: 'Kazakhstan', value: 'KZ' }, { label: 'Kenya', value: 'KE' }, { label: 'Kiribati', value: 'KI' }, { label: 'Korea, Democratic People\'S Republic of', value: 'KP' }, { label: 'Korea, Republic of', value: 'KR' }, { label: 'Kuwait', value: 'KW' }, { label: 'Kyrgyzstan', value: 'KG' }, { label: 'Lao People\'S Democratic Republic', value: 'LA' }, { label: 'Latvia', value: 'LV' }, { label: 'Lebanon', value: 'LB' }, { label: 'Lesotho', value: 'LS' }, { label: 'Liberia', value: 'LR' }, { label: 'Libyan Arab Jamahiriya', value: 'LY' }, { label: 'Liechtenstein', value: 'LI' }, { label: 'Lithuania', value: 'LT' }, { label: 'Luxembourg', value: 'LU' }, { label: 'Macao', value: 'MO' }, { label: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' }, { label: 'Madagascar', value: 'MG' }, { label: 'Malawi', value: 'MW' }, { label: 'Malaysia', value: 'MY' }, { label: 'Maldives', value: 'MV' }, { label: 'Mali', value: 'ML' }, { label: 'Malta', value: 'MT' }, { label: 'Marshall Islands', value: 'MH' }, { label: 'Martinique', value: 'MQ' }, { label: 'Mauritania', value: 'MR' }, { label: 'Mauritius', value: 'MU' }, { label: 'Mayotte', value: 'YT' }, { label: 'Mexico', value: 'MX' }, { label: 'Micronesia, Federated States of', value: 'FM' }, { label: 'Moldova, Republic of', value: 'MD' }, { label: 'Monaco', value: 'MC' }, { label: 'Mongolia', value: 'MN' }, { label: 'Montserrat', value: 'MS' }, { label: 'Morocco', value: 'MA' }, { label: 'Mozambique', value: 'MZ' }, { label: 'Myanmar', value: 'MM' }, { label: 'Namibia', value: 'NA' }, { label: 'Nauru', value: 'NR' }, { label: 'Nepal', value: 'NP' }, { label: 'Netherlands', value: 'NL' }, { label: 'Netherlands Antilles', value: 'AN' }, { label: 'New Caledonia', value: 'NC' }, { label: 'New Zealand', value: 'NZ' }, { label: 'Nicaragua', value: 'NI' }, { label: 'Niger', value: 'NE' }, { label: 'Nigeria', value: 'NG' }, { label: 'Niue', value: 'NU' }, { label: 'Norfolk Island', value: 'NF' }, { label: 'Northern Mariana Islands', value: 'MP' }, { label: 'Norway', value: 'NO' }, { label: 'Oman', value: 'OM' }, { label: 'Pakistan', value: 'PK' }, { label: 'Palau', value: 'PW' }, { label: 'Palestinian Territory, Occupied', value: 'PS' }, { label: 'Panama', value: 'PA' }, { label: 'Papua New Guinea', value: 'PG' }, { label: 'Paraguay', value: 'PY' }, { label: 'Peru', value: 'PE' }, { label: 'Philippines', value: 'PH' }, { label: 'Pitcairn', value: 'PN' }, { label: 'Poland', value: 'PL' }, { label: 'Portugal', value: 'PT' }, { label: 'Puerto Rico', value: 'PR' }, { label: 'Qatar', value: 'QA' }, { label: 'Reunion', value: 'RE' }, { label: 'Romania', value: 'RO' }, { label: 'Russian Federation', value: 'RU' }, { label: 'RWANDA', value: 'RW' }, { label: 'Saint Helena', value: 'SH' }, { label: 'Saint Kitts and Nevis', value: 'KN' }, { label: 'Saint Lucia', value: 'LC' }, { label: 'Saint Pierre and Miquelon', value: 'PM' }, { label: 'Saint Vincent and the Grenadines', value: 'VC' }, { label: 'Samoa', value: 'WS' }, { label: 'San Marino', value: 'SM' }, { label: 'Sao Tome and Principe', value: 'ST' }, { label: 'Saudi Arabia', value: 'SA' }, { label: 'Senegal', value: 'SN' }, { label: 'Serbia and Montenegro', value: 'CS' }, { label: 'Seychelles', value: 'SC' }, { label: 'Sierra Leone', value: 'SL' }, { label: 'Singapore', value: 'SG' }, { label: 'Slovakia', value: 'SK' }, { label: 'Slovenia', value: 'SI' }, { label: 'Solomon Islands', value: 'SB' }, { label: 'Somalia', value: 'SO' }, { label: 'South Africa', value: 'ZA' }, { label: 'South Georgia and the South Sandwich Islands', value: 'GS' }, { label: 'Spain', value: 'ES' }, { label: 'Sri Lanka', value: 'LK' }, { label: 'Sudan', value: 'SD' }, { label: 'Suriname', value: 'SR' }, { label: 'Svalbard and Jan Mayen', value: 'SJ' }, { label: 'Swaziland', value: 'SZ' }, { label: 'Sweden', value: 'SE' }, { label: 'Switzerland', value: 'CH' }, { label: 'Syrian Arab Republic', value: 'SY' }, { label: 'Taiwan, Province of China', value: 'TW' }, { label: 'Tajikistan', value: 'TJ' }, { label: 'Tanzania, United Republic of', value: 'TZ' }, { label: 'Thailand', value: 'TH' }, { label: 'Timor-Leste', value: 'TL' }, { label: 'Togo', value: 'TG' }, { label: 'Tokelau', value: 'TK' }, { label: 'Tonga', value: 'TO' }, { label: 'Trinidad and Tobago', value: 'TT' }, { label: 'Tunisia', value: 'TN' }, { label: 'Turkey', value: 'TR' }, { label: 'Turkmenistan', value: 'TM' }, { label: 'Turks and Caicos Islands', value: 'TC' }, { label: 'Tuvalu', value: 'TV' }, { label: 'Uganda', value: 'UG' }, { label: 'Ukraine', value: 'UA' }, { label: 'United Arab Emirates', value: 'AE' }, { label: 'United Kingdom', value: 'GB' }, { label: 'United States', value: 'US' }, { label: 'United States Minor Outlying Islands', value: 'UM' }, { label: 'Uruguay', value: 'UY' }, { label: 'Uzbekistan', value: 'UZ' }, { label: 'Vanuatu', value: 'VU' }, { label: 'Venezuela', value: 'VE' }, { label: 'Viet Nam', value: 'VN' }, { label: 'Virgin Islands, British', value: 'VG' }, { label: 'Virgin Islands, U.S.', value: 'VI' }, { label: 'Wallis and Futuna', value: 'WF' }, { label: 'Western Sahara', value: 'EH' }, { label: 'Yemen', value: 'YE' }, { label: 'Zambia', value: 'ZM' }, { label: 'Zimbabwe', value: 'ZW' }],
	    /* eslint-disable */
	    countriesIso: [{ id: 4, label: 'Afghanistan', alpha2: 'af', value: 'afg' }, { id: 8, label: 'Albania', alpha2: 'al', value: 'alb' }, { id: 12, label: 'Algeria', alpha2: 'dz', value: 'dza' }, { id: 20, label: 'Andorra', alpha2: 'ad', value: 'and' }, { id: 24, label: 'Angola', alpha2: 'ao', value: 'ago' }, { id: 28, label: 'Antigua and Barbuda', alpha2: 'ag', value: 'atg' }, { id: 32, label: 'Argentina', alpha2: 'ar', value: 'arg' }, { id: 51, label: 'Armenia', alpha2: 'am', value: 'arm' }, { id: 36, label: 'Australia', alpha2: 'au', value: 'aus' }, { id: 40, label: 'Austria', alpha2: 'at', value: 'aut' }, { id: 31, label: 'Azerbaijan', alpha2: 'az', value: 'aze' }, { id: 44, label: 'Bahamas', alpha2: 'bs', value: 'bhs' }, { id: 48, label: 'Bahrain', alpha2: 'bh', value: 'bhr' }, { id: 50, label: 'Bangladesh', alpha2: 'bd', value: 'bgd' }, { id: 52, label: 'Barbados', alpha2: 'bb', value: 'brb' }, { id: 112, label: 'Belarus', alpha2: 'by', value: 'blr' }, { id: 56, label: 'Belgium', alpha2: 'be', value: 'bel' }, { id: 84, label: 'Belize', alpha2: 'bz', value: 'blz' }, { id: 204, label: 'Benin', alpha2: 'bj', value: 'ben' }, { id: 64, label: 'Bhutan', alpha2: 'bt', value: 'btn' }, { id: 68, label: 'Bolivia (Plurinational State of)', alpha2: 'bo', value: 'bol' }, { id: 70, label: 'Bosnia and Herzegovina', alpha2: 'ba', value: 'bih' }, { id: 72, label: 'Botswana', alpha2: 'bw', value: 'bwa' }, { id: 76, label: 'Brazil', alpha2: 'br', value: 'bra' }, { id: 96, label: 'Brunei Darussalam', alpha2: 'bn', value: 'brn' }, { id: 100, label: 'Bulgaria', alpha2: 'bg', value: 'bgr' }, { id: 854, label: 'Burkina Faso', alpha2: 'bf', value: 'bfa' }, { id: 108, label: 'Burundi', alpha2: 'bi', value: 'bdi' }, { id: 132, label: 'Cabo Verde', alpha2: 'cv', value: 'cpv' }, { id: 116, label: 'Cambodia', alpha2: 'kh', value: 'khm' }, { id: 120, label: 'Cameroon', alpha2: 'cm', value: 'cmr' }, { id: 124, label: 'Canada', alpha2: 'ca', value: 'can' }, { id: 140, label: 'Central African Republic', alpha2: 'cf', value: 'caf' }, { id: 148, label: 'Chad', alpha2: 'td', value: 'tcd' }, { id: 152, label: 'Chile', alpha2: 'cl', value: 'chl' }, { id: 156, label: 'China', alpha2: 'cn', value: 'chn' }, { id: 170, label: 'Colombia', alpha2: 'co', value: 'col' }, { id: 174, label: 'Comoros', alpha2: 'km', value: 'com' }, { id: 178, label: 'Congo', alpha2: 'cg', value: 'cog' }, { id: 180, label: 'Congo, Democratic Republic of the', alpha2: 'cd', value: 'cod' }, { id: 188, label: 'Costa Rica', alpha2: 'cr', value: 'cri' }, { id: 384, label: 'Cote D\'Ivoire', alpha2: 'ci', value: 'civ' }, { id: 191, label: 'Croatia', alpha2: 'hr', value: 'hrv' }, { id: 192, label: 'Cuba', alpha2: 'cu', value: 'cub' }, { id: 196, label: 'Cyprus', alpha2: 'cy', value: 'cyp' }, { id: 203, label: 'Czechia', alpha2: 'cz', value: 'cze' }, { id: 208, label: 'Denmark', alpha2: 'dk', value: 'dnk' }, { id: 262, label: 'Djibouti', alpha2: 'dj', value: 'dji' }, { id: 212, label: 'Dominica', alpha2: 'dm', value: 'dma' }, { id: 214, label: 'Dominican Republic', alpha2: 'do', value: 'dom' }, { id: 218, label: 'Ecuador', alpha2: 'ec', value: 'ecu' }, { id: 818, label: 'Egypt', alpha2: 'eg', value: 'egy' }, { id: 222, label: 'El Salvador', alpha2: 'sv', value: 'slv' }, { id: 226, label: 'Equatorial Guinea', alpha2: 'gq', value: 'gnq' }, { id: 232, label: 'Eritrea', alpha2: 'er', value: 'eri' }, { id: 233, label: 'Estonia', alpha2: 'ee', value: 'est' }, { id: 748, label: 'Eswatini', alpha2: 'sz', value: 'swz' }, { id: 231, label: 'Ethiopia', alpha2: 'et', value: 'eth' }, { id: 242, label: 'Fiji', alpha2: 'fj', value: 'fji' }, { id: 246, label: 'Finland', alpha2: 'fi', value: 'fin' }, { id: 250, label: 'France', alpha2: 'fr', value: 'fra' }, { id: 266, label: 'Gabon', alpha2: 'ga', value: 'gab' }, { id: 270, label: 'Gambia', alpha2: 'gm', value: 'gmb' }, { id: 268, label: 'Georgia', alpha2: 'ge', value: 'geo' }, { id: 276, label: 'Germany', alpha2: 'de', value: 'deu' }, { id: 288, label: 'Ghana', alpha2: 'gh', value: 'gha' }, { id: 300, label: 'Greece', alpha2: 'gr', value: 'grc' }, { id: 308, label: 'Grenada', alpha2: 'gd', value: 'grd' }, { id: 320, label: 'Guatemala', alpha2: 'gt', value: 'gtm' }, { id: 324, label: 'Guinea', alpha2: 'gn', value: 'gin' }, { id: 624, label: 'Guinea-Bissau', alpha2: 'gw', value: 'gnb' }, { id: 328, label: 'Guyana', alpha2: 'gy', value: 'guy' }, { id: 332, label: 'Haiti', alpha2: 'ht', value: 'hti' }, { id: 340, label: 'Honduras', alpha2: 'hn', value: 'hnd' }, { id: 348, label: 'Hungary', alpha2: 'hu', value: 'hun' }, { id: 352, label: 'Iceland', alpha2: 'is', value: 'isl' }, { id: 356, label: 'India', alpha2: 'in', value: 'ind' }, { id: 360, label: 'Indonesia', alpha2: 'id', value: 'idn' }, { id: 364, label: 'Iran (Islamic Republic of)', alpha2: 'ir', value: 'irn' }, { id: 368, label: 'Iraq', alpha2: 'iq', value: 'irq' }, { id: 372, label: 'Ireland', alpha2: 'ie', value: 'irl' }, { id: 376, label: 'Israel', alpha2: 'il', value: 'isr' }, { id: 380, label: 'Italy', alpha2: 'it', value: 'ita' }, { id: 388, label: 'Jamaica', alpha2: 'jm', value: 'jam' }, { id: 392, label: 'Japan', alpha2: 'jp', value: 'jpn' }, { id: 400, label: 'Jordan', alpha2: 'jo', value: 'jor' }, { id: 398, label: 'Kazakhstan', alpha2: 'kz', value: 'kaz' }, { id: 404, label: 'Kenya', alpha2: 'ke', value: 'ken' }, { id: 296, label: 'Kiribati', alpha2: 'ki', value: 'kir' }, { id: 408, label: 'Korea (Democratic People\'s Republic of)', alpha2: 'kp', value: 'prk' }, { id: 410, label: 'Korea, Republic of', alpha2: 'kr', value: 'kor' }, { id: 414, label: 'Kuwait', alpha2: 'kw', value: 'kwt' }, { id: 417, label: 'Kyrgyzstan', alpha2: 'kg', value: 'kgz' }, { id: 418, label: 'Lao People\'s Democratic Republic', alpha2: 'la', value: 'lao' }, { id: 428, label: 'Latvia', alpha2: 'lv', value: 'lva' }, { id: 422, label: 'Lebanon', alpha2: 'lb', value: 'lbn' }, { id: 426, label: 'Lesotho', alpha2: 'ls', value: 'lso' }, { id: 430, label: 'Liberia', alpha2: 'lr', value: 'lbr' }, { id: 434, label: 'Libya', alpha2: 'ly', value: 'lby' }, { id: 438, label: 'Liechtenstein', alpha2: 'li', value: 'lie' }, { id: 440, label: 'Lithuania', alpha2: 'lt', value: 'ltu' }, { id: 442, label: 'Luxembourg', alpha2: 'lu', value: 'lux' }, { id: 807, label: 'Macedonia, the former Yugoslav Republic of', alpha2: 'mk', value: 'mkd' }, { id: 450, label: 'Madagascar', alpha2: 'mg', value: 'mdg' }, { id: 454, label: 'Malawi', alpha2: 'mw', value: 'mwi' }, { id: 458, label: 'Malaysia', alpha2: 'my', value: 'mys' }, { id: 462, label: 'Maldives', alpha2: 'mv', value: 'mdv' }, { id: 466, label: 'Mali', alpha2: 'ml', value: 'mli' }, { id: 470, label: 'Malta', alpha2: 'mt', value: 'mlt' }, { id: 584, label: 'Marshall Islands', alpha2: 'mh', value: 'mhl' }, { id: 478, label: 'Mauritania', alpha2: 'mr', value: 'mrt' }, { id: 480, label: 'Mauritius', alpha2: 'mu', value: 'mus' }, { id: 484, label: 'Mexico', alpha2: 'mx', value: 'mex' }, { id: 583, label: 'Micronesia (Federated States of)', alpha2: 'fm', value: 'fsm' }, { id: 498, label: 'Moldova, Republic of', alpha2: 'md', value: 'mda' }, { id: 492, label: 'Monaco', alpha2: 'mc', value: 'mco' }, { id: 496, label: 'Mongolia', alpha2: 'mn', value: 'mng' }, { id: 499, label: 'Montenegro', alpha2: 'me', value: 'mne' }, { id: 504, label: 'Morocco', alpha2: 'ma', value: 'mar' }, { id: 508, label: 'Mozambique', alpha2: 'mz', value: 'moz' }, { id: 104, label: 'Myanmar', alpha2: 'mm', value: 'mmr' }, { id: 516, label: 'Namibia', alpha2: 'na', value: 'nam' }, { id: 520, label: 'Nauru', alpha2: 'nr', value: 'nru' }, { id: 524, label: 'Nepal', alpha2: 'np', value: 'npl' }, { id: 528, label: 'Netherlands', alpha2: 'nl', value: 'nld' }, { id: 554, label: 'New Zealand', alpha2: 'nz', value: 'nzl' }, { id: 558, label: 'Nicaragua', alpha2: 'ni', value: 'nic' }, { id: 562, label: 'Niger', alpha2: 'ne', value: 'ner' }, { id: 566, label: 'Nigeria', alpha2: 'ng', value: 'nga' }, { id: 578, label: 'Norway', alpha2: 'no', value: 'nor' }, { id: 512, label: 'Oman', alpha2: 'om', value: 'omn' }, { id: 586, label: 'Pakistan', alpha2: 'pk', value: 'pak' }, { id: 585, label: 'Palau', alpha2: 'pw', value: 'plw' }, { id: 591, label: 'Panama', alpha2: 'pa', value: 'pan' }, { id: 598, label: 'Papua New Guinea', alpha2: 'pg', value: 'png' }, { id: 600, label: 'Paraguay', alpha2: 'py', value: 'pry' }, { id: 604, label: 'Peru', alpha2: 'pe', value: 'per' }, { id: 608, label: 'Philippines', alpha2: 'ph', value: 'phl' }, { id: 616, label: 'Poland', alpha2: 'pl', value: 'pol' }, { id: 620, label: 'Portugal', alpha2: 'pt', value: 'prt' }, { id: 634, label: 'Qatar', alpha2: 'qa', value: 'qat' }, { id: 642, label: 'Romania', alpha2: 'ro', value: 'rou' }, { id: 643, label: 'Russian Federation', alpha2: 'ru', value: 'rus' }, { id: 646, label: 'Rwanda', alpha2: 'rw', value: 'rwa' }, { id: 659, label: 'Saint Kitts and Nevis', alpha2: 'kn', value: 'kna' }, { id: 662, label: 'Saint Lucia', alpha2: 'lc', value: 'lca' }, { id: 670, label: 'Saint Vincent and the Grenadines', alpha2: 'vc', value: 'vct' }, { id: 882, label: 'Samoa', alpha2: 'ws', value: 'wsm' }, { id: 674, label: 'San Marino', alpha2: 'sm', value: 'smr' }, { id: 678, label: 'Sao Tome and Principe', alpha2: 'st', value: 'stp' }, { id: 682, label: 'Saudi Arabia', alpha2: 'sa', value: 'sau' }, { id: 686, label: 'Senegal', alpha2: 'sn', value: 'sen' }, { id: 688, label: 'Serbia', alpha2: 'rs', value: 'srb' }, { id: 690, label: 'Seychelles', alpha2: 'sc', value: 'syc' }, { id: 694, label: 'Sierra Leone', alpha2: 'sl', value: 'sle' }, { id: 702, label: 'Singapore', alpha2: 'sg', value: 'sgp' }, { id: 703, label: 'Slovakia', alpha2: 'sk', value: 'svk' }, { id: 705, label: 'Slovenia', alpha2: 'si', value: 'svn' }, { id: 90, label: 'Solomon Islands', alpha2: 'sb', value: 'slb' }, { id: 706, label: 'Somalia', alpha2: 'so', value: 'som' }, { id: 710, label: 'South Africa', alpha2: 'za', value: 'zaf' }, { id: 728, label: 'South Sudan', alpha2: 'ss', value: 'ssd' }, { id: 724, label: 'Spain', alpha2: 'es', value: 'esp' }, { id: 144, label: 'Sri Lanka', alpha2: 'lk', value: 'lka' }, { id: 729, label: 'Sudan', alpha2: 'sd', value: 'sdn' }, { id: 740, label: 'Suriname', alpha2: 'sr', value: 'sur' }, { id: 752, label: 'Sweden', alpha2: 'se', value: 'swe' }, { id: 756, label: 'Switzerland', alpha2: 'ch', value: 'che' }, { id: 760, label: 'Syrian Arab Republic', alpha2: 'sy', value: 'syr' }, { id: 762, label: 'Tajikistan', alpha2: 'tj', value: 'tjk' }, { id: 834, label: 'Tanzania, United Republic of', alpha2: 'tz', value: 'tza' }, { id: 764, label: 'Thailand', alpha2: 'th', value: 'tha' }, { id: 626, label: 'Timor-Leste', alpha2: 'tl', value: 'tls' }, { id: 768, label: 'Togo', alpha2: 'tg', value: 'tgo' }, { id: 776, label: 'Tonga', alpha2: 'to', value: 'ton' }, { id: 780, label: 'Trinidad and Tobago', alpha2: 'tt', value: 'tto' }, { id: 788, label: 'Tunisia', alpha2: 'tn', value: 'tun' }, { id: 792, label: 'Turkey', alpha2: 'tr', value: 'tur' }, { id: 795, label: 'Turkmenistan', alpha2: 'tm', value: 'tkm' }, { id: 798, label: 'Tuvalu', alpha2: 'tv', value: 'tuv' }, { id: 800, label: 'Uganda', alpha2: 'ug', value: 'uga' }, { id: 804, label: 'Ukraine', alpha2: 'ua', value: 'ukr' }, { id: 784, label: 'United Arab Emirates', alpha2: 'ae', value: 'are' }, { id: 826, label: 'United Kingdom of Great Britain and Northern Ireland', alpha2: 'gb', value: 'gbr' }, { id: 840, label: 'United States of America', alpha2: 'us', value: 'usa' }, { id: 858, label: 'Uruguay', alpha2: 'uy', value: 'ury' }, { id: 860, label: 'Uzbekistan', alpha2: 'uz', value: 'uzb' }, { id: 548, label: 'Vanuatu', alpha2: 'vu', value: 'vut' }, { id: 862, label: 'Venezuela (Bolivarian Republic of)', alpha2: 've', value: 'ven' }, { id: 704, label: 'Viet Nam', alpha2: 'vn', value: 'vnm' }, { id: 887, label: 'Yemen', alpha2: 'ye', value: 'yem' }, { id: 894, label: 'Zambia', alpha2: 'zm', value: 'zmb' }, { id: 716, label: 'Zimbabwe', alpha2: 'zw', value: 'zwe' }]
	  };
	}();
	
	exports.default = datasets;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(848);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./checks.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./checks.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.checks-container{display:flex;flex-direction:column;height:100vh}.checks-container .checks-inner-container{height:100%;display:flex}.checks-container .checks-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.checks-container .checks-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.checks-container .checks-inner-container .grid-container .checks-grid{margin-top:.5rem;margin-left:.5rem}.checks-container .checks-inner-container .grid-container .checks-grid .col-name .cell{display:flex;align-items:center}.checks-container .checks-inner-container .grid-container .checks-grid .col-name .cell .image-container{width:2rem}.checks-container .checks-inner-container .grid-container .checks-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.checks-container .checks-inner-container .grid-container .checks-grid .k-grid-norecords{margin-top:20rem}.checks-container .checks-inner-container .grid-container .checks-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}.form-item{display:flex;align-items:center;justify-content:space-between;margin-bottom:.5rem;position:relative}.form-item>.k-tooltip-validation.k-invalid-msg{position:absolute;right:1.5rem;top:1.8rem}", ""]);
	
	// exports


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _media = __webpack_require__(850);
	
	var _media2 = _interopRequireDefault(_media);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mediaModule = _angular2.default.module('app.containers.media', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('media', {
	    url: '/media',
	    template: '<media></media>'
	  });
	}]).component('media', _media2.default);
	
	exports.default = mediaModule;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _media = __webpack_require__(851);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _media3 = __webpack_require__(852);
	
	var _media4 = _interopRequireDefault(_media3);
	
	__webpack_require__(853);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mediaComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _media2.default,
	  controller: _media4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = mediaComponent;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"media-container\">\r\n  <div class=\"media-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <media-filter apply-filters=\"vm.applyFilters()\"></media-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"media-match\">{{vm.mediaMatchCount ? vm.mediaMatchCount + \" medias match\" : \"\"}}</div>\r\n      <div class=\"media-grid\">\r\n        <div id=\"media-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n  <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n    <p>\r\n      <label>\r\n        <span style=\"font-weight: bold;\">Review Status: </span> \r\n        <input k-on-change=\"dataItem.dirty=true\" \r\n          kendo-dropdownlist \r\n          k-options=\"vm.mediaReviewStatusOptions\" \r\n          data-bind=\"value: mediaReviewStatus\" />\r\n      <label>\r\n    </p>\r\n  </div>\r\n</script>"

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaController = function () {
	  MediaController.$inject = ["MediaService", "FilterService", "$scope"];
	  function MediaController(MediaService, FilterService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MediaController);
	    this.mediaService = MediaService;
	    this.filterService = FilterService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(MediaController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.mediaReviewStatusOptions = {
	        dataSource: [{ value: 0, text: "Unspecified" }, { value: 1, text: "Pending" }, { value: 2, text: "Approved" }, { value: 3, text: "Rejected" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.mediaService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          template: "No match found. Change your filter criteria."
	        },
	        columns: [{ field: "creationDate", title: "Date", template: "<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>", filterable: false, width: "6rem" }, { title: "Name", template: "<a class=\"cell\" href=\"#= '/users/' + userId #\">#= firstName + \" \" + lastName #</a>", filterable: false, sortable: false, width: "10rem" },
	        // { field: "mediaStatus", title: "Media Status", filterable: false, sortable: false, width: "8rem" },
	        { field: "mediaReviewStatus", title: "Review Status", filterable: false, sortable: true, width: "8rem", template: function template(dataItem) {
	            return "" + _this._getMediaReviewStatus(dataItem.mediaReviewStatus);
	          } }, { field: "duration", title: "Duration in seconds", filterable: false, sortable: false, width: "6rem" }, { title: "Watch Media", filterable: false, sortable: false, width: "6rem", template: "<a class=\"cell\" target=\"_blank\" href=\"#= '//jugglestreet.wistia.com/medias/' + externalHashedId #\">Link to media</a>" }, { title: "Update Review Status", command: [{ name: "edit", text: "Update" }], width: "7rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Update Review Status" },
	          template: kendo.template($("#popup-editor").html())
	        }
	      };
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.mediaMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }, {
	    key: "_getMediaReviewStatus",
	    value: function _getMediaReviewStatus(status) {
	
	      switch (status) {
	        case _constants2.default.mediaReviewStatuts.UNSPECIFIED:
	          return "Unspecified";
	        case _constants2.default.mediaReviewStatuts.PENDING:
	          return "Pending";
	        case _constants2.default.mediaReviewStatuts.APPROVED:
	          return "Approved";
	        case _constants2.default.mediaReviewStatuts.REJECTED:
	          return "Rejected";
	      }
	    }
	  }]);
	  return MediaController;
	}();
	
	exports.default = MediaController;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(854);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./media.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./media.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.media-container{display:flex;flex-direction:column;height:100vh}.media-container .media-inner-container{height:100%;display:flex}.media-container .media-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.media-container .media-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.media-container .media-inner-container .grid-container .media-grid{margin-top:.5rem;margin-left:.5rem}.media-container .media-inner-container .grid-container .media-grid .col-name .cell{display:flex;align-items:center}.media-container .media-inner-container .grid-container .media-grid .col-name .cell .image-container{width:2rem}.media-container .media-inner-container .grid-container .media-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.media-container .media-inner-container .grid-container .media-grid .k-grid-norecords{margin-top:20rem}.media-container .media-inner-container .grid-container .media-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _survey = __webpack_require__(856);
	
	var _survey2 = _interopRequireDefault(_survey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surveyModule = _angular2.default.module('app.containers.survey', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('survey', {
	    url: '/survey',
	    template: '<survey></survey>'
	  });
	}]).component('survey', _survey2.default);
	
	exports.default = surveyModule;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _survey = __webpack_require__(857);
	
	var _survey2 = _interopRequireDefault(_survey);
	
	var _survey3 = __webpack_require__(858);
	
	var _survey4 = _interopRequireDefault(_survey3);
	
	__webpack_require__(859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surveyComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _survey2.default,
	  controller: _survey4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = surveyComponent;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"survey-container\">\r\n  <div class=\"survey-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <survey-filter apply-filters=\"vm.applyFilters()\"></survey-filter>\r\n    </div> \r\n    <div class=\"grid-container\">\r\n      <div class=\"survey-match\">{{vm.surveyMatchCount ? vm.surveyMatchCount + \" survey match\" : \"\"}}</div>\r\n      <div class=\"survey-grid\">\r\n        <div id=\"survey-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n  <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n    <p>\r\n      <label>\r\n        <span style=\"font-weight: bold;\">Response: </span> \r\n        <input k-on-change=\"dataItem.dirty=true\" \r\n          kendo-dropdownlist \r\n          k-options=\"vm.surveyResponseOptions\" \r\n          data-bind=\"value: surveyResponse\" />\r\n      <label>\r\n    </p>\r\n  </div>\r\n</script>"

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyController = function () {
	  SurveyController.$inject = ["SurveyService", "FilterService", "$scope"];
	  function SurveyController(SurveyService, FilterService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SurveyController);
	    this.surveyService = SurveyService;
	    this.filterService = FilterService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(SurveyController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.surveyResponseOptions = {
	        dataSource: [{ value: 1, text: "Yes" }, { value: 2, text: "No" }, { value: 3, text: "NA" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      debugger;
	      return {
	        dataSource: this.surveyService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          template: "No match found. Change your filter criteria."
	        },
	        columns: [{ field: "responseDate", title: "Date", template: "<span>#= kendo.toString(new Date(responseDate), 'dd-MM-yyyy') #</span>", filterable: false, width: "6rem" }, { title: "Name", template: "<a class=\"cell\" href=\"#= '/users/' + jugglerId #\">#= fullName #</a>", filterable: false, sortable: false, width: "10rem" }, { field: "jugglerType", title: "Type", filterable: false, sortable: true, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getJugglerType(dataItem.jugglerType);
	          } }, { field: "email", title: "Email", filterable: false, sortable: false, width: "8rem" }, { field: "interestInHomeAgedCareResponse", title: "Response", filterable: false, sortable: true, width: "8rem", template: function template(dataItem) {
	            return "" + _this._getSurveyResponse(dataItem.interestInHomeAgedCareResponse);
	          } }]
	      };
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.surveyMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }, {
	    key: "_getSurveyResponse",
	    value: function _getSurveyResponse(status) {
	      switch (status) {
	        case _constants2.default.surveyResponse.YES:
	          return "Yes";
	        case _constants2.default.surveyResponse.NO:
	          return "No";
	        case _constants2.default.surveyResponse.NA:
	          return "NA";
	      }
	    }
	  }, {
	    key: "_getJugglerType",
	    value: function _getJugglerType(status) {
	      switch (status) {
	        case _constants2.default.jugglerType.PARENT:
	          return "Family";
	        case _constants2.default.jugglerType.HELPER:
	          return "Helper";
	      }
	    }
	  }]);
	  return SurveyController;
	}();
	
	exports.default = SurveyController;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(860);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./survey.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./survey.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.survey-container{display:flex;flex-direction:column;height:100vh}.survey-container .survey-inner-container{height:100%;display:flex}.survey-container .survey-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.survey-container .survey-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.survey-container .survey-inner-container .grid-container .survey-grid{margin-top:.5rem;margin-left:.5rem}.survey-container .survey-inner-container .grid-container .survey-grid .col-name .cell{display:flex;align-items:center}.survey-container .survey-inner-container .grid-container .survey-grid .col-name .cell .image-container{width:2rem}.survey-container .survey-inner-container .grid-container .survey-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.survey-container .survey-inner-container .grid-container .survey-grid .k-grid-norecords{margin-top:20rem}.survey-container .survey-inner-container .grid-container .survey-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _affiliates = __webpack_require__(862);
	
	var _affiliates2 = _interopRequireDefault(_affiliates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var affiliatesModule = _angular2.default.module('app.containers.affiliates', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('affiliates', {
	    url: '/affiliates',
	    template: '<affiliates></affiliates>'
	  });
	}]).component('affiliates', _affiliates2.default);
	
	exports.default = affiliatesModule;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _affiliates = __webpack_require__(863);
	
	var _affiliates2 = _interopRequireDefault(_affiliates);
	
	var _affiliates3 = __webpack_require__(864);
	
	var _affiliates4 = _interopRequireDefault(_affiliates3);
	
	__webpack_require__(865);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var affiliateComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _affiliates2.default,
	  controller: _affiliates4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = affiliateComponent;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"affiliates-container\">\r\n  <div class=\"affiliates-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <affiliates-filter apply-filters=\"vm.applyFilters()\"></affiliates-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"affiliates-match\">{{vm.affiliatesMatchCount ? vm.affiliatesMatchCount + \" Partnerships Match\" : \"\"}}</div>\r\n      <div class=\"affiliates-grid\">\r\n        <div id=\"affiliates-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n    <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n      <p>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Partner Name: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n            data-bind=\"value: affiliateName\" validationMessage=\"Enter affiliate name\" name=\"Partner Name\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Partner Code: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n            data-bind=\"value: code\" validationMessage=\"Enter code\" name=\"Code\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Email Pattern: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n            data-bind=\"value: emailPattern\" validationMessage=\"Email Pattern\" name=\"Email Pattern\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Start Date: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\"\r\n            kendo-datepicker\r\n            data-bind=\"value: startDate\"\r\n            validationMessage=\"Enter start date\" name=\"Start Date\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Expire Date: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\"\r\n            kendo-datepicker\r\n            data-bind=\"value: expireDate\"\r\n            validationMessage=\"Enter expire date\" name=\"Expire Date\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Partner Type: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\"\r\n            kendo-dropdownlist\r\n            k-options=\"vm.affiliateTypeOptions\"\r\n            data-bind=\"value: affiliateType\"\r\n            validationMessage=\"Select affiliate type\" name=\"Partner Type\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Activations Limit: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n            data-bind=\"value: activationsLimit\" validationMessage=\"Enter limit\" name=\"Limit\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Credit Amount: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n            data-bind=\"value: creditAmount\" validationMessage=\"Enter credit amount\" name=\"Credit Amount\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Parent Membership Type: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\"\r\n            kendo-dropdownlist\r\n            k-options=\"vm.paymentTypeOptions\"\r\n            data-bind=\"value: paymentType\"\r\n            validationMessage=\"Select membership type\" name=\"Membership type\"/>\r\n        </div>\r\n        <div class=\"form-item\">\r\n          <span style=\"font-weight: bold;\">Helper Membership Type: </span>\r\n          <input k-on-change=\"dataItem.dirty=true\"\r\n            kendo-dropdownlist\r\n            k-options=\"vm.secondaryPaymentTypeOptions\"\r\n            data-bind=\"value: secondaryPaymentType\"\r\n            name=\"Membership type\"/>\r\n        </div>\r\n      </p>\r\n    </div>\r\n  </script>\r\n\r\n  <script type=\"text/x-kendo-template\" id=\"template\">\r\n    <div class=\"detailTabstrip\">\r\n      <ul>\r\n          <li class=\"k-state-active\">\r\n              Details\r\n          </li>\r\n          <li>\r\n              Users\r\n          </li>\r\n          <li>\r\n            Jobs\r\n        </li>\r\n      </ul>\r\n      <div>\r\n          <div class='partner-details'>\r\n              <ul>\r\n                  <li><label>Partner Name: </label>#= affiliateName #</li>\r\n                  <li><label>Partner Code: </label>#= code #</li>\r\n                  <li><label>Partner Email: </label>#= emailPattern ? emailPattern : 'None' #</li>\r\n                  <li><label>Usage: </label>#= activationsCount #</li>\r\n                  <li><label>Start Date: </label>#= kendo.toString(new Date(startDate), 'dd/MM/yyyy') #</li>\r\n                  <li><label>Expire Date: </label>#= kendo.toString(new Date(expireDate), 'dd/MM/yyyy') #</li>\r\n                  <li><label>AU Signup Link: </label><a target=\"_blank\" href=\"#= 'https://web.jugglestreet' + '.com.au' + '/signup?ac=' + code #\">Link</a></li>\r\n                  <li><label>NZ Signup Link: </label><a target=\"_blank\" href=\"#= 'https://web.jugglestreet' + '.co.nz' + '/signup?ac=' + code #\">Link</a></li>\r\n              </ul>\r\n          </div>\r\n      </div>\r\n      <div>\r\n        <div class=\"users\"></div>\r\n      </div>\r\n      <div>\r\n        <div class=\"jobs\"></div>\r\n      </div>\r\n    </div>\r\n  </script>\r\n</div>"

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AffiliatesController = function () {
	  AffiliatesController.$inject = ["AffiliatesService", "FilterService", "AuthService", "$scope"];
	  function AffiliatesController(AffiliatesService, FilterService, AuthService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AffiliatesController);
	    this.affiliatesService = AffiliatesService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(AffiliatesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.affiliateTypeOptions = {
	        dataSource: [{ value: _constants2.default.affiliateType.CREDIT, text: "Credit" }, { value: _constants2.default.affiliateType.SUBSCRIPTION, text: "Membership" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	
	      this.paymentTypeOptions = {
	        dataSource: [{ value: _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180, text: "Complete Childcare" }, { value: _constants2.default.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240, text: "Tutoring + Childcare" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	
	      this.secondaryPaymentTypeOptions = {
	        dataSource: [{ value: _constants2.default.userPaymentType.NONE, text: "None" }, { value: _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30, text: "Paid Membership" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	
	    // https://demos.telerik.com/kendo-ui/grid/detailtemplate.
	
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.affiliatesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        toolbar: [{ name: "create", text: "Create New Partnership" }],
	        detailInit: this.detailInit.bind(this),
	        detailTemplate: kendo.template($("#template").html()),
	        noRecords: {
	          template: "No Partnerships."
	        },
	        // dataBound: function() {
	        //     this.expandRow(this.tbody.find("tr.k-master-row").first());
	        // },
	        columns: [
	        // { field: "code", title: "Code", filterable: false, sortable: false, width: "4rem" },
	        { field: "affiliateName", title: "Partner Name", filterable: false, sortable: false, width: "8rem" }, {
	          field: "fullName", title: "Referrer", filterable: false, attributes: { "class": "col-name" }, width: "8rem",
	          template: function template(dataItem) {
	            return dataItem.jugglerId ? "<a target=\"_blank\" class=\"cell\" href=\"/users/" + dataItem.jugglerId + "\">" + dataItem.fullName + "</a>" : 'None';
	          }
	        }, { field: "jugglerTypes", title: "Account Type", filterable: false, width: "6rem", template: function template(dataItem) {
	            return "" + _this._getAccountType(dataItem);
	          } }, { field: "affiliateType", title: "Type", filterable: false, width: "6rem", template: function template(dataItem) {
	            return "" + _this._getAffiliateDetails(dataItem);
	          } }, { field: "activationsCount", title: "Usage", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getActivationDetails(dataItem);
	          } },
	        // { field: "startDate", title: "Start Date", filterable: false, width: "4rem", template: `#= startDate ? kendo.toString(new Date(startDate), 'dd/MM/yyyy'): '-' #` },
	        // { field: "expireDate", title: "Expire Date", filterable: false, width: "4rem", template: `#= expireDate ? kendo.toString(new Date(expireDate), 'dd/MM/yyyy'): '-' #` },
	        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Partnership" },
	          template: kendo.template($("#popup-editor").html())
	        }
	      };
	    }
	  }, {
	    key: "detailInit",
	    value: function detailInit(e) {
	      var data = e.data;
	      var detailRow = e.detailRow;
	
	      detailRow.find(".detailTabstrip").kendoTabStrip({
	        animation: {
	          open: { effects: "fadeIn" }
	        }
	      });
	
	      detailRow.find(".users").kendoGrid({
	        dataSource: this.affiliatesService.getAffiliateUsersDataSource(data.id),
	        sortable: false,
	        pageable: true,
	        resizable: false,
	        noRecords: {
	          template: "None yet."
	        },
	        columns: [{
	          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "12rem",
	          template: function template(dataItem) {
	            return "<a target=\"_blank\" class=\"cell\" href=\"/users/" + dataItem.userId + "\">" + dataItem.fullName + "</a>";
	          }
	        }, { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" }, { field: "accountStatusName", title: "Account Status", filterable: false, width: "8rem" }, { field: "membershipTypeName", title: "Membership Type", filterable: false, width: "10rem" }, { field: "creationDate", title: "Signup Date", template: "<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>", filterable: false, width: "8rem" }]
	      });
	
	      detailRow.find(".jobs").kendoGrid({
	        dataSource: this.affiliatesService.getAffiliateJobsDataSource(data.id),
	        sortable: false,
	        pageable: true,
	        resizable: false,
	        noRecords: {
	          template: "None yet."
	        },
	        columns: [{ field: "month", title: "Month", template: "<span>#= kendo.toString(new Date(month), 'MMM yyyy') #</span>", filterable: false, width: "4em" }, { field: "jobsPosted", title: "Jobs Posted", filterable: false, sortable: false, width: "2rem" }, { field: "jobsAwarded", title: "Jobs Awarded", filterable: false, sortable: false, width: "2rem" }, { field: "jobsCompleted", title: "Jobs Completed", filterable: false, sortable: false, width: "2rem" }]
	      });
	    }
	  }, {
	    key: "_getActivationDetails",
	    value: function _getActivationDetails(affiliate) {
	      switch (affiliate.affiliateType) {
	        case _constants2.default.affiliateType.CREDIT:
	          return "" + affiliate.activationsCount;
	        case _constants2.default.affiliateType.SUBSCRIPTION:
	          return affiliate.activationsCount + " / " + affiliate.activationsLimit;
	      }
	
	      return '';
	    }
	  }, {
	    key: "_getAffiliateDetails",
	    value: function _getAffiliateDetails(affiliate) {
	      var details = '';
	      switch (affiliate.affiliateType) {
	        case _constants2.default.affiliateType.CREDIT:
	          details = "$" + affiliate.creditAmount + " Credit";
	          break;
	        case _constants2.default.affiliateType.SUBSCRIPTION:
	          details = "" + this.getPaymentType(affiliate.paymentType);
	          if (affiliate.secondaryPaymentType) {
	            details += ", " + this.getPaymentType(affiliate.secondaryPaymentType);
	          }
	          break;
	      }
	
	      return details;
	    }
	  }, {
	    key: "_getAccountType",
	    value: function _getAccountType(affiliate) {
	      switch (affiliate.jugglerTypes) {
	        case _constants2.default.jugglerType.PARENT:
	          return 'Parent';
	        case _constants2.default.jugglerType.HELPER:
	          return 'Helper';
	      }
	
	      return 'None';
	    }
	  }, {
	    key: "getPaymentType",
	    value: function getPaymentType(paymentType) {
	      if (!paymentType) return "-";
	
	      switch (paymentType) {
	        case _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION120:
	        case _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180:
	          return 'Childcare Membership';
	        case _constants2.default.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240:
	          return 'Tutoring + Childcare Membership';
	        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER1_SUBSCRIPTION_500:
	          return 'Juggle St Pro Quarterly - Single Site';
	        case _constants2.default.userPaymentType.ANNUAL_BUSINESS_TIER1_SUBSCRIPTION_1500:
	          return 'Juggle St Pro Annual - Single Site';
	        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_500:
	          return 'Juggle St Pro Quarterly - Agency';
	        case _constants2.default.userPaymentType.ANNUAL_BUSINESS_TIER2_SUBSCRIPTION_1500:
	          return 'Juggle St Pro Annual - Agency';
	        case _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30:
	          return 'Helper Membership';
	        default:
	          throw new Error("Unsupported option: " + paymentType);
	      }
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.affiliatesMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }]);
	  return AffiliatesController;
	}();
	
	exports.default = AffiliatesController;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(866);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./affiliates.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./affiliates.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.affiliates-container{display:flex;flex-direction:column;height:100vh}.affiliates-container .affiliates-inner-container{height:100%;display:flex}.affiliates-container .affiliates-inner-container .k-grid .k-alt,.affiliates-container .affiliates-inner-container .k-grid td.k-state-selected:hover,.affiliates-container .affiliates-inner-container .k-grid tr:hover{background-color:inherit!important;color:inherit!important}.affiliates-container .affiliates-inner-container .partner-details ul{padding:0}.affiliates-container .affiliates-inner-container .partner-details ul li{list-style:none;margin:10px 0}.affiliates-container .affiliates-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.affiliates-container .affiliates-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.affiliates-container .affiliates-inner-container .grid-container .affiliates-grid{margin-top:.5rem;margin-left:.5rem}.affiliates-container .affiliates-inner-container .grid-container .affiliates-grid .col-name .cell{display:flex;align-items:center}.affiliates-container .affiliates-inner-container .grid-container .affiliates-grid .col-name .cell .image-container{width:2rem}.affiliates-container .affiliates-inner-container .grid-container .affiliates-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.affiliates-container .affiliates-inner-container .grid-container .affiliates-grid .k-grid-norecords{margin-top:20rem}.affiliates-container .affiliates-inner-container .grid-container .affiliates-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vouches = __webpack_require__(868);
	
	var _vouches2 = _interopRequireDefault(_vouches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vouchesModule = _angular2.default.module('app.containers.vouches', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('vouches', {
	    url: '/vouches',
	    template: '<vouches></vouches>'
	  });
	}]).component('vouches', _vouches2.default);
	
	exports.default = vouchesModule;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vouches = __webpack_require__(869);
	
	var _vouches2 = _interopRequireDefault(_vouches);
	
	var _vouches3 = __webpack_require__(870);
	
	var _vouches4 = _interopRequireDefault(_vouches3);
	
	__webpack_require__(871);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vouchComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vouches2.default,
	  controller: _vouches4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = vouchComponent;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"vouches-container\">\r\n  <div class=\"vouches-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <vouches-filter apply-filters=\"vm.applyFilters()\"></vouches-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"vouches-match\">{{vm.vouchesMatchCount ? vm.vouchesMatchCount + \" vouches match\" : \"\"}}</div>\r\n      <div class=\"vouches-grid\">\r\n        <div id=\"vouches-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n  <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n    <p>\r\n      <!-- <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Visa Class: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n          data-bind=\"value: visaClass\" validationMessage=\"Enter visa class\" name=\"Visa class\"/>\r\n      </div> -->\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Status: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\"\r\n          kendo-dropdownlist\r\n          k-options=\"vm.vouchStatusOptions\"\r\n          data-bind=\"value: status\"\r\n          validationMessage=\"Select status\" name=\"check Status\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Feedback: </span>\r\n        <textarea rows=\"5\" k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n          data-bind=\"value: whatWouldYouLikeToSay\" validationMessage=\"Feedback\" name=\"Feedback\"/>\r\n      </div>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Notes: </span>\r\n        <textarea rows=\"5\" k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n          data-bind=\"value: notes\" validationMessage=\"Notes\" name=\"Notes\"/>\r\n      </div>\r\n      <div class=\"form-item\" style=\"display: none\">\r\n        <span style=\"font-weight: bold;\">User Id: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n          data-bind=\"value: jugglerId\" validationMessage=\"Feedback\" name=\"User ID\"/>\r\n      </div>\r\n      <!-- <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Grant Date: </span>\r\n        <input k-on-change=\"dataItem.dirty=true\"\r\n          kendo-datepicker\r\n          data-bind=\"value: visaGrantDate\"\r\n          validationMessage=\"Enter grant date\" name=\"Grant Date\"/>\r\n      </div> -->\r\n    </p>\r\n  </div>\r\n</script>"

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VouchesController = function () {
	  VouchesController.$inject = ["VouchesService", "FilterService", "NotificationService", "AuthService", "$scope"];
	  function VouchesController(VouchesService, FilterService, NotificationService, AuthService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VouchesController);
	    this.vouchesService = VouchesService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.notificationService = NotificationService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(VouchesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.vouchStatusOptions = {
	        dataSource: [{ value: 1, text: "Follow-up" }, { value: 2, text: "Complete" }, { value: 3, text: "Incomplete" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.vouchesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        save: this.saveChanges.bind(this),
	        height: "90vh",
	        // toolbar: [{ name: "create", text: "Create Reference" }],
	        noRecords: {
	          template: "No References."
	        },
	        columns: [{
	          field: "helperName", title: "Helper Name", filterable: false, attributes: { "class": "col-name" }, width: "4rem",
	          template: function template(dataItem) {
	            return "<a class=\"cell\" href=\"/users/" + dataItem.jugglerId + "\"><span>" + dataItem.helperName + "</span></a>";
	          }
	        }, { field: "fullName", title: "Voucher", filterable: false, width: "4rem" }, { field: "interestedInAuPairJobs", title: "Is Au Pair?", filterable: false, width: "2rem", template: function template(dataItem) {
	            return "" + (dataItem.interestedInAuPairJobs ? 'Yes' : 'No');
	          } }, { field: "status", title: "Status", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getVouchStatus(dataItem.status);
	          } }, { field: "referenceType", title: "Type", filterable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getVouchReferenceType(dataItem.referenceType, dataItem.otherReferenceType);
	          } }, { field: "email", title: "Email", filterable: false, width: "6rem" }, { field: "phoneNumber", title: "Phone Number", filterable: false, width: "6rem" }, { field: "submissionDate", title: "Submission Date", filterable: false, width: "4rem", template: "#= submissionDate ? kendo.toString(new Date(submissionDate), 'dd-MM-yyyy') : '-' #" }, { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Vouch" },
	          template: kendo.template($("#popup-editor").html())
	        }
	      };
	    }
	  }, {
	    key: "saveChanges",
	    value: function saveChanges(e) {
	      var status = e.model;
	
	      if (status.status == 2 && (!status.whatWouldYouLikeToSay || !status.jugglerId)) {
	        this.notificationService.error("Check missing fields and try again.");
	        e.preventDefault();
	      }
	    }
	  }, {
	    key: "_getVouchStatus",
	    value: function _getVouchStatus(status) {
	      switch (status) {
	        case _constants2.default.vouchStatus.PENDING:
	          return "Follow-up";
	        case _constants2.default.vouchStatus.APPROVED:
	          return "Complete";
	        case _constants2.default.vouchStatus.CANCELLED:
	          return "Incomplete";
	        case _constants2.default.vouchStatus.EXPIRED:
	          return "Expired";
	        case _constants2.default.vouchStatus.NONE:
	          return "-";
	      }
	    }
	  }, {
	    key: "_getVouchReferenceType",
	    value: function _getVouchReferenceType(status, otherReferenceType) {
	      switch (status) {
	        case _constants2.default.vouchReferenceType.FAMILY:
	          return "Family";
	        case _constants2.default.vouchReferenceType.CHILDCAREEMPLOYMENT:
	          return "Childcare Employment";
	        case _constants2.default.vouchReferenceType.NONCHILDCAREEMPLOYMENT:
	          return "Non-childcare Employment";
	        case _constants2.default.vouchReferenceType.OTHER:
	          return "Other (" + otherReferenceType + ")";
	        case _constants2.default.vouchReferenceType.JUGGLESTREET:
	          return "Juggle Street";
	        case _constants2.default.vouchReferenceType.UNSPECIFIED:
	          return "-";
	      }
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.vouchesMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }]);
	  return VouchesController;
	}();
	
	exports.default = VouchesController;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(872);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./vouches.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./vouches.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.vouches-container{display:flex;flex-direction:column;height:100vh}.vouches-container .vouches-inner-container{height:100%;display:flex}.vouches-container .vouches-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.vouches-container .vouches-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.vouches-container .vouches-inner-container .grid-container .vouches-grid{margin-top:.5rem;margin-left:.5rem}.vouches-container .vouches-inner-container .grid-container .vouches-grid .col-name .cell{display:flex;align-items:center}.vouches-container .vouches-inner-container .grid-container .vouches-grid .col-name .cell .image-container{width:2rem}.vouches-container .vouches-inner-container .grid-container .vouches-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.vouches-container .vouches-inner-container .grid-container .vouches-grid .k-grid-norecords{margin-top:20rem}.vouches-container .vouches-inner-container .grid-container .vouches-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _analytics = __webpack_require__(874);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsModule = _angular2.default.module('app.containers.analytics', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('analytics', {
	    url: '/analytics',
	    template: '<analytics></analytics>'
	  });
	}]).component('analytics', _analytics2.default);
	
	exports.default = analyticsModule;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analytics = __webpack_require__(875);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _analytics3 = __webpack_require__(876);
	
	var _analytics4 = _interopRequireDefault(_analytics3);
	
	__webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _analytics2.default,
	  controller: _analytics4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = analyticsComponent;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"analytics-container\" style=\"background-color: #eaeaec\">\r\n  <div class=\"analytics-inner-container\">\r\n    <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n    </div>    \r\n    <div class=\"revenue-chart-container\" ng-if=\"!vm.isLoading\">\r\n       <div kendo-tab-strip>\r\n              <ul>                \r\n                <li class=\"k-state-active\">Acquisition Funnels</li>\r\n                <li>Registrations</li>\r\n                <li>Approvals & Redemptions</li>\r\n                <li>Revenue at a Glance</li>\r\n                <li>Revenue Breakdown</li>\r\n                <li>Job Trends</li>\r\n                <li>Bot Insights</li>                \r\n                <li>Business Modelling</li>\r\n              </ul>\r\n          \r\n              <div style=\"padding: 1em; background-color: #eaeaec\">                \r\n                <div kendo-chart k-options=\"vm.clientJourneyOptions\" style=\"width: 500px; height: 350px; padding: 20px\"></div>\r\n                <div kendo-chart k-options=\"vm.providerJourneyOptions\" style=\"width: 500px; height: 350px; padding: 20px\"></div>  \r\n              </div>\r\n\r\n              <div style=\"padding: 1em; background-color: #eaeaec\">\r\n                <div id=\"registrations-over-time-chart\" kendo-chart k-options=\"vm.registrationsOverTimeOptions\"></div>      \r\n                <div kendo-chart k-options=\"vm.registrationsByRegionOverTimeOptions\"></div>      \r\n                <div id=\"recent-registrations-chart\" kendo-chart k-options=\"vm.recentRegistrationsOptions\"></div>     \r\n                <div>\r\n                  <div kendo-chart k-options=\"vm.registrationsByDeviceOptions\" style=\"float: left; width: 500px; height: 350px; padding: 5px\"></div>      \r\n                  <div kendo-chart k-options=\"vm.parentRegistrationsByDeviceOptions\" style=\"float: left; width: 500px; height: 350px; padding: 5px\"></div>      \r\n                  <div kendo-chart k-options=\"vm.helperRegistrationsByDeviceOptions\" style=\"float: left; width: 500px; height: 350px\"></div> \r\n                  <div style=\"clear:both\"></div>\r\n                </div>                \r\n              </div>              \r\n\r\n              <div style=\"padding: 1em; background-color: #eaeaec\">\r\n                <div id=\"account-approval-over-time\" kendo-chart k-options=\"vm.accountApprovalOverTimeOptions\" style=\"height: 600px\"></div>\r\n                <div style=\"margin: auto; max-width: 1000px\">              \r\n                  <div kendo-chart k-options=\"vm.clientProfileItemsPerYearOptions\" style=\"float: left; width: 450px; height: 350px; padding: 20px\"></div>\r\n                  <div kendo-chart k-options=\"vm.providerProfileItemsPerYearOptions\" style=\"float: left; width: 450px; height: 350px; padding: 20px\"></div>  \r\n                  <div style=\"clear:both\"/>     \r\n                </div>     \r\n                <div kendo-chart k-options=\"vm.redemptionsBySourceOptions\" style=\"height: 400px\"></div>      \r\n                <div id=\"customer-redemptions-and-paying-customers-over-time\" kendo-chart k-options=\"vm.redemptionsAndNewPayingCustomersOverTimeOptions\"></div>                      \r\n              </div>\r\n          \r\n              <div style=\"padding: 1em; background-color: #eaeaec\">     \r\n                <div>\r\n                  <div kendo-chart k-options=\"vm.revenueAtGlanceOptions\" style=\"float: left; width: 500px; height: 350px; padding: 5px\"></div>      \r\n                  <div kendo-chart k-options=\"vm.revenueByFrequencyOptions\" style=\"float: left; width: 500px; height: 350px; padding: 5px\"></div>      \r\n                  <div kendo-chart k-options=\"vm.revenueBySourceOptions\" style=\"float: left; width: 500px; height: 350px\"></div> \r\n                  <div style=\"clear:both\"></div>\r\n                </div>\r\n              </div>\r\n\r\n              <div style=\"padding: 1em; background-color: #eaeaec\">\r\n                <div kendo-chart k-options=\"vm.jobValueOverTimeChartOptions\" style=\"height: 500px\"></div>\r\n                <div id=\"total-revenue-chart\" kendo-chart k-options=\"vm.totalRevenueChartOptions\" style=\"height: 600px\"></div>\r\n                <div id=\"new-vs-recurring-revenue-chart\" kendo-chart k-options=\"vm.newVersusRecurringRevenueOptions\"></div>\r\n                <div kendo-chart k-options=\"vm.newVersusRecurringQuarterlyRevenueOptions\"></div>\r\n                <div kendo-chart k-options=\"vm.newVersusRecurringAnnualRevenueOptions\"></div>                \r\n                \r\n                <!--<div id=\"payg-revenue-chart\" kendo-chart k-options=\"vm.paygChartOptions\"></div>\r\n                <div id=\"plans-revenue-chart\" kendo-chart k-options=\"vm.plansChartOptions\"></div>-->                      \r\n              </div>\r\n\r\n              <div style=\"padding: 1em; background-color: #eaeaec\">\r\n                <div style=\"margin: auto; max-width: 1200px\">              \r\n                  <div kendo-chart k-options=\"vm.jobDistributionOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>\r\n                  <div kendo-chart k-options=\"vm.jobsByDeviceOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>  \r\n                  <div style=\"clear:both\"/>     \r\n                </div>                     \r\n                <div id=\"jobs-success-rate-chart\" kendo-chart k-options=\"vm.jobsSuccessRateoptions\"></div>            \r\n              </div>       \r\n              \r\n              <div style=\"padding: 1em; background-color: #eaeaec\">\r\n                <div kendo-chart k-options=\"vm.botEventsOptions\" style=\"width: 700px; height: 500px; padding: 5px\"></div>    \r\n              </div>   \r\n\r\n              <div style=\"padding: 1em; background-color: #eaeaec\">               \r\n                <h4 style=\"margin: 10px 0\">New Registrations</h4> \r\n                <div kendo-grid k-options=\"vm.registrationsOverTimeGridOptions\"></div> \r\n\r\n                <h4 style=\"margin: 10px 0\">Approvals and Redemptions</h4> \r\n                <div kendo-grid k-options=\"vm.approvalsAndRedemptionsOverTimeGridOptions\"></div> \r\n\r\n                <h4 style=\"margin: 10px 0\">Redemptions</h4> \r\n                <div kendo-grid k-options=\"vm.redemptionsGridOptions\"></div>                 \r\n\r\n                <h4 style=\"margin: 10px 0\">First Time Paying Customers</h4>\r\n                <div kendo-grid k-options=\"vm.firstTimePayingCustomersGridOptions\"></div>\r\n\r\n                <h4 style=\"margin: 10px 0\">Renewing Customers</h4>\r\n                <div kendo-grid k-options=\"vm.recurringPayingCustomersGridOptions\"></div>\r\n\r\n                <h4 style=\"margin: 10px 0\">New QS Customers</h4>\r\n                <div kendo-grid k-options=\"vm.firstTimeQSPayingCustomersGridOptions\"></div>                \r\n\r\n                <h4 style=\"margin: 10px 0\">New AS Customers</h4>\r\n                <div kendo-grid k-options=\"vm.firstTimeASPayingCustomersGridOptions\"></div>                                \r\n              </div>                                         \r\n            </div>                        \r\n        </div>                  \r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(877);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsController = function () {
	  AnalyticsController.$inject = ["AnalyticsService", "$q"];
	  function AnalyticsController(AnalyticsService, $q) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AnalyticsController);
	    this.analyticsService = AnalyticsService;
	    this.$q = $q;
	  }
	
	  (0, _createClass3.default)(AnalyticsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.isLoading = true;
	
	      var revenuePromise = this.analyticsService.getRevenueData();
	      var payingCustomersPromise = this.analyticsService.getPayingCustomersData();
	      var jobsSuccessRatePromise = this.analyticsService.getJobsSuccessRateData();
	      var registrationsOvertimePromise = this.analyticsService.getRegistrationsOverTimeData();
	      var recentRegistrationsPromise = this.analyticsService.getRecentRegistrationsData();
	      var customerRedemptionsOverTimePromise = this.analyticsService.getCustomerRedemptionsOverTime();
	      var accountApprovalOverTimePromise = this.analyticsService.getAccountApprovalOverTime();
	      var newVersusRecurringRevenuePromise = this.analyticsService.getNewVersusRecurringRevenueData();
	      var getGeneralStatsPromise = this.analyticsService.getGeneralStatsData();
	      var clientProfileItemsPerYearPromise = this.analyticsService.getClientProfileItemsPerYearData();
	      var providerProfileItemsPerYearPromise = this.analyticsService.getProviderProfileItemsPerYearData();
	      var getNSWRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getNSWRegistrationsByRegionOverTimeData();
	      var getVICRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getVICRegistrationsByRegionOverTimeData();
	      var getJobValueOverTimePromise = this.analyticsService.getJobValueOverTimeData();
	      var getBotStatsPromise = this.analyticsService.getBotStatsData();
	      var getDataSetsPromise = this.analyticsService.getDataSets();
	
	      this.$q.all([revenuePromise, payingCustomersPromise, jobsSuccessRatePromise, registrationsOvertimePromise, recentRegistrationsPromise, customerRedemptionsOverTimePromise, accountApprovalOverTimePromise, newVersusRecurringRevenuePromise, getGeneralStatsPromise, clientProfileItemsPerYearPromise, providerProfileItemsPerYearPromise, getNSWRegistrationsByRegionOverTimeDataPromise, getVICRegistrationsByRegionOverTimeDataPromise, getJobValueOverTimePromise, getBotStatsPromise, getDataSetsPromise]).then(function (data) {
	        var _data = (0, _slicedToArray3.default)(data, 16),
	            revenueResponse = _data[0],
	            payingCustomersResponse = _data[1],
	            jobsSuccessRateResponse = _data[2],
	            registrationsOvertimeResponse = _data[3],
	            recentRegistrationsResponse = _data[4],
	            customerRedemptionsOverTimeResponse = _data[5],
	            accountApprovalOverTimeResponse = _data[6],
	            newVersusRecurringRevenueResponse = _data[7],
	            getGeneralStatsResponse = _data[8],
	            clientProfileItemsPerYearResponse = _data[9],
	            providerProfileItemsPerYearResponse = _data[10],
	            getNSWRegistrationsByRegionOverTimeDataResponse = _data[11],
	            getVICRegistrationsByRegionOverTimeDataResponse = _data[12],
	            getJobValueOverTimeResponse = _data[13],
	            getBotStatsResponse = _data[14],
	            getdataSetsResponse = _data[15];
	
	        _this.setRevenueChartOptions(revenueResponse);
	
	        _this.setJobValueOverTimeOptions(getJobValueOverTimeResponse);
	
	        _this.setJobsSuccessRateChartOptions(jobsSuccessRateResponse);
	
	        _this.setRegistrationsOverTimeChartOptions(registrationsOvertimeResponse);
	
	        _this.setRecentRegistrationsChartOptions(recentRegistrationsResponse);
	
	        //this.setCustomerRedemptionsOverTimeChartOptions(customerRedemptionsOverTimeResponse);
	
	        //this.setPayingCustomersChartOptions(payingCustomersResponse);
	
	        _this.setRedemptionsAndNewPayingCustomersOverTimeOptions(payingCustomersResponse, customerRedemptionsOverTimeResponse);
	
	        _this.setAccountApprovalOverTimeOptions(accountApprovalOverTimeResponse);
	
	        _this.setNewVersusRecurringRevenueOptions(newVersusRecurringRevenueResponse);
	
	        _this.setGeneralStatsOptions(getGeneralStatsResponse);
	
	        _this.setBotStatsOptions(getBotStatsResponse);
	
	        _this.setClientProfileItemsPerYearOptions(clientProfileItemsPerYearResponse);
	
	        _this.setProviderProfileItemsPerYearOptions(providerProfileItemsPerYearResponse);
	
	        _this.setRegistrationsByRegionOverTimeChartOptions(getNSWRegistrationsByRegionOverTimeDataResponse, getVICRegistrationsByRegionOverTimeDataResponse);
	
	        _this.setDataSetsOptions(getdataSetsResponse);
	
	        _this.isLoading = false;
	      });
	    }
	  }, {
	    key: "setRevenueChartOptions",
	    value: function setRevenueChartOptions(data) {
	      var format = "{0:C}";
	      var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	      var dateFormat = { months: "MMM 'yy" };
	
	      var totalRevenueSeries = [];
	      totalRevenueSeries.push(data.series[0]);
	      totalRevenueSeries.push(data.series[2]);
	      totalRevenueSeries.push(data.series[3]);
	      totalRevenueSeries.push(data.series[1]);
	
	      this.totalRevenueChartOptions = this.analyticsService.getChartOptions("Revenue Breakdown", totalRevenueSeries, data.categories, format, template, dateFormat);
	
	      // var paygSeries = [];
	      // paygSeries.push(data.series[2]);
	      // paygSeries.push(data.series[3]);
	
	      // this.paygChartOptions = this.getChartOptions("PAYG Revenue", paygSeries, data.categories, format, template, dateFormat);
	
	      // var plansSeries = [];
	      // plansSeries.push(data.series[4]);
	      // plansSeries.push(data.series[5]);
	
	      // this.plansChartOptions = this.getChartOptions("Plans Revenue", plansSeries, data.categories, format, template, dateFormat);
	    }
	  }, {
	    key: "setJobValueOverTimeOptions",
	    value: function setJobValueOverTimeOptions(data) {
	      var format = "{0:C}";
	      var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	      var dateFormat = { months: "MMM 'yy" };
	
	      this.jobValueOverTimeChartOptions = this.analyticsService.getChartOptions("Total Jobs Value", data.series, data.categories, format, template, dateFormat);
	    }
	  }, {
	    key: "setNewVersusRecurringRevenueOptions",
	    value: function setNewVersusRecurringRevenueOptions(data) {
	      var format = "{0:C}";
	      var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	      var dateFormat = { months: "MMM 'yy" };
	
	      var totalRevenueSeries = [];
	      totalRevenueSeries.push(data.series[0]);
	      totalRevenueSeries.push(data.series[1]);
	      totalRevenueSeries.push(data.series[2]);
	
	      var quarterlyRevenueSeries = [];
	      quarterlyRevenueSeries.push(data.series[3]);
	      quarterlyRevenueSeries.push(data.series[4]);
	      quarterlyRevenueSeries.push(data.series[5]);
	
	      var annualRevenueSeries = [];
	      annualRevenueSeries.push(data.series[6]);
	      annualRevenueSeries.push(data.series[7]);
	      annualRevenueSeries.push(data.series[8]);
	
	      this.newVersusRecurringRevenueOptions = this.analyticsService.getChartOptions("New vs Recurring Revenue", totalRevenueSeries, data.categories, format, template, dateFormat);
	
	      this.newVersusRecurringQuarterlyRevenueOptions = this.analyticsService.getChartOptions("Quarterly Subscriptions - New vs Recurring Revenue", quarterlyRevenueSeries, data.categories, format, template, dateFormat);
	      this.newVersusRecurringAnnualRevenueOptions = this.analyticsService.getChartOptions("Annual Subscriptions - New vs Recurring Revenue", annualRevenueSeries, data.categories, format, template, dateFormat);
	    }
	
	    // setCustomerRedemptionsOverTimeChartOptions(data) {
	    //   var format = "{0}";
	    //   var template = "#: text # - Customers: #: series.totalCount #";
	    //   var dateFormat = {months: "MMM 'yy"};
	
	    //   this.customerRedemptionsOverTimeOptions = this.getChartOptions("$7.50 Redemptions", data.series, data.categories, format, template, dateFormat);
	    // }
	
	    // setPayingCustomersChartOptions(data) {
	    //   var format = "{0}";
	    //   var template = "#: text # - Customers: #: series.totalCount #";
	    //   var dateFormat = {months: "MMM 'yy"};
	
	    //   this.payingCustomersOptions = this.getChartOptions("New Paying Customers", data.series, data.categories, format, template, dateFormat);
	    // }
	
	  }, {
	    key: "setRedemptionsAndNewPayingCustomersOverTimeOptions",
	    value: function setRedemptionsAndNewPayingCustomersOverTimeOptions(redemptions, newPayingCustomers) {
	      var format = "{0}";
	      var template = "#: text # - Customers: #: series.totalCount #";
	      var dateFormat = { months: "MMM 'yy" };
	
	      var series = [];
	      series.push(newPayingCustomers.series[0]);
	      series.push(redemptions.series[0]);
	
	      this.redemptionsAndNewPayingCustomersOverTimeOptions = this.analyticsService.getChartOptions("Redemptions & New Paying Customers", series, redemptions.categories, format, template, dateFormat);
	    }
	  }, {
	    key: "setRegistrationsOverTimeChartOptions",
	    value: function setRegistrationsOverTimeChartOptions(data) {
	      var format = "{0}";
	      var template = "#: text #: #: series.totalCount #";
	      var dateFormat = { months: "MMM 'yy" };
	
	      this.registrationsOverTimeOptions = this.analyticsService.getChartOptions("Registrations Over Time", data.series, data.categories, format, template, dateFormat);
	    }
	  }, {
	    key: "setDataSetsOptions",
	    value: function setDataSetsOptions(set) {
	      this.registrationsOverTimeGridOptions = this.analyticsService.getGridOptions(set[0]);
	      this.approvalsAndRedemptionsOverTimeGridOptions = this.analyticsService.getGridOptions(set[1]);
	      this.firstTimePayingCustomersGridOptions = this.analyticsService.getGridOptions(set[2]);
	      this.recurringPayingCustomersGridOptions = this.analyticsService.getGridOptions(set[3]);
	      this.firstTimeQSPayingCustomersGridOptions = this.analyticsService.getGridOptions(set[4]);
	      this.firstTimeASPayingCustomersGridOptions = this.analyticsService.getGridOptions(set[5]);
	      this.redemptionsGridOptions = this.analyticsService.getGridOptions(set[6]);
	    }
	  }, {
	    key: "setRegistrationsByRegionOverTimeChartOptions",
	    value: function setRegistrationsByRegionOverTimeChartOptions(nswData, vicData) {
	      var format = "{0}";
	      var template = "#: text #: #: series.totalCount #";
	      var dateFormat = { months: "MMM 'yy" };
	
	      this.nswRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("NSW Registrations By Region", nswData.series, nswData.categories, format, template, dateFormat);
	      this.vicRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("VIC Registrations By Region", vicData.series, vicData.categories, format, template, dateFormat);
	    }
	  }, {
	    key: "setRecentRegistrationsChartOptions",
	    value: function setRecentRegistrationsChartOptions(data) {
	      var format = "{0}";
	      var template = "#: text #: #: series.totalCount #";
	      var dateFormat = { days: "ddd dd" };
	
	      this.recentRegistrationsOptions = this.analyticsService.getChartOptions("Recent Registrations", data.series, data.categories, format, template, dateFormat, null, "days");
	    }
	  }, {
	    key: "setAccountApprovalOverTimeOptions",
	    value: function setAccountApprovalOverTimeOptions(data) {
	      var format = "{0}";
	      var template = "#: text #: #: series.totalCount #";
	      var dateFormat = { days: "ddd dd" };
	
	      var parsedCats = data.categories.map(function (item) {
	        return kendo.toString(new Date(item), "yy-MM");
	      });
	      var tooltipTemplate = function tooltipTemplate(e) {
	        var idx = parsedCats.indexOf(kendo.toString(e.category, "yy-MM"));
	
	        var activeSeries = data.series[e.series.index];
	        var relatedSeries;
	        if (e.series.index < 2) relatedSeries = data.series[e.series.index == 0 ? 1 : 0];else relatedSeries = data.series[e.series.index == 2 ? 3 : 2];
	        var relatedItem = relatedSeries.data[idx];
	        var total = e.dataItem.value + relatedItem;
	
	        var ratio = kendo.toString(e.dataItem.value / total, "p");
	        return ratio;
	      };
	
	      this.accountApprovalOverTimeOptions = this.analyticsService.getChartOptions("Pending vs Approved Accounts", data.series, data.categories, format, template, dateFormat, tooltipTemplate);
	    }
	  }, {
	    key: "setJobsSuccessRateChartOptions",
	    value: function setJobsSuccessRateChartOptions(data) {
	      var format = "{0:p0}";
	      var template = "#: text #";
	      var dateFormat = { months: "MMM 'yy" };
	
	      this.jobsSuccessRateoptions = this.analyticsService.getChartOptions("Jobs Success Rate", data.series, data.categories, format, template, dateFormat);
	    }
	  }, {
	    key: "setGeneralStatsOptions",
	    value: function setGeneralStatsOptions(data) {
	      var clientJourneySet = data.series[0];
	      this.clientJourneyOptions = this.analyticsService.getFunnelChartOptions(clientJourneySet.name, clientJourneySet.data);
	
	      var providerJourneySet = data.series[1];
	      this.providerJourneyOptions = this.analyticsService.getFunnelChartOptions(providerJourneySet.name, providerJourneySet.data);
	
	      var revenueAtGlanceSet = data.series[2];
	      var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueAtGlanceSet.name, revenueAtGlanceSet.totalCount, revenueAtGlanceSet.totalRevenue);
	      var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
	      this.revenueAtGlanceOptions = this.analyticsService.getDonutChartOptions(revenueAtGlanceSet, titleFormat, labelFormat);
	
	      var revenueByFrequencySet = data.series[4];
	      var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueByFrequencySet.name, revenueByFrequencySet.totalCount, revenueByFrequencySet.totalRevenue);
	      var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
	      this.revenueByFrequencyOptions = this.analyticsService.getDonutChartOptions(revenueByFrequencySet, titleFormat, labelFormat);
	
	      var jobDistributionSet = data.series[3];
	      titleFormat = kendo.format("{0} - TRX: {1}", jobDistributionSet.name, jobDistributionSet.totalCount);
	      labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Jobs', dataItem.value)#";
	      this.jobDistributionOptions = this.analyticsService.getDonutChartOptions(jobDistributionSet, titleFormat, labelFormat);
	
	      var revenueBySourceSet = data.series[5];
	      titleFormat = kendo.format("{0} - Parents: {1}", revenueBySourceSet.name, revenueBySourceSet.totalCount);
	      labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Parents', dataItem.value)#";
	      this.revenueBySourceOptions = this.analyticsService.getDonutChartOptions(revenueBySourceSet, titleFormat, labelFormat);
	
	      var redemptionsBySourceSet = data.series[6];
	      titleFormat = kendo.format("{0} - Redemptions: {1}", redemptionsBySourceSet.name, redemptionsBySourceSet.totalCount);
	      labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Redemptions', dataItem.value)#";
	      this.redemptionsBySourceOptions = this.analyticsService.getDonutChartOptions(redemptionsBySourceSet, titleFormat, labelFormat);
	
	      var jobsByDeviceSet = data.series[7];
	      titleFormat = kendo.format("{0} - TRX: {1}", jobsByDeviceSet.name, jobsByDeviceSet.totalCount);
	      labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Jobs', dataItem.value)#";
	      this.jobsByDeviceOptions = this.analyticsService.getDonutChartOptions(jobsByDeviceSet, titleFormat, labelFormat);
	
	      var registrationsByDeviceSet = data.series[8];
	      titleFormat = kendo.format("{0} - Registrations: {1}", registrationsByDeviceSet.name, registrationsByDeviceSet.totalCount);
	      labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Registrations', dataItem.value)#";
	      this.registrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(registrationsByDeviceSet, titleFormat, labelFormat);
	
	      var parentRegistrationsByDeviceSet = data.series[9];
	      titleFormat = kendo.format("{0} - Registrations: {1}", parentRegistrationsByDeviceSet.name, parentRegistrationsByDeviceSet.totalCount);
	      labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Registrations', dataItem.value)#";
	      this.parentRegistrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(parentRegistrationsByDeviceSet, titleFormat, labelFormat);
	
	      var helperRegistrationsByDeviceSet = data.series[10];
	      titleFormat = kendo.format("{0} - Registrations: {1}", helperRegistrationsByDeviceSet.name, helperRegistrationsByDeviceSet.totalCount);
	      labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Registrations', dataItem.value)#";
	      this.helperRegistrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(helperRegistrationsByDeviceSet, titleFormat, labelFormat);
	    }
	  }, {
	    key: "setBotStatsOptions",
	    value: function setBotStatsOptions(data) {
	      var eventStats = data.series[0];
	      var titleFormat = kendo.format("{0} - Events: {1}", eventStats.name, eventStats.totalCount);
	      var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Events', dataItem.value)#";
	      this.botEventsOptions = this.analyticsService.getDonutChartOptions(eventStats, titleFormat, labelFormat);
	    }
	  }, {
	    key: "setClientProfileItemsPerYearOptions",
	    value: function setClientProfileItemsPerYearOptions(data) {
	      this.clientProfileItemsPerYearOptions = this.analyticsService.getColumnChartOptions("Missing Items in Parent Accounts ", data);
	    }
	  }, {
	    key: "setProviderProfileItemsPerYearOptions",
	    value: function setProviderProfileItemsPerYearOptions(data) {
	      this.providerProfileItemsPerYearOptions = this.analyticsService.getColumnChartOptions("Missing Items in Helper Accounts ", data);
	    }
	  }]);
	  return AnalyticsController;
	}();
	
	exports.default = AnalyticsController;

/***/ },
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(885);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.analytics-container{display:flex;flex-direction:column;height:100vh}.analytics-container .analytics-inner-container{margin-left:4rem}", ""]);
	
	// exports


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobs = __webpack_require__(887);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsModule = _angular2.default.module('app.containers.jobs', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('jobs', {
	    url: '/jobs',
	    template: '<jobs></jobs>'
	  });
	}]).component('jobs', _jobs2.default);
	
	exports.default = jobsModule;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobs = __webpack_require__(888);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _jobs3 = __webpack_require__(889);
	
	var _jobs4 = _interopRequireDefault(_jobs3);
	
	__webpack_require__(890);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _jobs2.default,
	  controller: _jobs4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = jobsComponent;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"jobs-container\">\r\n  <div class=\"jobs-inner-container\">    \r\n    <div class=\"filters-container\">\r\n      <jobs-filter apply-filters=\"vm.applyFilters()\"></jobs-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"jobs-match\">{{vm.jobsMatchCount ? vm.jobsMatchCount + \" jobs match\" : \"\"}}</div>\r\n      <div class=\"jobs-grid\">\r\n        <div id=\"jobs-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobsController = function () {
	  JobsController.$inject = ["JobsService", "FilterService", "AuthService", "$scope"];
	  function JobsController(JobsService, FilterService, AuthService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, JobsController);
	    this.jobsService = JobsService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(JobsController, [{
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.jobsService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          template: "No match found. Change your filter criteria."
	        },
	        columns: [{
	          field: "postDate", title: "Posted On", filterable: false, width: "4rem",
	          template: "<span>#= kendo.toString(new Date(postDate), 'dd-MM-yyyy') #</span>"
	        }, { field: "jobType", title: "Job Type", filterable: false, sortable: false, width: "8rem", template: function template(dataItem) {
	            return "" + _this._getJobTypeText(dataItem.jobType);
	          } }, { field: "jobReference", title: "Job Reference", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return _this._getJobReferenceCell(dataItem);
	          } }, { field: "jobStatus", title: "Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getJobStatusText(dataItem.jobStatus);
	          } }, { field: "totalInvites", title: "Helper Stats", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getHelperStats(dataItem);
	          } }, { field: "totalInvites", title: "Open Rate", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getOpenRate(dataItem);
	          } }, { field: "managedBy", title: "Mgmt", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getManagedByText(dataItem.managedBy);
	          } }, { field: "estimatedJobValue", title: "Job Value", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return kendo.toString(dataItem.estimatedJobValue, 'c0');
	          } }, {
	          field: "ownerFullName", title: "Job Owner", filterable: false, sortable: false, width: "8rem",
	          template: "<a class=\"cell\" href=\"#= '/users/' + ownerUserId #\">#= ownerFullName #</a>"
	        }, {
	          field: "addressState", title: "State", filterable: false, width: "4rem",
	          template: "<span>#= (country === 'au' ? addressState.toUpperCase() : addressState) #</span>"
	        },
	        // {
	        //   field: "ownerUserId", title: "User Id", filterable: false, sortable: false,width: "4rem",
	        // },
	        {
	          field: "jobDate", title: "Start Date", filterable: false, width: "4rem",
	          template: "<span>#= kendo.toString(new Date(jobDate), 'dd-MM-yyyy') #</span>"
	        },
	        // {
	        //   field: "jobFinishDate", title: "Finish Date", filterable: false, sortable: false, width: "4rem",
	        //   template: `<span>#= jobType != 1 ? kendo.toString(new Date(jobFinishDate), 'dd-MM-yyyy') : "-" #</span>`,
	        // },
	        {
	          field: "expirationDate", title: "Expiry Date", filterable: false, sortable: false, width: "4rem",
	          template: "<span>#= kendo.toString(new Date(expirationDate), 'dd-MM-yyyy') #</span>"
	        }, { field: "ownerNumberOfPostedJobs", title: "# Jobs", filterable: false, sortable: false, width: "5rem" }]
	      };
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.jobsMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	
	    // Links always use the internal ID; only the label shows the user-facing reference.
	
	  }, {
	    key: "_getJobReferenceCell",
	    value: function _getJobReferenceCell(dataItem) {
	      var reference = kendo.htmlEncode(dataItem.jobReference || String(dataItem.id));
	      var cell = "<a class=\"cell\" href=\"/jobs/" + dataItem.id + "\">" + reference + "</a>";
	
	      if (dataItem.isRepost && dataItem.relatedJobId) {
	        var originalReference = kendo.htmlEncode(dataItem.relatedJobReference || String(dataItem.relatedJobId));
	        cell += "<div class=\"repost-of\">Repost of <a class=\"cell\" href=\"/jobs/" + dataItem.relatedJobId + "\">" + originalReference + "</a></div>";
	      }
	
	      return cell;
	    }
	  }, {
	    key: "_getHelperStats",
	    value: function _getHelperStats(dataItem) {
	      return dataItem.activeInvites + " / " + dataItem.totalInvites;
	    }
	  }, {
	    key: "_getOpenRate",
	    value: function _getOpenRate(dataItem) {
	      var activity = dataItem.activeInvites + " / " + dataItem.totalInvites;
	      var openRate = dataItem.activeInvites / dataItem.totalInvites;
	      return kendo.format('{0:p0}', openRate);
	    }
	  }, {
	    key: "_getJobTypeText",
	    value: function _getJobTypeText(type) {
	      switch (type) {
	        case _constants2.default.jobType.BABYSITTING:
	          return "Babysitting";
	        case _constants2.default.jobType.NANNYING:
	          return "Nannying";
	        case _constants2.default.jobType.AFTER_SCHOOL_CARE:
	          return "After School Care";
	        case _constants2.default.jobType.BEFORE_SCHOOL_CARE:
	          return "Before School Care";
	        case _constants2.default.jobType.BEFORE_AFTER_SCHOOL_CARE:
	          return "Before/After School Care";
	        case _constants2.default.jobType.AU_PAIR:
	          return "Au Pair";
	        case _constants2.default.jobType.PRIMARY_SCHOOL_TUTORING:
	          return "Primary School Tutoring";
	        case _constants2.default.jobType.HIGH_SCHOOL_TUTORING:
	          return "High School Tutoring";
	        case _constants2.default.jobType.ONE_OFF_ODD_JOBS:
	          return "Odd Job";
	      }
	    }
	  }, {
	    key: "_getJobStatusText",
	    value: function _getJobStatusText(status) {
	      switch (status) {
	        case _constants2.default.jobStatus.PENDING:
	          return "Pending";
	        case _constants2.default.jobStatus.AWARDED:
	          return "Awarded";
	        case _constants2.default.jobStatus.CANCELLED:
	          return "Cancelled";
	        case _constants2.default.jobStatus.COMPLETED:
	          return "Completed";
	        case _constants2.default.jobStatus.FILLED:
	          return "Filled";
	        case _constants2.default.jobStatus.FILLED_AND_CANCELLED:
	          return "Filled and Closed";
	      }
	    }
	  }, {
	    key: "_getManagedByText",
	    value: function _getManagedByText(status) {
	      switch (status) {
	        case _constants2.default.managedBy.USER:
	          return "DIY";
	        case _constants2.default.managedBy.SYSTEM:
	          return "Assist";
	      }
	
	      return "";
	    }
	  }]);
	  return JobsController;
	}();
	
	exports.default = JobsController;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(891);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobs.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobs.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.jobs-container{display:flex;flex-direction:column;height:100vh}.jobs-container .jobs-inner-container{height:100%;display:flex}.jobs-container .jobs-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.jobs-container .jobs-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.jobs-container .jobs-inner-container .grid-container .jobs-grid{margin-top:.5rem;margin-left:.5rem}.jobs-container .jobs-inner-container .grid-container .jobs-grid .col-name .cell{display:flex;align-items:center}.jobs-container .jobs-inner-container .grid-container .jobs-grid .col-name .cell .image-container{width:2rem}.jobs-container .jobs-inner-container .grid-container .jobs-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.jobs-container .jobs-inner-container .grid-container .jobs-grid .repost-of{font-size:.8rem;color:#787878;white-space:nowrap}.jobs-container .jobs-inner-container .grid-container .jobs-grid .k-grid-norecords{margin-top:20rem}.jobs-container .jobs-inner-container .grid-container .jobs-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _flow = __webpack_require__(893);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flowModule = _angular2.default.module('app.flow', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('flow', {
	    url: '/flow',
	    template: '<flow></flow>'
	  });
	}]).component('flow', _flow2.default);
	
	exports.default = flowModule;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _flow = __webpack_require__(894);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _flow3 = __webpack_require__(895);
	
	var _flow4 = _interopRequireDefault(_flow3);
	
	__webpack_require__(896);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flowComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _flow2.default,
	  controller: _flow4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = flowComponent;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"flow-container\">\r\n  <!--<h2>Flow</h2>-->\r\n  <div class=\"flow-inner-container\">\r\n    <div class=\"tree-view\">\r\n      <ul kendo-tree-view k-options=\"vm.treeViewOptions\" id=\"flow-tree-view\">\r\n      </ul>\r\n    </div>\r\n    <div class=\"graph-container\">\r\n      <h2 class=\"header\">{{vm.header}}</h2>\r\n      <div id=\"graph\" class=\"graph\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FlowController = function () {
	  FlowController.$inject = ["MermaidService", "$scope"];
	  function FlowController(MermaidService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FlowController);
	    this.mermaidService = MermaidService;
	    this.$scope = $scope;
	  }
	
	  (0, _createClass3.default)(FlowController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.mermaidService.init();
	
	      this.treeViewOptions = {
	        dataSource: [{
	          text: "Flow Diagrams",
	          expanded: true,
	          items: [{
	            text: "Bot",
	            expanded: true,
	            items: [
	            // { id: c.flowDiagrams.SMS_CHANNEL, text: "SMS Channel" },
	            { id: _constants2.default.flowDiagrams.FACEBOOK_CHANNEL, text: "Helper Flow v1.1", selected: true }, { id: _constants2.default.flowDiagrams.LOCATE_HELPERS_IN_AREA_FLOW, text: "Locate Helpers In Area Flow" }, { id: _constants2.default.flowDiagrams.POST_JOB_FLOW, text: "Post Job Flow" }, { id: _constants2.default.flowDiagrams.DISPLAY_PROFILE_FLOW, text: "Display Profile Flow" }]
	          }, {
	            text: "Jobs",
	            items: [{ id: _constants2.default.flowDiagrams.BABYSITTING_JOB, text: "Babysitting Job" }, { id: _constants2.default.flowDiagrams.RECURRING_JOB, text: "Recurring Job" }]
	          }]
	        }],
	        select: function select(e) {
	          return _this.onTreeViewSelect(e);
	        }
	      };
	
	      this.renderGraph(_constants2.default.flowDiagrams.FACEBOOK_CHANNEL);
	    }
	  }, {
	    key: "onTreeViewSelect",
	    value: function onTreeViewSelect(e) {
	      var treeview = $("#flow-tree-view").data("kendoTreeView");
	      var dataItem = treeview.dataItem(e.node);
	
	      if (dataItem.id) this.renderGraph(dataItem.id);
	    }
	  }, {
	    key: "renderGraph",
	    value: function renderGraph(id) {
	      this.setHeader(id);
	      var graphData = this.mermaidService.getGraph(id);
	
	      this.mermaidService.render("graph-" + id, graphData, function (svg, bindingFunctions) {
	        document.getElementById("graph").innerHTML = svg;
	      });
	    }
	  }, {
	    key: "setHeader",
	    value: function setHeader(id) {
	      var _this2 = this;
	
	      var header = "";
	      switch (id) {
	        case _constants2.default.flowDiagrams.LOCATE_HELPERS_IN_AREA_FLOW:
	          header = "Locate Helpers in Area Flow";
	          break;
	        case _constants2.default.flowDiagrams.POST_JOB_FLOW:
	          header = "Post Job Flow";
	          break;
	        case _constants2.default.flowDiagrams.DISPLAY_PROFILE_FLOW:
	          header = "Display Profile Flow";
	          break;
	        case _constants2.default.flowDiagrams.BABYSITTING_JOB:
	          header = "Babysitting Job";
	          break;
	        case _constants2.default.flowDiagrams.RECURRING_JOB:
	          header = "Recurring Job";
	          break;
	        case _constants2.default.flowDiagrams.FACEBOOK_CHANNEL:
	          header = "Helper Flow v1.1";
	          break;
	      }
	
	      setTimeout(function () {
	        _this2.header = header;
	        _this2.$scope.$apply();
	      }, 0);
	    }
	  }]);
	  return FlowController;
	}();
	
	exports.default = FlowController;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(897);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./flow.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./flow.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	
	
	// module
	exports.push([module.id, ".flow-container .flow-inner-container{display:flex;justify-content:space-between;margin-left:4em;min-height:100vh}.flow-container .flow-inner-container .tree-view{flex-basis:18em;background:#162e3d;padding:2em 1em 0}.flow-container .flow-inner-container .tree-view .k-treeview{color:#fff}.flow-container .flow-inner-container .graph-container{flex:1}.flow-container .flow-inner-container .graph-container .header{text-align:center;padding:2em}.flow-container .flow-inner-container .graph-container .graph{display:flex;justify-content:center}.flow-container .flow-inner-container .graph-container .graph svg{flex:1}", ""]);
	
	// exports


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _botFlow = __webpack_require__(899);
	
	var _botFlow2 = _interopRequireDefault(_botFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botFlowModule = _angular2.default.module('app.containers.bot-flow', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('botFlow', {
	    url: '/bot-flows',
	    template: '<bot-flow></bot-flow>'
	  });
	}]).component('botFlow', _botFlow2.default);
	
	exports.default = botFlowModule;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _botFlow = __webpack_require__(900);
	
	var _botFlow2 = _interopRequireDefault(_botFlow);
	
	var _botFlow3 = __webpack_require__(901);
	
	var _botFlow4 = _interopRequireDefault(_botFlow3);
	
	__webpack_require__(902);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botFlowComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _botFlow2.default,
	  controller: _botFlow4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = botFlowComponent;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"bot-flow-container\">\r\n  <div class=\"bot-flow-inner-container\">\r\n    <div class=\"tree-view\">\r\n      <ul kendo-tree-view k-options=\"vm.treeViewOptions\" id=\"bot-flow-tree-view\">\r\n      </ul>\r\n    </div>\r\n    <div class=\"graph-container\">\r\n      <h2 class=\"header\">{{vm.header}}</h2>\r\n      <div id=\"bot-flow-graph\" class=\"graph\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(877);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotFlowController = function () {
	  BotFlowController.$inject = ["BotFlowService", "MermaidService", "$scope", "$q"];
	  function BotFlowController(BotFlowService, MermaidService, $scope, $q) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BotFlowController);
	    this.botFlowService = BotFlowService;
	    this.mermaidService = MermaidService;
	    this.$scope = $scope;
	    this.$q = $q;
	  }
	
	  (0, _createClass3.default)(BotFlowController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.mermaidService.init();
	
	      this.isLoading = true;
	
	      var botFlowsPromise = this.botFlowService.getBotFlowsPromise();
	
	      this.$q.all([botFlowsPromise]).then(function (data) {
	        var _data = (0, _slicedToArray3.default)(data, 1),
	            botsFlowsResponse = _data[0];
	
	        _this.isLoading = false;
	
	        _this.initializeFlows(botsFlowsResponse);
	      });
	    }
	  }, {
	    key: "initializeFlows",
	    value: function initializeFlows(flowGroups) {
	      var _this2 = this;
	
	      var items = [];
	      flowGroups.data.forEach(function (flowGroup) {
	        var childItems = [];
	        flowGroup.botFlows.forEach(function (botFlow) {
	          childItems.push({
	            id: botFlow.id,
	            text: botFlow.title,
	            flowChart: botFlow.flowChart
	          });
	        });
	
	        items.push({
	          text: flowGroup.title,
	          expanded: true,
	          items: childItems
	        });
	      });
	
	      this.treeViewOptions = {
	        dataSource: [{
	          text: "Bot Flows",
	          expanded: true,
	          items: items
	        }],
	        select: function select(e) {
	          return _this2.onTreeViewSelect(e);
	        }
	      };
	    }
	  }, {
	    key: "onTreeViewSelect",
	    value: function onTreeViewSelect(e) {
	      var treeview = $("#bot-flow-tree-view").data("kendoTreeView");
	      var dataItem = treeview.dataItem(e.node);
	
	      if (dataItem.id) this.renderGraph(dataItem);
	    }
	  }, {
	    key: "renderGraph",
	    value: function renderGraph(dataItem) {
	      this.setHeader(dataItem.text);
	      var id = dataItem.id;
	      var graphData = dataItem.flowChart;
	
	      this.mermaidService.render("graph-" + id, graphData, function (svg, bindingFunctions) {
	        document.getElementById("bot-flow-graph").innerHTML = svg;
	      });
	    }
	  }, {
	    key: "setHeader",
	    value: function setHeader(header) {
	      var _this3 = this;
	
	      setTimeout(function () {
	        _this3.header = header;
	        _this3.$scope.$apply();
	      }, 0);
	    }
	  }]);
	  return BotFlowController;
	}();
	
	exports.default = BotFlowController;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(903);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./bot-flow.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./bot-flow.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	
	
	// module
	exports.push([module.id, ".bot-flow-container .bot-flow-inner-container{display:flex;justify-content:space-between;margin-left:4em;min-height:100vh}.bot-flow-container .bot-flow-inner-container .tree-view{flex-basis:18em;background:#162e3d;padding:2em 1em 0}.bot-flow-container .bot-flow-inner-container .tree-view .k-treeview{color:#fff}.bot-flow-container .bot-flow-inner-container .graph-container{flex:1}.bot-flow-container .bot-flow-inner-container .graph-container .header{text-align:center;padding:2em}.bot-flow-container .bot-flow-inner-container .graph-container .graph{display:flex;justify-content:center}.bot-flow-container .bot-flow-inner-container .graph-container .graph svg{flex:1}", ""]);
	
	// exports


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _botSessions = __webpack_require__(905);
	
	var _botSessions2 = _interopRequireDefault(_botSessions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botSessionsModule = _angular2.default.module('app.containers.bot-sessions', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('botSessions', {
	    url: '/bot-sessions',
	    template: '<bot-sessions></bot-sessions>'
	  });
	}]).component('botSessions', _botSessions2.default);
	
	exports.default = botSessionsModule;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _botSessions = __webpack_require__(906);
	
	var _botSessions2 = _interopRequireDefault(_botSessions);
	
	var _botSessions3 = __webpack_require__(907);
	
	var _botSessions4 = _interopRequireDefault(_botSessions3);
	
	__webpack_require__(908);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botSessionsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _botSessions2.default,
	  controller: _botSessions4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = botSessionsComponent;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"bot-sessions-container\">\r\n  <div class=\"bot-sessions-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <bot-sessions-filter apply-filters=\"vm.applyFilters()\"></bot-sessions-filter>  \r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"bot-sessions-match\">{{vm.botSessionsMatchCount ? vm.botSessionsMatchCount + \" sessions match\" : \"\"}}</div>\r\n      <div class=\"bot-sessions-grid\">\r\n        <div id=\"bot-sessions-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script type=\"text/x-kendo-template\" id=\"bot-session-detail-template\">\r\n    <div class=\"tabstrip\">\r\n        <ul>\r\n            <li class=\"k-state-active\">\r\n                Conversation Flow\r\n            </li>\r\n        </ul>  \r\n        <div>\r\n            <div class=\"bot-session-detail-conversation\"></div>\r\n        </div>\r\n        <!--<div>\r\n            <div class=\"\">\r\n                <ul>\r\n                    <li><label>User Name: </label>#= userName #</li>\r\n                    <li><label>Channel: </label>#= channelId #</li>\r\n                </ul>\r\n            </div>\r\n        </div>              \r\n        <div>\r\n            <div class=\"bot-session-detail-persisted-attributes\"></div>\r\n        </div>        -->\r\n    </div>\r\n\r\n</script>"

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotSessionsController = function () {
	  BotSessionsController.$inject = ["BotSessionsService", "FilterService", "$scope"];
	  function BotSessionsController(BotSessionsService, FilterService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BotSessionsController);
	    this.botSessionsService = BotSessionsService;
	    this.filterService = FilterService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	
	    // TODO: Figure out a better approach.
	    window.processLineBreaks = function (text) {
	      if (!text) return "";
	
	      var regexp = new RegExp('\n', 'g');
	      return text.replace(regexp, '<br>');
	    };
	  }
	
	  (0, _createClass3.default)(BotSessionsController, [{
	    key: "getGridOptions",
	    value: function getGridOptions() {
	
	      return {
	        dataSource: this.botSessionsService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          template: "No match found. Change your filter criteria."
	        },
	        columns: [{ field: "userName", title: "User Name", filterable: false, width: "6rem" }, { field: "botName", title: "Bot Name", filterable: false, width: "6rem" }, { field: "channelId", title: "Channel Id", filterable: false, width: "6rem" },
	        // { field: "jugglerId", title: "Juggle St Account", filterable: false, width: "4rem" },        
	        { field: "startDate", title: "Start", width: "6rem", template: "<span> #= kendo.toString(new Date(startDate), 'dd/MM/yy') # </span>" }, { field: "lastUpdateDate", title: "Last Update", width: "6rem", template: "<span> #= kendo.toString(new Date(lastUpdateDate), 'dd-MM-yy @ hh:mm:ss') # </span>" }],
	        detailTemplate: kendo.template($("#bot-session-detail-template").html()),
	        detailInit: this.detailInit,
	        dataBound: this.dataBound
	      };
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.botSessionsMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "detailInit",
	    value: function detailInit(e) {
	      var detailRow = e.detailRow;
	
	      detailRow.find(".tabstrip").kendoTabStrip({
	        animation: {
	          open: { effects: "fadeIn" }
	        }
	      });
	
	      var sessionEntries = {
	        data: e.data.sessionEntries,
	        total: e.data.sessionEntries.length
	      };
	
	      detailRow.find(".bot-session-detail-conversation").kendoGrid({
	        dataSource: {
	          data: sessionEntries,
	          pageSize: 50,
	          schema: {
	            data: "data",
	            total: "total"
	          }
	        },
	        scrollable: false,
	        sortable: false,
	        pageable: true,
	        columns: [{ field: "activityTypeName", title: "Activity", width: "4rem" }, { field: "textScript", title: "Script", width: "12rem" }, { field: "fromName", title: "From", width: "4rem" },
	        // { field: "recipientName", title:"To", width: "4rem" },            
	        // { field: "text", title:"Message", width: "12rem" },            
	        { field: "text", title: "Message", width: "12rem", template: "<span> #= window.processLineBreaks(text) # </span>" }, { field: "entryDate", title: "Time", width: "4rem", template: "<span> #= kendo.toString(new Date(entryDate), 'dd/MM hh:mm:ss') # </span>" }, { field: "flowType", title: "Flow/Stream", width: "4rem" }]
	      });
	    }
	  }, {
	    key: "dataBound",
	    value: function dataBound(e) {
	      this.expandRow(this.tbody.find("tr.k-master-row").first());
	    }
	  }]);
	  return BotSessionsController;
	}();
	
	exports.default = BotSessionsController;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(909);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./bot-sessions.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./bot-sessions.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.bot-sessions-container{display:flex;flex-direction:column;height:100vh}.bot-sessions-container .bot-sessions-inner-container{height:100%;display:flex}.bot-sessions-container .bot-sessions-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.bot-sessions-container .bot-sessions-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.bot-sessions-container .bot-sessions-inner-container .grid-container .bot-sessions-grid{margin-top:.5rem;margin-left:.5rem}.bot-sessions-container .bot-sessions-inner-container .grid-container .bot-sessions-grid .col-name .cell{display:flex;align-items:center}.bot-sessions-container .bot-sessions-inner-container .grid-container .bot-sessions-grid .col-name .cell .image-container{width:2rem}.bot-sessions-container .bot-sessions-inner-container .grid-container .bot-sessions-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.bot-sessions-container .bot-sessions-inner-container .grid-container .bot-sessions-grid .k-grid-norecords{margin-top:20rem}.bot-sessions-container .bot-sessions-inner-container .grid-container .bot-sessions-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _botSessionDetails = __webpack_require__(911);
	
	var _botSessionDetails2 = _interopRequireDefault(_botSessionDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botSessionDetailsModule = _angular2.default.module('app.containers.bot-session-details', []).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('botSessionDetails', {
	    url: '/bot-sessions/:botSessionId',
	    template: '<bot-session-details></bot-session-details>'
	  });
	}]).component('botSessionDetails', _botSessionDetails2.default);
	
	exports.default = botSessionDetailsModule;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _botSessionDetails = __webpack_require__(912);
	
	var _botSessionDetails2 = _interopRequireDefault(_botSessionDetails);
	
	var _botSessionDetails3 = __webpack_require__(913);
	
	var _botSessionDetails4 = _interopRequireDefault(_botSessionDetails3);
	
	__webpack_require__(914);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botSessionDetailsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _botSessionDetails2.default,
	  controller: _botSessionDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = botSessionDetailsComponent;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"bot-session-details-container\">\r\n  <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n    <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n  </div>\r\n  <div class=\"bot-session-details-inner-container\" ng-if=\"!vm.isLoading\">\r\n    <header class=\"header-container\">\r\n      <div class=\"header-inner-container contain-max-width\">\r\n        <div class=\"basic-info\">\r\n          <div class=\"info-container\">\r\n            <h3>\r\n              {{vm.botSession.userName}}\r\n              <span class=\"entity-type-label\">{{vm.botSession.channelId}}</span>\r\n            </h3>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </header>\r\n    <div class=\"tabs-container\">\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n"

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(817);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(366);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _underscore = __webpack_require__(821);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotSessionDetailsController = function () {
	  BotSessionDetailsController.$inject = ["$stateParams", "BotSessionsService", "AppContextService", "NotificationService"];
	  function BotSessionDetailsController($stateParams, BotSessionsService, AppContextService, NotificationService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BotSessionDetailsController);
	    this.botSessionsService = BotSessionsService;
	    this.appContextService = AppContextService;
	    console.log($stateParams.botSessionId);
	    this.botSessionId = $stateParams.botSessionId;
	    this.getSessionDetails(this.botSessionId);
	    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
	    this.deleteIntercomAccount = true;
	    this.notificationService = NotificationService;
	  }
	
	  (0, _createClass3.default)(BotSessionDetailsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.tabTypes = {
	        PROFILE: 1,
	        PAYMENT: 2,
	        JOBS_AND_RATINGS: 3,
	        CERTIFICATES: 4,
	        MESSAGES: 5,
	        RATINGS: 6
	      };
	    }
	  }, {
	    key: "getSessionDetails",
	    value: function getSessionDetails(botSessionId) {
	      var _this = this;
	
	      this.isLoading = true;
	
	      this.botSessionsService.getSessionDetails(botSessionId, function (response) {
	        _this.botSession = response.data;
	        _this.isLoading = false;
	
	        _this.getTabs();
	      }, function (error) {
	        _this.isLoading = false;
	      });
	    }
	  }, {
	    key: "getTabs",
	    value: function getTabs() {
	      var _tabs;
	
	      this.tabs = (_tabs = {}, (0, _defineProperty3.default)(_tabs, this.tabTypes.PROFILE, {
	        key: 1,
	        label: "PROFILE",
	        isActive: true,
	        icon: "fa fa-user"
	      }), (0, _defineProperty3.default)(_tabs, this.tabTypes.PAYMENT, {
	        key: 2,
	        label: "PAYMENT",
	        isActive: false,
	        icon: "fa fa-dollar"
	      }), (0, _defineProperty3.default)(_tabs, this.tabTypes.JOBS_AND_RATINGS, {
	        key: 3,
	        label: "JOBS & RATINGS",
	        isActive: false,
	        icon: "fa fa-user"
	      }), (0, _defineProperty3.default)(_tabs, this.tabTypes.MESSAGES, {
	        key: 4,
	        label: "MESSAGES",
	        isActive: false,
	        icon: "fa fa-envelope"
	      }), _tabs);
	      this.activeTab = this.tabs["1"];
	    }
	  }, {
	    key: "switchTab",
	    value: function switchTab(tab) {
	      var _this2 = this;
	
	      this.activeTab = tab;
	
	      (0, _keys2.default)(this.tabs).map(function (i) {
	        if (_this2.tabs[i] == _this2.activeTab) _this2.tabs[i].isActive = true;else _this2.tabs[i].isActive = false;
	      });
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      return _common2.default.formatDate(date);
	    }
	  }, {
	    key: "hasGlobalAdminAccess",
	    value: function hasGlobalAdminAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
	    }
	  }]);
	  return BotSessionDetailsController;
	}();
	
	exports.default = BotSessionDetailsController;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(915);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./bot-session-details.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./bot-session-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.bot-session-details-container .bot-session-details-inner-container{margin-left:4rem}.bot-session-details-container .bot-session-details-inner-container .contain-max-width{max-width:1280px;margin:0 auto}.bot-session-details-container .bot-session-details-inner-container .header-container{background:#162e3d;color:#f4f4f4;height:8rem;padding:2rem .5rem 1rem}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container{height:8rem;display:flex;justify-content:space-between}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .basic-info{min-width:500px;display:flex;justify-content:flex-start}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .basic-info .profile-image{max-height:8rem;margin-right:.5rem}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .basic-info .info-container{flex-direction:column;display:flex;justify-content:flex-end}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .basic-info .info-container .entity-type-label{font-size:.9rem;background:#299c4a;padding:.1rem;margin-left:.5rem;border-radius:.2rem}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .basic-info .info-container .hidden-account-label{font-size:.9rem;background:red;padding:.1rem;margin-left:.5rem;border-radius:.2rem}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .more-info{min-width:700px;display:flex;justify-content:flex-end;flex-direction:column}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .more-info .info-item{margin-bottom:.5rem;display:flex;flex-direction:column;align-items:flex-end}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .more-info .info-item .item-title{margin-bottom:.2rem}.bot-session-details-container .bot-session-details-inner-container .header-container .header-inner-container .more-info .info-item .item-text{font-size:.9rem}.bot-session-details-container .bot-session-details-inner-container .tabs-container{height:3rem;background:#3f5464;display:flex;align-items:flex-end}.bot-session-details-container .bot-session-details-inner-container .tabs-container .tabs-inner-container{display:flex;justify-content:space-around;align-items:center;color:#f4f4f4;width:100%}.bot-session-details-container .bot-session-details-inner-container .tabs-container .tabs-inner-container .tab{padding:.5em 0;width:20rem;text-align:center;cursor:pointer}.bot-session-details-container .bot-session-details-inner-container .tabs-container .tabs-inner-container .tab .tab-icon{margin-right:1rem}.bot-session-details-container .bot-session-details-inner-container .tabs-container .tabs-inner-container .active-tab{border-bottom:5px solid #299c4a}.bot-session-details-container .bot-session-details-inner-container .body-container{margin-top:2rem}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container{margin:0 .5rem}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container{display:flex;justify-content:space-between;flex-wrap:wrap}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container .login-as-user{margin:2rem .5rem;flex-basis:100%}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container .login-as-user .title{margin-bottom:1rem}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container .bot-session-details-component{width:600px;margin-bottom:2rem}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container .bot-session-details-component .title{height:1rem;padding:.5rem}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container .bot-session-details-component .details{padding:.5rem;border:1px solid #d8d8d8}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container .bot-session-details-component .details .item{margin-bottom:1rem}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container .bot-session-details-component .details .item .item-title{margin-bottom:.3rem;color:#299c4a}.bot-session-details-container .bot-session-details-inner-container .body-container .body-inner-container .tab-body-container .bot-session-details-component .details .item .item-text{font-size:.9rem;color:#1c1c1c}", ""]);
	
	// exports


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _botManager = __webpack_require__(917);
	
	var _botManager2 = _interopRequireDefault(_botManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botManagerModule = _angular2.default.module('app.containers.bot-manager', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('botManager', {
	    url: '/bot-manager',
	    template: '<bot-manager></bot-manager>'
	  });
	}]).component('botManager', _botManager2.default);
	
	exports.default = botManagerModule;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _botManager = __webpack_require__(918);
	
	var _botManager2 = _interopRequireDefault(_botManager);
	
	var _botManager3 = __webpack_require__(919);
	
	var _botManager4 = _interopRequireDefault(_botManager3);
	
	__webpack_require__(920);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botManagerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _botManager2.default,
	  controller: _botManager4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = botManagerComponent;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"bot-manager-container\">\r\n  <div class=\"bot-manager-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <bot-manager-filter apply-filters=\"vm.applyFilters()\"></bot-manager-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"bot-manager-match\">{{vm.botManagerMatchCount ? vm.botManagerMatchCount + \" flows match\" : \"\"}}</div>\r\n      <div class=\"bot-manager-grid\">\r\n        <div id=\"bot-manager-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"bot-manager-popup-editor\" type=\"text/x-kendo-template\">\r\n\r\n    #if(data.isNew()) {#\r\n      <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n        <p>\r\n          <label>\r\n            <span style=\"font-weight: bold;display:inline-block; width: 80px\">Flow Title </span> \r\n            <input type=\"text\" \r\n              data-bind=\"value: title\" />\r\n          <label>\r\n        </p>        \r\n        <p>\r\n          <label>\r\n            <span style=\"font-weight: bold;display:inline-block; width: 80px\">Flow Status </span> \r\n            <input kendo-dropdownlist \r\n              k-options=\"vm.botFlowTestStatusOptions\" \r\n              data-bind=\"value: flowStatus\" />\r\n          <label>\r\n        </p>        \r\n        <p>\r\n          <label>\r\n            <span style=\"font-weight: bold;display:inline-block; width: 80px\">Flow File </span> \r\n            <input name=\"bot-flowfile\"\r\n                   type=\"file\"\r\n                   data-bind=\"fileValue: flowFileBinary\"\r\n                   kendo-upload\r\n                   k-select=\"vm.onBotFileSelect\"\r\n                   />              \r\n          <label>\r\n        </p>        \r\n      </div>\r\n\r\n    #} else {#\r\n        \r\n    <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n      <p>\r\n        <label>\r\n          <span style=\"font-weight: bold;\">Flow Status </span> \r\n          <input k-on-change=\"dataItem.dirty=true\" \r\n            kendo-dropdownlist \r\n            k-options=\"vm.botFlowLiveStatusOptions\" \r\n            data-bind=\"value: flowStatus\" />\r\n        <label>\r\n      </p>\r\n    </div>\r\n\r\n    #}#\r\n</script>"

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BotManagerController = function () {
	  BotManagerController.$inject = ["BotManagerService", "FilterService", "$scope"];
	  function BotManagerController(BotManagerService, FilterService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BotManagerController);
	    this.botManagerService = BotManagerService;
	    this.filterService = FilterService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(BotManagerController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.botFlowTestStatusOptions = {
	        dataSource: [{ value: 0, text: "Inactive" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	
	      this.botFlowLiveStatusOptions = {
	        dataSource: [{ value: 0, text: "Inactive" },
	        // { value: 1, text: "Test" },
	        { value: 2, text: "Live" }],
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.botManagerService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceOnErrorCallback.bind(this)),
	        sortable: true,
	        pageable: false,
	        resizable: true,
	        height: "90vh",
	        toolbar: [{ name: "create", text: "Create New Flow" }],
	        noRecords: {
	          template: "No Flows."
	        },
	        columns: [{ field: "title", title: "Title", filterable: false, sortable: false, width: "8rem" }, { field: "flowType", title: "Flow Type", filterable: false, sortable: false, width: "4rem" }, { field: "flowStatus", title: "Flow Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getFlowStatusText(dataItem.flowStatus);
	          } }, { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Update Bot Flow" },
	          template: kendo.template($("#bot-manager-popup-editor").html())
	        }
	      };
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.botManagerMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceOnErrorCallback",
	    value: function dataSourceOnErrorCallback(response) {
	      alert(JSON.parse(response.xhr.responseText).message);
	    }
	  }, {
	    key: "_getFlowStatusText",
	    value: function _getFlowStatusText(type) {
	      switch (type) {
	        case _constants2.default.botFlowStatus.INACTIVE:
	          return "Inactive";
	        case _constants2.default.botFlowStatus.TEST:
	          return "Test";
	        case _constants2.default.botFlowStatus.LIVE:
	          return "Live";
	      }
	    }
	  }]);
	  return BotManagerController;
	}();
	
	exports.default = BotManagerController;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(921);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./bot-manager.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./bot-manager.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.bot-manager-container{display:flex;flex-direction:column;height:100vh}.bot-manager-container .bot-manager-inner-container{height:100%;display:flex}.bot-manager-container .bot-manager-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.bot-manager-container .bot-manager-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.bot-manager-container .bot-manager-inner-container .grid-container .bot-manager-grid{margin-top:.5rem;margin-left:.5rem}.bot-manager-container .bot-manager-inner-container .grid-container .bot-manager-grid .col-name .cell{display:flex;align-items:center}.bot-manager-container .bot-manager-inner-container .grid-container .bot-manager-grid .col-name .cell .image-container{width:2rem}.bot-manager-container .bot-manager-inner-container .grid-container .bot-manager-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.bot-manager-container .bot-manager-inner-container .grid-container .bot-manager-grid .k-grid-norecords{margin-top:20rem}.bot-manager-container .bot-manager-inner-container .grid-container .bot-manager-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _analyticsRevenue = __webpack_require__(923);
	
	var _analyticsRevenue2 = _interopRequireDefault(_analyticsRevenue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsModule = _angular2.default.module('app.containers.analytics-revenue', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('analyticsRevenue', {
	    url: '/analytics-revenue',
	    template: '<analytics-revenue></analytics-revenue>'
	  });
	}]).component('analyticsRevenue', _analyticsRevenue2.default);
	
	exports.default = analyticsModule;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analyticsRevenue = __webpack_require__(924);
	
	var _analyticsRevenue2 = _interopRequireDefault(_analyticsRevenue);
	
	var _analyticsRevenue3 = __webpack_require__(925);
	
	var _analyticsRevenue4 = _interopRequireDefault(_analyticsRevenue3);
	
	__webpack_require__(926);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _analyticsRevenue2.default,
	  controller: _analyticsRevenue4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = analyticsComponent;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"analytics-container\" style=\"background-color: #eaeaec\">\r\n  <div class=\"analytics-inner-container\">\r\n    <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem\">\r\n      <!-- <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i> -->\r\n      <img src=\"/images/js-logo-animation.gif\" style=\"width: 150px; mix-blend-mode: multiply;\"/>\r\n    </div>\r\n    <div class=\"revenue-chart-container\" ng-if=\"!vm.isLoading\">\r\n       <div kendo-tab-strip>\r\n          <ul>\r\n            <li class=\"k-state-active\">Revenue at a Glance</li>\r\n            <li>Revenue Breakdown</li>\r\n            <li>MAU and ARPU</li>\r\n            <li>Recent Revenue</li>\r\n            <li>New vs Recurring Revenue</li>\r\n            <!-- <li>Renewals & Upselling</li> -->\r\n            <li>Job Trends</li>\r\n            <li>GMV</li>\r\n          </ul>\r\n\r\n          <div style=\"padding: 1em; background-color: #eaeaec\">\r\n            <div>\r\n              <div style=\"max-width: 1200px\">\r\n                <div kendo-chart k-options=\"vm.revenueFYoYSummaryChartOptions\" style=\"display: inline-block; width: 500px; height: 500px; padding: 5px\"></div>\r\n                <div kendo-chart k-options=\"vm.jobsValueFYoYChartOptions\" style=\"display: inline-block; width: 500px; height: 500px; padding: 5px\"></div>\r\n                <div style=\"clear:both\"/>\r\n              </div>\r\n              <!-- <div kendo-chart k-options=\"vm.revenueAtGlanceOptions\" style=\"display: inline-block; width: 600px; height: 400px; padding: 5px\"></div> -->\r\n              <div kendo-chart k-options=\"vm.revenueByFrequencyOptions\" style=\"display: inline-block; width: 450px; height: 450px; padding: 5px\"></div>\r\n              <div kendo-chart k-options=\"vm.revenueBySourceOptions\" style=\"display: inline-block; width: 550px; height: 550px\"></div>\r\n              <div kendo-chart k-options=\"vm.jobsByManagementTypeOptions\" style=\"display: inline-block; width: 450px; height: 450px\"></div>\r\n              <div style=\"clear:both;margin: 10px 0\"></div>\r\n              <div kendo-chart k-options=\"vm.avgTrnValueOptions\"></div>\r\n            </div>\r\n          </div>\r\n\r\n          <div style=\"padding: 1em; background-color: #eaeaec\">\r\n              <div kendo-chart k-options=\"vm.reveuneByCountryChartOptions\"></div>\r\n              <!-- <div kendo-chart k-options=\"vm.totalRevenueChartOptions\"></div> -->\r\n              <!-- <div kendo-chart k-options=\"vm.monthlyRevenueChartOptions\" style=\"height: 600px\"></div> -->\r\n              <!-- <div kendo-chart k-options=\"vm.revenueBreakdownChartOptions\" style=\"height: 600px\"></div> -->\r\n              <!-- <div kendo-chart k-options=\"vm.newRevenueBreakdownChartOptions\" style=\"height: 600px\"></div> -->\r\n              <div kendo-chart k-options=\"vm.familySubscriptionRevenueBreakdownChartOptions\"></div>\r\n              <div kendo-chart k-options=\"vm.helperSubscriptionRevenueBreakdownChartOptions\"></div>\r\n              <!-- <div kendo-chart k-options=\"vm.legacySubscriptionRevenueBreakdownChartOptions\"></div> -->\r\n              <div kendo-chart k-options=\"vm.businessSubscriptionRevenueBreakdownChartOptions\"></div>\r\n              <!-- <div kendo-chart k-options=\"vm.paygRevenueBreakdownChartOptions\"></div> -->\r\n              <div kendo-chart k-options=\"vm.revenueFYoYChartOptions\"></div>\r\n              <div kendo-chart k-options=\"vm.newRevenueFYoYChartOptions\"></div>\r\n              <div kendo-chart k-options=\"vm.recurringRevenueFYoYChartOptions\"></div>\r\n              <div kendo-chart k-options=\"vm.revenueByStateChartOptions\"></div>\r\n              <div kendo-chart k-options=\"vm.nzRevenueByRegionChartOptions\"></div>\r\n              <div kendo-chart k-options=\"vm.refundsChartOptions\"></div>\r\n              <div kendo-chart k-options=\"vm.refundAmountsChartOptions\"></div>\r\n              <div kendo-chart k-options=\"vm.clientRefundsChartOptions\"></div>\r\n          </div>\r\n\r\n          <div style=\"padding: 1em; background-color: #eaeaec\">\r\n            <div kendo-chart k-options=\"vm.monthlyActiveUsersOptions\" style=\"height: 600px\"></div>\r\n            <div kendo-chart k-options=\"vm.averageRevenuePerUserOptions\" style=\"height: 600px\"></div>\r\n            <div kendo-chart k-options=\"vm.revenueOvertimeOptions\" style=\"height: 600px\"></div>\r\n          </div>\r\n\r\n          <div style=\"padding: 1em; background-color: #eaeaec\">\r\n            <div kendo-chart k-options=\"vm.recentRevenueChartOptions\"></div>\r\n            <!-- <div kendo-chart k-options=\"vm.recentRevenueByTypeChartOptions\"></div> -->\r\n            <div kendo-chart k-options=\"vm.recentRevenueByDeviceChartOptions\"></div>\r\n\r\n            <div kendo-chart k-options=\"vm.recentRevenueYoYChartOptions\"></div>\r\n\r\n            <div kendo-chart k-options=\"vm.desktopSubscriptionRecentRevenueChartOptions\"></div>\r\n            <!-- <div kendo-chart k-options=\"vm.desktopPaygRecentRevenueChartOptions\"></div> -->\r\n\r\n            <div kendo-chart k-options=\"vm.mobileSubscriptionRecentRevenueChartOptions\"></div>\r\n            <!-- <div kendo-chart k-options=\"vm.mobilePaygRecentRevenueChartOptions\"></div> -->\r\n\r\n            <!-- <div kendo-chart k-options=\"vm.recentRevenueBreakdownChartOptions\"></div> -->\r\n            <!-- <div kendo-chart k-options=\"vm.desktopRecentRevenuehartOptions\"></div> -->\r\n            <!-- <div kendo-chart k-options=\"vm.mobileRecentRevenuehartOptions\"></div> -->\r\n            <div kendo-chart k-options=\"vm.topRevenueOptions\"></div>\r\n          </div>\r\n\r\n          <div style=\"padding: 1em; background-color: #eaeaec\">\r\n            <div id=\"new-vs-recurring-revenue-chart\" kendo-chart k-options=\"vm.newVersusRecurringRevenueOptions\"></div>\r\n            <div kendo-chart k-options=\"vm.payingClientsChurnOptions\"></div>\r\n            <div kendo-chart k-options=\"vm.payingProvidersChurnOptions\"></div>\r\n            <div kendo-chart k-options=\"vm.payingCustomersOvertimeOptions\"></div>\r\n            <!-- <div kendo-chart k-options=\"vm.newVersusRecurringQuarterlyRevenueOptions\"></div> -->\r\n            <div kendo-chart k-options=\"vm.newVersusRecurringAnnualRevenueOptions\"></div>\r\n            <div kendo-chart k-options=\"vm.familyNewRevenueOptions\"></div>\r\n            <div kendo-chart k-options=\"vm.familyRecurringRevenueOptions\"></div>\r\n            <div kendo-chart k-options=\"vm.helperNewRevenueOptions\"></div>\r\n            <div kendo-chart k-options=\"vm.helperRecurringRevenueOptions\"></div>\r\n          </div>\r\n\r\n          <!-- <div style=\"padding: 1em; background-color: #eaeaec\">\r\n            <div>\r\n              <div kendo-chart k-options=\"vm.monthlySubscriptionRenewalOptions\" style=\"float: left; width: 500px; height: 350px\"></div>\r\n              <div kendo-chart k-options=\"vm.annualSubscriptionRenewalOptions\" style=\"float: left; width: 500px; height: 350px\"></div>\r\n              <div style=\"clear:both;margin: 10px 0\"></div>\r\n              <div kendo-chart k-options=\"vm.frequentOneOffJobsOptions\" style=\"float: left; width: 500px; height: 350px\"></div>\r\n              <div kendo-chart k-options=\"vm.frequentRecurringJobsOptions\" style=\"float: left; width: 500px; height: 350px\"></div>\r\n              <div style=\"clear:both;margin: 10px 0\"></div>\r\n              <div style=\"max-width: 1200px\">\r\n                <div kendo-chart k-options=\"vm.oneOffUpsellBreakdownChartOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>\r\n                <div kendo-chart k-options=\"vm.recurringUpsellBreakdownChartOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>\r\n                <div kendo-chart k-options=\"vm.auPairUpsellBreakdownChartOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>\r\n                <div kendo-chart k-options=\"vm.tutoringUpsellBreakdownChartOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>\r\n                <div kendo-chart k-options=\"vm.tutoringUpsell2BreakdownChartOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>\r\n                <div style=\"clear:both\"/>\r\n              </div>\r\n            </div>\r\n          </div> -->\r\n\r\n          <div style=\"padding: 1em; background-color: #eaeaec\">\r\n            <div style=\"margin: auto; max-width: 1200px\">\r\n              <div kendo-chart k-options=\"vm.jobDistributionOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>\r\n              <div kendo-chart k-options=\"vm.jobsByDeviceOptions\" style=\"float: left; width: 550px; height: 400px; padding: 5px\"></div>\r\n              <div kendo-chart k-options=\"vm.ratingsByJobType\" style=\"float: left; width: 600px; height: 400px; padding: 5px\"></div>\r\n              <div style=\"clear:both\"/>\r\n            </div>\r\n            <div id=\"jobs-success-rate-chart\" kendo-chart k-options=\"vm.jobsSuccessRateoptions\"></div>\r\n          </div>\r\n\r\n          <div style=\"padding: 1em; background-color: #eaeaec\">\r\n            <div kendo-chart k-options=\"vm.jobValueOverTimeChartOptions\" style=\"height: 500px\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(877);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsController = function () {
	    AnalyticsController.$inject = ["AnalyticsService", "$q"];
	    function AnalyticsController(AnalyticsService, $q) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, AnalyticsController);
	
	        this.getColumnChartOptions = function (title, data, colorStyle) {
	
	            var categories = [];
	
	            var ds = [];
	            // var seriesColors = [
	            //     "#007bc3",
	            //     "#76b800",
	            //     "#ffae00",
	            //     "#ef4c00",
	            //     "#a419b7",
	            //     "#430b62"
	            // ];
	
	            var colors1 = ["#007bc3", "#007bc3", "#007bc3", "#007bc3", "#007bc3", "#76b800", "#a419b7", "#430b62"];
	
	            var colors2 = ["#ffae00", "#ffae00", "#ffae00", "#ffae00", "#ffae00", "#76b800", "#a419b7", "#430b62"];
	
	            var seriesColors = colorStyle == 1 ? colors1 : colors2;
	
	            data.series.forEach(function (s, index) {
	                ds.push({
	                    data: s.totalRevenue,
	                    category: s.name,
	                    color: seriesColors[index]
	                });
	                categories.push(s.name);
	            });
	
	            return {
	                title: {
	                    text: title,
	                    position: "bottom"
	                },
	                dataSource: {
	                    data: ds
	                },
	                theme: "silver",
	                legend: {
	                    position: "top"
	                },
	                seriesDefaults: {
	                    type: "column",
	                    labels: {
	                        visible: true,
	                        format: "{0:c0}",
	                        background: "transparent"
	                    }
	                },
	                series: [{
	                    field: "data",
	                    categoryField: "category",
	                    colorField: "color"
	                }],
	                valueAxis: {
	                    format: "{0:c0}",
	                    majorGridLines: {
	                        visible: true
	                    },
	                    visible: false
	                },
	                categoryAxis: {
	                    majorGridLines: {
	                        visible: true
	                    },
	                    line: {
	                        visible: false
	                    }
	                }
	            };
	        };
	
	        this.analyticsService = AnalyticsService;
	        this.$q = $q;
	    }
	
	    (0, _createClass3.default)(AnalyticsController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this = this;
	
	            this.isLoading = true;
	
	            var revenuePromise = this.analyticsService.getRevenueData();
	            var revenueYoYPromise = this.analyticsService.getRevenueYearOverYearData();
	            var revenueFYoYPromise = this.analyticsService.getRevenueFinancialYearOverYearData();
	            var refundsPromise = this.analyticsService.getRefundsData();
	            var refundAmountsPromise = this.analyticsService.getRefundsAmountData();
	            var clientRefundsPromise = this.analyticsService.getClientRefundsData();
	            var recentRevenuePromise = this.analyticsService.getRecentRevenueData();
	            var newVersusRecurringRevenuePromise = this.analyticsService.getNewVersusRecurringRevenueData();
	            var helperNewVersusRecurringRevenuePromise = this.analyticsService.getHelperNewVersusRecurringRevenueData();
	            var getGeneralStatsPromise = this.analyticsService.getGeneralStatsData();
	            var getJobValueOverTimePromise = this.analyticsService.getJobValueOverTimeData();
	            // const jobsSuccessRatePromise = this.analyticsService.getJobsSuccessRateData();
	            var recentRevenueByDevicePromise = this.analyticsService.getRecentRevenueByDeviceData();
	            // const revenueByDevicePromise = this.analyticsService.getRevenueByDeviceData();
	            var getRevenueBreakdownPromise = this.analyticsService.getRevenueBreakdownData();
	            var getNewRevenueBreakdownPromise = this.analyticsService.getNewRevenueBreakdownData();
	            var getUpsellBreakdownPromise = this.analyticsService.getUpsellBreakdown();
	            var getAvgTrnValuePromise = this.analyticsService.getAvgTrnValueData();
	            var payingCustomersOvertimePromise = this.analyticsService.getPayingCustomersOvertimeData();
	            var getRevenueByStatePromise = this.analyticsService.getRevenueByStateData();
	            var getTopRevenuePromise = this.analyticsService.getTopRevenueData();
	            var getMonthlyRevenuePromise = this.analyticsService.getMonthlyRevenueData();
	            var payingCustomersPromise = this.analyticsService.getPayingCustomersData();
	            var nzRevenueByRegionPromise = this.analyticsService.getNzRevenueByRegionData();
	            var getMonthlyActiveUsersPromise = this.analyticsService.getMonthlyActiveUsersData();
	            var arruPromise = this.analyticsService.getArruData();
	            var jobsValueByFinancialYearPromise = this.analyticsService.getJobValueByFinancialYearData();
	            var getBusinessRevenueBreakdownPromise = this.analyticsService.getBusinessRevenueBreakdownData();
	            var getHelperRevenueBreakdownPromise = this.analyticsService.getHelperRevenueBreakdownData();
	            var getRevenueFinancialYearOverYearBreakdownPromise = this.analyticsService.getRevenueFinancialYearOverYearBreakdownData();
	
	            this.$q.all([arruPromise, getMonthlyActiveUsersPromise, revenuePromise, revenueYoYPromise, revenueFYoYPromise, getRevenueBreakdownPromise, recentRevenuePromise, newVersusRecurringRevenuePromise, getGeneralStatsPromise, recentRevenueByDevicePromise, refundsPromise, getAvgTrnValuePromise, payingCustomersOvertimePromise, getRevenueByStatePromise, getNewRevenueBreakdownPromise, getUpsellBreakdownPromise, getTopRevenuePromise, getMonthlyRevenuePromise, payingCustomersPromise, nzRevenueByRegionPromise, getJobValueOverTimePromise, jobsValueByFinancialYearPromise, helperNewVersusRecurringRevenuePromise, getBusinessRevenueBreakdownPromise, getHelperRevenueBreakdownPromise, getRevenueFinancialYearOverYearBreakdownPromise, refundAmountsPromise, clientRefundsPromise]).then(function (data) {
	                var _data = (0, _slicedToArray3.default)(data, 28),
	                    arruResponse = _data[0],
	                    monthlyActiveUsersResponse = _data[1],
	                    revenueResponse = _data[2],
	                    revenueYoYResponse = _data[3],
	                    revenueFYoYResponse = _data[4],
	                    revenueBreakdownResponse = _data[5],
	                    recentRevenueResponse = _data[6],
	                    newVersusRecurringRevenueResponse = _data[7],
	                    getGeneralStatsResponse = _data[8],
	                    recentRevenueByDeviceResponse = _data[9],
	                    refundsResponse = _data[10],
	                    getAvgTrnValueResponse = _data[11],
	                    payingCustomersOvertimeResponse = _data[12],
	                    revenueByStateResponse = _data[13],
	                    newRevenueBreakdownResponse = _data[14],
	                    getUpsellBreakdownResponse = _data[15],
	                    getTopRevenueResponse = _data[16],
	                    getMonthlyRevenueResponse = _data[17],
	                    payingCustomersResponse = _data[18],
	                    nzRevenueByRegionResponse = _data[19],
	                    getJobValueOverTimeResponse = _data[20],
	                    jobsValueByFinancialYearResponse = _data[21],
	                    helperNewVersusRecurringRevenueResponse = _data[22],
	                    getBusinessRevenueBreakdownResponse = _data[23],
	                    getHelperRevenueBreakdownResponse = _data[24],
	                    revenueFYoYBreakdownResponse = _data[25],
	                    refundAmountsResponse = _data[26],
	                    clientRefundsResponse = _data[27];
	
	                _this.setMetricsChartOptions(monthlyActiveUsersResponse, arruResponse);
	
	                _this.setRevenueChartOptions(revenueResponse, getMonthlyRevenueResponse);
	
	                _this.setRevenueByStateChartOptions(revenueByStateResponse);
	
	                _this.setNzRevenueByRegionChartOptions(nzRevenueByRegionResponse);
	
	                _this.setRevenueYoYChartOptions(revenueYoYResponse, revenueFYoYResponse, revenueFYoYBreakdownResponse);
	
	                _this.setRevenueBreakdownChartOptions(revenueBreakdownResponse);
	
	                _this.setNewRevenueBreakdownChartOptions(newRevenueBreakdownResponse);
	
	                _this.setUpsellBreakdownChartOptions(getUpsellBreakdownResponse);
	
	                _this.setRefundsChartOptions(refundsResponse);
	
	                _this.setRefundsAmountChartOptions(refundAmountsResponse);
	
	                _this.setClientRefundsChartOptions(clientRefundsResponse);
	
	                _this.setRecentRevenueChartOptions(recentRevenueResponse);
	
	                _this.setRevenueByDeviceOptions(recentRevenueByDeviceResponse);
	
	                _this.setJobValueOverTimeOptions(getJobValueOverTimeResponse, jobsValueByFinancialYearResponse);
	
	                _this.setNewVersusRecurringRevenueOptions(newVersusRecurringRevenueResponse, helperNewVersusRecurringRevenueResponse);
	
	                _this.setGeneralStatsOptions(getGeneralStatsResponse);
	
	                // this.setJobsSuccessRateChartOptions(jobsSuccessRateResponse);
	
	                _this.setAvgTrnvalueChartOptions(getAvgTrnValueResponse);
	
	                _this.setPayingCustomersOvertimeOptions(payingCustomersOvertimeResponse);
	
	                _this.setTopRevenueOptions(getTopRevenueResponse);
	
	                _this.setPayingCustomersOptions(payingCustomersResponse);
	
	                _this.setBusinessRevenueBreakdownChartOptions(getBusinessRevenueBreakdownResponse);
	
	                _this.setHelperRevenueBreakdownChartOptions(getHelperRevenueBreakdownResponse);
	
	                _this.isLoading = false;
	            });
	        }
	    }, {
	        key: "setMetricsChartOptions",
	        value: function setMetricsChartOptions(monthlyActiveUsers, arru) {
	            var template = "#: text #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var numberFormat = function numberFormat(args) {
	                var date = kendo.toString(new Date(args.category), 'MMM yyyy');
	                return date + ' - ' + kendo.toString(args.value, 'n0');
	            };
	            this.monthlyActiveUsersOptions = this.analyticsService.getChartOptions("Monthly Active Users", monthlyActiveUsers.series, monthlyActiveUsers.categories, "{0:n0}", template, dateFormat, "n0");
	
	            var curFormat = function curFormat(args) {
	                var date = kendo.toString(new Date(args.category), 'MMM yyyy');
	                return date + ' - ' + kendo.toString(args.value, 'c0');
	            };
	            var revenue = [];
	            revenue.push(arru.series[0]);
	            this.revenueOvertimeOptions = this.analyticsService.getChartOptions("Revenue", revenue, arru.categories, "{0:C0}", template, dateFormat, "c0");
	
	            var curFormat2 = function curFormat2(args) {
	                var date = kendo.toString(new Date(args.category), 'MMM yyyy');
	                return date + ' - ' + kendo.toString(args.value, 'c2');
	            };
	            var arruSeries = [];
	            arruSeries.push(arru.series[1]);
	            this.averageRevenuePerUserOptions = this.analyticsService.getChartOptions("Average Revenue Per User", arruSeries, arru.categories, "{0:C2}", template, dateFormat, "c2");
	        }
	    }, {
	        key: "setPayingCustomersOptions",
	        value: function setPayingCustomersOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var clientsChurn = [];
	            clientsChurn.push(data.series[0]);
	            clientsChurn.push(data.series[1]);
	            clientsChurn.push(data.series[2]);
	
	            var providersChurn = [];
	            providersChurn.push(data.series[3]);
	            providersChurn.push(data.series[4]);
	            providersChurn.push(data.series[5]);
	
	            var parsedCats = data.categories.map(function (item) {
	                return kendo.toString(new Date(item), "yy-MM");
	            });
	            var clientTooltipTemplate = function clientTooltipTemplate(e) {
	                var datePoint = kendo.toString(e.category, "yy-MM");
	                var idx = parsedCats.indexOf(datePoint);
	
	                var payingSeries = clientsChurn[0];
	                var cancelledSeries = clientsChurn[1];
	                var deletedSeries = clientsChurn[2];
	
	                var churn = 0;
	                if (payingSeries.data[idx] > 0) churn = (cancelledSeries.data[idx] + deletedSeries.data[idx]) / payingSeries.data[idx];
	
	                var ratio = kendo.toString(churn, "p");
	                return kendo.toString(e.category, "MMM yyyy") + " - Churn: " + ratio;
	            };
	
	            var providerTooltipTemplate = function providerTooltipTemplate(e) {
	                var datePoint = kendo.toString(e.category, "yy-MM");
	                var idx = parsedCats.indexOf(datePoint);
	
	                var payingSeries = providersChurn[0];
	                var cancelledSeries = providersChurn[1];
	                var deletedSeries = providersChurn[2];
	
	                var churn = 0;
	                if (payingSeries.data[idx] > 0) churn = (cancelledSeries.data[idx] + deletedSeries.data[idx]) / payingSeries.data[idx];
	
	                var ratio = kendo.toString(churn, "p");
	                return kendo.toString(e.category, "MMM yyyy") + " - Churn: " + ratio;
	            };
	            this.payingClientsChurnOptions = this.analyticsService.getChartOptions("Paying Parents Churn", clientsChurn, data.categories, format, template, dateFormat, clientTooltipTemplate);
	            this.payingProvidersChurnOptions = this.analyticsService.getChartOptions("Paying Helpers Churn", providersChurn, data.categories, format, template, dateFormat, providerTooltipTemplate);
	        }
	    }, {
	        key: "setTopRevenueOptions",
	        value: function setTopRevenueOptions(data) {
	            this.topRevenueOptions = {
	                title: {
	                    text: 'Hall of Fame'
	                },
	                theme: "silver",
	                legend: {
	                    visible: false
	                },
	                seriesDefaults: {
	                    type: "column",
	                    labels: {
	                        visible: true,
	                        format: "{0:c0}"
	                    }
	                },
	                series: data.series,
	                valueAxis: {
	                    labels: {
	                        format: "{0:nc}"
	                    },
	                    line: {
	                        visible: false
	                    }
	                },
	                categoryAxis: {
	                    categories: data.categories,
	                    labels: {
	                        template: "#= kendo.toString(new Date(value), 'ddd d MMM yy') #"
	                    },
	                    line: {
	                        visible: false
	                    }
	                },
	                tooltip: {
	                    visible: true,
	                    format: "{0}%",
	                    template: "#= series.name #: #= kendo.toString(value, 'c0') #"
	                }
	            };
	        }
	    }, {
	        key: "setPayingCustomersOvertimeOptions",
	        value: function setPayingCustomersOvertimeOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var parsedCats = data.categories.map(function (item) {
	                return kendo.toString(new Date(item), "yy-MM");
	            });
	            var tooltipTemplate = function tooltipTemplate(e) {
	                var idx = parsedCats.indexOf(kendo.toString(e.category, "yy-MM"));
	
	                var activeSeries = data.series[e.series.index];
	                var relatedSeries = data.series[0];
	
	                var relatedItem = relatedSeries.data[idx];
	                var total = relatedItem;
	
	                var ratio = kendo.toString(e.dataItem.value / total, "p");
	                return ratio;
	            };
	
	            this.payingCustomersOvertimeOptions = this.analyticsService.getChartOptions("New/Recurring Transactions", data.series, data.categories, format, template, dateFormat, tooltipTemplate);
	        }
	    }, {
	        key: "setAvgTrnvalueChartOptions",
	        value: function setAvgTrnvalueChartOptions(data) {
	            this.avgTrnValueOptions = {
	                title: {
	                    text: 'Average Transaction Value'
	                },
	                theme: "silver",
	                legend: {
	                    position: "top",
	                    visible: false
	                },
	                seriesDefaults: {
	                    type: "column",
	                    labels: {
	                        visible: true,
	                        format: "{0:c0}"
	                    }
	                },
	                series: data.series,
	                valueAxis: {
	                    labels: {
	                        format: "{0:c0}"
	                    },
	                    line: {
	                        visible: true
	                    }
	                },
	                categoryAxis: {
	                    categories: data.categories,
	                    labels: {
	                        template: "#= kendo.toString(new Date(value), 'MMM yy') #"
	                    },
	                    line: {
	                        visible: true
	                    }
	                },
	                tooltip: {
	                    visible: true,
	                    format: "{0}%",
	                    template: "#= series.name #: #= kendo.toString(value, 'c0') #"
	                }
	            };
	        }
	    }, {
	        key: "setJobsSuccessRateChartOptions",
	        value: function setJobsSuccessRateChartOptions(data) {
	            var format = "{0:p0}";
	            var template = "#: text #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.jobsSuccessRateoptions = this.analyticsService.getChartOptions("Jobs Success Rate", data.series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setRevenueChartOptions",
	        value: function setRevenueChartOptions(data, monthlyRevenueData) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var totalRevenueSeries = [];
	            totalRevenueSeries.push(data.series[0]);
	            totalRevenueSeries.push(data.series[1]);
	            totalRevenueSeries.push(data.series[2]);
	
	            this.totalRevenueChartOptions = this.analyticsService.getChartOptions("Revenue", totalRevenueSeries, data.categories, format, template, dateFormat);
	
	            var revenueByCountrySeries = [];
	            revenueByCountrySeries.push(data.series[0]);
	            revenueByCountrySeries.push(data.series[3]);
	            revenueByCountrySeries.push(data.series[4]);
	            this.reveuneByCountryChartOptions = this.analyticsService.getChartOptions("Revenue by Country", revenueByCountrySeries, data.categories, format, template, dateFormat);
	
	            var monthlyRevenueSeries = [];
	            monthlyRevenueSeries.push(monthlyRevenueData.series[0]);
	            monthlyRevenueSeries.push(monthlyRevenueData.series[1]);
	            // monthlyRevenueSeries.push(monthlyRevenueData.series[2]);
	            // monthlyRevenueSeries.push(monthlyRevenueData.series[3]);
	            monthlyRevenueSeries.push(monthlyRevenueData.series[4]);
	            this.monthlyRevenueChartOptions = this.analyticsService.getChartOptions("Net Monthly Revenue", monthlyRevenueSeries, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setRevenueByStateChartOptions",
	        value: function setRevenueByStateChartOptions(data) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.revenueByStateChartOptions = this.analyticsService.getChartOptions("Australian Revenue by State", data.series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setNzRevenueByRegionChartOptions",
	        value: function setNzRevenueByRegionChartOptions(data) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.nzRevenueByRegionChartOptions = this.analyticsService.getChartOptions("New Zealand Revenue by Region", data.series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setRevenueYoYChartOptions",
	        value: function setRevenueYoYChartOptions(data, fdata, fdataBreakdown) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM" };
	
	            var tooltipTemplate = function tooltipTemplate(e) {
	                return kendo.toString(e.value, 'C0');
	            };
	
	            this.revenueYoYChartOptions = this.analyticsService.getChartOptions("Revenue YoY", data.series, data.categories, format, template, dateFormat, tooltipTemplate);
	            this.revenueFYoYChartOptions = this.analyticsService.getChartOptions("Revenue FYoY", fdata.series, fdata.categories, format, template, dateFormat, tooltipTemplate);
	            this.revenueFYoYSummaryChartOptions = this.getColumnChartOptions("Revenue", fdata, 1);
	
	            var newRevenue = [];
	            newRevenue.push(fdataBreakdown.series[0]);
	            newRevenue.push(fdataBreakdown.series[1]);
	            newRevenue.push(fdataBreakdown.series[2]);
	            newRevenue.push(fdataBreakdown.series[3]);
	            newRevenue.push(fdataBreakdown.series[4]);
	
	            var recurringRevenue = [];
	            recurringRevenue.push(fdataBreakdown.series[5]);
	            recurringRevenue.push(fdataBreakdown.series[6]);
	            recurringRevenue.push(fdataBreakdown.series[7]);
	            recurringRevenue.push(fdataBreakdown.series[8]);
	            recurringRevenue.push(fdataBreakdown.series[9]);
	
	            this.newRevenueFYoYChartOptions = this.analyticsService.getChartOptions("New Revenue FYoY", newRevenue, fdata.categories, format, template, dateFormat, tooltipTemplate);
	            this.recurringRevenueFYoYChartOptions = this.analyticsService.getChartOptions("Recurring Revenue FYoY", recurringRevenue, fdata.categories, format, template, dateFormat, tooltipTemplate);
	        }
	    }, {
	        key: "setRevenueBreakdownChartOptions",
	        value: function setRevenueBreakdownChartOptions(data) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            // var revenueBreakdownSeries = [];
	            // revenueBreakdownSeries.push(data.series[0]);
	            // revenueBreakdownSeries.push(data.series[1]);
	            // revenueBreakdownSeries.push(data.series[2]);
	            // revenueBreakdownSeries.push(data.series[3]);
	            // revenueBreakdownSeries.push(data.series[4]);
	
	            //  this.revenueBreakdownChartOptions = this.analyticsService.getChartOptions("Revenue Breakdown", revenueBreakdownSeries, data.categories, format, template, dateFormat);
	
	            var paygRevenueSeries = [];
	            paygRevenueSeries.push(data.series[3]);
	            paygRevenueSeries.push(data.series[4]);
	            paygRevenueSeries.push(data.series[5]);
	            paygRevenueSeries.push(data.series[6]);
	            paygRevenueSeries.push(data.series[13]);
	            this.paygRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("PAYG Revenue", paygRevenueSeries, data.categories, format, template, dateFormat);
	
	            var familyRevenueSeries = [];
	            familyRevenueSeries.push(data.series[18]);
	            familyRevenueSeries.push(data.series[8]);
	            familyRevenueSeries.push(data.series[9]); // Annual Childcare
	            familyRevenueSeries.push(data.series[11]); // Annual Tutoring + Childcare
	            familyRevenueSeries.push(data.series[26]); // Monthly Childcare
	            // familyRevenueSeries.push(data.series[24]); /// Annual Agency
	
	            var legacyRevenueSeries = [];
	            legacyRevenueSeries.push(data.series[7]); // Annual Babysitting
	            legacyRevenueSeries.push(data.series[12]);
	            legacyRevenueSeries.push(data.series[10]);
	
	            this.familySubscriptionRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("Family Subscription Revenue", familyRevenueSeries, data.categories, format, template, dateFormat);
	            this.legacySubscriptionRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("Legacy Subscription Revenue", legacyRevenueSeries, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setHelperRevenueBreakdownChartOptions",
	        value: function setHelperRevenueBreakdownChartOptions(data) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var helperRevenueSeries = [];
	            helperRevenueSeries.push(data.series[0]);
	            helperRevenueSeries.push(data.series[1]);
	            helperRevenueSeries.push(data.series[2]);
	            helperRevenueSeries.push(data.series[3]);
	
	            this.helperSubscriptionRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("Helper Subscription Revenue", helperRevenueSeries, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setBusinessRevenueBreakdownChartOptions",
	        value: function setBusinessRevenueBreakdownChartOptions(data) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var businessRevenueSeries = [];
	            businessRevenueSeries.push(data.series[0]);
	            businessRevenueSeries.push(data.series[1]);
	            businessRevenueSeries.push(data.series[2]);
	            // businessRevenueSeries.push(data.series[3]);
	            // businessRevenueSeries.push(data.series[4]);
	
	            this.businessSubscriptionRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("Business Revenue", businessRevenueSeries, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setNewRevenueBreakdownChartOptions",
	        value: function setNewRevenueBreakdownChartOptions(data) {
	            var format = "{0:N0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.newRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("New Transactions by Type", data.series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setUpsellBreakdownChartOptions",
	        value: function setUpsellBreakdownChartOptions(data) {
	            var format = "{0:N0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var oneOffSeries = [];
	            oneOffSeries.push(data.series[0]);
	            oneOffSeries.push(data.series[1]);
	            oneOffSeries.push(data.series[2]);
	
	            var recurringSeries = [];
	            recurringSeries.push(data.series[3]);
	            recurringSeries.push(data.series[4]);
	
	            var auPairseries = [];
	            auPairseries.push(data.series[5]);
	            auPairseries.push(data.series[6]);
	
	            var tutoringSeries = [];
	            tutoringSeries.push(data.series[7]);
	            tutoringSeries.push(data.series[8]);
	            tutoringSeries.push(data.series[9]);
	
	            var tutoringSeries2 = [];
	            tutoringSeries2.push(data.series[10]);
	            tutoringSeries2.push(data.series[11]);
	
	            this.oneOffUpsellBreakdownChartOptions = this.analyticsService.getChartOptions("One-off Upsell Breakdown", oneOffSeries, data.categories, format, template, dateFormat);
	            this.recurringUpsellBreakdownChartOptions = this.analyticsService.getChartOptions("Nannying Upsell Breakdown", recurringSeries, data.categories, format, template, dateFormat);
	            this.auPairUpsellBreakdownChartOptions = this.analyticsService.getChartOptions("Au Pair Upsell Breakdown", auPairseries, data.categories, format, template, dateFormat);
	            this.tutoringUpsellBreakdownChartOptions = this.analyticsService.getChartOptions("PS Tutoring Upsell Breakdown", tutoringSeries, data.categories, format, template, dateFormat);
	            this.tutoringUpsell2BreakdownChartOptions = this.analyticsService.getChartOptions("HS Tutoring Upsell Breakdown", tutoringSeries2, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setRefundsChartOptions",
	        value: function setRefundsChartOptions(data) {
	            var format = "{0:C}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var series = [];
	            series.push(data.series[1]);
	            series.push(data.series[2]);
	
	            this.refundsChartOptions = this.analyticsService.getChartOptions("Refunds Breakdown (Amount)", series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setRefundsAmountChartOptions",
	        value: function setRefundsAmountChartOptions(data) {
	            var format = "{0:N0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalCount, 'N0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var series = [];
	            series.push(data.series[1]);
	            series.push(data.series[2]);
	
	            this.refundAmountsChartOptions = this.analyticsService.getChartOptions("Refunds Breakdown (Count)", series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setClientRefundsChartOptions",
	        value: function setClientRefundsChartOptions(data) {
	            var format = "{0:C}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.clientRefundsChartOptions = this.analyticsService.getChartOptions("Client Refunds Breakdown (Amount)", data.series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setRecentRevenueChartOptions",
	        value: function setRecentRevenueChartOptions(data) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { days: "ddd dd" };
	            var tooltipFormat = "C0";
	
	            var totalRevenueSeries = [];
	            // totalRevenueSeries.push(data.series[7]);
	            totalRevenueSeries.push(data.series[0]);
	            totalRevenueSeries.push(data.series[1]);
	            totalRevenueSeries.push(data.series[11]);
	            // totalRevenueSeries.push(data.series[6]);
	
	            var desktopRevenue = [];
	            desktopRevenue.push(data.series[2]);
	            desktopRevenue.push(data.series[3]);
	
	            var mobileRevenue = [];
	            mobileRevenue.push(data.series[4]);
	            mobileRevenue.push(data.series[5]);
	
	            var dailyRevenueSeries = [];
	            dailyRevenueSeries.push(data.series[9]);
	            dailyRevenueSeries.push(data.series[7]);
	            dailyRevenueSeries.push(data.series[10]);
	            dailyRevenueSeries.push(data.series[8]);
	
	            var dailyRevenueYoYSeries = [];
	            dailyRevenueYoYSeries.push(data.series[9]);
	            dailyRevenueYoYSeries.push(data.series[12]);
	
	            var dailyRevenueByUserSeries = [];
	            dailyRevenueByUserSeries.push(data.series[7]);
	            dailyRevenueByUserSeries.push(data.series[8]);
	
	            this.recentRevenueChartOptions = this.analyticsService.getChartOptions("Daily Revenue", dailyRevenueSeries, data.categories, format, template, dateFormat, tooltipFormat);
	            // this.recentRevenueByTypeChartOptions = this.analyticsService.getChartOptions("Daily Revenue - By User", dailyRevenueByUserSeries, data.categories, format, template, dateFormat, tooltipFormat);
	            this.recentRevenueByDeviceChartOptions = this.analyticsService.getChartOptions("Revenue by Device", totalRevenueSeries, data.categories, format, template, dateFormat, tooltipFormat);
	            this.desktopRecentRevenuehartOptions = this.analyticsService.getChartOptions("Revenue on Desktop", desktopRevenue, data.categories, format, template, dateFormat, tooltipFormat);
	            this.mobileRecentRevenuehartOptions = this.analyticsService.getChartOptions("Revenue on Mobile Web", mobileRevenue, data.categories, format, template, dateFormat, tooltipFormat);
	            this.recentRevenueYoYChartOptions = this.analyticsService.getChartOptions("Daily Revenue YoY", dailyRevenueYoYSeries, data.categories, format, template, dateFormat, tooltipFormat);
	        }
	    }, {
	        key: "setRevenueByDeviceOptions",
	        value: function setRevenueByDeviceOptions(data) {
	            var format = "{0:N0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { weeks: "ddd dd MMM" };
	
	            var totalRevenueSeries = [];
	            totalRevenueSeries.push(data.series[0]);
	            totalRevenueSeries.push(data.series[1]);
	
	            var subscriptionDesktopRevenue = [];
	            subscriptionDesktopRevenue.push(data.series[2]);
	            subscriptionDesktopRevenue.push(data.series[3]);
	            subscriptionDesktopRevenue.push(data.series[4]);
	
	            var mobileSubscriptionRevenue = [];
	            mobileSubscriptionRevenue.push(data.series[5]);
	            mobileSubscriptionRevenue.push(data.series[6]);
	            mobileSubscriptionRevenue.push(data.series[7]);
	            mobileSubscriptionRevenue.push(data.series[8]);
	
	            this.desktopSubscriptionRecentRevenueChartOptions = this.analyticsService.getChartOptions("First Transaction on Desktop", subscriptionDesktopRevenue, data.categories, format, template, dateFormat, '', 'weeks');
	
	            this.mobileSubscriptionRecentRevenueChartOptions = this.analyticsService.getChartOptions("First Transaction on Mobile App", mobileSubscriptionRevenue, data.categories, format, template, dateFormat, '', 'weeks');
	        }
	    }, {
	        key: "setJobValueOverTimeOptions",
	        value: function setJobValueOverTimeOptions(data, fdata) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.jobValueOverTimeChartOptions = this.analyticsService.getChartOptions("GMV", data.series, data.categories, format, template, dateFormat);
	            this.jobsValueFYoYChartOptions = this.getColumnChartOptions("GMV", fdata, 2);
	        }
	    }, {
	        key: "setNewVersusRecurringRevenueOptions",
	        value: function setNewVersusRecurringRevenueOptions(data, helpersData) {
	            var format = "{0:C0}";
	            var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var totalRevenueSeries = [];
	            totalRevenueSeries.push(data.series[0]);
	            totalRevenueSeries.push(data.series[1]);
	            totalRevenueSeries.push(data.series[2]);
	
	            var quarterlyRevenueSeries = [];
	            quarterlyRevenueSeries.push(data.series[3]);
	            quarterlyRevenueSeries.push(data.series[4]);
	            quarterlyRevenueSeries.push(data.series[5]);
	
	            var annualRevenueSeries = [];
	            annualRevenueSeries.push(data.series[6]);
	            annualRevenueSeries.push(data.series[7]);
	            annualRevenueSeries.push(data.series[8]);
	
	            var familyNewRevenueSeries = [];
	            familyNewRevenueSeries.push(data.series[10]);
	            familyNewRevenueSeries.push(data.series[12]);
	            familyNewRevenueSeries.push(data.series[13]);
	            familyNewRevenueSeries.push(data.series[14]);
	            familyNewRevenueSeries.push(data.series[15]);
	            familyNewRevenueSeries.push(data.series[16]);
	
	            var familyRecurringRevenueSeries = [];
	            familyRecurringRevenueSeries.push(data.series[11]);
	            familyRecurringRevenueSeries.push(data.series[17]);
	            familyRecurringRevenueSeries.push(data.series[18]);
	            familyRecurringRevenueSeries.push(data.series[19]);
	            familyRecurringRevenueSeries.push(data.series[20]);
	
	            var helperNewRevenueSeries = [];
	            helperNewRevenueSeries.push(helpersData.series[1]);
	            helperNewRevenueSeries.push(helpersData.series[3]);
	            helperNewRevenueSeries.push(helpersData.series[4]);
	            helperNewRevenueSeries.push(helpersData.series[7]);
	
	            var helperRecurringRevenueSeries = [];
	            helperRecurringRevenueSeries.push(helpersData.series[2]);
	            helperRecurringRevenueSeries.push(helpersData.series[5]);
	            helperRecurringRevenueSeries.push(helpersData.series[6]);
	            helperRecurringRevenueSeries.push(helpersData.series[8]);
	
	            this.newVersusRecurringRevenueOptions = this.analyticsService.getChartOptions("New vs Recurring Revenue", totalRevenueSeries, data.categories, format, template, dateFormat);
	
	            this.newVersusRecurringQuarterlyRevenueOptions = this.analyticsService.getChartOptions("Quarterly Subscriptions - New vs Recurring Revenue", quarterlyRevenueSeries, data.categories, format, template, dateFormat);
	            this.newVersusRecurringAnnualRevenueOptions = this.analyticsService.getChartOptions("Annual Subscriptions - New vs Recurring Revenue", annualRevenueSeries, data.categories, format, template, dateFormat);
	
	            this.familyNewRevenueOptions = this.analyticsService.getChartOptions("New Family Revenue", familyNewRevenueSeries, data.categories, format, template, dateFormat);
	            this.familyRecurringRevenueOptions = this.analyticsService.getChartOptions("Recurring Family Revenue", familyRecurringRevenueSeries, data.categories, format, template, dateFormat);
	
	            this.helperNewRevenueOptions = this.analyticsService.getChartOptions("New Helper Revenue", helperNewRevenueSeries, helpersData.categories, format, template, dateFormat);
	            this.helperRecurringRevenueOptions = this.analyticsService.getChartOptions("Recurring Helper Revenue", helperRecurringRevenueSeries, helpersData.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setGeneralStatsOptions",
	        value: function setGeneralStatsOptions(data) {
	            var clientJourneySet = data.series[0];
	            this.clientJourneyOptions = this.analyticsService.getFunnelChartOptions(clientJourneySet.name, clientJourneySet.data);
	
	            var providerJourneySet = data.series[1];
	            this.providerJourneyOptions = this.analyticsService.getFunnelChartOptions(providerJourneySet.name, providerJourneySet.data);
	
	            var revenueAtGlanceSet = data.series[2];
	            var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueAtGlanceSet.name, revenueAtGlanceSet.totalCount, revenueAtGlanceSet.totalRevenue);
	            var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
	            this.revenueAtGlanceOptions = this.analyticsService.getDonutChartOptions(revenueAtGlanceSet, titleFormat, labelFormat);
	
	            var revenueByFrequencySet = data.series[4];
	            var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueByFrequencySet.name, revenueByFrequencySet.totalCount, revenueByFrequencySet.totalRevenue);
	            // var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
	            var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
	            this.revenueByFrequencyOptions = this.analyticsService.getDonutChartOptions(revenueByFrequencySet, "", labelFormat);
	
	            var jobDistributionSet = data.series[3];
	            titleFormat = kendo.format("{0}", jobDistributionSet.name, jobDistributionSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
	            this.jobDistributionOptions = this.analyticsService.getDonutChartOptions(jobDistributionSet, titleFormat, labelFormat);
	
	            var revenueBySourceSet = data.series[5];
	            titleFormat = kendo.format("{0}", revenueBySourceSet.name, revenueBySourceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
	            this.revenueBySourceOptions = this.analyticsService.getDonutChartOptions(revenueBySourceSet, "", labelFormat);
	
	            var jobsByManagementTypeSet = data.series[19];
	            titleFormat = kendo.format("{0}", jobsByManagementTypeSet.name, jobsByManagementTypeSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
	            this.jobsByManagementTypeOptions = this.analyticsService.getDonutChartOptions(jobsByManagementTypeSet, "", labelFormat);
	
	            var redemptionsBySourceSet = data.series[6];
	            titleFormat = kendo.format("{0} - Redemptions: {1}", redemptionsBySourceSet.name, redemptionsBySourceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Redemptions', dataItem.value)#";
	            this.redemptionsBySourceOptions = this.analyticsService.getDonutChartOptions(redemptionsBySourceSet, titleFormat, labelFormat);
	
	            var jobsByDeviceSet = data.series[7];
	            titleFormat = kendo.format("{0}", jobsByDeviceSet.name, jobsByDeviceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
	            this.jobsByDeviceOptions = this.analyticsService.getDonutChartOptions(jobsByDeviceSet, titleFormat, labelFormat);
	
	            var ratingsByType = data.series[12];
	            titleFormat = kendo.format("{0}", ratingsByType.name, ratingsByType.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Jobs', dataItem.value)#";
	            this.ratingsByJobType = this.analyticsService.getDonutChartOptions(ratingsByType, titleFormat, labelFormat);
	
	            var quarterlySubscriptionLegacyRenewals = data.series[13];
	            titleFormat = kendo.format("{0} - Total: {1:n0}", quarterlySubscriptionLegacyRenewals.name, quarterlySubscriptionLegacyRenewals.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
	            this.quarterlySubscriptionLegacyRenewalOptions = this.analyticsService.getDonutChartOptions(quarterlySubscriptionLegacyRenewals, titleFormat, labelFormat);
	
	            var quarterlySubscriptionRenewals = data.series[14];
	            titleFormat = kendo.format("{0} - Total: {1:n0}", quarterlySubscriptionRenewals.name, quarterlySubscriptionRenewals.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
	            this.quarterlySubscriptionRenewalOptions = this.analyticsService.getDonutChartOptions(quarterlySubscriptionRenewals, titleFormat, labelFormat);
	
	            var annualSubscriptionRenewals = data.series[15];
	            titleFormat = kendo.format("{0} - Total: {1:n0}", annualSubscriptionRenewals.name, annualSubscriptionRenewals.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
	            this.annualSubscriptionRenewalOptions = this.analyticsService.getDonutChartOptions(annualSubscriptionRenewals, titleFormat, labelFormat);
	
	            var frequentRecurringJobs = data.series[16];
	            titleFormat = kendo.format("{0} - Total: {1:n0}", frequentRecurringJobs.name, frequentRecurringJobs.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
	            this.frequentRecurringJobsOptions = this.analyticsService.getDonutChartOptions(frequentRecurringJobs, titleFormat, labelFormat);
	
	            var frequentOneOffJobs = data.series[17];
	            titleFormat = kendo.format("{0} - Total: {1:n0}", frequentOneOffJobs.name, frequentOneOffJobs.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
	            this.frequentOneOffJobsOptions = this.analyticsService.getDonutChartOptions(frequentOneOffJobs, titleFormat, labelFormat);
	
	            var monthlySubscriptionRenewals = data.series[18];
	            titleFormat = kendo.format("{0} - Total: {1:n0}", monthlySubscriptionRenewals.name, monthlySubscriptionRenewals.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
	            this.monthlySubscriptionRenewalOptions = this.analyticsService.getDonutChartOptions(monthlySubscriptionRenewals, titleFormat, labelFormat);
	        }
	    }]);
	    return AnalyticsController;
	}();
	
	exports.default = AnalyticsController;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(927);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-revenue.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-revenue.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.analytics-container{display:flex;flex-direction:column;height:100vh}.analytics-container .analytics-inner-container{margin-left:4rem}", ""]);
	
	// exports


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _analyticsUsers = __webpack_require__(929);
	
	var _analyticsUsers2 = _interopRequireDefault(_analyticsUsers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsModule = _angular2.default.module('app.containers.analytics-users', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('analyticsUsers', {
	    url: '/analytics-users',
	    template: '<analytics-users></analytics-users>'
	  });
	}]).component('analyticsUsers', _analyticsUsers2.default);
	
	exports.default = analyticsModule;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analyticsUsers = __webpack_require__(930);
	
	var _analyticsUsers2 = _interopRequireDefault(_analyticsUsers);
	
	var _analyticsUsers3 = __webpack_require__(931);
	
	var _analyticsUsers4 = _interopRequireDefault(_analyticsUsers3);
	
	__webpack_require__(932);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _analyticsUsers2.default,
	  controller: _analyticsUsers4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = analyticsComponent;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"analytics-container\" style=\"background-color: #eaeaec\">\r\n  <div class=\"analytics-inner-container\">\r\n    <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n    </div>\r\n    <div class=\"revenue-chart-container\" ng-if=\"!vm.isLoading\">\r\n       <div kendo-tab-strip>\r\n        <ul>\r\n          <li class=\"k-state-active\">Acquisition Funnels</li>\r\n          <li>Registrations at a Glance</li>\r\n          <li>Registrations by State (AU)</li>\r\n          <li>Recent Registrations (AU)</li>\r\n          <li>Recent Registrations (NZ)</li>\r\n          <li>Registrations by Region</li>\r\n          <li>Juggle St App</li>\r\n          <li>Account Stats</li>\r\n        </ul>\r\n\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <div kendo-chart k-options=\"vm.clientJourneyOptions\" style=\"display: inline-block; width: 500px; height: 350px; padding: 20px\"></div>\r\n          <div kendo-chart k-options=\"vm.providerJourneyOptions\" style=\"display: inline-block; width: 500px; height: 350px; padding: 20px\"></div>\r\n          <div kendo-chart k-options=\"vm.registrationsFinancialYearOverYearSummaryOptions\" style=\"display: inline-block; width: 500px; height: 350px; padding: 20px\"></div>\r\n        </div>\r\n\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <div id=\"registrations-over-time-chart\" kendo-chart k-options=\"vm.registrationsOverTimeOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.registrationsFinancialYearOverYearOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.registrationsByCountryOverTimeOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.topRegistrationsOptions\"></div>\r\n          <div>\r\n            <div kendo-chart k-options=\"vm.helpersByJobTypeSetOptions\" style=\"float: left; width: 500px; height: 350px\"></div>\r\n            <div kendo-chart k-options=\"vm.registrationsByDeviceOptions\" style=\"float: left; width: 500px; height: 350px; padding: 5px\"></div>\r\n            <div kendo-chart k-options=\"vm.parentRegistrationsByDeviceOptions\" style=\"float: left; width: 500px; height: 350px; padding: 5px\"></div>\r\n            <div kendo-chart k-options=\"vm.helperRegistrationsByDeviceOptions\" style=\"float: left; width: 500px; height: 350px\"></div>\r\n            <div style=\"clear:both\"></div>\r\n          </div>\r\n        </div>\r\n\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <div kendo-chart k-options=\"vm.registrationsByStateOverTimeOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.recentNSWRegistrationsOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.recentVICRegistrationsOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.recentQLDRegistrationsOptions\"></div>\r\n        </div>\r\n\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <div kendo-chart k-options=\"vm.recentRegistrationsOptions\"></div>\r\n          <!-- <div kendo-chart k-options=\"vm.recentRegistrationsBySourceOptions\"></div> -->\r\n          <div kendo-chart k-options=\"vm.recentRegistrationsByDeviceOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.recentRegistrationsByTypeByDeviceOptions\"></div>\r\n        </div>\r\n\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <div kendo-chart k-options=\"vm.recentRegistrationsNzOptions\"></div>\r\n          <!-- <div kendo-chart k-options=\"vm.recentRegistrationsBySourceNzOptions\"></div> -->\r\n          <div kendo-chart k-options=\"vm.recentRegistrationsByDeviceNzOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.recentRegistrationsByTypeByDeviceNzOptions\"></div>\r\n        </div>\r\n\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <div kendo-chart k-options=\"vm.nswRegistrationsByRegionOverTimeOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.vicRegistrationsByRegionOverTimeOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.qldRegistrationsByRegionOverTimeOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.nzRegistrationsByRegionOverTimeOptions\"></div>\r\n        </div>\r\n\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <div kendo-chart k-options=\"vm.recentAppDownloadsByDeviceOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.recentAppDownloadsByCountryOptions\"></div>\r\n          <div kendo-chart k-options=\"vm.recentDeviceRegistrationsByCountryOptions\"></div>\r\n        </div>\r\n\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <div id=\"account-approval-over-time\" kendo-chart k-options=\"vm.accountApprovalOverTimeOptions\" style=\"height: 600px\"></div>\r\n          <div kendo-chart k-options=\"vm.accountRatingsOverTimeOptions\" style=\"height: 600px\"></div>\r\n\r\n          <!-- <div style=\"margin: auto; max-width: 1000px\">\r\n            <div kendo-chart k-options=\"vm.clientProfileItemsPerYearOptions\" style=\"float: left; width: 450px; height: 350px; padding: 20px\"></div>\r\n            <div kendo-chart k-options=\"vm.providerProfileItemsPerYearOptions\" style=\"float: left; width: 450px; height: 350px; padding: 20px\"></div>\r\n            <div style=\"clear:both\"/>\r\n          </div> -->\r\n          <!-- <div kendo-chart k-options=\"vm.redemptionsBySourceOptions\" style=\"height: 400px\"></div> -->\r\n          <!-- <div id=\"customer-redemptions-and-paying-customers-over-time\" kendo-chart k-options=\"vm.redemptionsAndNewPayingCustomersOverTimeOptions\"></div> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(877);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsController = function () {
	    AnalyticsController.$inject = ["AnalyticsService", "$q"];
	    function AnalyticsController(AnalyticsService, $q) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, AnalyticsController);
	
	        this.getColumnChartOptions = function (title, data) {
	
	            var categories = [];
	
	            var ds = [];
	            // var seriesColors = [
	            //     "#007bc3",
	            //     "#76b800",
	            //     "#ffae00",
	            //     "#ef4c00",
	            //     "#a419b7",
	            //     "#430b62"
	            // ];
	
	            var seriesColors = ["#007bc3", "#007bc3", "#007bc3", "#007bc3", "#007bc3", "#76b800", "#a419b7", "#430b62"];
	
	            data.series.forEach(function (s, index) {
	                ds.push({
	                    data: s.totalCount,
	                    category: s.name,
	                    color: seriesColors[index]
	                });
	                categories.push(s.name);
	            });
	
	            return {
	                title: {
	                    text: title,
	                    position: "bottom"
	                },
	                dataSource: {
	                    data: ds
	                },
	                theme: "silver",
	                legend: {
	                    position: "top"
	                },
	                seriesDefaults: {
	                    type: "column",
	                    labels: {
	                        visible: true,
	                        format: "{0:n0}",
	                        background: "transparent"
	                    }
	                },
	                series: [{
	                    field: "data",
	                    categoryField: "category",
	                    colorField: "color"
	                }],
	                valueAxis: {
	                    format: "{0:n0}",
	                    majorGridLines: {
	                        visible: true
	                    },
	                    visible: false
	                },
	                categoryAxis: {
	                    majorGridLines: {
	                        visible: true
	                    },
	                    line: {
	                        visible: false
	                    }
	                }
	            };
	        };
	
	        this.analyticsService = AnalyticsService;
	        this.$q = $q;
	    }
	
	    (0, _createClass3.default)(AnalyticsController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this = this;
	
	            this.isLoading = true;
	
	            var registrationsOvertimePromise = this.analyticsService.getRegistrationsOverTimeData();
	            var recentRegistrationsPromise = this.analyticsService.getRecentRegistrationsData();
	            var recentNSWRegistrationsPromise = this.analyticsService.getRecentNSWRegistrationsData();
	            var recentVICRegistrationsPromise = this.analyticsService.getRecentVICRegistrationsData();
	            var recentQLDRegistrationsPromise = this.analyticsService.getRecentQLDRegistrationsData();
	            var accountApprovalOverTimePromise = this.analyticsService.getAccountApprovalOverTime();
	            var getGeneralStatsPromise = this.analyticsService.getGeneralStatsData();
	            var clientProfileItemsPerYearPromise = this.analyticsService.getClientProfileItemsPerYearData();
	            var providerProfileItemsPerYearPromise = this.analyticsService.getProviderProfileItemsPerYearData();
	            var getNSWRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getNSWRegistrationsByRegionOverTimeData();
	            var getVICRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getVICRegistrationsByRegionOverTimeData();
	            var getQLDRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getQLDRegistrationsByRegionOverTimeData();
	            var getNZRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getNZRegistrationsByRegionOverTimeData();
	            var payingCustomersPromise = this.analyticsService.getPayingCustomersData();
	            var customerRedemptionsOverTimePromise = this.analyticsService.getCustomerRedemptionsOverTime();
	            var getRegistrationsYearOverYearPromise = this.analyticsService.getRegistrationsYearOverYearData();
	            var getRegistrationsFinancialYearOverYearPromise = this.analyticsService.getRegistrationsFinancialYearOverYearData();
	            var topRegistrationsPromise = this.analyticsService.getTopRegistrationsData();
	            var registrationsByStatePromise = this.analyticsService.getRegistrationsByStateData();
	            var recentAppDownloadsPromise = this.analyticsService.getRecentAppDownloadsData();
	            var accountRatingsPromise = this.analyticsService.getAccountRatingsBreakdownData();
	
	            this.$q.all([payingCustomersPromise, customerRedemptionsOverTimePromise, registrationsOvertimePromise, recentRegistrationsPromise, recentNSWRegistrationsPromise, recentVICRegistrationsPromise, recentQLDRegistrationsPromise, accountApprovalOverTimePromise, getGeneralStatsPromise, clientProfileItemsPerYearPromise, providerProfileItemsPerYearPromise, getNSWRegistrationsByRegionOverTimeDataPromise, getVICRegistrationsByRegionOverTimeDataPromise, getQLDRegistrationsByRegionOverTimeDataPromise, getRegistrationsYearOverYearPromise, topRegistrationsPromise, registrationsByStatePromise, getNZRegistrationsByRegionOverTimeDataPromise, getRegistrationsFinancialYearOverYearPromise, recentAppDownloadsPromise, accountRatingsPromise]).then(function (data) {
	                var _data = (0, _slicedToArray3.default)(data, 21),
	                    payingCustomersResponse = _data[0],
	                    customerRedemptionsOverTimeResponse = _data[1],
	                    registrationsOvertimeResponse = _data[2],
	                    recentRegistrationsResponse = _data[3],
	                    recentNSWRegistrationsResponse = _data[4],
	                    recentVICRegistrationsResponse = _data[5],
	                    recentQLDRegistrationsResponse = _data[6],
	                    accountApprovalOverTimeResponse = _data[7],
	                    getGeneralStatsResponse = _data[8],
	                    clientProfileItemsPerYearResponse = _data[9],
	                    providerProfileItemsPerYearResponse = _data[10],
	                    getNSWRegistrationsByRegionOverTimeDataResponse = _data[11],
	                    getVICRegistrationsByRegionOverTimeDataResponse = _data[12],
	                    getQLDRegistrationsByRegionOverTimeDataResponse = _data[13],
	                    getRegistrationsYearOverYearResponse = _data[14],
	                    topRegistrationsResponse = _data[15],
	                    registrationsByStateResponse = _data[16],
	                    getNZRegistrationsByRegionOverTimeResponse = _data[17],
	                    getRegistrationsFinancialYearOverYearResponse = _data[18],
	                    recentAppDownloadsResponse = _data[19],
	                    accountRatingsResponse = _data[20];
	
	                _this.setRegistrationsOverTimeChartOptions(registrationsOvertimeResponse);
	                _this.setRegistrationsYearOverYearChartOptions(getRegistrationsYearOverYearResponse, getRegistrationsFinancialYearOverYearResponse);
	
	                _this.setRecentRegistrationsChartOptions(recentRegistrationsResponse);
	                _this.setRecentAppDownloadsChartOptions(recentAppDownloadsResponse);
	                _this.setTopRegistrationsChartOptions(topRegistrationsResponse);
	                _this.setRecentNSWRegistrationsChartOptions(recentNSWRegistrationsResponse);
	                _this.setRecentVICRegistrationsChartOptions(recentVICRegistrationsResponse);
	                _this.setRecentQLDRegistrationsChartOptions(recentQLDRegistrationsResponse);
	
	                _this.setRedemptionsAndNewPayingCustomersOverTimeOptions(payingCustomersResponse, customerRedemptionsOverTimeResponse);
	
	                _this.setAccountApprovalOverTimeOptions(accountApprovalOverTimeResponse);
	
	                _this.setGeneralStatsOptions(getGeneralStatsResponse);
	
	                _this.setClientProfileItemsPerYearOptions(clientProfileItemsPerYearResponse);
	
	                _this.setProviderProfileItemsPerYearOptions(providerProfileItemsPerYearResponse);
	
	                _this.setRegistrationsByRegionOverTimeChartOptions(getNSWRegistrationsByRegionOverTimeDataResponse, getVICRegistrationsByRegionOverTimeDataResponse, getQLDRegistrationsByRegionOverTimeDataResponse, registrationsByStateResponse, getNZRegistrationsByRegionOverTimeResponse);
	
	                _this.setAccountRatingsOverTimeOptions(accountRatingsResponse);
	                _this.isLoading = false;
	            });
	        }
	    }, {
	        key: "setRedemptionsAndNewPayingCustomersOverTimeOptions",
	        value: function setRedemptionsAndNewPayingCustomersOverTimeOptions(redemptions, newPayingCustomers) {
	            var format = "{0}";
	            var template = "#: text # - Customers: #: series.totalCount #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            var series = [];
	            series.push(newPayingCustomers.series[0]);
	            series.push(redemptions.series[0]);
	
	            this.redemptionsAndNewPayingCustomersOverTimeOptions = this.analyticsService.getChartOptions("Redemptions & New Paying Customers", series, redemptions.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setRegistrationsOverTimeChartOptions",
	        value: function setRegistrationsOverTimeChartOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.registrationsOverTimeOptions = this.analyticsService.getChartOptions("Registrations Over Time", data.series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setAccountRatingsOverTimeOptions",
	        value: function setAccountRatingsOverTimeOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.accountRatingsOverTimeOptions = this.analyticsService.getChartOptions("Account Ratings Over Time", data.series, data.categories, format, template, dateFormat);
	        }
	    }, {
	        key: "setRegistrationsYearOverYearChartOptions",
	        value: function setRegistrationsYearOverYearChartOptions(data, fdata) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { months: "MMM" };
	
	            this.registrationsYearOverYearOptions = this.analyticsService.getChartOptions("Registrations YoY", data.series, data.categories, format, template, dateFormat);
	            this.registrationsFinancialYearOverYearOptions = this.analyticsService.getChartOptions("Registrations FYoY", fdata.series, fdata.categories, format, template, dateFormat);
	            this.registrationsFinancialYearOverYearSummaryOptions = this.getColumnChartOptions("Registrations by Financial Year", fdata);
	        }
	    }, {
	        key: "setRegistrationsByRegionOverTimeChartOptions",
	        value: function setRegistrationsByRegionOverTimeChartOptions(nswData, vicData, qldData, stateData, nzData) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { months: "MMM 'yy" };
	
	            this.nswRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("NSW Registrations By Region", nswData.series, nswData.categories, format, template, dateFormat);
	            this.vicRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("VIC Registrations By Region", vicData.series, vicData.categories, format, template, dateFormat);
	            this.qldRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("QLD Registrations By Region", qldData.series, qldData.categories, format, template, dateFormat);
	            this.nzRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("NZ Registrations By Region", nzData.series, nzData.categories, format, template, dateFormat);
	
	            var parsedCats = stateData.categories.map(function (item) {
	                return kendo.toString(new Date(item), "yy-MM");
	            });
	            var tooltipTemplate = function tooltipTemplate(e) {
	                var date = kendo.toString(new Date(e.category), "MMM yyyy");
	                var idx = parsedCats.indexOf(kendo.toString(e.category, "yy-MM"));
	                var totalSeries = stateData.series[0];
	                var total = totalSeries.data[idx];
	
	                var ratio = kendo.toString(e.dataItem.value / total, "p");
	                return date + ' - ' + ratio;
	            };
	
	            var stateSeries = [];
	            stateSeries.push(stateData.series[0]);
	            stateSeries.push(stateData.series[1]);
	            stateSeries.push(stateData.series[2]);
	            stateSeries.push(stateData.series[3]);
	            stateSeries.push(stateData.series[4]);
	            stateSeries.push(stateData.series[5]);
	            this.registrationsByStateOverTimeOptions = this.analyticsService.getChartOptions("Registrations By State", stateSeries, stateData.categories, format, template, dateFormat, tooltipTemplate);
	
	            var countrySeries = [];
	            countrySeries.push(stateData.series[6]);
	            countrySeries.push(stateData.series[7]);
	            this.registrationsByCountryOverTimeOptions = this.analyticsService.getChartOptions("Registrations By Country", countrySeries, stateData.categories, format, template, dateFormat, tooltipTemplate);
	        }
	    }, {
	        key: "setRecentAppDownloadsChartOptions",
	        value: function setRecentAppDownloadsChartOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { days: "ddd dd" };
	            var downloadsByDeviceSeries = [];
	            downloadsByDeviceSeries.push(data.series[0]);
	            downloadsByDeviceSeries.push(data.series[1]);
	            downloadsByDeviceSeries.push(data.series[2]);
	
	            var downloadsByCountrySeries = [];
	            downloadsByCountrySeries.push(data.series[0]);
	            downloadsByCountrySeries.push(data.series[3]);
	            downloadsByCountrySeries.push(data.series[4]);
	
	            var regsByCountrySeries = [];
	            regsByCountrySeries.push(data.series[5]);
	            regsByCountrySeries.push(data.series[6]);
	            regsByCountrySeries.push(data.series[7]);
	
	            this.recentAppDownloadsByDeviceOptions = this.analyticsService.getChartOptions("App Downloads by Device", downloadsByDeviceSeries, data.categories, format, template, dateFormat, null, "days");
	            this.recentAppDownloadsByCountryOptions = this.analyticsService.getChartOptions("App Downloads by Country", downloadsByCountrySeries, data.categories, format, template, dateFormat, null, "days");
	            this.recentDeviceRegistrationsByCountryOptions = this.analyticsService.getChartOptions("App Registrations by Device", regsByCountrySeries, data.categories, format, template, dateFormat, null, "days");
	        }
	    }, {
	        key: "setRecentRegistrationsChartOptions",
	        value: function setRecentRegistrationsChartOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { days: "ddd dd" };
	
	            var recentRegSeries = [];
	            recentRegSeries.push(data.series[0]);
	            recentRegSeries.push(data.series[1]);
	            recentRegSeries.push(data.series[2]);
	            recentRegSeries.push(data.series[34]);
	
	            var recentRegByDeviceSeries = [];
	            recentRegByDeviceSeries.push(data.series[0]);
	            recentRegByDeviceSeries.push(data.series[3]);
	            recentRegByDeviceSeries.push(data.series[4]);
	            recentRegByDeviceSeries.push(data.series[28]);
	
	            var recentRegByTypeByDeviceSeries = [];
	            recentRegByTypeByDeviceSeries.push(data.series[5]);
	            recentRegByTypeByDeviceSeries.push(data.series[6]);
	            recentRegByTypeByDeviceSeries.push(data.series[7]);
	            recentRegByTypeByDeviceSeries.push(data.series[8]);
	            recentRegByTypeByDeviceSeries.push(data.series[29]);
	            recentRegByTypeByDeviceSeries.push(data.series[30]);
	
	            var recentRegBySourceSeries = [];
	            recentRegBySourceSeries.push(data.series[18]);
	            recentRegBySourceSeries.push(data.series[19]);
	            recentRegBySourceSeries.push(data.series[20]);
	            recentRegBySourceSeries.push(data.series[21]);
	            recentRegBySourceSeries.push(data.series[22]);
	
	            this.recentRegistrationsOptions = this.analyticsService.getChartOptions("Recent Registrations", recentRegSeries, data.categories, format, template, dateFormat, null, "days");
	
	            this.recentRegistrationsByDeviceOptions = this.analyticsService.getChartOptions("Recent Registrations by Device", recentRegByDeviceSeries, data.categories, format, template, dateFormat, null, "days");
	
	            this.recentRegistrationsByTypeByDeviceOptions = this.analyticsService.getChartOptions("Recent Registrations by Type by Device", recentRegByTypeByDeviceSeries, data.categories, format, template, dateFormat, null, "days");
	
	            this.recentRegistrationsBySourceOptions = this.analyticsService.getChartOptions("Recent Registrations - Acquisition Source", recentRegBySourceSeries, data.categories, format, template, dateFormat, null, "days");
	
	            var recentRegNzSeries = [];
	            recentRegNzSeries.push(data.series[9]);
	            recentRegNzSeries.push(data.series[10]);
	            recentRegNzSeries.push(data.series[11]);
	            recentRegNzSeries.push(data.series[35]);
	
	            var recentRegByDeviceNzSeries = [];
	            recentRegByDeviceNzSeries.push(data.series[9]);
	            recentRegByDeviceNzSeries.push(data.series[12]);
	            recentRegByDeviceNzSeries.push(data.series[13]);
	            recentRegByDeviceNzSeries.push(data.series[31]);
	
	            var recentRegByTypeByDeviceNzSeries = [];
	            recentRegByTypeByDeviceNzSeries.push(data.series[14]);
	            recentRegByTypeByDeviceNzSeries.push(data.series[15]);
	            recentRegByTypeByDeviceNzSeries.push(data.series[16]);
	            recentRegByTypeByDeviceNzSeries.push(data.series[17]);
	            recentRegByTypeByDeviceNzSeries.push(data.series[32]);
	            recentRegByTypeByDeviceNzSeries.push(data.series[33]);
	
	            var recentRegBySourceNzSeries = [];
	            recentRegBySourceNzSeries.push(data.series[23]);
	            recentRegBySourceNzSeries.push(data.series[24]);
	            recentRegBySourceNzSeries.push(data.series[25]);
	            recentRegBySourceNzSeries.push(data.series[26]);
	            recentRegBySourceNzSeries.push(data.series[27]);
	
	            this.recentRegistrationsNzOptions = this.analyticsService.getChartOptions("Recent Registrations", recentRegNzSeries, data.categories, format, template, dateFormat, null, "days");
	
	            this.recentRegistrationsByDeviceNzOptions = this.analyticsService.getChartOptions("Recent Registrations by Device", recentRegByDeviceNzSeries, data.categories, format, template, dateFormat, null, "days");
	
	            this.recentRegistrationsByTypeByDeviceNzOptions = this.analyticsService.getChartOptions("Recent Registrations by Type by Device", recentRegByTypeByDeviceNzSeries, data.categories, format, template, dateFormat, null, "days");
	
	            this.recentRegistrationsBySourceNzOptions = this.analyticsService.getChartOptions("Recent Registrations - Acquisition Source", recentRegBySourceNzSeries, data.categories, format, template, dateFormat, null, "days");
	        }
	    }, {
	        key: "setTopRegistrationsChartOptions",
	        value: function setTopRegistrationsChartOptions(data) {
	            this.topRegistrationsOptions = {
	                title: {
	                    text: 'Hall of Fame'
	                },
	                theme: "silver",
	                legend: {
	                    visible: false
	                },
	                seriesDefaults: {
	                    type: "column",
	                    labels: {
	                        visible: true,
	                        format: "{0:n0}"
	                    }
	                },
	                series: data.series,
	                valueAxis: {
	                    labels: {
	                        format: "{0:n0}"
	                    },
	                    line: {
	                        visible: false
	                    }
	                },
	                categoryAxis: {
	                    categories: data.categories,
	                    labels: {
	                        template: "#= kendo.toString(new Date(value), 'ddd d MMM yy') #"
	                    },
	                    line: {
	                        visible: false
	                    }
	                },
	                tooltip: {
	                    visible: true,
	                    format: "{0}%",
	                    template: "#= series.name #: #= kendo.toString(value, 'n0') #"
	                }
	            };
	        }
	    }, {
	        key: "setRecentNSWRegistrationsChartOptions",
	        value: function setRecentNSWRegistrationsChartOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { days: "ddd dd" };
	
	            this.recentNSWRegistrationsOptions = this.analyticsService.getChartOptions("Recent NSW Registrations", data.series, data.categories, format, template, dateFormat, null, "days");
	        }
	    }, {
	        key: "setRecentVICRegistrationsChartOptions",
	        value: function setRecentVICRegistrationsChartOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { days: "ddd dd" };
	
	            this.recentVICRegistrationsOptions = this.analyticsService.getChartOptions("Recent VIC Registrations", data.series, data.categories, format, template, dateFormat, null, "days");
	        }
	    }, {
	        key: "setRecentQLDRegistrationsChartOptions",
	        value: function setRecentQLDRegistrationsChartOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { days: "ddd dd" };
	
	            this.recentQLDRegistrationsOptions = this.analyticsService.getChartOptions("Recent QLD Registrations", data.series, data.categories, format, template, dateFormat, null, "days");
	        }
	    }, {
	        key: "setAccountApprovalOverTimeOptions",
	        value: function setAccountApprovalOverTimeOptions(data) {
	            var format = "{0}";
	            var template = "#: text #: #: series.totalCount #";
	            var dateFormat = { days: "ddd dd" };
	
	            var parsedCats = data.categories.map(function (item) {
	                return kendo.toString(new Date(item), "yy-MM");
	            });
	            var tooltipTemplate = function tooltipTemplate(e) {
	                var idx = parsedCats.indexOf(kendo.toString(e.category, "yy-MM"));
	
	                var activeSeries = data.series[e.series.index];
	                var relatedSeries;
	                if (e.series.index < 2) relatedSeries = data.series[e.series.index == 0 ? 1 : 0];else relatedSeries = data.series[e.series.index == 2 ? 3 : 2];
	                var relatedItem = relatedSeries.data[idx];
	                var total = e.dataItem.value + relatedItem;
	
	                var ratio = kendo.toString(e.dataItem.value / total, "p");
	                return ratio;
	            };
	
	            this.accountApprovalOverTimeOptions = this.analyticsService.getChartOptions("Pending vs Approved Accounts", data.series, data.categories, format, template, dateFormat, tooltipTemplate);
	        }
	    }, {
	        key: "setGeneralStatsOptions",
	        value: function setGeneralStatsOptions(data) {
	            var clientJourneySet = data.series[0];
	            this.clientJourneyOptions = this.analyticsService.getFunnelChartOptions(clientJourneySet.name, clientJourneySet.data, this.analyticsService.getPercentage);
	
	            var providerJourneySet = data.series[1];
	            this.providerJourneyOptions = this.analyticsService.getFunnelChartOptions(providerJourneySet.name, providerJourneySet.data, this.analyticsService.getPercentage);
	
	            var revenueAtGlanceSet = data.series[2];
	            var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueAtGlanceSet.name, revenueAtGlanceSet.totalCount, revenueAtGlanceSet.totalRevenue);
	            var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
	            this.revenueAtGlanceOptions = this.analyticsService.getDonutChartOptions(revenueAtGlanceSet, titleFormat, labelFormat);
	
	            var revenueByFrequencySet = data.series[4];
	            var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueByFrequencySet.name, revenueByFrequencySet.totalCount, revenueByFrequencySet.totalRevenue);
	            var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
	            this.revenueByFrequencyOptions = this.analyticsService.getDonutChartOptions(revenueByFrequencySet, titleFormat, labelFormat);
	
	            var jobDistributionSet = data.series[3];
	            titleFormat = kendo.format("{0} - TRX: {1}", jobDistributionSet.name, jobDistributionSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Jobs', dataItem.value)#";
	            this.jobDistributionOptions = this.analyticsService.getDonutChartOptions(jobDistributionSet, titleFormat, labelFormat);
	
	            var revenueBySourceSet = data.series[5];
	            titleFormat = kendo.format("{0} - Parents: {1}", revenueBySourceSet.name, revenueBySourceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Parents', dataItem.value)#";
	            this.revenueBySourceOptions = this.analyticsService.getDonutChartOptions(revenueBySourceSet, titleFormat, labelFormat);
	
	            var redemptionsBySourceSet = data.series[6];
	            titleFormat = kendo.format("{0}", redemptionsBySourceSet.name, redemptionsBySourceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p2}', value) #";
	            this.redemptionsBySourceOptions = this.analyticsService.getDonutChartOptions(redemptionsBySourceSet, titleFormat, labelFormat);
	
	            var jobsByDeviceSet = data.series[7];
	            titleFormat = kendo.format("{0} - TRX: {1}", jobsByDeviceSet.name, jobsByDeviceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
	            this.jobsByDeviceOptions = this.analyticsService.getDonutChartOptions(jobsByDeviceSet, titleFormat, labelFormat);
	
	            var registrationsByDeviceSet = data.series[8];
	            titleFormat = kendo.format("{0}", registrationsByDeviceSet.name, registrationsByDeviceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p2}', value) #";
	            this.registrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(registrationsByDeviceSet, titleFormat, labelFormat);
	
	            var parentRegistrationsByDeviceSet = data.series[9];
	            titleFormat = kendo.format("{0}", parentRegistrationsByDeviceSet.name, parentRegistrationsByDeviceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p2}', value) #";
	            this.parentRegistrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(parentRegistrationsByDeviceSet, titleFormat, labelFormat);
	
	            var helperRegistrationsByDeviceSet = data.series[10];
	            titleFormat = kendo.format("{0}", helperRegistrationsByDeviceSet.name, helperRegistrationsByDeviceSet.totalCount);
	            labelFormat = "#= category # - #= kendo.format('{0:p2}', value) #";
	            this.helperRegistrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(helperRegistrationsByDeviceSet, titleFormat, labelFormat);
	
	            var helpersByJobTypeSet = data.series[11];
	            if (helpersByJobTypeSet) {
	                titleFormat = kendo.format("{0}", helpersByJobTypeSet.name, helpersByJobTypeSet.totalCount);
	                labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Helpers', dataItem.value)#";
	                this.helpersByJobTypeSetOptions = this.analyticsService.getDonutChartOptions(helpersByJobTypeSet, titleFormat, labelFormat);
	            }
	        }
	    }, {
	        key: "setClientProfileItemsPerYearOptions",
	        value: function setClientProfileItemsPerYearOptions(data) {
	            this.clientProfileItemsPerYearOptions = this.analyticsService.getColumnChartOptions("Missing Items in Parent Accounts ", data);
	        }
	    }, {
	        key: "setProviderProfileItemsPerYearOptions",
	        value: function setProviderProfileItemsPerYearOptions(data) {
	            this.providerProfileItemsPerYearOptions = this.analyticsService.getColumnChartOptions("Missing Items in Helper Accounts ", data);
	        }
	    }]);
	    return AnalyticsController;
	}();
	
	exports.default = AnalyticsController;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(933);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-users.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-users.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.analytics-container{display:flex;flex-direction:column;height:100vh}.analytics-container .analytics-inner-container{margin-left:4rem}", ""]);
	
	// exports


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _analyticsTraffic = __webpack_require__(935);
	
	var _analyticsTraffic2 = _interopRequireDefault(_analyticsTraffic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsModule = _angular2.default.module('app.containers.analytics-traffic', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('analyticsTraffic', {
	    url: '/analytics-traffic',
	    template: '<analytics-traffic></analytics-traffic>'
	  });
	}]).component('analyticsTraffic', _analyticsTraffic2.default);
	
	exports.default = analyticsModule;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analyticsTraffic = __webpack_require__(936);
	
	var _analyticsTraffic2 = _interopRequireDefault(_analyticsTraffic);
	
	var _analyticsTraffic3 = __webpack_require__(937);
	
	var _analyticsTraffic4 = _interopRequireDefault(_analyticsTraffic3);
	
	__webpack_require__(938);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _analyticsTraffic2.default,
	  controller: _analyticsTraffic4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = analyticsComponent;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"analytics-container\" style=\"background-color: #eaeaec\">\r\n  <div class=\"analytics-inner-container\">\r\n    <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n    </div>    \r\n    <div ng-if=\"!vm.isLoading\">\r\n      Coming soon...              \r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsController = function () {
	  AnalyticsController.$inject = ["AnalyticsService", "$q"];
	  function AnalyticsController(AnalyticsService, $q) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AnalyticsController);
	    this.analyticsService = AnalyticsService;
	    this.$q = $q;
	  }
	
	  (0, _createClass3.default)(AnalyticsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.isLoading = false;
	    }
	  }]);
	  return AnalyticsController;
	}();
	
	exports.default = AnalyticsController;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(939);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-traffic.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-traffic.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.analytics-container{display:flex;flex-direction:column;height:100vh}.analytics-container .analytics-inner-container{margin-left:4rem}", ""]);
	
	// exports


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _analyticsData = __webpack_require__(941);
	
	var _analyticsData2 = _interopRequireDefault(_analyticsData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsModule = _angular2.default.module('app.containers.analytics-data', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('analyticsData', {
	    url: '/analytics-data',
	    template: '<analytics-data></analytics-data>'
	  });
	}]).component('analyticsData', _analyticsData2.default);
	
	exports.default = analyticsModule;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analyticsData = __webpack_require__(942);
	
	var _analyticsData2 = _interopRequireDefault(_analyticsData);
	
	var _analyticsData3 = __webpack_require__(943);
	
	var _analyticsData4 = _interopRequireDefault(_analyticsData3);
	
	__webpack_require__(944);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _analyticsData2.default,
	  controller: _analyticsData4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = analyticsComponent;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"analytics-container\" style=\"background-color: #eaeaec\">\r\n  <div class=\"analytics-inner-container\">\r\n    <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n    </div>\r\n    <div class=\"revenue-chart-container\" ng-if=\"!vm.isLoading\">\r\n      <div kendo-tab-strip>\r\n        <ul>\r\n          <li class=\"k-state-active\">Registrations</li>\r\n          <!-- <li>Rego by Source</li> -->\r\n          <li>Revenue</li>\r\n          <!-- <li>Repeat Customers</li>\r\n          <li>Organic First-time Customers</li> -->\r\n          <!-- <li>Paid First-time Customers</li> -->\r\n          <!-- <li>Aggregates</li> -->\r\n        </ul>\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <h4 style=\"margin: 10px 0\">New Registrations</h4>\r\n          <div kendo-grid k-options=\"vm.registrationsOverTimeGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Family Approvals</h4>\r\n          <div kendo-grid k-options=\"vm.approvalsOverTimeGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Helper Approvals</h4>\r\n          <div kendo-grid k-options=\"vm.helperApprovalsOverTimeGridOptions\"></div>\r\n        </div>\r\n        <!-- <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <h4 style=\"margin: 10px 0\">Family Registrations by Source (AU)</h4>\r\n          <div kendo-grid k-options=\"vm.auFamilyRegistrationsBySource\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Family Registrations by Source (NZ)</h4>\r\n          <div kendo-grid k-options=\"vm.nzFamilyRegistrationsBySource\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Helper Registrations by Source (AU)</h4>\r\n          <div kendo-grid k-options=\"vm.auHelperRegistrationsBySource\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Helper Registrations by Source (NZ)</h4>\r\n          <div kendo-grid k-options=\"vm.nzHelperRegistrationsBySource\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Total Registrations</h4>\r\n          <div kendo-grid k-options=\"vm.registrationsByCountry\"></div>\r\n        </div> -->\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <h4 style=\"margin: 10px 0\">First Time Paying Customers</h4>\r\n          <div kendo-grid k-options=\"vm.firstTimePayingCustomersGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Repeat Customers</h4>\r\n          <div kendo-grid k-options=\"vm.recurringPayingCustomersGridOptions\"></div>\r\n\r\n          <!-- <h4 style=\"margin: 10px 0\">First Time Paying Customers (Count)</h4>\r\n          <div kendo-grid k-options=\"vm.firstTimePayingCustomersSummaryGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">First Time Paying Customers (Dollar Value)</h4>\r\n          <div kendo-grid k-options=\"vm.firstTimePayingCustomersRevenueSummaryGridOptions\"></div> -->\r\n\r\n          <!-- <h4 style=\"margin: 10px 0\">New QS Customers</h4>\r\n          <div kendo-grid k-options=\"vm.firstTimeQSPayingCustomersGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">New AS Customers</h4>\r\n          <div kendo-grid k-options=\"vm.firstTimeASPayingCustomersGridOptions\"></div> -->\r\n        </div>\r\n        <!-- <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <h4 style=\"margin: 10px 0\">Repeat Customers</h4>\r\n          <div kendo-grid k-options=\"vm.recurringPayingCustomersGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Repeat Paying Customers (Count)</h4>\r\n          <div kendo-grid k-options=\"vm.recurringPayingCustomersSummaryGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Repeat Paying Customers (Dollar Value)</h4>\r\n          <div kendo-grid k-options=\"vm.recurringPayingCustomersRevenueSummaryGridOptions\"></div>\r\n        </div> -->\r\n        <!-- <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <h4 style=\"margin: 10px 0\">Organic First Time Paying Customers</h4>\r\n          <div kendo-grid k-options=\"vm.organicFirstTimePayingCustomersGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Organic First Time Paying Customers</h4>\r\n          <div kendo-grid k-options=\"vm.organicFirstTimePayingCustomersRevenueGridOptions\"></div>\r\n        </div>\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <h4 style=\"margin: 10px 0\">Paid First Time Paying Customers</h4>\r\n          <div kendo-grid k-options=\"vm.paidFirstTimePayingCustomersGridOptions\"></div>\r\n\r\n          <h4 style=\"margin: 10px 0\">Paid First Time Paying Customers</h4>\r\n          <div kendo-grid k-options=\"vm.paidFirstTimePayingCustomersRevenueGridOptions\"></div>\r\n        </div> -->\r\n        <!-- <div style=\"padding: 1em; background-color: #eaeaec\">\r\n          <h4 style=\"margin: 10px 0\">Aggregate Totals</h4>\r\n          <div kendo-grid k-options=\"vm.aggregateTotalsGridOptions\"></div>\r\n        </div> -->\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(877);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsController = function () {
	    AnalyticsController.$inject = ["AnalyticsService", "$q"];
	    function AnalyticsController(AnalyticsService, $q) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, AnalyticsController);
	        this.analyticsService = AnalyticsService;
	        this.$q = $q;
	    }
	
	    (0, _createClass3.default)(AnalyticsController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this = this;
	
	            this.isLoading = true;
	
	            var getDataSetsPromise = this.analyticsService.getDataSets();
	
	            this.$q.all([getDataSetsPromise]).then(function (data) {
	                var _data = (0, _slicedToArray3.default)(data, 1),
	                    getDataSetsResponse = _data[0];
	
	                _this.setDataSetsOptions(getDataSetsResponse);
	
	                _this.isLoading = false;
	            });
	        }
	    }, {
	        key: "setDataSetsOptions",
	        value: function setDataSetsOptions(set) {
	            this.registrationsOverTimeGridOptions = this.getGridOptions(set[0]);
	            this.approvalsOverTimeGridOptions = this.getGridOptions(set[1]);
	            this.helperApprovalsOverTimeGridOptions = this.getGridOptions(set[17]);
	
	            this.firstTimePayingCustomersGridOptions = this.getGridOptions(set[2]);
	            this.organicFirstTimePayingCustomersGridOptions = this.getGridOptions(set[3]);
	            this.paidFirstTimePayingCustomersGridOptions = this.getGridOptions(set[4]);
	
	            this.recurringPayingCustomersGridOptions = this.getGridOptions(set[5]);
	            this.aggregateTotalsGridOptions = this.getGridOptions(set[6]);
	
	            this.organicFirstTimePayingCustomersRevenueGridOptions = this.getGridOptions(set[7]);
	            this.paidFirstTimePayingCustomersRevenueGridOptions = this.getGridOptions(set[8]);
	
	            this.firstTimePayingCustomersSummaryGridOptions = this.getGridOptions(set[9]);
	            this.firstTimePayingCustomersRevenueSummaryGridOptions = this.getGridOptions(set[10]);
	
	            this.recurringPayingCustomersSummaryGridOptions = this.getGridOptions(set[11]);
	            this.recurringPayingCustomersRevenueSummaryGridOptions = this.getGridOptions(set[12]);
	
	            this.auFamilyRegistrationsBySource = this.getGridOptions(set[13]);
	            this.nzFamilyRegistrationsBySource = this.getGridOptions(set[14]);
	            this.auHelperRegistrationsBySource = this.getGridOptions(set[15]);
	            this.nzHelperRegistrationsBySource = this.getGridOptions(set[16]);
	            this.registrationsByCountry = this.getGridOptions(set[18]);
	
	            // this.firstTimeQSPayingCustomersGridOptions = this.getGridOptions(set[4]);
	            // this.firstTimeASPayingCustomersGridOptions = this.getGridOptions(set[5]);
	            // this.redemptionsGridOptions = this.getGridOptions(set[6]);
	        }
	    }, {
	        key: "getGridOptions",
	        value: function getGridOptions(set) {
	            var data = set.data;
	            var columns = set.dataInfo;
	            columns[0].width = "250px";
	
	            return {
	                dataSource: {
	                    data: data,
	                    pageable: false
	                },
	                columns: columns,
	                scrollable: false,
	                sortable: false,
	                filterable: false
	            };
	        }
	    }]);
	    return AnalyticsController;
	}();
	
	exports.default = AnalyticsController;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(945);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-data.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-data.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.analytics-container{display:flex;flex-direction:column;height:100vh}.analytics-container .analytics-inner-container{margin-left:4rem}", ""]);
	
	// exports


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _analyticsBot = __webpack_require__(947);
	
	var _analyticsBot2 = _interopRequireDefault(_analyticsBot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsModule = _angular2.default.module('app.containers.analytics-bot', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('analyticsBot', {
	    url: '/analytics-bot',
	    template: '<analytics-bot></analytics-bot>'
	  });
	}]).component('analyticsBot', _analyticsBot2.default);
	
	exports.default = analyticsModule;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analyticsBot = __webpack_require__(948);
	
	var _analyticsBot2 = _interopRequireDefault(_analyticsBot);
	
	var _analyticsBot3 = __webpack_require__(949);
	
	var _analyticsBot4 = _interopRequireDefault(_analyticsBot3);
	
	__webpack_require__(950);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _analyticsBot2.default,
	  controller: _analyticsBot4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = analyticsComponent;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"analytics-container\" style=\"background-color: #eaeaec\">\r\n  <div class=\"analytics-inner-container\">\r\n    <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n    </div>    \r\n    <div class=\"\" ng-if=\"!vm.isLoading\">\r\n       <div kendo-tab-strip>\r\n          <ul>                \r\n            <li class=\"k-state-active\">Bot Insights</li>            \r\n          </ul>   \r\n          <div style=\"padding: 1em; background-color: #eaeaec\">\r\n            <div kendo-chart k-options=\"vm.botEventsOptions\" style=\"width: 900px; height: 500px; padding: 5px\"></div>    \r\n          </div>                                                    \r\n      </div>                  \r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(877);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsController = function () {
	  AnalyticsController.$inject = ["AnalyticsService", "$q"];
	  function AnalyticsController(AnalyticsService, $q) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AnalyticsController);
	    this.analyticsService = AnalyticsService;
	    this.$q = $q;
	  }
	
	  (0, _createClass3.default)(AnalyticsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.isLoading = true;
	
	      var getBotStatsPromise = this.analyticsService.getBotStatsData();
	
	      this.$q.all([getBotStatsPromise]).then(function (data) {
	        var _data = (0, _slicedToArray3.default)(data, 1),
	            getBotStatsResponse = _data[0];
	
	        _this.setBotStatsOptions(getBotStatsResponse);
	
	        _this.isLoading = false;
	      });
	    }
	  }, {
	    key: "setBotStatsOptions",
	    value: function setBotStatsOptions(data) {
	      var eventStats = data.series[0];
	      var titleFormat = kendo.format("{0} - Events: {1}", eventStats.name, eventStats.totalCount);
	      var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Events', dataItem.value)#";
	      this.botEventsOptions = this.analyticsService.getDonutChartOptions(eventStats, titleFormat, labelFormat);
	    }
	  }]);
	  return AnalyticsController;
	}();
	
	exports.default = AnalyticsController;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(951);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-bot.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-bot.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.analytics-container{display:flex;flex-direction:column;height:100vh}.analytics-container .analytics-inner-container{margin-left:4rem}", ""]);
	
	// exports


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _analyticsMarketing = __webpack_require__(953);
	
	var _analyticsMarketing2 = _interopRequireDefault(_analyticsMarketing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsModule = _angular2.default.module('app.containers.analytics-marketing', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('analyticsMarketing', {
	    url: '/analytics-marketing',
	    template: '<analytics-marketing></analytics-marketing>'
	  });
	}]).component('analyticsMarketing', _analyticsMarketing2.default);
	
	exports.default = analyticsModule;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analyticsMarketing = __webpack_require__(954);
	
	var _analyticsMarketing2 = _interopRequireDefault(_analyticsMarketing);
	
	var _analyticsMarketing3 = __webpack_require__(955);
	
	var _analyticsMarketing4 = _interopRequireDefault(_analyticsMarketing3);
	
	__webpack_require__(956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analyticsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _analyticsMarketing2.default,
	  controller: _analyticsMarketing4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = analyticsComponent;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"analytics-container\" style=\"background-color: #eaeaec\">\r\n  <div class=\"analytics-inner-container\">\r\n    <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n    </div>\r\n    <div class=\"container\" ng-if=\"!vm.isLoading\">\r\n        <iframe width=\"100%\" height=\"1000\" src=\"https://datastudio.google.com/embed/reporting/2e5e46cc-d36a-49cf-af5c-edc3e52f53e7/page/bkaoC\"\r\n          frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe>\r\n\r\n      <!-- <div kendo-tab-strip>\r\n        <ul>\r\n          <li class=\"k-state-active\">Users</li>\r\n          <li>Revenue</li>\r\n        </ul>\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n        </div>\r\n        <div style=\"padding: 1em; background-color: #eaeaec\">\r\n        </div>\r\n      </div> -->\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsController = function () {
	  AnalyticsController.$inject = ["AnalyticsService", "$q"];
	  function AnalyticsController(AnalyticsService, $q) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AnalyticsController);
	    this.analyticsService = AnalyticsService;
	    this.$q = $q;
	  }
	
	  (0, _createClass3.default)(AnalyticsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.isLoading = false;
	    }
	  }]);
	  return AnalyticsController;
	}();
	
	exports.default = AnalyticsController;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(957);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-marketing.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./analytics-marketing.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.analytics-container{display:flex;flex-direction:column;height:100vh}.analytics-container .analytics-inner-container{margin-left:4rem}", ""]);
	
	// exports


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _businesses = __webpack_require__(959);
	
	var _businesses2 = _interopRequireDefault(_businesses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var businessesModule = _angular2.default.module('app.containers.businesses', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('businesses', {
	    url: '/businesses',
	    template: '<businesses></businesses>'
	  });
	}]).component('businesses', _businesses2.default);
	
	exports.default = businessesModule;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _businesses = __webpack_require__(960);
	
	var _businesses2 = _interopRequireDefault(_businesses);
	
	var _businesses3 = __webpack_require__(961);
	
	var _businesses4 = _interopRequireDefault(_businesses3);
	
	__webpack_require__(962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var businessesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _businesses2.default,
	  controller: _businesses4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = businessesComponent;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"businesses-container\">\r\n  <div class=\"businesses-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <businesses-filter apply-filters=\"vm.applyFilters()\"></businesses-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"businesses-match\">{{vm.businessesMatchCount ? vm.businessesMatchCount + \" businesses match\" : \"\"}}</div>\r\n      <div class=\"businesses-grid\">\r\n        <div id=\"businesses-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n  <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n    <div class=\"form-item\">\r\n      <span style=\"font-weight: bold;\">Lead Status: </span>\r\n      <input k-on-change=\"dataItem.dirty=true\"\r\n        kendo-dropdownlist\r\n        k-options=\"vm.businessStatusOptions\"\r\n        data-bind=\"value: locationStatus\"\r\n        validationMessage=\"Select lead status\" name=\"Lead Status\"/>\r\n    </div>\r\n    <div class=\"form-item\">\r\n      <span style=\"font-weight: bold;\">Notes: </span>\r\n      <textarea rows=\"5\" k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n        data-bind=\"value: notes\" validationMessage=\"Notes\" name=\"Notes\"/>\r\n    </div>\r\n  </div>\r\n</script>\r\n\r\n"

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(817);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _moment = __webpack_require__(412);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BusinessesController = function () {
	  BusinessesController.$inject = ["BusinessesService", "FilterService", "AuthService", "$scope"];
	  function BusinessesController(BusinessesService, FilterService, AuthService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BusinessesController);
	    this.businessesService = BusinessesService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.$scope = $scope;
	    this.gridOptions = this.getGridOptions();
	  }
	
	  (0, _createClass3.default)(BusinessesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var dataSource = [];
	      (0, _keys2.default)(_constants2.default.locationStatus).forEach(function (key) {
	        var value = _constants2.default.locationStatus[key];
	        if (value === 0) return;
	
	        dataSource.push({
	          value: value,
	          text: _constants2.default.getLocationStatusText(value)
	        });
	      });
	      this.businessStatusOptions = {
	        dataSource: dataSource,
	        dataTextField: "text",
	        dataValueField: "value"
	      };
	    }
	  }, {
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.businessesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          template: "No match found. Change your filter criteria."
	        },
	        columns: [{ field: "id", title: "ID", filterable: false, width: "3rem" }, {
	          field: "name", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "6rem",
	          template: function template(dataItem) {
	            return "<a class=\"cell\" href=\"/businesses/" + dataItem.id + "\"><span>" + dataItem.name + "</span></a>";
	          }
	        }, {
	          field: "name", title: "Landing Page", filterable: false, attributes: { "class": "col-name" }, width: "4rem",
	          template: function template(dataItem) {
	            return "<a target=\"_blank\" class=\"cell\" href=\"https://www.jugglestreet.com.au/business-details?businessId=" + dataItem.id + "\"><span>Search results</span></a>";
	          }
	        },
	        // {
	        //   field: "jugglerId", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "12rem",
	        //   template: (dataItem) => `<a class="cell" href="/users/${dataItem.userId}"><div class="image-container"><img src="${dataItem.imageUrl ? this.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png"}"></img></div><span>${dataItem.fullName}</span></a>`,
	        // },
	        // {
	        //   field: "email", title: "Email", filterable: false, width: "15rem",
	        //   template: `<a href="mailto:#= email #">#= email #</a>`
	        // },
	        // { field: "address", title: "Address", filterable: false, width: "8rem" },
	        { field: "locationType", title: "Type", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getBusinessType(dataItem.locationType);
	          } }, { field: "helpersCount", title: "Helpers Count", filterable: false, width: "2rem" }, { field: "locationStatus", title: "Lead Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getBusinessStatus(dataItem.locationStatus);
	          } },
	        // { field: "addressState", title: "State", filterable: false, width: "8rem" },
	        // { field: "addressPostCode", title: "Postcode", filterable: false, width: "8rem" },
	        // {
	        //   field: "updatedAt", title: "Updated At", filterable: false, width: "6rem",
	        //   template: `<span>#= kendo.toString(new Date(updatedAt ? updatedAt : createdAt), 'dd/MM @hh:mmtt') #</span>`,
	        // },
	        { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Update Business" },
	          template: kendo.template($("#popup-editor").html())
	        }
	      };
	    }
	  }, {
	    key: "saveChanges",
	    value: function saveChanges(e) {
	      // const check = e.model;
	
	      // if ((check.visaCheckStatus == 2) && (!check.visaClass || !check.visaSubclass || !check.visaGrantDate || !check.visaExpiry)) {
	      //   this.notificationService.error("Check missing fields and try again.");
	      //   e.preventDefault();
	      // }
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.businessesMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this2 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this2.applyFilters();
	        }).catch(function (error) {
	          _this2.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }, {
	    key: "_getBusinessStatus",
	    value: function _getBusinessStatus(status) {
	      return _constants2.default.getLocationStatusText(status);
	    }
	  }, {
	    key: "_getBusinessType",
	    value: function _getBusinessType(type) {
	      return _constants2.default.getLocationTypeText(type);
	    }
	  }]);
	  return BusinessesController;
	}();
	
	exports.default = BusinessesController;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(963);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./businesses.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./businesses.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.businesses-container{display:flex;flex-direction:column;height:100vh}.businesses-container .businesses-inner-container{height:100%;display:flex}.businesses-container .businesses-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.businesses-container .businesses-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.businesses-container .businesses-inner-container .grid-container .businesses-grid{margin-top:.5rem;margin-left:.5rem}.businesses-container .businesses-inner-container .grid-container .businesses-grid .col-name .cell{display:flex;align-items:center}.businesses-container .businesses-inner-container .grid-container .businesses-grid .col-name .cell .image-container{width:2rem}.businesses-container .businesses-inner-container .grid-container .businesses-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.businesses-container .businesses-inner-container .grid-container .businesses-grid .k-grid-norecords{margin-top:20rem}.businesses-container .businesses-inner-container .grid-container .businesses-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _businessDetails = __webpack_require__(965);
	
	var _businessDetails2 = _interopRequireDefault(_businessDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var businessDetailsModule = _angular2.default.module('app.containers.business-details', []).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('businessDetails', {
	    url: '/businesses/:businessId',
	    template: '<business-details></business-details>'
	  });
	}]).component('businessDetails', _businessDetails2.default);
	
	exports.default = businessDetailsModule;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _businessDetails = __webpack_require__(966);
	
	var _businessDetails2 = _interopRequireDefault(_businessDetails);
	
	var _businessDetails3 = __webpack_require__(967);
	
	var _businessDetails4 = _interopRequireDefault(_businessDetails3);
	
	__webpack_require__(968);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var businessDetailsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _businessDetails2.default,
	  controller: _businessDetails4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = businessDetailsComponent;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"business-details-container\">\r\n  <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n    <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n  </div>\r\n  <div class=\"business-details-inner-container\" ng-if=\"!vm.isLoading\">\r\n    <header class=\"header-container\">\r\n      <div class=\"header-inner-container contain-max-width\">\r\n        <div class=\"basic-info\">\r\n          <div class=\"info-container\">\r\n            <h3>\r\n              {{vm.business.name}}\r\n            </h3>\r\n            <div style=\"margin: 2px 0\">\r\n              <span class=\"fa fa-building\"></span>\r\n              <span class=\"item-title\">Account Type:</span>\r\n              <span>{{vm.locationType()}}</span>\r\n            </div>\r\n            <div style=\"margin: 2px 0\">\r\n              <span class=\"fa fa-clock\"></span>\r\n              <span class=\"item-title\">Lead Status:</span>\r\n              <span>{{vm.locationStatus()}}</span>\r\n            </div>\r\n            <div style=\"margin: 2px 0\">\r\n              <span class=\"fa fa-map-marker\"></span>\r\n              <span>{{vm.business.formattedSuburb + \" \" + vm.business.state.toUpperCase() + \", \" + vm.business.country.toUpperCase()}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- <div class=\"more-info\">\r\n          <div class=\"info-item\">\r\n            <span class=\"item-text\">\r\n\r\n            </span>\r\n          </div>\r\n          <div class=\"info-item\">\r\n            <h4 class=\"item-title\">Lead Date</h4>\r\n            <span class=\"item-text\">\r\n              <span class=\"fa fa-calendar\"></span>\r\n              {{vm.formatDate(vm.business.createdAt)}}\r\n            </span>\r\n          </div>\r\n        </div> -->\r\n      </div>\r\n    </header>\r\n    <div class=\"tabs-container\">\r\n      <div class=\"contain-max-width tabs-inner-container\">\r\n        <div class=\"tab\" ng-repeat=\"tab in vm.tabs\" ng-click=\"vm.switchTab(tab)\" ng-class=\"{'active-tab': tab.isActive}\">\r\n          <span class=\"tab-icon {{tab.icon}}\"></span><span>{{tab.label}}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"contain-max-width body-container\">\r\n      <div class=\"body-inner-container\">\r\n        <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.LEAD_DETAILS]\" class=\"tab-body-container\">\r\n          <!-- <div>\r\n            Lead Status: {{vm.locationStatus()}}\r\n          </div> -->\r\n          <div>\r\n            <h4>Contact Details:</h4>\r\n            {{vm.business.formattedAddress}}\r\n            <br/>\r\n            Emai: <a href=\"mailto:{{vm.business.email}}\">{{vm.business.email}}</a>\r\n            <br/>\r\n            Phone: {{vm.business.normalisedPhoneNumber}}\r\n            <br/>\r\n            <span ng-if=\"vm.business.mobilePhoneNumber\">Mobile Phone: {{vm.business.normalisedMobilePhoneNumber}}</span>\r\n          </div>\r\n\r\n          <div>\r\n            <h4>Acquisition Details:</h4>\r\n            Helpers Count: {{vm.business.helpersCount}}\r\n            <br/>\r\n            Landing Page: <a target=\"_blank\" href=\"{{vm.businessLink()}}\">Link</a>\r\n          </div>\r\n          <div>\r\n            <h4>Notes:</h4>\r\n            {{vm.business.notes ? vm.business.notes : 'None'}}\r\n          </div>\r\n          <div>\r\n            <h4>Activity Log:</h4>\r\n            <span style=\"white-space: pre-line\">{{vm.business.systemLog ? vm.business.systemLog : 'None'}}</span>\r\n          </div>\r\n        </div>\r\n        <!-- <div ng-if=\"vm.activeTab == vm.tabs[vm.tabTypes.NOTES]\" class=\"tab-body-container\">\r\n          <div>\r\n            Lead Status: {{vm.locationStatus()}}\r\n          </div>\r\n          <div>\r\n            <h4>Notes:</h4>\r\n            {{vm.business.notes ? vm.business.notes : 'None'}}\r\n          </div>\r\n        </div> -->\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n"

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(817);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(366);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _common = __webpack_require__(411);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _underscore = __webpack_require__(821);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BusinessDetailsController = function () {
	  BusinessDetailsController.$inject = ["$stateParams", "$sce", "BusinessesService", "AppContextService", "NotificationService", "$scope"];
	  function BusinessDetailsController($stateParams, $sce, BusinessesService, AppContextService, NotificationService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BusinessDetailsController);
	    this.businessesService = BusinessesService;
	    this.appContextService = AppContextService;
	    console.log($stateParams.businessId);
	    this.businessId = $stateParams.businessId;
	    this.getBusinessDetails(this.businessId);
	    this.deleteIntercomAccount = true;
	    this.notificationService = NotificationService;
	    this.$scope = $scope;
	    this.$sce = $sce;
	  }
	
	  (0, _createClass3.default)(BusinessDetailsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.tabTypes = {
	        LEAD_DETAILS: 1,
	        ACTIVITY: 2,
	        NOTES: 3
	      };
	    }
	  }, {
	    key: "businessLink",
	    value: function businessLink() {
	      if (!this.business) return "";
	
	      return 'https://www.jugglestreet.com.au/business-details?businessId=' + this.business.id;
	    }
	  }, {
	    key: "locationStatus",
	    value: function locationStatus() {
	      if (!this.business) return '';
	
	      return _constants2.default.getLocationStatusText(this.business.locationStatus);
	    }
	  }, {
	    key: "locationType",
	    value: function locationType() {
	      if (!this.business) return '';
	
	      return _constants2.default.getLocationTypeText(this.business.locationType);
	    }
	  }, {
	    key: "getBusinessDetails",
	    value: function getBusinessDetails(businessId) {
	      var _this = this;
	
	      this.isLoading = true;
	
	      this.businessesService.getBusinessDetails(businessId, function (response) {
	        _this.business = response.data;
	        _this.isLoading = false;
	
	        _this.getTabs();
	
	        _this.$scope.$apply();
	      }, function (error) {
	        _this.isLoading = false;
	      });
	    }
	  }, {
	    key: "getTabs",
	    value: function getTabs() {
	      this.tabs = (0, _defineProperty3.default)({}, this.tabTypes.LEAD_DETAILS, {
	        key: 1,
	        label: "LEAD DETAILS",
	        isActive: true,
	        icon: "fa fa-user"
	      });
	
	      this.activeTab = this.tabs["1"];
	    }
	  }, {
	    key: "switchTab",
	    value: function switchTab(tab) {
	      var _this2 = this;
	
	      this.activeTab = tab;
	
	      (0, _keys2.default)(this.tabs).map(function (i) {
	        if (_this2.tabs[i] == _this2.activeTab) _this2.tabs[i].isActive = true;else _this2.tabs[i].isActive = false;
	      });
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      return _common2.default.formatDate(date);
	    }
	  }, {
	    key: "hasGlobalAdminAccess",
	    value: function hasGlobalAdminAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
	    }
	  }, {
	    key: "hasLoginAsUserAccess",
	    value: function hasLoginAsUserAccess() {
	      var appContext = this.appContextService.getAppContext();
	      if (!appContext) return false;
	
	      if (this.appContextService.hasLoginAsUserAccess(appContext.roles)) return true;else return false;
	    }
	  }, {
	    key: "_getDialogOptions",
	    value: function _getDialogOptions() {
	      return {
	        buttonLayout: "normal",
	        messages: {
	          close: ""
	        },
	        visible: false,
	        closable: true,
	        modal: true
	      };
	    }
	  }, {
	    key: "handleRefreshCache",
	    value: function handleRefreshCache() {
	      var _this3 = this;
	
	      var payload = { actionType: _constants2.default.adminEntitiesActionType.REFRESH_CACHE };
	      this.businessesService.updateUserDetails(this.businessId, payload, function () {
	        _this3.notificationService.success("Cache refresh successful.");
	      }, function () {
	        _this3.notificationService.error("Cache refresh failed.");
	      });
	    }
	  }]);
	  return BusinessDetailsController;
	}();
	
	exports.default = BusinessDetailsController;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(969);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./business-details.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./business-details.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.business-details-container .business-details-inner-container{margin-left:4rem}.business-details-container .business-details-inner-container .contain-max-width{max-width:1280px;margin:0 auto}.business-details-container .business-details-inner-container .header-container{background:#162e3d;color:#f4f4f4;height:5rem;padding:2rem .5rem 1rem}.business-details-container .business-details-inner-container .header-container .header-inner-container{height:5rem;display:flex;justify-content:space-between}.business-details-container .business-details-inner-container .header-container .header-inner-container .basic-info{min-width:500px;display:flex;justify-content:flex-start}.business-details-container .business-details-inner-container .header-container .header-inner-container .basic-info .profile-image{max-height:8rem;margin-right:.5rem}.business-details-container .business-details-inner-container .header-container .header-inner-container .basic-info .info-container{flex-direction:column;display:flex;justify-content:flex-end}.business-details-container .business-details-inner-container .header-container .header-inner-container .basic-info .info-container .entity-type-label{font-size:.9rem;background:#299c4a;padding:.1rem;margin-left:.5rem;border-radius:.2rem}.business-details-container .business-details-inner-container .header-container .header-inner-container .basic-info .info-container .hidden-account-label{font-size:.9rem;background:red;padding:.1rem;margin-left:.5rem;border-radius:.2rem}.business-details-container .business-details-inner-container .header-container .header-inner-container .more-info{min-width:700px;display:flex;justify-content:flex-end;flex-direction:column}.business-details-container .business-details-inner-container .header-container .header-inner-container .more-info .info-item{margin-bottom:.5rem;display:flex;flex-direction:column;align-items:flex-end}.business-details-container .business-details-inner-container .header-container .header-inner-container .more-info .info-item .item-title{margin-bottom:.2rem}.business-details-container .business-details-inner-container .header-container .header-inner-container .more-info .info-item .item-text{font-size:.9rem}.business-details-container .business-details-inner-container .tabs-container{height:3rem;background:#3f5464;display:flex;align-items:flex-end}.business-details-container .business-details-inner-container .tabs-container .tabs-inner-container{display:flex;align-items:center;color:#f4f4f4;width:100%}.business-details-container .business-details-inner-container .tabs-container .tabs-inner-container .tab{padding:.5em 0;width:20rem;text-align:center;cursor:pointer}.business-details-container .business-details-inner-container .tabs-container .tabs-inner-container .tab .tab-icon{margin-right:1rem}.business-details-container .business-details-inner-container .tabs-container .tabs-inner-container .active-tab{border-bottom:5px solid #299c4a}.business-details-container .business-details-inner-container .body-container{margin-top:2rem}.business-details-container .business-details-inner-container .body-container h4{text-decoration:underline;font-style:italic;margin-bottom:.1rem}.business-details-container .business-details-inner-container .body-container .body-inner-container{margin:0 .5rem}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container>div{margin:.5rem 0}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container .login-as-user{margin:2rem .5rem;flex-basis:100%}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container .login-as-user .title{margin-bottom:1rem}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container .business-details-component{width:600px;margin-bottom:2rem}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container .business-details-component .title{height:1rem;padding:.5rem}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container .business-details-component .details{padding:.5rem;border:1px solid #d8d8d8}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container .business-details-component .details .item{margin-bottom:1rem}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container .business-details-component .details .item .item-title{margin-bottom:.3rem;color:#299c4a}.business-details-container .business-details-inner-container .body-container .body-inner-container .tab-body-container .business-details-component .details .item .item-text{font-size:.9rem;color:#1c1c1c}", ""]);
	
	// exports


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(334);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(336);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobRequests = __webpack_require__(971);
	
	var _jobRequests2 = _interopRequireDefault(_jobRequests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobRequestsModule = _angular2.default.module('app.containers.job-requests', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('jobRequests', {
	    url: '/job-requests',
	    template: '<job-requests></job-requests>'
	  });
	}]).component('jobRequests', _jobRequests2.default);
	
	exports.default = jobRequestsModule;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobRequests = __webpack_require__(972);
	
	var _jobRequests2 = _interopRequireDefault(_jobRequests);
	
	var _jobRequests3 = __webpack_require__(973);
	
	var _jobRequests4 = _interopRequireDefault(_jobRequests3);
	
	__webpack_require__(974);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobRequests = {
	  restrict: 'E',
	  bindings: {},
	  template: _jobRequests2.default,
	  controller: _jobRequests4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = jobRequests;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"job-requests-container\">\r\n  <div class=\"job-requests-inner-container\">\r\n    <div class=\"filters-container\">\r\n      <job-requests-filter apply-filters=\"vm.applyFilters()\"></job-requests-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"job-requests-match\">{{vm.jobsMatchCount ? vm.jobsMatchCount + \" match\" : \"\"}}</div>\r\n      <div class=\"job-requests-grid\">\r\n        <div id=\"job-requests-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<script id=\"popup-editor\" type=\"text/x-kendo-template\">\r\n  <div style=\"padding: 0 1rem; font-size: 0.9rem\">\r\n    <p>\r\n      <div class=\"form-item\">\r\n        <span style=\"font-weight: bold;\">Notes: </span>\r\n        <textarea rows=\"5\" k-on-change=\"dataItem.dirty=true\" class=\"k-textbox\"\r\n          data-bind=\"value: notes\" validationMessage=\"Notes\" name=\"Notes\"/>\r\n      </div>\r\n    </p>\r\n  </div>\r\n</script>"

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _env = __webpack_require__(515);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Look for a cleaner solution.
	var requestsVm = void 0;
	
	var JobRequestsController = function () {
	  JobRequestsController.$inject = ["JobRequestsService", "FilterService", "AuthService", "UsersService", "$scope"];
	  function JobRequestsController(JobRequestsService, FilterService, AuthService, UsersService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, JobRequestsController);
	    this.usersService = UsersService;
	    this.jobRequestsService = JobRequestsService;
	    this.filterService = FilterService;
	    this.authService = AuthService;
	    this.$scope = $scope;
	    this.jobRequestsDataSource = this.jobRequestsService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this));
	    this.gridOptions = this.getGridOptions();
	    requestsVm = this;
	  }
	
	  (0, _createClass3.default)(JobRequestsController, [{
	    key: "getGridOptions",
	    value: function getGridOptions() {
	      var _this = this;
	
	      return {
	        dataSource: this.jobRequestsDataSource,
	        sortable: true,
	        pageable: true,
	        resizable: true,
	        height: "90vh",
	        noRecords: {
	          // template: "No match found. Change your filter criteria."
	          template: "None yet."
	        },
	        columns: [{
	          field: "requestDate", title: "Request Date", filterable: false, width: "4rem",
	          template: "<span>#= kendo.toString(new Date(requestDate), 'dd-MM-yyyy') #</span>"
	        }, {
	          field: "ownerFullName", title: "Job Owner", filterable: false, sortable: false, width: "6rem",
	          template: "<a class=\"cell\" href=\"#= '/users/' + ownerUserId #\">#= ownerFullName #</a>"
	        }, { field: "jobType", title: "Job Type", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getJobTypeText(dataItem.jobType);
	          } }, { field: "id", title: "Request #", filterable: false, sortable: false, width: "2rem", template: function template(dataItem) {
	            return "#" + dataItem.id;
	          } }, {
	          field: "scheduledCallLocalTime", title: "Briefing Call", filterable: false, width: "4rem",
	          template: function template(dataItem) {
	            return _this._getScheduledDate(dataItem);
	          }
	        }, { field: "jobRequestStatus", title: "Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
	            return "" + _this._getJobRequestStatusText(dataItem.jobRequestStatus);
	          } },
	        // {
	        //   field: "state", title: "State", filterable: false, width: "4rem",
	        //   template: `<span>#= (country === 'au' ? state.toUpperCase() : state) #</span>`,
	        // },
	        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" },
	        // { title: 'Post Job', command: { text: "Post Job", click: this.handlePostJob }, width: "4rem" },
	        { title: 'Transfer Job', command: { text: "Transfer Job", click: this.handleTransferJob }, width: "4rem" }],
	        editable: {
	          mode: "popup",
	          window: { title: "Update" },
	          template: kendo.template($("#popup-editor").html())
	        }
	      };
	    }
	
	    // https://demos.telerik.com/kendo-ui/grid/custom-command
	
	  }, {
	    key: "handleTransferJob",
	    value: function handleTransferJob(e) {
	      e.preventDefault();
	
	      var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
	
	      if (dataItem.jobRequestStatus != _constants2.default.jobRequestStatus.JOB_POSTED) {
	        alert('Job can only be transfered after it has been posted. ');
	        return;
	      }
	
	      if (confirm('Are you sure that you would like to finalise this job and transfer it to the parent? This action is irreversible.')) {
	        requestsVm.jobRequestsService.transferJob(dataItem, function () {
	          requestsVm.jobRequestsDataSource.read();
	        });
	      } else {
	        console.log('no-transfer');
	      }
	    }
	  }, {
	    key: "handlePostJob",
	    value: function handlePostJob(e) {
	      e.preventDefault();
	
	      var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
	
	      if (dataItem.jobRequestStatus != _constants2.default.jobRequestStatus.CALL_SCHEDULED) {
	        alert('Only requests in a scheduled call status can be posted. ');
	        return;
	      }
	      var jobManagerId = dataItem.jobManagerId;
	
	      requestsVm.loginAsUser(2, jobManagerId);
	    }
	  }, {
	    key: "loginAsUser",
	    value: function loginAsUser(targetDevice, userId) {
	      var _this2 = this;
	
	      this.usersService.getLoginAsUserAccessToken(userId, function (response) {
	        console.log("Access token::", response.data);
	        _this2.redirectToTarget(targetDevice, response.data.accessToken, 'au');
	      }, function (error) {});
	    }
	  }, {
	    key: "redirectToTarget",
	    value: function redirectToTarget(targetDevice, token, country) {
	      var rootUrl = _env2.default.getLoginAsBaseUrl(targetDevice, country);
	      var url = rootUrl + ("?admin_mode=1&access_token=" + token);
	      console.log(url);
	      window.open(rootUrl + ("?admin_mode=1&access_token=" + token));
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters() {
	      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
	    }
	  }, {
	    key: "dataSourceFetchSuccessCallback",
	    value: function dataSourceFetchSuccessCallback(e) {
	      this.jobsMatchCount = this.gridOptions.dataSource.total();
	      this.$scope.$apply();
	    }
	  }, {
	    key: "dataSourceErrorSuccessCallback",
	    value: function dataSourceErrorSuccessCallback(e) {
	      var _this3 = this;
	
	      if (e.xhr.status == 401) {
	        this.authService.refreshToken().then(function (response) {
	          _this3.applyFilters();
	        }).catch(function (error) {
	          _this3.authService.logout();
	        });
	      } else {
	        this.authService.logout();
	      }
	    }
	  }, {
	    key: "_getScheduledDate",
	    value: function _getScheduledDate(dataItem) {
	      if (!dataItem.scheduledCallLocalTime) return 'N/A';
	
	      return kendo.toString(new Date(dataItem.scheduledCallLocalTime), 'dd/MM @ hh:mmtt');
	    }
	  }, {
	    key: "_getJobRequestActions",
	    value: function _getJobRequestActions(dataItem) {
	      // <span class='k-icon k-i-edit'></span>
	      // const postJobAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Post Job</a>";
	      var transferJobAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Transfer Job</a>";
	      var notesAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Notes</a>";
	
	      return "<span>" + transferJobAction + notesAction + "</span>";
	    }
	  }, {
	    key: "_getHelperStats",
	    value: function _getHelperStats(dataItem) {
	      return dataItem.activeInvites + " / " + dataItem.totalInvites;
	    }
	  }, {
	    key: "_getOpenRate",
	    value: function _getOpenRate(dataItem) {
	      var activity = dataItem.activeInvites + " / " + dataItem.totalInvites;
	      var openRate = dataItem.activeInvites / dataItem.totalInvites;
	      return kendo.format('{0:p0}', openRate);
	    }
	  }, {
	    key: "_getJobTypeText",
	    value: function _getJobTypeText(type) {
	      switch (type) {
	        case _constants2.default.jobType.BABYSITTING:
	          return "Babysitting";
	        case _constants2.default.jobType.NANNYING:
	          return "Nannying";
	        case _constants2.default.jobType.AFTER_SCHOOL_CARE:
	          return "After School Care";
	        case _constants2.default.jobType.BEFORE_SCHOOL_CARE:
	          return "Before School Care";
	        case _constants2.default.jobType.BEFORE_AFTER_SCHOOL_CARE:
	          return "Before/After School Care";
	        case _constants2.default.jobType.AU_PAIR:
	          return "Au Pair";
	        case _constants2.default.jobType.PRIMARY_SCHOOL_TUTORING:
	          return "Primary School Tutoring";
	        case _constants2.default.jobType.HIGH_SCHOOL_TUTORING:
	          return "High School Tutoring";
	        case _constants2.default.jobType.ONE_OFF_ODD_JOBS:
	          return "Odd Job";
	      }
	    }
	  }, {
	    key: "_getJobRequestStatusText",
	    value: function _getJobRequestStatusText(status) {
	      switch (status) {
	        case _constants2.default.jobRequestStatus.NEW_REQUEST:
	          return "New Request";
	        case _constants2.default.jobRequestStatus.CALL_SCHEDULED:
	          return "Call Scheduled";
	        case _constants2.default.jobRequestStatus.JOB_POSTED:
	          return "Job Posted";
	        case _constants2.default.jobRequestStatus.JOB_TRANSFERRED:
	          return "Job Transferred";
	        case _constants2.default.jobRequestStatus.JOB_AWARDED:
	          return "Job Awarded";
	      }
	    }
	  }, {
	    key: "_getManagedByText",
	    value: function _getManagedByText(status) {
	      switch (status) {
	        case _constants2.default.managedBy.USER:
	          return "DIY";
	        case _constants2.default.managedBy.SYSTEM:
	          return "Assist";
	      }
	
	      return "";
	    }
	  }]);
	  return JobRequestsController;
	}();
	
	exports.default = JobRequestsController;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(975);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./job-requests.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./job-requests.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:16px Roboto,sans-serif}body h1,body h2,body h3,body h4,body h5,body h6{margin:0}a:active,a:hover,a:link,a:visited{color:#000}.pointer-cursor{cursor:pointer}.k-input{padding:.5rem;border:1px solid #dbdbdb;border-radius:.3rem}.k-dropdown:hover,.k-state-hover,.k-textbox:hover,.k-tiles li.k-state-hover{border-color:#299c4a!important}.k-state-hover,.k-state-hover:hover{background-color:#299c4a;border-color:#299c4a;background-image:none,linear-gradient(180deg,#299c4a 0,#299c4a)}.k-tabstrip-scrollable .k-button-bare:hover{background-color:#299c4a!important}.k-edit-buttons .k-button{border-radius:5px;background-color:#ffa63d!important;border-color:#ffa63d!important}.k-grid td.k-state-selected:hover,.k-grid tr:hover{background-color:#299c4a!important}.k-autocomplete .k-state-focused,.k-draghandle.k-state-selected:hover,.k-dropdown-wrap.k-state-focused,.k-dropdown .k-state-focused,.k-ghost-splitbar-horizontal,.k-ghost-splitbar-vertical,.k-list>.k-state-highlight,.k-list>.k-state-selected,.k-marquee-color,.k-panel>.k-state-selected,.k-scheduler .k-scheduler-toolbar .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected,.k-state-selected:link,.k-state-selected:visited{background-color:#299c4a!important;border-color:#299c4a!important}.k-button.k-state-focused,.k-button.k-state-hover,.k-button:focus,.k-button:hover,.k-draghandle:hover,.k-other-month.k-state-hover .k-link,.k-pager-wrap .k-link:hover,.k-split-button:focus,div.k-filebrowser-dropzone em{background-color:#ffa63d!important;border-color:#ffa63d!important;border-radius:5px;background-image:none,linear-gradient(180deg,#ffa63d 0,#ffa63d)}.k-overflow-container .k-primary,.k-primary{background-color:#299c4a!important;border-color:#299c4a!important}.job-requests-container{display:flex;flex-direction:column;height:100vh}.job-requests-container .job-requests-inner-container{height:100%;display:flex}.job-requests-container .job-requests-inner-container .filters-container{min-width:16rem;background:#ededed;margin-left:4rem;border-right:1px solid #d8d8d8}.job-requests-container .job-requests-inner-container .grid-container{background:#f5f5f5;overflow-x:scroll;flex:1}.job-requests-container .job-requests-inner-container .grid-container .job-requests-grid{margin-top:.5rem;margin-left:.5rem}.job-requests-container .job-requests-inner-container .grid-container .job-requests-grid .col-name .cell{display:flex;align-items:center}.job-requests-container .job-requests-inner-container .grid-container .job-requests-grid .col-name .cell .image-container{width:2rem}.job-requests-container .job-requests-inner-container .grid-container .job-requests-grid .col-name .cell .image-container img{max-width:1.5rem;max-height:1.5rem;vertical-align:middle}.job-requests-container .job-requests-inner-container .grid-container .job-requests-grid .k-grid-norecords{margin-top:20rem}.job-requests-container .job-requests-inner-container .grid-container .job-requests-match{margin:.5rem;font-size:1.2rem;color:#787878;height:1.4rem}", ""]);
	
	// exports


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(977);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(978);
	
	var _app4 = _interopRequireDefault(_app3);
	
	__webpack_require__(979);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: 'E',
	  controller: _app4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = appComponent;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"app\">\r\n  <navbar \r\n    ng-hide=\"vm.hideNav()\" \r\n    global-filter-options=\"vm.getGlobalFilterOptions()\" \r\n    hide-global-filters=\"vm.hideGlobalFilters()\">\r\n  </navbar>\r\n  <leftnav ng-hide=\"vm.hideNav()\"></leftnav>\r\n  <div ui-view></div>\r\n</div>\r\n"

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(344);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(345);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(365);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppController = function () {
	  AppController.$inject = ["NavigationService", "FilterService"];
	  function AppController(NavigationService, FilterService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AppController);
	    this.navigationService = NavigationService;
	    this.filterService = FilterService;
	    // this.getGlobaFilterOptions();
	  }
	
	  (0, _createClass3.default)(AppController, [{
	    key: "$onInit",
	    value: function $onInit() {}
	  }, {
	    key: "hideNav",
	    value: function hideNav() {
	      return this.navigationService.isCurrent("login");
	    }
	  }, {
	    key: "hideGlobalFilters",
	    value: function hideGlobalFilters() {
	      // return !this.navigationService.isCurrent("users");
	      return false;
	    }
	  }, {
	    key: "getGlobalFilterOptions",
	    value: function getGlobalFilterOptions() {
	      var filterOptions = void 0;
	
	      if (this.navigationService.isCurrent(_constants2.default.screens.USERS)) {
	        filterOptions = this.filterService.getGlobalUsersFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.JOBS)) {
	        filterOptions = this.filterService.getGlobalJobsFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.JOB_REQUESTS)) {
	        filterOptions = this.filterService.getGlobalJobRequestsFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.AFFILIATES)) {
	        filterOptions = this.filterService.getGlobalAffiliatesFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.CERTIFICATES)) {
	        filterOptions = this.filterService.getGlobalCertificatesFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.CHECKS)) {
	        filterOptions = this.filterService.getGlobalCheckssFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.BOT_MANAGER)) {
	        filterOptions = this.filterService.getGlobalBotManagerFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.BOT_SESSIONS)) {
	        filterOptions = this.filterService.getGlobalBotSessionsFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.VOUCHES)) {
	        filterOptions = this.filterService.getGlobalVocuhesFilterOptions();
	      } else if (this.navigationService.isCurrent(_constants2.default.screens.BUSINESSES)) {
	        filterOptions = this.filterService.getGlobalBusinessesFilterOptions();
	      }
	
	      return filterOptions;
	    }
	  }]);
	  return AppController;
	}();
	
	exports.default = AppController;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(980);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(370)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(369)();
	// imports
	
	
	// module
	exports.push([module.id, ".app{height:100%;background-color:$lightBgColor}", ""]);
	
	// exports


/***/ }
]);


/** WEBPACK FOOTER **
 ** app.bundle.js
 **/